const country = {
  zh_CN: [
    {
      id: 2,
      country_name: "加拿大",
      country_code: "CA",
      phone_code: "+1",
    },
    {
      id: 239,
      country_name: "美国本土外小岛屿",
      country_code: "UM",
      phone_code: "+1",
    },
    {
      id: 5,
      country_name: "美国",
      country_code: "US",
      phone_code: "+1",
    },
    {
      id: 47,
      country_name: "巴哈马",
      country_code: "BS",
      phone_code: "+1242",
    },
    {
      id: 9,
      country_name: "巴巴多斯",
      country_code: "BB",
      phone_code: "+1246",
    },
    {
      id: 22,
      country_name: "安圭拉",
      country_code: "AI",
      phone_code: "+1264",
    },
    {
      id: 23,
      country_name: "安提瓜 和巴布达",
      country_code: "AG",
      phone_code: "+1268",
    },
    {
      id: 90,
      country_name: "美属维尔京群岛",
      country_code: "VI",
      phone_code: "+1284",
    },
    {
      id: 91,
      country_name: "英属处女群岛",
      country_code: "VG",
      phone_code: "+1340",
    },
    {
      id: 152,
      country_name: "开曼群岛",
      country_code: "KY",
      phone_code: "+1345",
    },
    {
      id: 55,
      country_name: "百慕大群岛",
      country_code: "BM",
      phone_code: "+1441",
    },
    {
      id: 196,
      country_name: "格林纳达",
      country_code: "GD",
      phone_code: "+1473",
    },
    {
      id: 73,
      country_name: "特克斯和凯科斯群岛",
      country_code: "TC",
      phone_code: "+1649",
    },
    {
      id: 126,
      country_name: "蒙特塞拉特岛",
      country_code: "MS",
      phone_code: "+1664",
    },
    {
      id: 129,
      country_name: "马里亚那群岛",
      country_code: "MP",
      phone_code: "+1670",
    },
    {
      id: 184,
      country_name: "关岛",
      country_code: "GU",
      phone_code: "+1671",
    },
    {
      id: 17,
      country_name: "美属萨摩亚",
      country_code: "AS",
      phone_code: "+1684",
    },
    {
      id: 82,
      country_name: "圣马丁岛（荷兰部分）",
      country_code: "SX",
      phone_code: "+1721",
    },
    {
      id: 148,
      country_name: "圣露西亚",
      country_code: "LC",
      phone_code: "+1758",
    },
    {
      id: 105,
      country_name: "多米尼加",
      country_code: "DM",
      phone_code: "+1767",
    },
    {
      id: 95,
      country_name: "圣文森特和格林纳丁斯",
      country_code: "VC",
      phone_code: "+1784",
    },
    {
      id: 33,
      country_name: "波多黎各",
      country_code: "PR",
      phone_code: "+1787",
    },
    {
      id: 104,
      country_name: "多明尼加共和国",
      country_code: "DO",
      phone_code: "+1809",
    },
    {
      id: 111,
      country_name: "特立尼达和多巴哥",
      country_code: "TT",
      phone_code: "+1868",
    },
    {
      id: 155,
      country_name: "圣基茨和尼维斯",
      country_code: "KN",
      phone_code: "+1869",
    },
    {
      id: 163,
      country_name: "牙买加",
      country_code: "JM",
      phone_code: "+1876",
    },
    {
      id: 98,
      country_name: "埃及",
      country_code: "EG",
      phone_code: "+20",
    },
    {
      id: 87,
      country_name: "南苏丹",
      country_code: "SS",
      phone_code: "+211",
    },
    {
      id: 139,
      country_name: "摩洛哥",
      country_code: "MA",
      phone_code: "+212",
    },
    {
      id: 101,
      country_name: "阿尔及利亚",
      country_code: "DZ",
      phone_code: "+213",
    },
    {
      id: 114,
      country_name: "突尼斯",
      country_code: "TN",
      phone_code: "+216",
    },
    {
      id: 140,
      country_name: "利比亚",
      country_code: "LY",
      phone_code: "+218",
    },
    {
      id: 190,
      country_name: "冈比亚",
      country_code: "GM",
      phone_code: "+220",
    },
    {
      id: 35,
      country_name: "塞内加尔",
      country_code: "SN",
      phone_code: "+221",
    },
    {
      id: 127,
      country_name: "毛里塔尼亚",
      country_code: "MR",
      phone_code: "+222",
    },
    {
      id: 133,
      country_name: "马里",
      country_code: "ML",
      phone_code: "+223",
    },
    {
      id: 189,
      country_name: "几内亚",
      country_code: "GN",
      phone_code: "+224",
    },
    {
      id: 80,
      country_name: "科特迪瓦",
      country_code: "CI",
      phone_code: "+225",
    },
    {
      id: 61,
      country_name: "布基纳法索",
      country_code: "BF",
      phone_code: "+226",
    },
    {
      id: 116,
      country_name: "尼日尔",
      country_code: "NE",
      phone_code: "+227",
    },
    {
      id: 68,
      country_name: "多哥",
      country_code: "TG",
      phone_code: "+228",
    },
    {
      id: 56,
      country_name: "贝宁",
      country_code: "BJ",
      phone_code: "+229",
    },
    {
      id: 124,
      country_name: "毛里求斯",
      country_code: "MU",
      phone_code: "+230",
    },
    {
      id: 145,
      country_name: "利比里亚",
      country_code: "LR",
      phone_code: "+231",
    },
    {
      id: 37,
      country_name: "塞拉利昂",
      country_code: "SL",
      phone_code: "+232",
    },
    {
      id: 193,
      country_name: "加纳",
      country_code: "GH",
      phone_code: "+233",
    },
    {
      id: 1,
      country_name: "尼日利亚",
      country_code: "NG",
      phone_code: "+234",
    },
    {
      id: 71,
      country_name: "乍得",
      country_code: "TD",
      phone_code: "+235",
    },
    {
      id: 85,
      country_name: "中非共和国",
      country_code: "CF",
      phone_code: "+236",
    },
    {
      id: 75,
      country_name: "喀麦隆",
      country_code: "CM",
      phone_code: "+237",
    },
    {
      id: 69,
      country_name: "开普",
      country_code: "CV",
      phone_code: "+238",
    },
    {
      id: 86,
      country_name: "圣多美和普林西比",
      country_code: "ST",
      phone_code: "+239",
    },
    {
      id: 187,
      country_name: "赤道几内亚",
      country_code: "GQ",
      phone_code: "+240",
    },
    {
      id: 199,
      country_name: "加蓬",
      country_code: "GA",
      phone_code: "+241",
    },
    {
      id: 83,
      country_name: "刚果共和国",
      country_code: "CG",
      phone_code: "+242",
    },
    {
      id: 3,
      country_name: "刚果民主共和国",
      country_code: "CD",
      phone_code: "+243",
    },
    {
      id: 19,
      country_name: "安哥拉",
      country_code: "AO",
      phone_code: "+244",
    },
    {
      id: 183,
      country_name: "几内亚比绍共和国",
      country_code: "GW",
      phone_code: "+245",
    },
    {
      id: 230,
      country_name: "英属印度洋领地",
      country_code: "IO",
      phone_code: "+246",
    },
    {
      id: 27,
      country_name: "阿森松岛",
      country_code: "AC",
      phone_code: "+247",
    },
    {
      id: 49,
      country_name: "塞舌尔",
      country_code: "SC",
      phone_code: "+248",
    },
    {
      id: 46,
      country_name: "苏丹",
      country_code: "SD",
      phone_code: "+249",
    },
    {
      id: 60,
      country_name: "卢旺达",
      country_code: "RW",
      phone_code: "+250",
    },
    {
      id: 93,
      country_name: "埃塞俄比亚",
      country_code: "ET",
      phone_code: "+251",
    },
    {
      id: 34,
      country_name: "索马里",
      country_code: "SO",
      phone_code: "+252",
    },
    {
      id: 108,
      country_name: "吉布提",
      country_code: "DJ",
      phone_code: "+253",
    },
    {
      id: 160,
      country_name: "肯尼亚",
      country_code: "KE",
      phone_code: "+254",
    },
    {
      id: 107,
      country_name: "坦桑尼亚",
      country_code: "TZ",
      phone_code: "+255",
    },
    {
      id: 102,
      country_name: "乌干达",
      country_code: "UG",
      phone_code: "+256",
    },
    {
      id: 57,
      country_name: "布隆迪",
      country_code: "BI",
      phone_code: "+257",
    },
    {
      id: 119,
      country_name: "莫桑比克",
      country_code: "MZ",
      phone_code: "+258",
    },
    {
      id: 165,
      country_name: "赞比亚",
      country_code: "ZM",
      phone_code: "+260",
    },
    {
      id: 135,
      country_name: "马达加斯加",
      country_code: "MG",
      phone_code: "+261",
    },
    {
      id: 16,
      country_name: "留尼汪",
      country_code: "RE",
      phone_code: "+262",
    },
    {
      id: 231,
      country_name: "法属南部领地",
      country_code: "TF",
      phone_code: "+262",
    },
    {
      id: 164,
      country_name: "津巴布韦",
      country_code: "ZW",
      phone_code: "+263",
    },
    {
      id: 118,
      country_name: "纳米比亚",
      country_code: "NA",
      phone_code: "+264",
    },
    {
      id: 122,
      country_name: "马拉维",
      country_code: "MW",
      phone_code: "+265",
    },
    {
      id: 144,
      country_name: "莱索托",
      country_code: "LS",
      phone_code: "+266",
    },
    {
      id: 42,
      country_name: "博茨瓦纳",
      country_code: "BW",
      phone_code: "+267",
    },
    {
      id: 78,
      country_name: "斯威士兰",
      country_code: "SZ",
      phone_code: "+268",
    },
    {
      id: 156,
      country_name: "科摩罗",
      country_code: "KM",
      phone_code: "+269",
    },
    {
      id: 175,
      country_name: "马约特",
      country_code: "YT",
      phone_code: "+269",
    },
    {
      id: 170,
      country_name: "南非",
      country_code: "ZA",
      phone_code: "+27",
    },
    {
      id: 13,
      country_name: "阿鲁巴",
      country_code: "AW",
      phone_code: "+297",
    },
    {
      id: 201,
      country_name: "法罗群岛",
      country_code: "FO",
      phone_code: "+298",
    },
    {
      id: 191,
      country_name: "格陵兰岛",
      country_code: "GL",
      phone_code: "+299",
    },
    {
      id: 186,
      country_name: "希腊",
      country_code: "GR",
      phone_code: "+30",
    },
    {
      id: 217,
      country_name: "荷兰",
      country_code: "NL",
      phone_code: "+31",
    },
    {
      id: 6,
      country_name: "比利时",
      country_code: "BE",
      phone_code: "+32",
    },
    {
      id: 200,
      country_name: "法国",
      country_code: "FR",
      phone_code: "+33",
    },
    {
      id: 94,
      country_name: "西班牙",
      country_code: "ES",
      phone_code: "+34",
    },
    {
      id: 192,
      country_name: "直布罗陀",
      country_code: "GI",
      phone_code: "+350",
    },
    {
      id: 31,
      country_name: "葡萄牙",
      country_code: "PT",
      phone_code: "+351",
    },
    {
      id: 142,
      country_name: "卢森堡",
      country_code: "LU",
      phone_code: "+352",
    },
    {
      id: 173,
      country_name: "爱尔兰",
      country_code: "IE",
      phone_code: "+353",
    },
    {
      id: 167,
      country_name: "冰岛",
      country_code: "IS",
      phone_code: "+354",
    },
    {
      id: 21,
      country_name: "阿尔巴尼亚",
      country_code: "AL",
      phone_code: "+355",
    },
    {
      id: 125,
      country_name: "马耳他",
      country_code: "MT",
      phone_code: "+356",
    },
    {
      id: 65,
      country_name: "塞浦路斯",
      country_code: "CY",
      phone_code: "+357",
    },
    {
      id: 225,
      country_name: "奥兰群岛",
      country_code: "AX",
      phone_code: "+358",
    },
    {
      id: 203,
      country_name: "芬兰",
      country_code: "FI",
      phone_code: "+358",
    },
    {
      id: 59,
      country_name: "保加利亚",
      country_code: "BG",
      phone_code: "+359",
    },
    {
      id: 176,
      country_name: "匈牙利",
      country_code: "HU",
      phone_code: "+36",
    },
    {
      id: 143,
      country_name: "立陶宛",
      country_code: "LT",
      phone_code: "+370",
    },
    {
      id: 141,
      country_name: "拉脱维亚",
      country_code: "LV",
      phone_code: "+371",
    },
    {
      id: 99,
      country_name: "爱沙尼亚",
      country_code: "EE",
      phone_code: "+372",
    },
    {
      id: 137,
      country_name: "摩尔多瓦",
      country_code: "MD",
      phone_code: "+373",
    },
    {
      id: 20,
      country_name: "亚美尼亚",
      country_code: "AM",
      phone_code: "+374",
    },
    {
      id: 40,
      country_name: "白俄罗斯",
      country_code: "BY",
      phone_code: "+375",
    },
    {
      id: 26,
      country_name: "安道尔",
      country_code: "AD",
      phone_code: "+376",
    },
    {
      id: 138,
      country_name: "摩纳哥",
      country_code: "MC",
      phone_code: "+377",
    },
    {
      id: 36,
      country_name: "圣马力诺",
      country_code: "SM",
      phone_code: "+378",
    },
    {
      id: 220,
      country_name: "梵蒂冈",
      country_code: "VA",
      phone_code: "+379",
    },
    {
      id: 103,
      country_name: "乌克兰",
      country_code: "UA",
      phone_code: "+380",
    },
    {
      id: 8,
      country_name: "塞尔维亚",
      country_code: "RS",
      phone_code: "+381",
    },
    {
      id: 136,
      country_name: "黑山",
      country_code: "ME",
      phone_code: "+382",
    },
    {
      id: 179,
      country_name: "克罗地亚",
      country_code: "HR",
      phone_code: "+385",
    },
    {
      id: 41,
      country_name: "斯洛文尼亚",
      country_code: "SI",
      phone_code: "+386",
    },
    {
      id: 10,
      country_name: "波斯尼亚和黑塞哥维那",
      country_code: "BA",
      phone_code: "+387",
    },
    {
      id: 134,
      country_name: "马其顿",
      country_code: "MK",
      phone_code: "+389",
    },
    {
      id: 166,
      country_name: "意大利",
      country_code: "IT",
      phone_code: "+39",
    },
    {
      id: 11,
      country_name: "罗马尼亚",
      country_code: "RO",
      phone_code: "+40",
    },
    {
      id: 81,
      country_name: "瑞士",
      country_code: "CH",
      phone_code: "+41",
    },
    {
      id: 63,
      country_name: "捷克",
      country_code: "CZ",
      phone_code: "+420",
    },
    {
      id: 38,
      country_name: "斯洛伐克",
      country_code: "SK",
      phone_code: "+421",
    },
    {
      id: 147,
      country_name: "列支敦士登",
      country_code: "LI",
      phone_code: "+423",
    },
    {
      id: 15,
      country_name: "奥地利",
      country_code: "AT",
      phone_code: "+43",
    },
    {
      id: 198,
      country_name: "英国",
      country_code: "GB",
      phone_code: "+44",
    },
    {
      id: 232,
      country_name: "根西岛",
      country_code: "GG",
      phone_code: "+44",
    },
    {
      id: 234,
      country_name: "马恩岛",
      country_code: "IM",
      phone_code: "+44",
    },
    {
      id: 233,
      country_name: "泽西岛",
      country_code: "JE",
      phone_code: "+44",
    },
    {
      id: 106,
      country_name: "丹麦",
      country_code: "DK",
      phone_code: "+45",
    },
    {
      id: 44,
      country_name: "瑞典",
      country_code: "SE",
      phone_code: "+46",
    },
    {
      id: 226,
      country_name: "布韦岛",
      country_code: "BV",
      phone_code: "+47",
    },
    {
      id: 216,
      country_name: "挪威",
      country_code: "NO",
      phone_code: "+47",
    },
    {
      id: 238,
      country_name: "斯瓦尔巴群岛",
      country_code: "SJ",
      phone_code: "+47",
    },
    {
      id: 206,
      country_name: "波兰",
      country_code: "PL",
      phone_code: "+48",
    },
    {
      id: 110,
      country_name: "德国",
      country_code: "DE",
      phone_code: "+49",
    },
    {
      id: 237,
      country_name: "南乔治亚岛",
      country_code: "GS",
      phone_code: "+500",
    },
    {
      id: 39,
      country_name: "伯利兹",
      country_code: "BZ",
      phone_code: "+501",
    },
    {
      id: 185,
      country_name: "瓜地马拉",
      country_code: "GT",
      phone_code: "+502",
    },
    {
      id: 84,
      country_name: "萨尔瓦多",
      country_code: "SV",
      phone_code: "+503",
    },
    {
      id: 180,
      country_name: "洪都拉斯",
      country_code: "HN",
      phone_code: "+504",
    },
    {
      id: 218,
      country_name: "尼加拉瓜",
      country_code: "NI",
      phone_code: "+505",
    },
    {
      id: 72,
      country_name: "哥斯达黎加",
      country_code: "CR",
      phone_code: "+506",
    },
    {
      id: 212,
      country_name: "巴拿马",
      country_code: "PA",
      phone_code: "+507",
    },
    {
      id: 205,
      country_name: "圣彼埃尔和密克隆岛",
      country_code: "PM",
      phone_code: "+508",
    },
    {
      id: 178,
      country_name: "海地",
      country_code: "HT",
      phone_code: "+509",
    },
    {
      id: 211,
      country_name: "秘鲁",
      country_code: "PE",
      phone_code: "+51",
    },
    {
      id: 121,
      country_name: "墨西哥",
      country_code: "MX",
      phone_code: "+52",
    },
    {
      id: 70,
      country_name: "古巴",
      country_code: "CU",
      phone_code: "+53",
    },
    {
      id: 18,
      country_name: "阿根廷",
      country_code: "AR",
      phone_code: "+54",
    },
    {
      id: 48,
      country_name: "巴西",
      country_code: "BR",
      phone_code: "+55",
    },
    {
      id: 76,
      country_name: "智利",
      country_code: "CL",
      phone_code: "+56",
    },
    {
      id: 74,
      country_name: "哥伦比亚",
      country_code: "CO",
      phone_code: "+57",
    },
    {
      id: 92,
      country_name: "委内瑞拉",
      country_code: "VE",
      phone_code: "+58",
    },
    {
      id: 188,
      country_name: "瓜德罗普岛",
      country_code: "GP",
      phone_code: "+590",
    },
    {
      id: 53,
      country_name: "玻利维亚",
      country_code: "BO",
      phone_code: "+591",
    },
    {
      id: 182,
      country_name: "圭亚那",
      country_code: "GY",
      phone_code: "+592",
    },
    {
      id: 100,
      country_name: "厄瓜多尔",
      country_code: "EC",
      phone_code: "+593",
    },
    {
      id: 194,
      country_name: "法属圭亚那",
      country_code: "GF",
      phone_code: "+594",
    },
    {
      id: 29,
      country_name: "巴拉圭",
      country_code: "PY",
      phone_code: "+595",
    },
    {
      id: 128,
      country_name: "马提尼克",
      country_code: "MQ",
      phone_code: "+596",
    },
    {
      id: 88,
      country_name: "苏里南",
      country_code: "SR",
      phone_code: "+597",
    },
    {
      id: 97,
      country_name: "乌拉圭",
      country_code: "UY",
      phone_code: "+598",
    },
    {
      id: 51,
      country_name: "博内尔岛，圣尤斯特歇斯和萨巴",
      country_code: "BQ",
      phone_code: "+599",
    },
    {
      id: 67,
      country_name: "库拉索",
      country_code: "CW",
      phone_code: "+599",
    },
    {
      id: 120,
      country_name: "马来西亚",
      country_code: "MY",
      phone_code: "+60",
    },
    {
      id: 14,
      country_name: "澳大利亚",
      country_code: "AU",
      phone_code: "+61",
    },
    {
      id: 227,
      country_name: "科科斯群岛",
      country_code: "CC",
      phone_code: "+61",
    },
    {
      id: 228,
      country_name: "圣诞岛",
      country_code: "CX",
      phone_code: "+61",
    },
    {
      id: 174,
      country_name: "印度尼西亚",
      country_code: "ID",
      phone_code: "+62",
    },
    {
      id: 208,
      country_name: "菲律宾",
      country_code: "PH",
      phone_code: "+63",
    },
    {
      id: 214,
      country_name: "新西兰",
      country_code: "NZ",
      phone_code: "+64",
    },
    {
      id: 236,
      country_name: "皮特凯恩群岛",
      country_code: "PN",
      phone_code: "+64",
    },
    {
      id: 43,
      country_name: "新加坡",
      country_code: "SG",
      phone_code: "+65",
    },
    {
      id: 66,
      country_name: "泰国",
      country_code: "TH",
      phone_code: "+66",
    },
    {
      id: 62,
      country_name: "东帝汶",
      country_code: "TL",
      phone_code: "+670",
    },
    {
      id: 229,
      country_name: "赫德岛和麦克唐纳群岛",
      country_code: "HM",
      phone_code: "+672",
    },
    {
      id: 235,
      country_name: "诺福克岛",
      country_code: "NF",
      phone_code: "+672",
    },
    {
      id: 54,
      country_name: "文莱",
      country_code: "BN",
      phone_code: "+673",
    },
    {
      id: 223,
      country_name: "瑙鲁",
      country_code: "NR",
      phone_code: "+674",
    },
    {
      id: 209,
      country_name: "巴布亚新几内亚",
      country_code: "PG",
      phone_code: "+675",
    },
    {
      id: 113,
      country_name: "汤加",
      country_code: "TO",
      phone_code: "+676",
    },
    {
      id: 50,
      country_name: "所罗门群岛",
      country_code: "SB",
      phone_code: "+677",
    },
    {
      id: 204,
      country_name: "瓦努阿图",
      country_code: "VU",
      phone_code: "+678",
    },
    {
      id: 202,
      country_name: "斐济",
      country_code: "FJ",
      phone_code: "+679",
    },
    {
      id: 30,
      country_name: "帕劳",
      country_code: "PW",
      phone_code: "+680",
    },
    {
      id: 77,
      country_name: "库克群岛",
      country_code: "CK",
      phone_code: "+682",
    },
    {
      id: 197,
      country_name: "萨摩亚",
      country_code: "WS",
      phone_code: "+685",
    },
    {
      id: 157,
      country_name: "基里巴斯",
      country_code: "KI",
      phone_code: "+686",
    },
    {
      id: 117,
      country_name: "新喀里多尼亚",
      country_code: "NC",
      phone_code: "+687",
    },
    {
      id: 224,
      country_name: "图瓦卢",
      country_code: "TV",
      phone_code: "+688",
    },
    {
      id: 210,
      country_name: "法属波利尼 西亚",
      country_code: "PF",
      phone_code: "+689",
    },
    {
      id: 222,
      country_name: "密克罗尼西亚",
      country_code: "FM",
      phone_code: "+691",
    },
    {
      id: 221,
      country_name: "马绍尔群岛",
      country_code: "MH",
      phone_code: "+692",
    },
    {
      id: 151,
      country_name: "哈萨克斯坦",
      country_code: "KZ",
      phone_code: "+7",
    },
    {
      id: 4,
      country_name: "俄罗斯",
      country_code: "RU",
      phone_code: "+7",
    },
    {
      id: 161,
      country_name: "日本",
      country_code: "JP",
      phone_code: "+81",
    },
    {
      id: 154,
      country_name: "韩国",
      country_code: "KR",
      phone_code: "+82",
    },
    {
      id: 89,
      country_name: "越南",
      country_code: "VN",
      phone_code: "+84",
    },
    {
      id: 181,
      country_name: "中国香港",
      country_code: "HK",
      phone_code: "+852",
    },
    {
      id: 130,
      country_name: "中国澳门",
      country_code: "MO",
      phone_code: "+853",
    },
    {
      id: 158,
      country_name: "柬埔寨",
      country_code: "KH",
      phone_code: "+855",
    },
    {
      id: 150,
      country_name: "老挝",
      country_code: "LA",
      phone_code: "+856",
    },
    {
      id: 219,
      country_name: "中国大陆",
      country_code: "CN",
      phone_code: "+86",
    },
    {
      id: 7,
      country_name: "孟加拉国",
      country_code: "BD",
      phone_code: "+880",
    },
    {
      id: 109,
      country_name: "中国台湾",
      country_code: "TW",
      phone_code: "+886",
    },
    {
      id: 112,
      country_name: "土耳其",
      country_code: "TR",
      phone_code: "+90",
    },
    {
      id: 171,
      country_name: "印度",
      country_code: "IN",
      phone_code: "+91",
    },
    {
      id: 207,
      country_name: "巴基斯坦",
      country_code: "PK",
      phone_code: "+92",
    },
    {
      id: 24,
      country_name: "阿富汗",
      country_code: "AF",
      phone_code: "+93",
    },
    {
      id: 146,
      country_name: "斯里兰卡",
      country_code: "LK",
      phone_code: "+94",
    },
    {
      id: 132,
      country_name: "缅甸",
      country_code: "MM",
      phone_code: "+95",
    },
    {
      id: 123,
      country_name: "马尔代夫",
      country_code: "MV",
      phone_code: "+960",
    },
    {
      id: 149,
      country_name: "黎巴嫩",
      country_code: "LB",
      phone_code: "+961",
    },
    {
      id: 162,
      country_name: "约旦",
      country_code: "JO",
      phone_code: "+962",
    },
    {
      id: 79,
      country_name: "叙利亚",
      country_code: "SY",
      phone_code: "+963",
    },
    {
      id: 169,
      country_name: "伊拉克",
      country_code: "IQ",
      phone_code: "+964",
    },
    {
      id: 153,
      country_name: "科威特",
      country_code: "KW",
      phone_code: "+965",
    },
    {
      id: 52,
      country_name: "沙特阿拉伯",
      country_code: "SA",
      phone_code: "+966",
    },
    {
      id: 177,
      country_name: "也门",
      country_code: "YE",
      phone_code: "+967",
    },
    {
      id: 213,
      country_name: "阿曼",
      country_code: "OM",
      phone_code: "+968",
    },
    {
      id: 32,
      country_name: "巴勒斯坦领土",
      country_code: "PS",
      phone_code: "+970",
    },
    {
      id: 25,
      country_name: "阿拉伯联合酋长国",
      country_code: "AE",
      phone_code: "+971",
    },
    {
      id: 172,
      country_name: "以色列",
      country_code: "IL",
      phone_code: "+972",
    },
    {
      id: 58,
      country_name: "巴林",
      country_code: "BH",
      phone_code: "+973",
    },
    {
      id: 28,
      country_name: "卡塔尔",
      country_code: "QA",
      phone_code: "+974",
    },
    {
      id: 45,
      country_name: "不丹",
      country_code: "BT",
      phone_code: "+975",
    },
    {
      id: 131,
      country_name: "蒙古",
      country_code: "MN",
      phone_code: "+976",
    },
    {
      id: 215,
      country_name: "尼泊尔",
      country_code: "NP",
      phone_code: "+977",
    },
    {
      id: 168,
      country_name: "伊朗",
      country_code: "IR",
      phone_code: "+98",
    },
    {
      id: 64,
      country_name: "塔吉克斯坦",
      country_code: "TJ",
      phone_code: "+992",
    },
    {
      id: 115,
      country_name: "土库曼斯坦",
      country_code: "TM",
      phone_code: "+993",
    },
    {
      id: 12,
      country_name: "阿塞拜疆",
      country_code: "AZ",
      phone_code: "+994",
    },
    {
      id: 195,
      country_name: "格鲁吉亚",
      country_code: "GE",
      phone_code: "+995",
    },
    {
      id: 159,
      country_name: "吉尔吉斯斯坦",
      country_code: "KG",
      phone_code: "+996",
    },
    {
      id: 96,
      country_name: "乌兹别克斯坦",
      country_code: "UZ",
      phone_code: "+998",
    },
  ],
  zh_TW: [
    {
      id: 2,
      country_name: "加拿大",
      country_code: "CA",
      phone_code: "+1",
    },
    {
      id: 239,
      country_name: "美國本土外小島嶼",
      country_code: "UM",
      phone_code: "+1",
    },
    {
      id: 5,
      country_name: "美國",
      country_code: "US",
      phone_code: "+1",
    },
    {
      id: 47,
      country_name: "巴哈馬",
      country_code: "BS",
      phone_code: "+1242",
    },
    {
      id: 9,
      country_name: "巴巴多斯",
      country_code: "BB",
      phone_code: "+1246",
    },
    {
      id: 22,
      country_name: "安圭拉",
      country_code: "AI",
      phone_code: "+1264",
    },
    {
      id: 23,
      country_name: "安提瓜 和巴布達",
      country_code: "AG",
      phone_code: "+1268",
    },
    {
      id: 90,
      country_name: "美屬維爾京群島",
      country_code: "VI",
      phone_code: "+1284",
    },
    {
      id: 91,
      country_name: "英屬處女群島",
      country_code: "VG",
      phone_code: "+1340",
    },
    {
      id: 152,
      country_name: "開曼群島",
      country_code: "KY",
      phone_code: "+1345",
    },
    {
      id: 55,
      country_name: "百慕大群島",
      country_code: "BM",
      phone_code: "+1441",
    },
    {
      id: 196,
      country_name: "格林納達",
      country_code: "GD",
      phone_code: "+1473",
    },
    {
      id: 73,
      country_name: "特克斯和凱科斯群島",
      country_code: "TC",
      phone_code: "+1649",
    },
    {
      id: 126,
      country_name: "蒙特塞拉特島",
      country_code: "MS",
      phone_code: "+1664",
    },
    {
      id: 129,
      country_name: "馬里亞那群島",
      country_code: "MP",
      phone_code: "+1670",
    },
    {
      id: 184,
      country_name: "關島",
      country_code: "GU",
      phone_code: "+1671",
    },
    {
      id: 17,
      country_name: "美屬薩摩亞",
      country_code: "AS",
      phone_code: "+1684",
    },
    {
      id: 82,
      country_name: "聖馬丁島（荷蘭部分）",
      country_code: "SX",
      phone_code: "+1721",
    },
    {
      id: 148,
      country_name: "聖露西亞",
      country_code: "LC",
      phone_code: "+1758",
    },
    {
      id: 105,
      country_name: "多米尼加",
      country_code: "DM",
      phone_code: "+1767",
    },
    {
      id: 95,
      country_name: "聖文森特和格林納丁斯",
      country_code: "VC",
      phone_code: "+1784",
    },
    {
      id: 33,
      country_name: "波多黎各",
      country_code: "PR",
      phone_code: "+1787",
    },
    {
      id: 104,
      country_name: "多明尼加共和國",
      country_code: "DO",
      phone_code: "+1809",
    },
    {
      id: 111,
      country_name: "特立尼達和多巴哥",
      country_code: "TT",
      phone_code: "+1868",
    },
    {
      id: 155,
      country_name: "聖基茨和尼維斯",
      country_code: "KN",
      phone_code: "+1869",
    },
    {
      id: 163,
      country_name: "牙買加",
      country_code: "JM",
      phone_code: "+1876",
    },
    {
      id: 98,
      country_name: "埃及",
      country_code: "EG",
      phone_code: "+20",
    },
    {
      id: 87,
      country_name: "南蘇丹",
      country_code: "SS",
      phone_code: "+211",
    },
    {
      id: 139,
      country_name: "摩洛哥",
      country_code: "MA",
      phone_code: "+212",
    },
    {
      id: 101,
      country_name: "阿爾及利亞",
      country_code: "DZ",
      phone_code: "+213",
    },
    {
      id: 114,
      country_name: "突尼斯",
      country_code: "TN",
      phone_code: "+216",
    },
    {
      id: 140,
      country_name: "利比亞",
      country_code: "LY",
      phone_code: "+218",
    },
    {
      id: 190,
      country_name: "岡比亞",
      country_code: "GM",
      phone_code: "+220",
    },
    {
      id: 35,
      country_name: "塞內加爾",
      country_code: "SN",
      phone_code: "+221",
    },
    {
      id: 127,
      country_name: "毛里塔尼亞",
      country_code: "MR",
      phone_code: "+222",
    },
    {
      id: 133,
      country_name: "馬里",
      country_code: "ML",
      phone_code: "+223",
    },
    {
      id: 189,
      country_name: "幾內亞",
      country_code: "GN",
      phone_code: "+224",
    },
    {
      id: 80,
      country_name: "科特迪瓦",
      country_code: "CI",
      phone_code: "+225",
    },
    {
      id: 61,
      country_name: "布基納法索",
      country_code: "BF",
      phone_code: "+226",
    },
    {
      id: 116,
      country_name: "尼日爾",
      country_code: "NE",
      phone_code: "+227",
    },
    {
      id: 68,
      country_name: "多哥",
      country_code: "TG",
      phone_code: "+228",
    },
    {
      id: 56,
      country_name: "貝寧",
      country_code: "BJ",
      phone_code: "+229",
    },
    {
      id: 124,
      country_name: "毛里求斯",
      country_code: "MU",
      phone_code: "+230",
    },
    {
      id: 145,
      country_name: "利比里亞",
      country_code: "LR",
      phone_code: "+231",
    },
    {
      id: 37,
      country_name: "塞拉利昂",
      country_code: "SL",
      phone_code: "+232",
    },
    {
      id: 193,
      country_name: "加納",
      country_code: "GH",
      phone_code: "+233",
    },
    {
      id: 1,
      country_name: "尼日利亞",
      country_code: "NG",
      phone_code: "+234",
    },
    {
      id: 71,
      country_name: "乍得",
      country_code: "TD",
      phone_code: "+235",
    },
    {
      id: 85,
      country_name: "中非共和國",
      country_code: "CF",
      phone_code: "+236",
    },
    {
      id: 75,
      country_name: "喀麥隆",
      country_code: "CM",
      phone_code: "+237",
    },
    {
      id: 69,
      country_name: "開普",
      country_code: "CV",
      phone_code: "+238",
    },
    {
      id: 86,
      country_name: "聖多美和普林西比",
      country_code: "ST",
      phone_code: "+239",
    },
    {
      id: 187,
      country_name: "赤道幾內亞",
      country_code: "GQ",
      phone_code: "+240",
    },
    {
      id: 199,
      country_name: "加蓬",
      country_code: "GA",
      phone_code: "+241",
    },
    {
      id: 83,
      country_name: "剛果共和國",
      country_code: "CG",
      phone_code: "+242",
    },
    {
      id: 3,
      country_name: "剛果民主共和國",
      country_code: "CD",
      phone_code: "+243",
    },
    {
      id: 19,
      country_name: "安哥拉",
      country_code: "AO",
      phone_code: "+244",
    },
    {
      id: 183,
      country_name: "幾內亞比紹共和國",
      country_code: "GW",
      phone_code: "+245",
    },
    {
      id: 230,
      country_name: "英屬印度洋領地",
      country_code: "IO",
      phone_code: "+246",
    },
    {
      id: 27,
      country_name: "阿森松島",
      country_code: "AC",
      phone_code: "+247",
    },
    {
      id: 49,
      country_name: "塞舌爾",
      country_code: "SC",
      phone_code: "+248",
    },
    {
      id: 46,
      country_name: "蘇丹",
      country_code: "SD",
      phone_code: "+249",
    },
    {
      id: 60,
      country_name: "盧旺達",
      country_code: "RW",
      phone_code: "+250",
    },
    {
      id: 93,
      country_name: "埃塞俄比亞",
      country_code: "ET",
      phone_code: "+251",
    },
    {
      id: 34,
      country_name: "索馬里",
      country_code: "SO",
      phone_code: "+252",
    },
    {
      id: 108,
      country_name: "吉布提",
      country_code: "DJ",
      phone_code: "+253",
    },
    {
      id: 160,
      country_name: "肯尼亞",
      country_code: "KE",
      phone_code: "+254",
    },
    {
      id: 107,
      country_name: "坦桑尼亞",
      country_code: "TZ",
      phone_code: "+255",
    },
    {
      id: 102,
      country_name: "烏干達",
      country_code: "UG",
      phone_code: "+256",
    },
    {
      id: 57,
      country_name: "布隆迪",
      country_code: "BI",
      phone_code: "+257",
    },
    {
      id: 119,
      country_name: "莫桑比克",
      country_code: "MZ",
      phone_code: "+258",
    },
    {
      id: 165,
      country_name: "贊比亞",
      country_code: "ZM",
      phone_code: "+260",
    },
    {
      id: 135,
      country_name: "馬達加斯加",
      country_code: "MG",
      phone_code: "+261",
    },
    {
      id: 16,
      country_name: "留尼汪",
      country_code: "RE",
      phone_code: "+262",
    },
    {
      id: 231,
      country_name: "法屬南部領地",
      country_code: "TF",
      phone_code: "+262",
    },
    {
      id: 164,
      country_name: "津巴布韋",
      country_code: "ZW",
      phone_code: "+263",
    },
    {
      id: 118,
      country_name: "納米比亞",
      country_code: "NA",
      phone_code: "+264",
    },
    {
      id: 122,
      country_name: "馬拉維",
      country_code: "MW",
      phone_code: "+265",
    },
    {
      id: 144,
      country_name: "萊索托",
      country_code: "LS",
      phone_code: "+266",
    },
    {
      id: 42,
      country_name: "博茨瓦納",
      country_code: "BW",
      phone_code: "+267",
    },
    {
      id: 78,
      country_name: "斯威士蘭",
      country_code: "SZ",
      phone_code: "+268",
    },
    {
      id: 156,
      country_name: "科摩羅",
      country_code: "KM",
      phone_code: "+269",
    },
    {
      id: 175,
      country_name: "馬約特",
      country_code: "YT",
      phone_code: "+269",
    },
    {
      id: 170,
      country_name: "南非",
      country_code: "ZA",
      phone_code: "+27",
    },
    {
      id: 13,
      country_name: "阿魯巴",
      country_code: "AW",
      phone_code: "+297",
    },
    {
      id: 201,
      country_name: "法羅群島",
      country_code: "FO",
      phone_code: "+298",
    },
    {
      id: 191,
      country_name: "格陵蘭島",
      country_code: "GL",
      phone_code: "+299",
    },
    {
      id: 186,
      country_name: "希臘",
      country_code: "GR",
      phone_code: "+30",
    },
    {
      id: 217,
      country_name: "荷蘭",
      country_code: "NL",
      phone_code: "+31",
    },
    {
      id: 6,
      country_name: "比利時",
      country_code: "BE",
      phone_code: "+32",
    },
    {
      id: 200,
      country_name: "法國",
      country_code: "FR",
      phone_code: "+33",
    },
    {
      id: 94,
      country_name: "西班牙",
      country_code: "ES",
      phone_code: "+34",
    },
    {
      id: 192,
      country_name: "直布羅陀",
      country_code: "GI",
      phone_code: "+350",
    },
    {
      id: 31,
      country_name: "葡萄牙",
      country_code: "PT",
      phone_code: "+351",
    },
    {
      id: 142,
      country_name: "盧森堡",
      country_code: "LU",
      phone_code: "+352",
    },
    {
      id: 173,
      country_name: "愛爾蘭",
      country_code: "IE",
      phone_code: "+353",
    },
    {
      id: 167,
      country_name: "冰島",
      country_code: "IS",
      phone_code: "+354",
    },
    {
      id: 21,
      country_name: "阿爾巴尼亞",
      country_code: "AL",
      phone_code: "+355",
    },
    {
      id: 125,
      country_name: "馬耳他",
      country_code: "MT",
      phone_code: "+356",
    },
    {
      id: 65,
      country_name: "塞浦路斯",
      country_code: "CY",
      phone_code: "+357",
    },
    {
      id: 225,
      country_name: "奧蘭群島",
      country_code: "AX",
      phone_code: "+358",
    },
    {
      id: 203,
      country_name: "芬蘭",
      country_code: "FI",
      phone_code: "+358",
    },
    {
      id: 59,
      country_name: "保加利亞",
      country_code: "BG",
      phone_code: "+359",
    },
    {
      id: 176,
      country_name: "匈牙利",
      country_code: "HU",
      phone_code: "+36",
    },
    {
      id: 143,
      country_name: "立陶宛",
      country_code: "LT",
      phone_code: "+370",
    },
    {
      id: 141,
      country_name: "拉脫維亞",
      country_code: "LV",
      phone_code: "+371",
    },
    {
      id: 99,
      country_name: "愛沙尼亞",
      country_code: "EE",
      phone_code: "+372",
    },
    {
      id: 137,
      country_name: "摩爾多瓦",
      country_code: "MD",
      phone_code: "+373",
    },
    {
      id: 20,
      country_name: "亞美尼亞",
      country_code: "AM",
      phone_code: "+374",
    },
    {
      id: 40,
      country_name: "白俄羅斯",
      country_code: "BY",
      phone_code: "+375",
    },
    {
      id: 26,
      country_name: "安道爾",
      country_code: "AD",
      phone_code: "+376",
    },
    {
      id: 138,
      country_name: "摩納哥",
      country_code: "MC",
      phone_code: "+377",
    },
    {
      id: 36,
      country_name: "聖馬力諾",
      country_code: "SM",
      phone_code: "+378",
    },
    {
      id: 220,
      country_name: "梵蒂岡",
      country_code: "VA",
      phone_code: "+379",
    },
    {
      id: 103,
      country_name: "烏克蘭",
      country_code: "UA",
      phone_code: "+380",
    },
    {
      id: 8,
      country_name: "塞爾維亞",
      country_code: "RS",
      phone_code: "+381",
    },
    {
      id: 136,
      country_name: "黑山",
      country_code: "ME",
      phone_code: "+382",
    },
    {
      id: 179,
      country_name: "克羅地亞",
      country_code: "HR",
      phone_code: "+385",
    },
    {
      id: 41,
      country_name: "斯洛文尼亞",
      country_code: "SI",
      phone_code: "+386",
    },
    {
      id: 10,
      country_name: "波斯尼亞和黑塞哥維那",
      country_code: "BA",
      phone_code: "+387",
    },
    {
      id: 134,
      country_name: "馬其頓",
      country_code: "MK",
      phone_code: "+389",
    },
    {
      id: 166,
      country_name: "意大利",
      country_code: "IT",
      phone_code: "+39",
    },
    {
      id: 11,
      country_name: "羅馬尼亞",
      country_code: "RO",
      phone_code: "+40",
    },
    {
      id: 81,
      country_name: "瑞士",
      country_code: "CH",
      phone_code: "+41",
    },
    {
      id: 63,
      country_name: "捷克",
      country_code: "CZ",
      phone_code: "+420",
    },
    {
      id: 38,
      country_name: "斯洛伐克",
      country_code: "SK",
      phone_code: "+421",
    },
    {
      id: 147,
      country_name: "列支敦士登",
      country_code: "LI",
      phone_code: "+423",
    },
    {
      id: 15,
      country_name: "奧地利",
      country_code: "AT",
      phone_code: "+43",
    },
    {
      id: 198,
      country_name: "英國",
      country_code: "GB",
      phone_code: "+44",
    },
    {
      id: 232,
      country_name: "根西島",
      country_code: "GG",
      phone_code: "+44",
    },
    {
      id: 234,
      country_name: "馬恩島",
      country_code: "IM",
      phone_code: "+44",
    },
    {
      id: 233,
      country_name: "澤西島",
      country_code: "JE",
      phone_code: "+44",
    },
    {
      id: 106,
      country_name: "丹麥",
      country_code: "DK",
      phone_code: "+45",
    },
    {
      id: 44,
      country_name: "瑞典",
      country_code: "SE",
      phone_code: "+46",
    },
    {
      id: 226,
      country_name: "布韋島",
      country_code: "BV",
      phone_code: "+47",
    },
    {
      id: 216,
      country_name: "挪威",
      country_code: "NO",
      phone_code: "+47",
    },
    {
      id: 238,
      country_name: "斯瓦爾巴群島",
      country_code: "SJ",
      phone_code: "+47",
    },
    {
      id: 206,
      country_name: "波蘭",
      country_code: "PL",
      phone_code: "+48",
    },
    {
      id: 110,
      country_name: "德國",
      country_code: "DE",
      phone_code: "+49",
    },
    {
      id: 237,
      country_name: "南喬治亞島",
      country_code: "GS",
      phone_code: "+500",
    },
    {
      id: 39,
      country_name: "伯利茲",
      country_code: "BZ",
      phone_code: "+501",
    },
    {
      id: 185,
      country_name: "瓜地馬拉",
      country_code: "GT",
      phone_code: "+502",
    },
    {
      id: 84,
      country_name: "薩爾瓦多",
      country_code: "SV",
      phone_code: "+503",
    },
    {
      id: 180,
      country_name: "洪都拉斯",
      country_code: "HN",
      phone_code: "+504",
    },
    {
      id: 218,
      country_name: "尼加拉瓜",
      country_code: "NI",
      phone_code: "+505",
    },
    {
      id: 72,
      country_name: "哥斯達黎加",
      country_code: "CR",
      phone_code: "+506",
    },
    {
      id: 212,
      country_name: "巴拿馬",
      country_code: "PA",
      phone_code: "+507",
    },
    {
      id: 205,
      country_name: "聖彼埃爾和密克隆島",
      country_code: "PM",
      phone_code: "+508",
    },
    {
      id: 178,
      country_name: "海地",
      country_code: "HT",
      phone_code: "+509",
    },
    {
      id: 211,
      country_name: "秘魯",
      country_code: "PE",
      phone_code: "+51",
    },
    {
      id: 121,
      country_name: "墨西哥",
      country_code: "MX",
      phone_code: "+52",
    },
    {
      id: 70,
      country_name: "古巴",
      country_code: "CU",
      phone_code: "+53",
    },
    {
      id: 18,
      country_name: "阿根廷",
      country_code: "AR",
      phone_code: "+54",
    },
    {
      id: 48,
      country_name: "巴西",
      country_code: "BR",
      phone_code: "+55",
    },
    {
      id: 76,
      country_name: "智利",
      country_code: "CL",
      phone_code: "+56",
    },
    {
      id: 74,
      country_name: "哥倫比亞",
      country_code: "CO",
      phone_code: "+57",
    },
    {
      id: 92,
      country_name: "委內瑞拉",
      country_code: "VE",
      phone_code: "+58",
    },
    {
      id: 188,
      country_name: "瓜德羅普島",
      country_code: "GP",
      phone_code: "+590",
    },
    {
      id: 53,
      country_name: "玻利維亞",
      country_code: "BO",
      phone_code: "+591",
    },
    {
      id: 182,
      country_name: "圭亞那",
      country_code: "GY",
      phone_code: "+592",
    },
    {
      id: 100,
      country_name: "厄瓜多爾",
      country_code: "EC",
      phone_code: "+593",
    },
    {
      id: 194,
      country_name: "法屬圭亞那",
      country_code: "GF",
      phone_code: "+594",
    },
    {
      id: 29,
      country_name: "巴拉圭",
      country_code: "PY",
      phone_code: "+595",
    },
    {
      id: 128,
      country_name: "馬提尼克",
      country_code: "MQ",
      phone_code: "+596",
    },
    {
      id: 88,
      country_name: "蘇里南",
      country_code: "SR",
      phone_code: "+597",
    },
    {
      id: 97,
      country_name: "烏拉圭",
      country_code: "UY",
      phone_code: "+598",
    },
    {
      id: 51,
      country_name: "博內爾島，聖尤斯特歇斯和薩巴",
      country_code: "BQ",
      phone_code: "+599",
    },
    {
      id: 67,
      country_name: "庫拉索",
      country_code: "CW",
      phone_code: "+599",
    },
    {
      id: 120,
      country_name: "馬來西亞",
      country_code: "MY",
      phone_code: "+60",
    },
    {
      id: 14,
      country_name: "澳大利亞",
      country_code: "AU",
      phone_code: "+61",
    },
    {
      id: 227,
      country_name: "科科斯群島",
      country_code: "CC",
      phone_code: "+61",
    },
    {
      id: 228,
      country_name: "聖誕島",
      country_code: "CX",
      phone_code: "+61",
    },
    {
      id: 174,
      country_name: "印度尼西亞",
      country_code: "ID",
      phone_code: "+62",
    },
    {
      id: 208,
      country_name: "菲律賓",
      country_code: "PH",
      phone_code: "+63",
    },
    {
      id: 214,
      country_name: "新西蘭",
      country_code: "NZ",
      phone_code: "+64",
    },
    {
      id: 236,
      country_name: "皮特凱恩群島",
      country_code: "PN",
      phone_code: "+64",
    },
    {
      id: 43,
      country_name: "新加坡",
      country_code: "SG",
      phone_code: "+65",
    },
    {
      id: 66,
      country_name: "泰國",
      country_code: "TH",
      phone_code: "+66",
    },
    {
      id: 62,
      country_name: "東帝汶",
      country_code: "TL",
      phone_code: "+670",
    },
    {
      id: 229,
      country_name: "赫德島和麥克唐納群島",
      country_code: "HM",
      phone_code: "+672",
    },
    {
      id: 235,
      country_name: "諾福克島",
      country_code: "NF",
      phone_code: "+672",
    },
    {
      id: 54,
      country_name: "文萊",
      country_code: "BN",
      phone_code: "+673",
    },
    {
      id: 223,
      country_name: "諾魯",
      country_code: "NR",
      phone_code: "+674",
    },
    {
      id: 209,
      country_name: "巴布亞新幾內亞",
      country_code: "PG",
      phone_code: "+675",
    },
    {
      id: 113,
      country_name: "湯加",
      country_code: "TO",
      phone_code: "+676",
    },
    {
      id: 50,
      country_name: "所羅門群島",
      country_code: "SB",
      phone_code: "+677",
    },
    {
      id: 204,
      country_name: "瓦努阿圖",
      country_code: "VU",
      phone_code: "+678",
    },
    {
      id: 202,
      country_name: "斐濟",
      country_code: "FJ",
      phone_code: "+679",
    },
    {
      id: 30,
      country_name: "帕勞",
      country_code: "PW",
      phone_code: "+680",
    },
    {
      id: 77,
      country_name: "庫克群島",
      country_code: "CK",
      phone_code: "+682",
    },
    {
      id: 197,
      country_name: "薩摩亞",
      country_code: "WS",
      phone_code: "+685",
    },
    {
      id: 157,
      country_name: "基里巴斯",
      country_code: "KI",
      phone_code: "+686",
    },
    {
      id: 117,
      country_name: "新喀裡多尼亞",
      country_code: "NC",
      phone_code: "+687",
    },
    {
      id: 224,
      country_name: "吐瓦魯",
      country_code: "TV",
      phone_code: "+688",
    },
    {
      id: 210,
      country_name: "法屬波利尼 西亞",
      country_code: "PF",
      phone_code: "+689",
    },
    {
      id: 222,
      country_name: "密克羅尼西亞",
      country_code: "FM",
      phone_code: "+691",
    },
    {
      id: 221,
      country_name: "馬紹爾群島",
      country_code: "MH",
      phone_code: "+692",
    },
    {
      id: 151,
      country_name: "哈薩克斯坦",
      country_code: "KZ",
      phone_code: "+7",
    },
    {
      id: 4,
      country_name: "俄羅斯",
      country_code: "RU",
      phone_code: "+7",
    },
    {
      id: 161,
      country_name: "日本",
      country_code: "JP",
      phone_code: "+81",
    },
    {
      id: 154,
      country_name: "韓國",
      country_code: "KR",
      phone_code: "+82",
    },
    {
      id: 89,
      country_name: "越南",
      country_code: "VN",
      phone_code: "+84",
    },
    {
      id: 181,
      country_name: "中國香港",
      country_code: "HK",
      phone_code: "+852",
    },
    {
      id: 130,
      country_name: "中國澳門",
      country_code: "MO",
      phone_code: "+853",
    },
    {
      id: 158,
      country_name: "柬埔寨",
      country_code: "KH",
      phone_code: "+855",
    },
    {
      id: 150,
      country_name: "老撾",
      country_code: "LA",
      phone_code: "+856",
    },
    {
      id: 219,
      country_name: "中國大陸",
      country_code: "CN",
      phone_code: "+86",
    },
    {
      id: 7,
      country_name: "孟加拉國",
      country_code: "BD",
      phone_code: "+880",
    },
    {
      id: 109,
      country_name: "中國台灣",
      country_code: "TW",
      phone_code: "+886",
    },
    {
      id: 112,
      country_name: "土耳其",
      country_code: "TR",
      phone_code: "+90",
    },
    {
      id: 171,
      country_name: "印度",
      country_code: "IN",
      phone_code: "+91",
    },
    {
      id: 207,
      country_name: "巴基斯坦",
      country_code: "PK",
      phone_code: "+92",
    },
    {
      id: 24,
      country_name: "阿富汗",
      country_code: "AF",
      phone_code: "+93",
    },
    {
      id: 146,
      country_name: "斯里蘭卡",
      country_code: "LK",
      phone_code: "+94",
    },
    {
      id: 132,
      country_name: "緬甸",
      country_code: "MM",
      phone_code: "+95",
    },
    {
      id: 123,
      country_name: "馬爾代夫",
      country_code: "MV",
      phone_code: "+960",
    },
    {
      id: 149,
      country_name: "黎巴嫩",
      country_code: "LB",
      phone_code: "+961",
    },
    {
      id: 162,
      country_name: "約旦",
      country_code: "JO",
      phone_code: "+962",
    },
    {
      id: 79,
      country_name: "敘利亞",
      country_code: "SY",
      phone_code: "+963",
    },
    {
      id: 169,
      country_name: "伊拉克",
      country_code: "IQ",
      phone_code: "+964",
    },
    {
      id: 153,
      country_name: "科威特",
      country_code: "KW",
      phone_code: "+965",
    },
    {
      id: 52,
      country_name: "沙特阿拉伯",
      country_code: "SA",
      phone_code: "+966",
    },
    {
      id: 177,
      country_name: "也門",
      country_code: "YE",
      phone_code: "+967",
    },
    {
      id: 213,
      country_name: "阿曼",
      country_code: "OM",
      phone_code: "+968",
    },
    {
      id: 32,
      country_name: "巴勒斯坦領土",
      country_code: "PS",
      phone_code: "+970",
    },
    {
      id: 25,
      country_name: "阿拉伯聯合酋長國",
      country_code: "AE",
      phone_code: "+971",
    },
    {
      id: 172,
      country_name: "以色列",
      country_code: "IL",
      phone_code: "+972",
    },
    {
      id: 58,
      country_name: "巴林",
      country_code: "BH",
      phone_code: "+973",
    },
    {
      id: 28,
      country_name: "卡塔爾",
      country_code: "QA",
      phone_code: "+974",
    },
    {
      id: 45,
      country_name: "不丹",
      country_code: "BT",
      phone_code: "+975",
    },
    {
      id: 131,
      country_name: "蒙古",
      country_code: "MN",
      phone_code: "+976",
    },
    {
      id: 215,
      country_name: "尼泊爾",
      country_code: "NP",
      phone_code: "+977",
    },
    {
      id: 168,
      country_name: "伊朗",
      country_code: "IR",
      phone_code: "+98",
    },
    {
      id: 64,
      country_name: "塔吉克斯坦",
      country_code: "TJ",
      phone_code: "+992",
    },
    {
      id: 115,
      country_name: "土庫曼斯坦",
      country_code: "TM",
      phone_code: "+993",
    },
    {
      id: 12,
      country_name: "阿塞拜疆",
      country_code: "AZ",
      phone_code: "+994",
    },
    {
      id: 195,
      country_name: "格魯吉亞",
      country_code: "GE",
      phone_code: "+995",
    },
    {
      id: 159,
      country_name: "吉爾吉斯斯坦",
      country_code: "KG",
      phone_code: "+996",
    },
    {
      id: 96,
      country_name: "烏茲別克斯坦",
      country_code: "UZ",
      phone_code: "+998",
    },
  ],
  en_GB: [
    {
      id: 2,
      country_name: "Canada",
      country_code: "CA",
      phone_code: "+1",
    },
    {
      id: 239,
      country_name: "United States Minor Outlying Islands",
      country_code: "UM",
      phone_code: "+1",
    },
    {
      id: 5,
      country_name: "U.S.",
      country_code: "US",
      phone_code: "+1",
    },
    {
      id: 47,
      country_name: "Bahamas",
      country_code: "BS",
      phone_code: "+1242",
    },
    {
      id: 9,
      country_name: "Barbados",
      country_code: "BB",
      phone_code: "+1246",
    },
    {
      id: 22,
      country_name: "Anguilla",
      country_code: "AI",
      phone_code: "+1264",
    },
    {
      id: 23,
      country_name: "Antigua and Barbuda",
      country_code: "AG",
      phone_code: "+1268",
    },
    {
      id: 90,
      country_name: "United States Virgin Islands",
      country_code: "VI",
      phone_code: "+1284",
    },
    {
      id: 91,
      country_name: "British Virgin Islands",
      country_code: "VG",
      phone_code: "+1340",
    },
    {
      id: 152,
      country_name: "Cayman Islands",
      country_code: "KY",
      phone_code: "+1345",
    },
    {
      id: 55,
      country_name: "Bermuda",
      country_code: "BM",
      phone_code: "+1441",
    },
    {
      id: 196,
      country_name: "Grenada",
      country_code: "GD",
      phone_code: "+1473",
    },
    {
      id: 73,
      country_name: "Turks and Caicos Islands",
      country_code: "TC",
      phone_code: "+1649",
    },
    {
      id: 126,
      country_name: "Montserrat",
      country_code: "MS",
      phone_code: "+1664",
    },
    {
      id: 129,
      country_name: "Mariana Islands",
      country_code: "MP",
      phone_code: "+1670",
    },
    {
      id: 184,
      country_name: "Guam",
      country_code: "GU",
      phone_code: "+1671",
    },
    {
      id: 17,
      country_name: "American Samoa",
      country_code: "AS",
      phone_code: "+1684",
    },
    {
      id: 82,
      country_name: "St. Maarten (Dutch part)",
      country_code: "SX",
      phone_code: "+1721",
    },
    {
      id: 148,
      country_name: "St Lucia",
      country_code: "LC",
      phone_code: "+1758",
    },
    {
      id: 105,
      country_name: "Dominica",
      country_code: "DM",
      phone_code: "+1767",
    },
    {
      id: 95,
      country_name: "Saint Vincent and the Grenadines",
      country_code: "VC",
      phone_code: "+1784",
    },
    {
      id: 33,
      country_name: "Puerto Rico",
      country_code: "PR",
      phone_code: "+1787",
    },
    {
      id: 104,
      country_name: "Dominican Republic",
      country_code: "DO",
      phone_code: "+1809",
    },
    {
      id: 111,
      country_name: "Trinidad and Tobago",
      country_code: "TT",
      phone_code: "+1868",
    },
    {
      id: 155,
      country_name: "Saint Kitts and Nevis",
      country_code: "KN",
      phone_code: "+1869",
    },
    {
      id: 163,
      country_name: "Jamaica",
      country_code: "JM",
      phone_code: "+1876",
    },
    {
      id: 98,
      country_name: "Egypt",
      country_code: "EG",
      phone_code: "+20",
    },
    {
      id: 87,
      country_name: "South Sudan",
      country_code: "SS",
      phone_code: "+211",
    },
    {
      id: 139,
      country_name: "Morocco",
      country_code: "MA",
      phone_code: "+212",
    },
    {
      id: 101,
      country_name: "Algeria",
      country_code: "DZ",
      phone_code: "+213",
    },
    {
      id: 114,
      country_name: "Tunisia",
      country_code: "TN",
      phone_code: "+216",
    },
    {
      id: 140,
      country_name: "Libya",
      country_code: "LY",
      phone_code: "+218",
    },
    {
      id: 190,
      country_name: "Gambia",
      country_code: "GM",
      phone_code: "+220",
    },
    {
      id: 35,
      country_name: "Senegal",
      country_code: "SN",
      phone_code: "+221",
    },
    {
      id: 127,
      country_name: "Mauritania",
      country_code: "MR",
      phone_code: "+222",
    },
    {
      id: 133,
      country_name: "Mali",
      country_code: "ML",
      phone_code: "+223",
    },
    {
      id: 189,
      country_name: "Guinea",
      country_code: "GN",
      phone_code: "+224",
    },
    {
      id: 80,
      country_name: "Côte d'Ivoire",
      country_code: "CI",
      phone_code: "+225",
    },
    {
      id: 61,
      country_name: "Burkina Faso",
      country_code: "BF",
      phone_code: "+226",
    },
    {
      id: 116,
      country_name: "Niger",
      country_code: "NE",
      phone_code: "+227",
    },
    {
      id: 68,
      country_name: "Togo",
      country_code: "TG",
      phone_code: "+228",
    },
    {
      id: 56,
      country_name: "Benin",
      country_code: "BJ",
      phone_code: "+229",
    },
    {
      id: 124,
      country_name: "Mauritius",
      country_code: "MU",
      phone_code: "+230",
    },
    {
      id: 145,
      country_name: "Liberia",
      country_code: "LR",
      phone_code: "+231",
    },
    {
      id: 37,
      country_name: "Sierra Leone",
      country_code: "SL",
      phone_code: "+232",
    },
    {
      id: 193,
      country_name: "Ghana",
      country_code: "GH",
      phone_code: "+233",
    },
    {
      id: 1,
      country_name: "Nigeria",
      country_code: "NG",
      phone_code: "+234",
    },
    {
      id: 71,
      country_name: "Chad",
      country_code: "TD",
      phone_code: "+235",
    },
    {
      id: 85,
      country_name: "Central African Republic",
      country_code: "CF",
      phone_code: "+236",
    },
    {
      id: 75,
      country_name: "Cameroon",
      country_code: "CM",
      phone_code: "+237",
    },
    {
      id: 69,
      country_name: "Cape",
      country_code: "CV",
      phone_code: "+238",
    },
    {
      id: 86,
      country_name: "Sao Tome and Principe",
      country_code: "ST",
      phone_code: "+239",
    },
    {
      id: 187,
      country_name: "Equatorial Guinea",
      country_code: "GQ",
      phone_code: "+240",
    },
    {
      id: 199,
      country_name: "Gabon",
      country_code: "GA",
      phone_code: "+241",
    },
    {
      id: 83,
      country_name: "The republic of Congo",
      country_code: "CG",
      phone_code: "+242",
    },
    {
      id: 3,
      country_name: "Democratic Republic of Congo",
      country_code: "CD",
      phone_code: "+243",
    },
    {
      id: 19,
      country_name: "Angola",
      country_code: "AO",
      phone_code: "+244",
    },
    {
      id: 183,
      country_name: "Republic of Guinea-Bissau",
      country_code: "GW",
      phone_code: "+245",
    },
    {
      id: 230,
      country_name: "British Indian Ocean Territory",
      country_code: "IO",
      phone_code: "+246",
    },
    {
      id: 27,
      country_name: "Ascension Island",
      country_code: "AC",
      phone_code: "+247",
    },
    {
      id: 49,
      country_name: "Seychelles",
      country_code: "SC",
      phone_code: "+248",
    },
    {
      id: 46,
      country_name: "Sudan",
      country_code: "SD",
      phone_code: "+249",
    },
    {
      id: 60,
      country_name: "Rwanda",
      country_code: "RW",
      phone_code: "+250",
    },
    {
      id: 93,
      country_name: "Ethiopia",
      country_code: "ET",
      phone_code: "+251",
    },
    {
      id: 34,
      country_name: "Somalia",
      country_code: "SO",
      phone_code: "+252",
    },
    {
      id: 108,
      country_name: "Djibouti",
      country_code: "DJ",
      phone_code: "+253",
    },
    {
      id: 160,
      country_name: "Kenya",
      country_code: "KE",
      phone_code: "+254",
    },
    {
      id: 107,
      country_name: "Tanzania",
      country_code: "TZ",
      phone_code: "+255",
    },
    {
      id: 102,
      country_name: "Uganda",
      country_code: "UG",
      phone_code: "+256",
    },
    {
      id: 57,
      country_name: "Burundi",
      country_code: "BI",
      phone_code: "+257",
    },
    {
      id: 119,
      country_name: "Mozambique",
      country_code: "MZ",
      phone_code: "+258",
    },
    {
      id: 165,
      country_name: "Zambia",
      country_code: "ZM",
      phone_code: "+260",
    },
    {
      id: 135,
      country_name: "Madagascar",
      country_code: "MG",
      phone_code: "+261",
    },
    {
      id: 16,
      country_name: "Reunion",
      country_code: "RE",
      phone_code: "+262",
    },
    {
      id: 231,
      country_name: "French Southern Territories",
      country_code: "TF",
      phone_code: "+262",
    },
    {
      id: 164,
      country_name: "Zimbabwe",
      country_code: "ZW",
      phone_code: "+263",
    },
    {
      id: 118,
      country_name: "Namibia",
      country_code: "NA",
      phone_code: "+264",
    },
    {
      id: 122,
      country_name: "Malawi",
      country_code: "MW",
      phone_code: "+265",
    },
    {
      id: 144,
      country_name: "Lesotho",
      country_code: "LS",
      phone_code: "+266",
    },
    {
      id: 42,
      country_name: "Botswana",
      country_code: "BW",
      phone_code: "+267",
    },
    {
      id: 78,
      country_name: "Swaziland",
      country_code: "SZ",
      phone_code: "+268",
    },
    {
      id: 156,
      country_name: "Comoros",
      country_code: "KM",
      phone_code: "+269",
    },
    {
      id: 175,
      country_name: "Mayotte",
      country_code: "YT",
      phone_code: "+269",
    },
    {
      id: 170,
      country_name: "South Africa",
      country_code: "ZA",
      phone_code: "+27",
    },
    {
      id: 13,
      country_name: "Aruba",
      country_code: "AW",
      phone_code: "+297",
    },
    {
      id: 201,
      country_name: "Faroe Islands",
      country_code: "FO",
      phone_code: "+298",
    },
    {
      id: 191,
      country_name: "Greenland",
      country_code: "GL",
      phone_code: "+299",
    },
    {
      id: 186,
      country_name: "Greece",
      country_code: "GR",
      phone_code: "+30",
    },
    {
      id: 217,
      country_name: "Netherlands",
      country_code: "NL",
      phone_code: "+31",
    },
    {
      id: 6,
      country_name: "Belgium",
      country_code: "BE",
      phone_code: "+32",
    },
    {
      id: 200,
      country_name: "France",
      country_code: "FR",
      phone_code: "+33",
    },
    {
      id: 94,
      country_name: "Spain",
      country_code: "ES",
      phone_code: "+34",
    },
    {
      id: 192,
      country_name: "Gibraltar",
      country_code: "GI",
      phone_code: "+350",
    },
    {
      id: 31,
      country_name: "Portugal",
      country_code: "PT",
      phone_code: "+351",
    },
    {
      id: 142,
      country_name: "Luxembourg",
      country_code: "LU",
      phone_code: "+352",
    },
    {
      id: 173,
      country_name: "Ireland",
      country_code: "IE",
      phone_code: "+353",
    },
    {
      id: 167,
      country_name: "Iceland",
      country_code: "IS",
      phone_code: "+354",
    },
    {
      id: 21,
      country_name: "Albania",
      country_code: "AL",
      phone_code: "+355",
    },
    {
      id: 125,
      country_name: "Malta",
      country_code: "MT",
      phone_code: "+356",
    },
    {
      id: 65,
      country_name: "Cyprus",
      country_code: "CY",
      phone_code: "+357",
    },
    {
      id: 225,
      country_name: "Åland Islands",
      country_code: "AX",
      phone_code: "+358",
    },
    {
      id: 203,
      country_name: "Finland",
      country_code: "FI",
      phone_code: "+358",
    },
    {
      id: 59,
      country_name: "Bulgaria",
      country_code: "BG",
      phone_code: "+359",
    },
    {
      id: 176,
      country_name: "Hungary",
      country_code: "HU",
      phone_code: "+36",
    },
    {
      id: 143,
      country_name: "Lithuania",
      country_code: "LT",
      phone_code: "+370",
    },
    {
      id: 141,
      country_name: "Latvia",
      country_code: "LV",
      phone_code: "+371",
    },
    {
      id: 99,
      country_name: "Estonia",
      country_code: "EE",
      phone_code: "+372",
    },
    {
      id: 137,
      country_name: "Moldova",
      country_code: "MD",
      phone_code: "+373",
    },
    {
      id: 20,
      country_name: "Armenia",
      country_code: "AM",
      phone_code: "+374",
    },
    {
      id: 40,
      country_name: "Belarus",
      country_code: "BY",
      phone_code: "+375",
    },
    {
      id: 26,
      country_name: "Andorra",
      country_code: "AD",
      phone_code: "+376",
    },
    {
      id: 138,
      country_name: "Monaco",
      country_code: "MC",
      phone_code: "+377",
    },
    {
      id: 36,
      country_name: "San Marino",
      country_code: "SM",
      phone_code: "+378",
    },
    {
      id: 220,
      country_name: "Vatican",
      country_code: "VA",
      phone_code: "+379",
    },
    {
      id: 103,
      country_name: "Ukraine",
      country_code: "UA",
      phone_code: "+380",
    },
    {
      id: 8,
      country_name: "Serbia",
      country_code: "RS",
      phone_code: "+381",
    },
    {
      id: 136,
      country_name: "Montenegro",
      country_code: "ME",
      phone_code: "+382",
    },
    {
      id: 179,
      country_name: "Croatia",
      country_code: "HR",
      phone_code: "+385",
    },
    {
      id: 41,
      country_name: "Slovenia",
      country_code: "SI",
      phone_code: "+386",
    },
    {
      id: 10,
      country_name: "Bosnia and Herzegovina",
      country_code: "BA",
      phone_code: "+387",
    },
    {
      id: 134,
      country_name: "Macedonia",
      country_code: "MK",
      phone_code: "+389",
    },
    {
      id: 166,
      country_name: "Italy",
      country_code: "IT",
      phone_code: "+39",
    },
    {
      id: 11,
      country_name: "Romania",
      country_code: "RO",
      phone_code: "+40",
    },
    {
      id: 81,
      country_name: "Switzerland",
      country_code: "CH",
      phone_code: "+41",
    },
    {
      id: 63,
      country_name: "Czech",
      country_code: "CZ",
      phone_code: "+420",
    },
    {
      id: 38,
      country_name: "Slovakia",
      country_code: "SK",
      phone_code: "+421",
    },
    {
      id: 147,
      country_name: "Liechtenstein",
      country_code: "LI",
      phone_code: "+423",
    },
    {
      id: 15,
      country_name: "Austria",
      country_code: "AT",
      phone_code: "+43",
    },
    {
      id: 198,
      country_name: "U.K.",
      country_code: "GB",
      phone_code: "+44",
    },
    {
      id: 232,
      country_name: "Guernsey",
      country_code: "GG",
      phone_code: "+44",
    },
    {
      id: 234,
      country_name: "Isle of Man",
      country_code: "IM",
      phone_code: "+44",
    },
    {
      id: 233,
      country_name: "Jersey",
      country_code: "JE",
      phone_code: "+44",
    },
    {
      id: 106,
      country_name: "Denmark",
      country_code: "DK",
      phone_code: "+45",
    },
    {
      id: 44,
      country_name: "Sweden",
      country_code: "SE",
      phone_code: "+46",
    },
    {
      id: 226,
      country_name: "Bouve Island",
      country_code: "BV",
      phone_code: "+47",
    },
    {
      id: 216,
      country_name: "Norway",
      country_code: "NO",
      phone_code: "+47",
    },
    {
      id: 238,
      country_name: "Svalbard",
      country_code: "SJ",
      phone_code: "+47",
    },
    {
      id: 206,
      country_name: "Poland",
      country_code: "PL",
      phone_code: "+48",
    },
    {
      id: 110,
      country_name: "Germany",
      country_code: "DE",
      phone_code: "+49",
    },
    {
      id: 237,
      country_name: "South Georgia Island",
      country_code: "GS",
      phone_code: "+500",
    },
    {
      id: 39,
      country_name: "Belize",
      country_code: "BZ",
      phone_code: "+501",
    },
    {
      id: 185,
      country_name: "Guatemala",
      country_code: "GT",
      phone_code: "+502",
    },
    {
      id: 84,
      country_name: "Salvador",
      country_code: "SV",
      phone_code: "+503",
    },
    {
      id: 180,
      country_name: "Honduras",
      country_code: "HN",
      phone_code: "+504",
    },
    {
      id: 218,
      country_name: "Nicaragua",
      country_code: "NI",
      phone_code: "+505",
    },
    {
      id: 72,
      country_name: "Costa Rica",
      country_code: "CR",
      phone_code: "+506",
    },
    {
      id: 212,
      country_name: "Panama",
      country_code: "PA",
      phone_code: "+507",
    },
    {
      id: 205,
      country_name: "Saint Pierre and Miquelon",
      country_code: "PM",
      phone_code: "+508",
    },
    {
      id: 178,
      country_name: "Haiti",
      country_code: "HT",
      phone_code: "+509",
    },
    {
      id: 211,
      country_name: "Peru",
      country_code: "PE",
      phone_code: "+51",
    },
    {
      id: 121,
      country_name: "Mexico",
      country_code: "MX",
      phone_code: "+52",
    },
    {
      id: 70,
      country_name: "Cuba",
      country_code: "CU",
      phone_code: "+53",
    },
    {
      id: 18,
      country_name: "Argentina",
      country_code: "AR",
      phone_code: "+54",
    },
    {
      id: 48,
      country_name: "Brazil",
      country_code: "BR",
      phone_code: "+55",
    },
    {
      id: 76,
      country_name: "Chile",
      country_code: "CL",
      phone_code: "+56",
    },
    {
      id: 74,
      country_name: "Colombia",
      country_code: "CO",
      phone_code: "+57",
    },
    {
      id: 92,
      country_name: "Venezuela",
      country_code: "VE",
      phone_code: "+58",
    },
    {
      id: 188,
      country_name: "Guadeloupe",
      country_code: "GP",
      phone_code: "+590",
    },
    {
      id: 53,
      country_name: "Bolivia",
      country_code: "BO",
      phone_code: "+591",
    },
    {
      id: 182,
      country_name: "Guyana",
      country_code: "GY",
      phone_code: "+592",
    },
    {
      id: 100,
      country_name: "Ecuador",
      country_code: "EC",
      phone_code: "+593",
    },
    {
      id: 194,
      country_name: "French Guiana",
      country_code: "GF",
      phone_code: "+594",
    },
    {
      id: 29,
      country_name: "Paraguay",
      country_code: "PY",
      phone_code: "+595",
    },
    {
      id: 128,
      country_name: "Martinique",
      country_code: "MQ",
      phone_code: "+596",
    },
    {
      id: 88,
      country_name: "Suriname",
      country_code: "SR",
      phone_code: "+597",
    },
    {
      id: 97,
      country_name: "Uruguay",
      country_code: "UY",
      phone_code: "+598",
    },
    {
      id: 51,
      country_name: "Bonaire, St Eustatius and Saba",
      country_code: "BQ",
      phone_code: "+599",
    },
    {
      id: 67,
      country_name: "Curacao",
      country_code: "CW",
      phone_code: "+599",
    },
    {
      id: 120,
      country_name: "Malaysia",
      country_code: "MY",
      phone_code: "+60",
    },
    {
      id: 14,
      country_name: "Australia",
      country_code: "AU",
      phone_code: "+61",
    },
    {
      id: 227,
      country_name: "Cocos Islands",
      country_code: "CC",
      phone_code: "+61",
    },
    {
      id: 228,
      country_name: "Christmas Island",
      country_code: "CX",
      phone_code: "+61",
    },
    {
      id: 174,
      country_name: "Indonesia",
      country_code: "ID",
      phone_code: "+62",
    },
    {
      id: 208,
      country_name: "The Philippines",
      country_code: "PH",
      phone_code: "+63",
    },
    {
      id: 214,
      country_name: "New Zealand",
      country_code: "NZ",
      phone_code: "+64",
    },
    {
      id: 236,
      country_name: "Pitcairn Islands",
      country_code: "PN",
      phone_code: "+64",
    },
    {
      id: 43,
      country_name: "Singapore",
      country_code: "SG",
      phone_code: "+65",
    },
    {
      id: 66,
      country_name: "Thailand",
      country_code: "TH",
      phone_code: "+66",
    },
    {
      id: 62,
      country_name: "East Timor",
      country_code: "TL",
      phone_code: "+670",
    },
    {
      id: 229,
      country_name: "Heard and McDonald Islands",
      country_code: "HM",
      phone_code: "+672",
    },
    {
      id: 235,
      country_name: "Norfolk Island",
      country_code: "NF",
      phone_code: "+672",
    },
    {
      id: 54,
      country_name: "Brunei",
      country_code: "BN",
      phone_code: "+673",
    },
    {
      id: 223,
      country_name: "Nauru",
      country_code: "NR",
      phone_code: "+674",
    },
    {
      id: 209,
      country_name: "Papua New Guinea",
      country_code: "PG",
      phone_code: "+675",
    },
    {
      id: 113,
      country_name: "Tonga",
      country_code: "TO",
      phone_code: "+676",
    },
    {
      id: 50,
      country_name: "Solomon Islands",
      country_code: "SB",
      phone_code: "+677",
    },
    {
      id: 204,
      country_name: "Vanuatu",
      country_code: "VU",
      phone_code: "+678",
    },
    {
      id: 202,
      country_name: "Fiji",
      country_code: "FJ",
      phone_code: "+679",
    },
    {
      id: 30,
      country_name: "Palau",
      country_code: "PW",
      phone_code: "+680",
    },
    {
      id: 77,
      country_name: "Island",
      country_code: "CK",
      phone_code: "+682",
    },
    {
      id: 197,
      country_name: "Samoa",
      country_code: "WS",
      phone_code: "+685",
    },
    {
      id: 157,
      country_name: "Kiribati",
      country_code: "KI",
      phone_code: "+686",
    },
    {
      id: 117,
      country_name: "New caledonia",
      country_code: "NC",
      phone_code: "+687",
    },
    {
      id: 224,
      country_name: "Tuvalu",
      country_code: "TV",
      phone_code: "+688",
    },
    {
      id: 210,
      country_name: "French Polynesia",
      country_code: "PF",
      phone_code: "+689",
    },
    {
      id: 222,
      country_name: "Micronesia",
      country_code: "FM",
      phone_code: "+691",
    },
    {
      id: 221,
      country_name: "Marshall Islands",
      country_code: "MH",
      phone_code: "+692",
    },
    {
      id: 151,
      country_name: "Kazakhstan",
      country_code: "KZ",
      phone_code: "+7",
    },
    {
      id: 4,
      country_name: "Russia",
      country_code: "RU",
      phone_code: "+7",
    },
    {
      id: 161,
      country_name: "Japan",
      country_code: "JP",
      phone_code: "+81",
    },
    {
      id: 154,
      country_name: "South Korea",
      country_code: "KR",
      phone_code: "+82",
    },
    {
      id: 89,
      country_name: "Vietnam",
      country_code: "VN",
      phone_code: "+84",
    },
    {
      id: 181,
      country_name: "China Hong Kong",
      country_code: "HK",
      phone_code: "+852",
    },
    {
      id: 130,
      country_name: "Macao, China",
      country_code: "MO",
      phone_code: "+853",
    },
    {
      id: 158,
      country_name: "Cambodia",
      country_code: "KH",
      phone_code: "+855",
    },
    {
      id: 150,
      country_name: "Laos",
      country_code: "LA",
      phone_code: "+856",
    },
    {
      id: 219,
      country_name: "Chinese mainland",
      country_code: "CN",
      phone_code: "+86",
    },
    {
      id: 7,
      country_name: "Bangladesh",
      country_code: "BD",
      phone_code: "+880",
    },
    {
      id: 109,
      country_name: "Taiwan, China",
      country_code: "TW",
      phone_code: "+886",
    },
    {
      id: 112,
      country_name: "Turkey",
      country_code: "TR",
      phone_code: "+90",
    },
    {
      id: 171,
      country_name: "India",
      country_code: "IN",
      phone_code: "+91",
    },
    {
      id: 207,
      country_name: "Pakistan",
      country_code: "PK",
      phone_code: "+92",
    },
    {
      id: 24,
      country_name: "Afghanistan",
      country_code: "AF",
      phone_code: "+93",
    },
    {
      id: 146,
      country_name: "Sri Lanka",
      country_code: "LK",
      phone_code: "+94",
    },
    {
      id: 132,
      country_name: "Myanmar",
      country_code: "MM",
      phone_code: "+95",
    },
    {
      id: 123,
      country_name: "Maldives",
      country_code: "MV",
      phone_code: "+960",
    },
    {
      id: 149,
      country_name: "Lebanon",
      country_code: "LB",
      phone_code: "+961",
    },
    {
      id: 162,
      country_name: "Jordan",
      country_code: "JO",
      phone_code: "+962",
    },
    {
      id: 79,
      country_name: "Syria",
      country_code: "SY",
      phone_code: "+963",
    },
    {
      id: 169,
      country_name: "Iraq",
      country_code: "IQ",
      phone_code: "+964",
    },
    {
      id: 153,
      country_name: "Kuwait",
      country_code: "KW",
      phone_code: "+965",
    },
    {
      id: 52,
      country_name: "Saudi Arabia",
      country_code: "SA",
      phone_code: "+966",
    },
    {
      id: 177,
      country_name: "Yemen",
      country_code: "YE",
      phone_code: "+967",
    },
    {
      id: 213,
      country_name: "Oman",
      country_code: "OM",
      phone_code: "+968",
    },
    {
      id: 32,
      country_name: "Palestinian Territories",
      country_code: "PS",
      phone_code: "+970",
    },
    {
      id: 25,
      country_name: "United Arab Emirates",
      country_code: "AE",
      phone_code: "+971",
    },
    {
      id: 172,
      country_name: "Israel",
      country_code: "IL",
      phone_code: "+972",
    },
    {
      id: 58,
      country_name: "Bahrain",
      country_code: "BH",
      phone_code: "+973",
    },
    {
      id: 28,
      country_name: "Qatar",
      country_code: "QA",
      phone_code: "+974",
    },
    {
      id: 45,
      country_name: "Bhutan",
      country_code: "BT",
      phone_code: "+975",
    },
    {
      id: 131,
      country_name: "Mongolia",
      country_code: "MN",
      phone_code: "+976",
    },
    {
      id: 215,
      country_name: "Nepal",
      country_code: "NP",
      phone_code: "+977",
    },
    {
      id: 168,
      country_name: "Iran",
      country_code: "IR",
      phone_code: "+98",
    },
    {
      id: 64,
      country_name: "Tajikistan",
      country_code: "TJ",
      phone_code: "+992",
    },
    {
      id: 115,
      country_name: "Turkmenistan",
      country_code: "TM",
      phone_code: "+993",
    },
    {
      id: 12,
      country_name: "Azerbaijan",
      country_code: "AZ",
      phone_code: "+994",
    },
    {
      id: 195,
      country_name: "Georgia",
      country_code: "GE",
      phone_code: "+995",
    },
    {
      id: 159,
      country_name: "Kyrgyzstan",
      country_code: "KG",
      phone_code: "+996",
    },
    {
      id: 96,
      country_name: "Uzbekistan",
      country_code: "UZ",
      phone_code: "+998",
    },
  ],
  fr_FR: [
    {
      id: 2,
      country_name: "Canada",
      country_code: "CA",
      phone_code: "+1",
    },
    {
      id: 239,
      country_name: "Îles mineures éloignées des États-Unis",
      country_code: "UM",
      phone_code: "+1",
    },
    {
      id: 5,
      country_name: "États-Unis",
      country_code: "US",
      phone_code: "+1",
    },
    {
      id: 47,
      country_name: "Bahamas",
      country_code: "BS",
      phone_code: "+1242",
    },
    {
      id: 9,
      country_name: "Barbade",
      country_code: "BB",
      phone_code: "+1246",
    },
    {
      id: 22,
      country_name: "Anguilla",
      country_code: "AI",
      phone_code: "+1264",
    },
    {
      id: 23,
      country_name: "Antigua-et-Barbuda",
      country_code: "AG",
      phone_code: "+1268",
    },
    {
      id: 90,
      country_name: "Îles Vierges des États-Unis",
      country_code: "VI",
      phone_code: "+1284",
    },
    {
      id: 91,
      country_name: "Îles Vierges britanniques",
      country_code: "VG",
      phone_code: "+1340",
    },
    {
      id: 152,
      country_name: "Îles Caïmans",
      country_code: "KY",
      phone_code: "+1345",
    },
    {
      id: 55,
      country_name: "Bermudes",
      country_code: "BM",
      phone_code: "+1441",
    },
    {
      id: 196,
      country_name: "Grenade",
      country_code: "GD",
      phone_code: "+1473",
    },
    {
      id: 73,
      country_name: "îles Turques-et-Caïques",
      country_code: "TC",
      phone_code: "+1649",
    },
    {
      id: 126,
      country_name: "Montserrat",
      country_code: "MS",
      phone_code: "+1664",
    },
    {
      id: 129,
      country_name: "Îles Mariannes",
      country_code: "MP",
      phone_code: "+1670",
    },
    {
      id: 184,
      country_name: "Guam",
      country_code: "GU",
      phone_code: "+1671",
    },
    {
      id: 17,
      country_name: "Samoa américaines",
      country_code: "AS",
      phone_code: "+1684",
    },
    {
      id: 82,
      country_name: "Sint Maarten (partie hollandaise)",
      country_code: "SX",
      phone_code: "+1721",
    },
    {
      id: 148,
      country_name: "Sainte-Lucie",
      country_code: "LC",
      phone_code: "+1758",
    },
    {
      id: 105,
      country_name: "Dominique",
      country_code: "DM",
      phone_code: "+1767",
    },
    {
      id: 95,
      country_name: "Saint-Vincent-et-les-Grenadines",
      country_code: "VC",
      phone_code: "+1784",
    },
    {
      id: 33,
      country_name: "Porto Rico",
      country_code: "PR",
      phone_code: "+1787",
    },
    {
      id: 104,
      country_name: "République dominicaine",
      country_code: "DO",
      phone_code: "+1809",
    },
    {
      id: 111,
      country_name: "Trinité-et-Tobago",
      country_code: "TT",
      phone_code: "+1868",
    },
    {
      id: 155,
      country_name: "Saint-Christophe-et-Niévès",
      country_code: "KN",
      phone_code: "+1869",
    },
    {
      id: 163,
      country_name: "Jamaïque",
      country_code: "JM",
      phone_code: "+1876",
    },
    {
      id: 98,
      country_name: "Egypte",
      country_code: "EG",
      phone_code: "+20",
    },
    {
      id: 87,
      country_name: "Soudan du sud",
      country_code: "SS",
      phone_code: "+211",
    },
    {
      id: 139,
      country_name: "Maroc",
      country_code: "MA",
      phone_code: "+212",
    },
    {
      id: 101,
      country_name: "Algérie",
      country_code: "DZ",
      phone_code: "+213",
    },
    {
      id: 114,
      country_name: "Tunisie",
      country_code: "TN",
      phone_code: "+216",
    },
    {
      id: 140,
      country_name: "Libye",
      country_code: "LY",
      phone_code: "+218",
    },
    {
      id: 190,
      country_name: "Gambie",
      country_code: "GM",
      phone_code: "+220",
    },
    {
      id: 35,
      country_name: "Sénégal",
      country_code: "SN",
      phone_code: "+221",
    },
    {
      id: 127,
      country_name: "Mauritanie",
      country_code: "MR",
      phone_code: "+222",
    },
    {
      id: 133,
      country_name: "Mali",
      country_code: "ML",
      phone_code: "+223",
    },
    {
      id: 189,
      country_name: "Guinée",
      country_code: "GN",
      phone_code: "+224",
    },
    {
      id: 80,
      country_name: "Côte d'Ivoire",
      country_code: "CI",
      phone_code: "+225",
    },
    {
      id: 61,
      country_name: "Burkina Faso",
      country_code: "BF",
      phone_code: "+226",
    },
    {
      id: 116,
      country_name: "Niger",
      country_code: "NE",
      phone_code: "+227",
    },
    {
      id: 68,
      country_name: "Aller",
      country_code: "TG",
      phone_code: "+228",
    },
    {
      id: 56,
      country_name: "bénin",
      country_code: "BJ",
      phone_code: "+229",
    },
    {
      id: 124,
      country_name: "Maurice",
      country_code: "MU",
      phone_code: "+230",
    },
    {
      id: 145,
      country_name: "Libéria",
      country_code: "LR",
      phone_code: "+231",
    },
    {
      id: 37,
      country_name: "Sierra Leone",
      country_code: "SL",
      phone_code: "+232",
    },
    {
      id: 193,
      country_name: "Ghana",
      country_code: "GH",
      phone_code: "+233",
    },
    {
      id: 1,
      country_name: "Nigeria",
      country_code: "NG",
      phone_code: "+234",
    },
    {
      id: 71,
      country_name: "Tchad",
      country_code: "TD",
      phone_code: "+235",
    },
    {
      id: 85,
      country_name: "République centrafricaine",
      country_code: "CF",
      phone_code: "+236",
    },
    {
      id: 75,
      country_name: "Cameroun",
      country_code: "CM",
      phone_code: "+237",
    },
    {
      id: 69,
      country_name: "Cap",
      country_code: "CV",
      phone_code: "+238",
    },
    {
      id: 86,
      country_name: "Sao Tomé et Principe",
      country_code: "ST",
      phone_code: "+239",
    },
    {
      id: 187,
      country_name: "Guinée Équatoriale",
      country_code: "GQ",
      phone_code: "+240",
    },
    {
      id: 199,
      country_name: "Gabon",
      country_code: "GA",
      phone_code: "+241",
    },
    {
      id: 83,
      country_name: "La République du Congo",
      country_code: "CG",
      phone_code: "+242",
    },
    {
      id: 3,
      country_name: "République Démocratique du Congo",
      country_code: "CD",
      phone_code: "+243",
    },
    {
      id: 19,
      country_name: "Angola",
      country_code: "AO",
      phone_code: "+244",
    },
    {
      id: 183,
      country_name: "République de Guinée-Bissau",
      country_code: "GW",
      phone_code: "+245",
    },
    {
      id: 230,
      country_name: "Territoire britannique de l'océan Indien",
      country_code: "IO",
      phone_code: "+246",
    },
    {
      id: 27,
      country_name: "Île de l'Ascension",
      country_code: "AC",
      phone_code: "+247",
    },
    {
      id: 49,
      country_name: "Les Seychelles",
      country_code: "SC",
      phone_code: "+248",
    },
    {
      id: 46,
      country_name: "Soudan",
      country_code: "SD",
      phone_code: "+249",
    },
    {
      id: 60,
      country_name: "Rwanda",
      country_code: "RW",
      phone_code: "+250",
    },
    {
      id: 93,
      country_name: "Ethiopie",
      country_code: "ET",
      phone_code: "+251",
    },
    {
      id: 34,
      country_name: "Somalie",
      country_code: "SO",
      phone_code: "+252",
    },
    {
      id: 108,
      country_name: "Djibouti",
      country_code: "DJ",
      phone_code: "+253",
    },
    {
      id: 160,
      country_name: "Kenya",
      country_code: "KE",
      phone_code: "+254",
    },
    {
      id: 107,
      country_name: "Tanzanie",
      country_code: "TZ",
      phone_code: "+255",
    },
    {
      id: 102,
      country_name: "Ouganda",
      country_code: "UG",
      phone_code: "+256",
    },
    {
      id: 57,
      country_name: "Burundi",
      country_code: "BI",
      phone_code: "+257",
    },
    {
      id: 119,
      country_name: "Mozambique",
      country_code: "MZ",
      phone_code: "+258",
    },
    {
      id: 165,
      country_name: "Zambie",
      country_code: "ZM",
      phone_code: "+260",
    },
    {
      id: 135,
      country_name: "Madagascar",
      country_code: "MG",
      phone_code: "+261",
    },
    {
      id: 16,
      country_name: "Réunion",
      country_code: "RE",
      phone_code: "+262",
    },
    {
      id: 231,
      country_name: "Terres australes françaises",
      country_code: "TF",
      phone_code: "+262",
    },
    {
      id: 164,
      country_name: "Zimbabwe",
      country_code: "ZW",
      phone_code: "+263",
    },
    {
      id: 118,
      country_name: "Namibie",
      country_code: "NA",
      phone_code: "+264",
    },
    {
      id: 122,
      country_name: "Malawi",
      country_code: "MW",
      phone_code: "+265",
    },
    {
      id: 144,
      country_name: "Lesotho",
      country_code: "LS",
      phone_code: "+266",
    },
    {
      id: 42,
      country_name: "Bostwana",
      country_code: "BW",
      phone_code: "+267",
    },
    {
      id: 78,
      country_name: "Swaziland",
      country_code: "SZ",
      phone_code: "+268",
    },
    {
      id: 156,
      country_name: "Comores",
      country_code: "KM",
      phone_code: "+269",
    },
    {
      id: 175,
      country_name: "Mayotte",
      country_code: "YT",
      phone_code: "+269",
    },
    {
      id: 170,
      country_name: "Afrique du Sud",
      country_code: "ZA",
      phone_code: "+27",
    },
    {
      id: 13,
      country_name: "Aruba",
      country_code: "AW",
      phone_code: "+297",
    },
    {
      id: 201,
      country_name: "Îles Féroé",
      country_code: "FO",
      phone_code: "+298",
    },
    {
      id: 191,
      country_name: "Groenland",
      country_code: "GL",
      phone_code: "+299",
    },
    {
      id: 186,
      country_name: "Grèce",
      country_code: "GR",
      phone_code: "+30",
    },
    {
      id: 217,
      country_name: "Pays-Bas",
      country_code: "NL",
      phone_code: "+31",
    },
    {
      id: 6,
      country_name: "Belgique",
      country_code: "BE",
      phone_code: "+32",
    },
    {
      id: 200,
      country_name: "France",
      country_code: "FR",
      phone_code: "+33",
    },
    {
      id: 94,
      country_name: "Espagne",
      country_code: "ES",
      phone_code: "+34",
    },
    {
      id: 192,
      country_name: "Gibraltar",
      country_code: "GI",
      phone_code: "+350",
    },
    {
      id: 31,
      country_name: "Le Portugal",
      country_code: "PT",
      phone_code: "+351",
    },
    {
      id: 142,
      country_name: "Luxembourg",
      country_code: "LU",
      phone_code: "+352",
    },
    {
      id: 173,
      country_name: "Irlande",
      country_code: "IE",
      phone_code: "+353",
    },
    {
      id: 167,
      country_name: "Islande",
      country_code: "IS",
      phone_code: "+354",
    },
    {
      id: 21,
      country_name: "Albanie",
      country_code: "AL",
      phone_code: "+355",
    },
    {
      id: 125,
      country_name: "Malte",
      country_code: "MT",
      phone_code: "+356",
    },
    {
      id: 65,
      country_name: "Chypre",
      country_code: "CY",
      phone_code: "+357",
    },
    {
      id: 225,
      country_name: "Îles Åland",
      country_code: "AX",
      phone_code: "+358",
    },
    {
      id: 203,
      country_name: "Finlande",
      country_code: "FI",
      phone_code: "+358",
    },
    {
      id: 59,
      country_name: "Bulgarie",
      country_code: "BG",
      phone_code: "+359",
    },
    {
      id: 176,
      country_name: "Hongrie",
      country_code: "HU",
      phone_code: "+36",
    },
    {
      id: 143,
      country_name: "Lituanie",
      country_code: "LT",
      phone_code: "+370",
    },
    {
      id: 141,
      country_name: "Lettonie",
      country_code: "LV",
      phone_code: "+371",
    },
    {
      id: 99,
      country_name: "Estonie",
      country_code: "EE",
      phone_code: "+372",
    },
    {
      id: 137,
      country_name: "Moldavie",
      country_code: "MD",
      phone_code: "+373",
    },
    {
      id: 20,
      country_name: "Arménie",
      country_code: "AM",
      phone_code: "+374",
    },
    {
      id: 40,
      country_name: "Biélorussie",
      country_code: "BY",
      phone_code: "+375",
    },
    {
      id: 26,
      country_name: "Andorre",
      country_code: "AD",
      phone_code: "+376",
    },
    {
      id: 138,
      country_name: "Monaco",
      country_code: "MC",
      phone_code: "+377",
    },
    {
      id: 36,
      country_name: "Saint Marin",
      country_code: "SM",
      phone_code: "+378",
    },
    {
      id: 220,
      country_name: "Vatican",
      country_code: "VA",
      phone_code: "+379",
    },
    {
      id: 103,
      country_name: "Ukraine",
      country_code: "UA",
      phone_code: "+380",
    },
    {
      id: 8,
      country_name: "Serbie",
      country_code: "RS",
      phone_code: "+381",
    },
    {
      id: 136,
      country_name: "Monténégro",
      country_code: "ME",
      phone_code: "+382",
    },
    {
      id: 179,
      country_name: "Croatie",
      country_code: "HR",
      phone_code: "+385",
    },
    {
      id: 41,
      country_name: "Slovénie",
      country_code: "SI",
      phone_code: "+386",
    },
    {
      id: 10,
      country_name: "Bosnie Herzégovine",
      country_code: "BA",
      phone_code: "+387",
    },
    {
      id: 134,
      country_name: "Macédoine",
      country_code: "MK",
      phone_code: "+389",
    },
    {
      id: 166,
      country_name: "Italie",
      country_code: "IT",
      phone_code: "+39",
    },
    {
      id: 11,
      country_name: "Roumanie",
      country_code: "RO",
      phone_code: "+40",
    },
    {
      id: 81,
      country_name: "Suisse",
      country_code: "CH",
      phone_code: "+41",
    },
    {
      id: 63,
      country_name: "République tchèque",
      country_code: "CZ",
      phone_code: "+420",
    },
    {
      id: 38,
      country_name: "Slovaquie",
      country_code: "SK",
      phone_code: "+421",
    },
    {
      id: 147,
      country_name: "Liechtenstein",
      country_code: "LI",
      phone_code: "+423",
    },
    {
      id: 15,
      country_name: "L'Autriche",
      country_code: "AT",
      phone_code: "+43",
    },
    {
      id: 198,
      country_name: "ROYAUME-UNI.",
      country_code: "GB",
      phone_code: "+44",
    },
    {
      id: 232,
      country_name: "Guernesey",
      country_code: "GG",
      phone_code: "+44",
    },
    {
      id: 234,
      country_name: "Île de Man",
      country_code: "IM",
      phone_code: "+44",
    },
    {
      id: 233,
      country_name: "Jersey",
      country_code: "JE",
      phone_code: "+44",
    },
    {
      id: 106,
      country_name: "Danemark",
      country_code: "DK",
      phone_code: "+45",
    },
    {
      id: 44,
      country_name: "Suède",
      country_code: "SE",
      phone_code: "+46",
    },
    {
      id: 226,
      country_name: "Île Bouve",
      country_code: "BV",
      phone_code: "+47",
    },
    {
      id: 216,
      country_name: "Norvège",
      country_code: "NO",
      phone_code: "+47",
    },
    {
      id: 238,
      country_name: "Svalbard",
      country_code: "SJ",
      phone_code: "+47",
    },
    {
      id: 206,
      country_name: "Pologne",
      country_code: "PL",
      phone_code: "+48",
    },
    {
      id: 110,
      country_name: "Allemagne",
      country_code: "DE",
      phone_code: "+49",
    },
    {
      id: 237,
      country_name: "Île de Géorgie du Sud",
      country_code: "GS",
      phone_code: "+500",
    },
    {
      id: 39,
      country_name: "Bélize",
      country_code: "BZ",
      phone_code: "+501",
    },
    {
      id: 185,
      country_name: "Guatemala",
      country_code: "GT",
      phone_code: "+502",
    },
    {
      id: 84,
      country_name: "Le Salvador",
      country_code: "SV",
      phone_code: "+503",
    },
    {
      id: 180,
      country_name: "Honduras",
      country_code: "HN",
      phone_code: "+504",
    },
    {
      id: 218,
      country_name: "Nicaragua",
      country_code: "NI",
      phone_code: "+505",
    },
    {
      id: 72,
      country_name: "Costa Rica",
      country_code: "CR",
      phone_code: "+506",
    },
    {
      id: 212,
      country_name: "Panama",
      country_code: "PA",
      phone_code: "+507",
    },
    {
      id: 205,
      country_name: "Saint-Pierre-et-Miquelon",
      country_code: "PM",
      phone_code: "+508",
    },
    {
      id: 178,
      country_name: "Haïti",
      country_code: "HT",
      phone_code: "+509",
    },
    {
      id: 211,
      country_name: "Pérou",
      country_code: "PE",
      phone_code: "+51",
    },
    {
      id: 121,
      country_name: "Mexique",
      country_code: "MX",
      phone_code: "+52",
    },
    {
      id: 70,
      country_name: "Cuba",
      country_code: "CU",
      phone_code: "+53",
    },
    {
      id: 18,
      country_name: "Argentine",
      country_code: "AR",
      phone_code: "+54",
    },
    {
      id: 48,
      country_name: "Brésil",
      country_code: "BR",
      phone_code: "+55",
    },
    {
      id: 76,
      country_name: "Chili",
      country_code: "CL",
      phone_code: "+56",
    },
    {
      id: 74,
      country_name: "Colombie",
      country_code: "CO",
      phone_code: "+57",
    },
    {
      id: 92,
      country_name: "Venezuela",
      country_code: "VE",
      phone_code: "+58",
    },
    {
      id: 188,
      country_name: "Guadeloupe",
      country_code: "GP",
      phone_code: "+590",
    },
    {
      id: 53,
      country_name: "Bolivie",
      country_code: "BO",
      phone_code: "+591",
    },
    {
      id: 182,
      country_name: "Guyane",
      country_code: "GY",
      phone_code: "+592",
    },
    {
      id: 100,
      country_name: "Equateur",
      country_code: "EC",
      phone_code: "+593",
    },
    {
      id: 194,
      country_name: "Guyane Française",
      country_code: "GF",
      phone_code: "+594",
    },
    {
      id: 29,
      country_name: "Paraguay",
      country_code: "PY",
      phone_code: "+595",
    },
    {
      id: 128,
      country_name: "Martinique",
      country_code: "MQ",
      phone_code: "+596",
    },
    {
      id: 88,
      country_name: "Suriname",
      country_code: "SR",
      phone_code: "+597",
    },
    {
      id: 97,
      country_name: "Uruguay",
      country_code: "UY",
      phone_code: "+598",
    },
    {
      id: 51,
      country_name: "Bonaire, St Eustache Et Saba",
      country_code: "BQ",
      phone_code: "+599",
    },
    {
      id: 67,
      country_name: "Curacao",
      country_code: "CW",
      phone_code: "+599",
    },
    {
      id: 120,
      country_name: "Malaisie",
      country_code: "MY",
      phone_code: "+60",
    },
    {
      id: 14,
      country_name: "Australie",
      country_code: "AU",
      phone_code: "+61",
    },
    {
      id: 227,
      country_name: "Îles Cocos",
      country_code: "CC",
      phone_code: "+61",
    },
    {
      id: 228,
      country_name: "Île Christmas",
      country_code: "CX",
      phone_code: "+61",
    },
    {
      id: 174,
      country_name: "Indonésie",
      country_code: "ID",
      phone_code: "+62",
    },
    {
      id: 208,
      country_name: "Les Philippines",
      country_code: "PH",
      phone_code: "+63",
    },
    {
      id: 214,
      country_name: "Nouvelle-Zélande",
      country_code: "NZ",
      phone_code: "+64",
    },
    {
      id: 236,
      country_name: "Îles Pitcairn",
      country_code: "PN",
      phone_code: "+64",
    },
    {
      id: 43,
      country_name: "Singapour",
      country_code: "SG",
      phone_code: "+65",
    },
    {
      id: 66,
      country_name: "Thaïlande",
      country_code: "TH",
      phone_code: "+66",
    },
    {
      id: 62,
      country_name: "Timor oriental",
      country_code: "TL",
      phone_code: "+670",
    },
    {
      id: 229,
      country_name: "Îles Heard-et-MacDonald",
      country_code: "HM",
      phone_code: "+672",
    },
    {
      id: 235,
      country_name: "Norfolk Île",
      country_code: "NF",
      phone_code: "+672",
    },
    {
      id: 54,
      country_name: "Brunéi",
      country_code: "BN",
      phone_code: "+673",
    },
    {
      id: 223,
      country_name: "Nauru",
      country_code: "NR",
      phone_code: "+674",
    },
    {
      id: 209,
      country_name: "Papouasie Nouvelle Guinée",
      country_code: "PG",
      phone_code: "+675",
    },
    {
      id: 113,
      country_name: "Tonga",
      country_code: "TO",
      phone_code: "+676",
    },
    {
      id: 50,
      country_name: "Les îles Salomon",
      country_code: "SB",
      phone_code: "+677",
    },
    {
      id: 204,
      country_name: "Vanuatu",
      country_code: "VU",
      phone_code: "+678",
    },
    {
      id: 202,
      country_name: "Fidji",
      country_code: "FJ",
      phone_code: "+679",
    },
    {
      id: 30,
      country_name: "Palaos",
      country_code: "PW",
      phone_code: "+680",
    },
    {
      id: 77,
      country_name: "île",
      country_code: "CK",
      phone_code: "+682",
    },
    {
      id: 197,
      country_name: "Samoa",
      country_code: "WS",
      phone_code: "+685",
    },
    {
      id: 157,
      country_name: "Kiribati",
      country_code: "KI",
      phone_code: "+686",
    },
    {
      id: 117,
      country_name: "Nouvelle Calédonie",
      country_code: "NC",
      phone_code: "+687",
    },
    {
      id: 224,
      country_name: "Tuvalu",
      country_code: "TV",
      phone_code: "+688",
    },
    {
      id: 210,
      country_name: "Polynésie française",
      country_code: "PF",
      phone_code: "+689",
    },
    {
      id: 222,
      country_name: "Micronésie",
      country_code: "FM",
      phone_code: "+691",
    },
    {
      id: 221,
      country_name: "Îles Marshall",
      country_code: "MH",
      phone_code: "+692",
    },
    {
      id: 151,
      country_name: "Kazakhstan",
      country_code: "KZ",
      phone_code: "+7",
    },
    {
      id: 4,
      country_name: "Russie",
      country_code: "RU",
      phone_code: "+7",
    },
    {
      id: 161,
      country_name: "Japon",
      country_code: "JP",
      phone_code: "+81",
    },
    {
      id: 154,
      country_name: "Corée du Sud",
      country_code: "KR",
      phone_code: "+82",
    },
    {
      id: 89,
      country_name: "Viêt Nam",
      country_code: "VN",
      phone_code: "+84",
    },
    {
      id: 181,
      country_name: "Chine Hong Kong",
      country_code: "HK",
      phone_code: "+852",
    },
    {
      id: 130,
      country_name: "Macao, Chine",
      country_code: "MO",
      phone_code: "+853",
    },
    {
      id: 158,
      country_name: "Cambodge",
      country_code: "KH",
      phone_code: "+855",
    },
    {
      id: 150,
      country_name: "Laos",
      country_code: "LA",
      phone_code: "+856",
    },
    {
      id: 219,
      country_name: "Chine Continentale",
      country_code: "CN",
      phone_code: "+86",
    },
    {
      id: 7,
      country_name: "Bengladesh",
      country_code: "BD",
      phone_code: "+880",
    },
    {
      id: 109,
      country_name: "Taïwan, Chine",
      country_code: "TW",
      phone_code: "+886",
    },
    {
      id: 112,
      country_name: "Turquie",
      country_code: "TR",
      phone_code: "+90",
    },
    {
      id: 171,
      country_name: "Inde",
      country_code: "IN",
      phone_code: "+91",
    },
    {
      id: 207,
      country_name: "Pakistan",
      country_code: "PK",
      phone_code: "+92",
    },
    {
      id: 24,
      country_name: "Afghanistan",
      country_code: "AF",
      phone_code: "+93",
    },
    {
      id: 146,
      country_name: "Sri Lanka",
      country_code: "LK",
      phone_code: "+94",
    },
    {
      id: 132,
      country_name: "Birmanie",
      country_code: "MM",
      phone_code: "+95",
    },
    {
      id: 123,
      country_name: "Maldives",
      country_code: "MV",
      phone_code: "+960",
    },
    {
      id: 149,
      country_name: "Liban",
      country_code: "LB",
      phone_code: "+961",
    },
    {
      id: 162,
      country_name: "Jordan",
      country_code: "JO",
      phone_code: "+962",
    },
    {
      id: 79,
      country_name: "Syrie",
      country_code: "SY",
      phone_code: "+963",
    },
    {
      id: 169,
      country_name: "Irak",
      country_code: "IQ",
      phone_code: "+964",
    },
    {
      id: 153,
      country_name: "Koweit",
      country_code: "KW",
      phone_code: "+965",
    },
    {
      id: 52,
      country_name: "Arabie Saoudite",
      country_code: "SA",
      phone_code: "+966",
    },
    {
      id: 177,
      country_name: "Yémen",
      country_code: "YE",
      phone_code: "+967",
    },
    {
      id: 213,
      country_name: "Oman",
      country_code: "OM",
      phone_code: "+968",
    },
    {
      id: 32,
      country_name: "Territoires palestiniens",
      country_code: "PS",
      phone_code: "+970",
    },
    {
      id: 25,
      country_name: "Emirats Arabes Unis",
      country_code: "AE",
      phone_code: "+971",
    },
    {
      id: 172,
      country_name: "Israël",
      country_code: "IL",
      phone_code: "+972",
    },
    {
      id: 58,
      country_name: "Bahreïn",
      country_code: "BH",
      phone_code: "+973",
    },
    {
      id: 28,
      country_name: "Qatar",
      country_code: "QA",
      phone_code: "+974",
    },
    {
      id: 45,
      country_name: "Bhoutan",
      country_code: "BT",
      phone_code: "+975",
    },
    {
      id: 131,
      country_name: "Mongolie",
      country_code: "MN",
      phone_code: "+976",
    },
    {
      id: 215,
      country_name: "Népal",
      country_code: "NP",
      phone_code: "+977",
    },
    {
      id: 168,
      country_name: "L'Iran",
      country_code: "IR",
      phone_code: "+98",
    },
    {
      id: 64,
      country_name: "Tadjikistan",
      country_code: "TJ",
      phone_code: "+992",
    },
    {
      id: 115,
      country_name: "Turkménistan",
      country_code: "TM",
      phone_code: "+993",
    },
    {
      id: 12,
      country_name: "Azerbaïdjan",
      country_code: "AZ",
      phone_code: "+994",
    },
    {
      id: 195,
      country_name: "Géorgie",
      country_code: "GE",
      phone_code: "+995",
    },
    {
      id: 159,
      country_name: "Kirghizistan",
      country_code: "KG",
      phone_code: "+996",
    },
    {
      id: 96,
      country_name: "Ouzbékistan",
      country_code: "UZ",
      phone_code: "+998",
    },
  ],
  pt_PT: [
    {
      id: 2,
      country_name: "Canadá",
      country_code: "CA",
      phone_code: "+1",
    },
    {
      id: 239,
      country_name: "Ilhas Menores Distantes dos Estados Unidos",
      country_code: "UM",
      phone_code: "+1",
    },
    {
      id: 5,
      country_name: "Estados Unidos",
      country_code: "US",
      phone_code: "+1",
    },
    {
      id: 47,
      country_name: "Bahamas",
      country_code: "BS",
      phone_code: "+1242",
    },
    {
      id: 9,
      country_name: "Barbados",
      country_code: "BB",
      phone_code: "+1246",
    },
    {
      id: 22,
      country_name: "Anguila",
      country_code: "AI",
      phone_code: "+1264",
    },
    {
      id: 23,
      country_name: "Antígua e Barbuda",
      country_code: "AG",
      phone_code: "+1268",
    },
    {
      id: 90,
      country_name: "Ilhas Virgens Americanas",
      country_code: "VI",
      phone_code: "+1284",
    },
    {
      id: 91,
      country_name: "Ilhas Virgens Britânicas",
      country_code: "VG",
      phone_code: "+1340",
    },
    {
      id: 152,
      country_name: "Ilhas Cayman",
      country_code: "KY",
      phone_code: "+1345",
    },
    {
      id: 55,
      country_name: "Bermudas",
      country_code: "BM",
      phone_code: "+1441",
    },
    {
      id: 196,
      country_name: "Granada",
      country_code: "GD",
      phone_code: "+1473",
    },
    {
      id: 73,
      country_name: "Ilhas Turcas e Caicos",
      country_code: "TC",
      phone_code: "+1649",
    },
    {
      id: 126,
      country_name: "Montserrat",
      country_code: "MS",
      phone_code: "+1664",
    },
    {
      id: 129,
      country_name: "Ilhas Marianas",
      country_code: "MP",
      phone_code: "+1670",
    },
    {
      id: 184,
      country_name: "Guam",
      country_code: "GU",
      phone_code: "+1671",
    },
    {
      id: 17,
      country_name: "Samoa Americana",
      country_code: "AS",
      phone_code: "+1684",
    },
    {
      id: 82,
      country_name: "Sint Maarten (parte holandesa)",
      country_code: "SX",
      phone_code: "+1721",
    },
    {
      id: 148,
      country_name: "Santa Lúcia",
      country_code: "LC",
      phone_code: "+1758",
    },
    {
      id: 105,
      country_name: "Dominica",
      country_code: "DM",
      phone_code: "+1767",
    },
    {
      id: 95,
      country_name: "São Vicente e Granadinas",
      country_code: "VC",
      phone_code: "+1784",
    },
    {
      id: 33,
      country_name: "Porto Rico",
      country_code: "PR",
      phone_code: "+1787",
    },
    {
      id: 104,
      country_name: "República Dominicana",
      country_code: "DO",
      phone_code: "+1809",
    },
    {
      id: 111,
      country_name: "Trindade e Tobago",
      country_code: "TT",
      phone_code: "+1868",
    },
    {
      id: 155,
      country_name: "São Cristóvão e Nevis",
      country_code: "KN",
      phone_code: "+1869",
    },
    {
      id: 163,
      country_name: "Jamaica",
      country_code: "JM",
      phone_code: "+1876",
    },
    {
      id: 98,
      country_name: "Egito",
      country_code: "EG",
      phone_code: "+20",
    },
    {
      id: 87,
      country_name: "Sudão do Sul",
      country_code: "SS",
      phone_code: "+211",
    },
    {
      id: 139,
      country_name: "Marrocos",
      country_code: "MA",
      phone_code: "+212",
    },
    {
      id: 101,
      country_name: "Argélia",
      country_code: "DZ",
      phone_code: "+213",
    },
    {
      id: 114,
      country_name: "Tunísia",
      country_code: "TN",
      phone_code: "+216",
    },
    {
      id: 140,
      country_name: "Líbia",
      country_code: "LY",
      phone_code: "+218",
    },
    {
      id: 190,
      country_name: "Gâmbia",
      country_code: "GM",
      phone_code: "+220",
    },
    {
      id: 35,
      country_name: "Senegal",
      country_code: "SN",
      phone_code: "+221",
    },
    {
      id: 127,
      country_name: "Mauritânia",
      country_code: "MR",
      phone_code: "+222",
    },
    {
      id: 133,
      country_name: "Mali",
      country_code: "ML",
      phone_code: "+223",
    },
    {
      id: 189,
      country_name: "Guiné",
      country_code: "GN",
      phone_code: "+224",
    },
    {
      id: 80,
      country_name: "Costa do Marfim",
      country_code: "CI",
      phone_code: "+225",
    },
    {
      id: 61,
      country_name: "Burkina Faso",
      country_code: "BF",
      phone_code: "+226",
    },
    {
      id: 116,
      country_name: "Níger",
      country_code: "NE",
      phone_code: "+227",
    },
    {
      id: 68,
      country_name: "Togo",
      country_code: "TG",
      phone_code: "+228",
    },
    {
      id: 56,
      country_name: "Benim",
      country_code: "BJ",
      phone_code: "+229",
    },
    {
      id: 124,
      country_name: "maurício",
      country_code: "MU",
      phone_code: "+230",
    },
    {
      id: 145,
      country_name: "Libéria",
      country_code: "LR",
      phone_code: "+231",
    },
    {
      id: 37,
      country_name: "Serra Leoa",
      country_code: "SL",
      phone_code: "+232",
    },
    {
      id: 193,
      country_name: "Gana",
      country_code: "GH",
      phone_code: "+233",
    },
    {
      id: 1,
      country_name: "Nigéria",
      country_code: "NG",
      phone_code: "+234",
    },
    {
      id: 71,
      country_name: "Chade",
      country_code: "TD",
      phone_code: "+235",
    },
    {
      id: 85,
      country_name: "República Centro-Africana",
      country_code: "CF",
      phone_code: "+236",
    },
    {
      id: 75,
      country_name: "Camarões",
      country_code: "CM",
      phone_code: "+237",
    },
    {
      id: 69,
      country_name: "Capa",
      country_code: "CV",
      phone_code: "+238",
    },
    {
      id: 86,
      country_name: "São Tomé e Príncipe",
      country_code: "ST",
      phone_code: "+239",
    },
    {
      id: 187,
      country_name: "Guiné Equatorial",
      country_code: "GQ",
      phone_code: "+240",
    },
    {
      id: 199,
      country_name: "Gabão",
      country_code: "GA",
      phone_code: "+241",
    },
    {
      id: 83,
      country_name: "A República Do Congo",
      country_code: "CG",
      phone_code: "+242",
    },
    {
      id: 3,
      country_name: "República Democrática do Congo",
      country_code: "CD",
      phone_code: "+243",
    },
    {
      id: 19,
      country_name: "Angola",
      country_code: "AO",
      phone_code: "+244",
    },
    {
      id: 183,
      country_name: "República da Guiné-Bissau",
      country_code: "GW",
      phone_code: "+245",
    },
    {
      id: 230,
      country_name: "Território Britânico do Oceano Índico",
      country_code: "IO",
      phone_code: "+246",
    },
    {
      id: 27,
      country_name: "Ilha de Ascensão",
      country_code: "AC",
      phone_code: "+247",
    },
    {
      id: 49,
      country_name: "Seychelles",
      country_code: "SC",
      phone_code: "+248",
    },
    {
      id: 46,
      country_name: "Sudão",
      country_code: "SD",
      phone_code: "+249",
    },
    {
      id: 60,
      country_name: "Ruanda",
      country_code: "RW",
      phone_code: "+250",
    },
    {
      id: 93,
      country_name: "Etiópia",
      country_code: "ET",
      phone_code: "+251",
    },
    {
      id: 34,
      country_name: "Somália",
      country_code: "SO",
      phone_code: "+252",
    },
    {
      id: 108,
      country_name: "Djibuti",
      country_code: "DJ",
      phone_code: "+253",
    },
    {
      id: 160,
      country_name: "Quênia",
      country_code: "KE",
      phone_code: "+254",
    },
    {
      id: 107,
      country_name: "Tanzânia",
      country_code: "TZ",
      phone_code: "+255",
    },
    {
      id: 102,
      country_name: "Uganda",
      country_code: "UG",
      phone_code: "+256",
    },
    {
      id: 57,
      country_name: "Burundi",
      country_code: "BI",
      phone_code: "+257",
    },
    {
      id: 119,
      country_name: "Moçambique",
      country_code: "MZ",
      phone_code: "+258",
    },
    {
      id: 165,
      country_name: "Zâmbia",
      country_code: "ZM",
      phone_code: "+260",
    },
    {
      id: 135,
      country_name: "Madagáscar",
      country_code: "MG",
      phone_code: "+261",
    },
    {
      id: 16,
      country_name: "Reunião",
      country_code: "RE",
      phone_code: "+262",
    },
    {
      id: 231,
      country_name: "Territórios Franceses do Sul",
      country_code: "TF",
      phone_code: "+262",
    },
    {
      id: 164,
      country_name: "Zimbábue",
      country_code: "ZW",
      phone_code: "+263",
    },
    {
      id: 118,
      country_name: "Namíbia",
      country_code: "NA",
      phone_code: "+264",
    },
    {
      id: 122,
      country_name: "Malauí",
      country_code: "MW",
      phone_code: "+265",
    },
    {
      id: 144,
      country_name: "Lesoto",
      country_code: "LS",
      phone_code: "+266",
    },
    {
      id: 42,
      country_name: "Botsuana",
      country_code: "BW",
      phone_code: "+267",
    },
    {
      id: 78,
      country_name: "Suazilândia",
      country_code: "SZ",
      phone_code: "+268",
    },
    {
      id: 156,
      country_name: "Comores",
      country_code: "KM",
      phone_code: "+269",
    },
    {
      id: 175,
      country_name: "Maiote",
      country_code: "YT",
      phone_code: "+269",
    },
    {
      id: 170,
      country_name: "África do Sul",
      country_code: "ZA",
      phone_code: "+27",
    },
    {
      id: 13,
      country_name: "Aruba",
      country_code: "AW",
      phone_code: "+297",
    },
    {
      id: 201,
      country_name: "Ilhas Faroe",
      country_code: "FO",
      phone_code: "+298",
    },
    {
      id: 191,
      country_name: "Groenlândia",
      country_code: "GL",
      phone_code: "+299",
    },
    {
      id: 186,
      country_name: "Grécia",
      country_code: "GR",
      phone_code: "+30",
    },
    {
      id: 217,
      country_name: "Holanda",
      country_code: "NL",
      phone_code: "+31",
    },
    {
      id: 6,
      country_name: "Bélgica",
      country_code: "BE",
      phone_code: "+32",
    },
    {
      id: 200,
      country_name: "França",
      country_code: "FR",
      phone_code: "+33",
    },
    {
      id: 94,
      country_name: "Espanha",
      country_code: "ES",
      phone_code: "+34",
    },
    {
      id: 192,
      country_name: "Gibraltar",
      country_code: "GI",
      phone_code: "+350",
    },
    {
      id: 31,
      country_name: "Portugal",
      country_code: "PT",
      phone_code: "+351",
    },
    {
      id: 142,
      country_name: "Luxemburgo",
      country_code: "LU",
      phone_code: "+352",
    },
    {
      id: 173,
      country_name: "Irlanda",
      country_code: "IE",
      phone_code: "+353",
    },
    {
      id: 167,
      country_name: "Islândia",
      country_code: "IS",
      phone_code: "+354",
    },
    {
      id: 21,
      country_name: "Albânia",
      country_code: "AL",
      phone_code: "+355",
    },
    {
      id: 125,
      country_name: "Malta",
      country_code: "MT",
      phone_code: "+356",
    },
    {
      id: 65,
      country_name: "Chipre",
      country_code: "CY",
      phone_code: "+357",
    },
    {
      id: 225,
      country_name: "Ilhas Åland",
      country_code: "AX",
      phone_code: "+358",
    },
    {
      id: 203,
      country_name: "Finlândia",
      country_code: "FI",
      phone_code: "+358",
    },
    {
      id: 59,
      country_name: "Bulgária",
      country_code: "BG",
      phone_code: "+359",
    },
    {
      id: 176,
      country_name: "Hungria",
      country_code: "HU",
      phone_code: "+36",
    },
    {
      id: 143,
      country_name: "Lituânia",
      country_code: "LT",
      phone_code: "+370",
    },
    {
      id: 141,
      country_name: "Letônia",
      country_code: "LV",
      phone_code: "+371",
    },
    {
      id: 99,
      country_name: "Estônia",
      country_code: "EE",
      phone_code: "+372",
    },
    {
      id: 137,
      country_name: "Moldávia",
      country_code: "MD",
      phone_code: "+373",
    },
    {
      id: 20,
      country_name: "Armênia",
      country_code: "AM",
      phone_code: "+374",
    },
    {
      id: 40,
      country_name: "Bielorrússia",
      country_code: "BY",
      phone_code: "+375",
    },
    {
      id: 26,
      country_name: "Andorra",
      country_code: "AD",
      phone_code: "+376",
    },
    {
      id: 138,
      country_name: "Mônaco",
      country_code: "MC",
      phone_code: "+377",
    },
    {
      id: 36,
      country_name: "San Marino",
      country_code: "SM",
      phone_code: "+378",
    },
    {
      id: 220,
      country_name: "Vaticano",
      country_code: "VA",
      phone_code: "+379",
    },
    {
      id: 103,
      country_name: "Ucrânia",
      country_code: "UA",
      phone_code: "+380",
    },
    {
      id: 8,
      country_name: "Sérvia",
      country_code: "RS",
      phone_code: "+381",
    },
    {
      id: 136,
      country_name: "Montenegro",
      country_code: "ME",
      phone_code: "+382",
    },
    {
      id: 179,
      country_name: "Croácia",
      country_code: "HR",
      phone_code: "+385",
    },
    {
      id: 41,
      country_name: "Eslovênia",
      country_code: "SI",
      phone_code: "+386",
    },
    {
      id: 10,
      country_name: "Bósnia e Herzegovina",
      country_code: "BA",
      phone_code: "+387",
    },
    {
      id: 134,
      country_name: "Macedônia",
      country_code: "MK",
      phone_code: "+389",
    },
    {
      id: 166,
      country_name: "Itália",
      country_code: "IT",
      phone_code: "+39",
    },
    {
      id: 11,
      country_name: "Romênia",
      country_code: "RO",
      phone_code: "+40",
    },
    {
      id: 81,
      country_name: "Suíça",
      country_code: "CH",
      phone_code: "+41",
    },
    {
      id: 63,
      country_name: "República Checa",
      country_code: "CZ",
      phone_code: "+420",
    },
    {
      id: 38,
      country_name: "Eslováquia",
      country_code: "SK",
      phone_code: "+421",
    },
    {
      id: 147,
      country_name: "Liechtenstein",
      country_code: "LI",
      phone_code: "+423",
    },
    {
      id: 15,
      country_name: "Áustria",
      country_code: "AT",
      phone_code: "+43",
    },
    {
      id: 198,
      country_name: "REINO UNIDO.",
      country_code: "GB",
      phone_code: "+44",
    },
    {
      id: 232,
      country_name: "Guernsey",
      country_code: "GG",
      phone_code: "+44",
    },
    {
      id: 234,
      country_name: "Ilha de Man",
      country_code: "IM",
      phone_code: "+44",
    },
    {
      id: 233,
      country_name: "Jersey",
      country_code: "JE",
      phone_code: "+44",
    },
    {
      id: 106,
      country_name: "Dinamarca",
      country_code: "DK",
      phone_code: "+45",
    },
    {
      id: 44,
      country_name: "Suécia",
      country_code: "SE",
      phone_code: "+46",
    },
    {
      id: 226,
      country_name: "Ilha Bouve",
      country_code: "BV",
      phone_code: "+47",
    },
    {
      id: 216,
      country_name: "Noruega",
      country_code: "NO",
      phone_code: "+47",
    },
    {
      id: 238,
      country_name: "Svalbard",
      country_code: "SJ",
      phone_code: "+47",
    },
    {
      id: 206,
      country_name: "Polônia",
      country_code: "PL",
      phone_code: "+48",
    },
    {
      id: 110,
      country_name: "Alemanha",
      country_code: "DE",
      phone_code: "+49",
    },
    {
      id: 237,
      country_name: "Ilha Geórgia do Sul",
      country_code: "GS",
      phone_code: "+500",
    },
    {
      id: 39,
      country_name: "Belize",
      country_code: "BZ",
      phone_code: "+501",
    },
    {
      id: 185,
      country_name: "Guatemala",
      country_code: "GT",
      phone_code: "+502",
    },
    {
      id: 84,
      country_name: "El Salvador",
      country_code: "SV",
      phone_code: "+503",
    },
    {
      id: 180,
      country_name: "Honduras",
      country_code: "HN",
      phone_code: "+504",
    },
    {
      id: 218,
      country_name: "Nicarágua",
      country_code: "NI",
      phone_code: "+505",
    },
    {
      id: 72,
      country_name: "Costa Rica",
      country_code: "CR",
      phone_code: "+506",
    },
    {
      id: 212,
      country_name: "Panamá",
      country_code: "PA",
      phone_code: "+507",
    },
    {
      id: 205,
      country_name: "São Pedro e Miquelon",
      country_code: "PM",
      phone_code: "+508",
    },
    {
      id: 178,
      country_name: "Haiti",
      country_code: "HT",
      phone_code: "+509",
    },
    {
      id: 211,
      country_name: "Peru",
      country_code: "PE",
      phone_code: "+51",
    },
    {
      id: 121,
      country_name: "México",
      country_code: "MX",
      phone_code: "+52",
    },
    {
      id: 70,
      country_name: "Cuba",
      country_code: "CU",
      phone_code: "+53",
    },
    {
      id: 18,
      country_name: "Argentina",
      country_code: "AR",
      phone_code: "+54",
    },
    {
      id: 48,
      country_name: "Brasil",
      country_code: "BR",
      phone_code: "+55",
    },
    {
      id: 76,
      country_name: "Chile",
      country_code: "CL",
      phone_code: "+56",
    },
    {
      id: 74,
      country_name: "Colômbia",
      country_code: "CO",
      phone_code: "+57",
    },
    {
      id: 92,
      country_name: "Venezuela",
      country_code: "VE",
      phone_code: "+58",
    },
    {
      id: 188,
      country_name: "Guadalupe",
      country_code: "GP",
      phone_code: "+590",
    },
    {
      id: 53,
      country_name: "Bolívia",
      country_code: "BO",
      phone_code: "+591",
    },
    {
      id: 182,
      country_name: "Guiana",
      country_code: "GY",
      phone_code: "+592",
    },
    {
      id: 100,
      country_name: "Equador",
      country_code: "EC",
      phone_code: "+593",
    },
    {
      id: 194,
      country_name: "Guiana Francesa",
      country_code: "GF",
      phone_code: "+594",
    },
    {
      id: 29,
      country_name: "Paraguai",
      country_code: "PY",
      phone_code: "+595",
    },
    {
      id: 128,
      country_name: "Martinica",
      country_code: "MQ",
      phone_code: "+596",
    },
    {
      id: 88,
      country_name: "Suriname",
      country_code: "SR",
      phone_code: "+597",
    },
    {
      id: 97,
      country_name: "Uruguai",
      country_code: "UY",
      phone_code: "+598",
    },
    {
      id: 51,
      country_name: "Bonaire, Santo Eustáquio e Saba",
      country_code: "BQ",
      phone_code: "+599",
    },
    {
      id: 67,
      country_name: "Curaçao",
      country_code: "CW",
      phone_code: "+599",
    },
    {
      id: 120,
      country_name: "Malásia",
      country_code: "MY",
      phone_code: "+60",
    },
    {
      id: 14,
      country_name: "Austrália",
      country_code: "AU",
      phone_code: "+61",
    },
    {
      id: 227,
      country_name: "Ilhas Coco",
      country_code: "CC",
      phone_code: "+61",
    },
    {
      id: 228,
      country_name: "Ilha Christmas",
      country_code: "CX",
      phone_code: "+61",
    },
    {
      id: 174,
      country_name: "Indonésia",
      country_code: "ID",
      phone_code: "+62",
    },
    {
      id: 208,
      country_name: "As Filipinas",
      country_code: "PH",
      phone_code: "+63",
    },
    {
      id: 214,
      country_name: "Nova Zelândia",
      country_code: "NZ",
      phone_code: "+64",
    },
    {
      id: 236,
      country_name: "Ilhas Pitcairn",
      country_code: "PN",
      phone_code: "+64",
    },
    {
      id: 43,
      country_name: "Cingapura",
      country_code: "SG",
      phone_code: "+65",
    },
    {
      id: 66,
      country_name: "Tailândia",
      country_code: "TH",
      phone_code: "+66",
    },
    {
      id: 62,
      country_name: "Timor Leste",
      country_code: "TL",
      phone_code: "+670",
    },
    {
      id: 229,
      country_name: "Ilhas Heard e McDonald",
      country_code: "HM",
      phone_code: "+672",
    },
    {
      id: 235,
      country_name: "Ilha de Norfolk",
      country_code: "NF",
      phone_code: "+672",
    },
    {
      id: 54,
      country_name: "Brunei",
      country_code: "BN",
      phone_code: "+673",
    },
    {
      id: 223,
      country_name: "Nauru",
      country_code: "NR",
      phone_code: "+674",
    },
    {
      id: 209,
      country_name: "Papua Nova Guiné",
      country_code: "PG",
      phone_code: "+675",
    },
    {
      id: 113,
      country_name: "Tonga",
      country_code: "TO",
      phone_code: "+676",
    },
    {
      id: 50,
      country_name: "Ilhas Salomão",
      country_code: "SB",
      phone_code: "+677",
    },
    {
      id: 204,
      country_name: "Vanuatu",
      country_code: "VU",
      phone_code: "+678",
    },
    {
      id: 202,
      country_name: "Fiji",
      country_code: "FJ",
      phone_code: "+679",
    },
    {
      id: 30,
      country_name: "Palau",
      country_code: "PW",
      phone_code: "+680",
    },
    {
      id: 77,
      country_name: "Ilha",
      country_code: "CK",
      phone_code: "+682",
    },
    {
      id: 197,
      country_name: "Samoa",
      country_code: "WS",
      phone_code: "+685",
    },
    {
      id: 157,
      country_name: "Kiribati",
      country_code: "KI",
      phone_code: "+686",
    },
    {
      id: 117,
      country_name: "Nova Caledônia",
      country_code: "NC",
      phone_code: "+687",
    },
    {
      id: 224,
      country_name: "Tuvalu",
      country_code: "TV",
      phone_code: "+688",
    },
    {
      id: 210,
      country_name: "Polinésia Francesa",
      country_code: "PF",
      phone_code: "+689",
    },
    {
      id: 222,
      country_name: "Micronésia",
      country_code: "FM",
      phone_code: "+691",
    },
    {
      id: 221,
      country_name: "Ilhas Marshall",
      country_code: "MH",
      phone_code: "+692",
    },
    {
      id: 151,
      country_name: "Cazaquistão",
      country_code: "KZ",
      phone_code: "+7",
    },
    {
      id: 4,
      country_name: "Rússia",
      country_code: "RU",
      phone_code: "+7",
    },
    {
      id: 161,
      country_name: "Japão",
      country_code: "JP",
      phone_code: "+81",
    },
    {
      id: 154,
      country_name: "Coreia do Sul",
      country_code: "KR",
      phone_code: "+82",
    },
    {
      id: 89,
      country_name: "Vietnã",
      country_code: "VN",
      phone_code: "+84",
    },
    {
      id: 181,
      country_name: "China Hong Kong",
      country_code: "HK",
      phone_code: "+852",
    },
    {
      id: 130,
      country_name: "Macau, China",
      country_code: "MO",
      phone_code: "+853",
    },
    {
      id: 158,
      country_name: "Camboja",
      country_code: "KH",
      phone_code: "+855",
    },
    {
      id: 150,
      country_name: "Laos",
      country_code: "LA",
      phone_code: "+856",
    },
    {
      id: 219,
      country_name: "Continente Chinês",
      country_code: "CN",
      phone_code: "+86",
    },
    {
      id: 7,
      country_name: "Bangladesh",
      country_code: "BD",
      phone_code: "+880",
    },
    {
      id: 109,
      country_name: "Taiwan, China",
      country_code: "TW",
      phone_code: "+886",
    },
    {
      id: 112,
      country_name: "Türkiye",
      country_code: "TR",
      phone_code: "+90",
    },
    {
      id: 171,
      country_name: "Índia",
      country_code: "IN",
      phone_code: "+91",
    },
    {
      id: 207,
      country_name: "Paquistão",
      country_code: "PK",
      phone_code: "+92",
    },
    {
      id: 24,
      country_name: "Afeganistão",
      country_code: "AF",
      phone_code: "+93",
    },
    {
      id: 146,
      country_name: "Sri Lanka",
      country_code: "LK",
      phone_code: "+94",
    },
    {
      id: 132,
      country_name: "Mianmar",
      country_code: "MM",
      phone_code: "+95",
    },
    {
      id: 123,
      country_name: "Maldivas",
      country_code: "MV",
      phone_code: "+960",
    },
    {
      id: 149,
      country_name: "Líbano",
      country_code: "LB",
      phone_code: "+961",
    },
    {
      id: 162,
      country_name: "Jordânia",
      country_code: "JO",
      phone_code: "+962",
    },
    {
      id: 79,
      country_name: "Síria",
      country_code: "SY",
      phone_code: "+963",
    },
    {
      id: 169,
      country_name: "Iraque",
      country_code: "IQ",
      phone_code: "+964",
    },
    {
      id: 153,
      country_name: "Kuwait",
      country_code: "KW",
      phone_code: "+965",
    },
    {
      id: 52,
      country_name: "Arábia Saudita",
      country_code: "SA",
      phone_code: "+966",
    },
    {
      id: 177,
      country_name: "Iémen",
      country_code: "YE",
      phone_code: "+967",
    },
    {
      id: 213,
      country_name: "Omã",
      country_code: "OM",
      phone_code: "+968",
    },
    {
      id: 32,
      country_name: "Territórios Palestinos",
      country_code: "PS",
      phone_code: "+970",
    },
    {
      id: 25,
      country_name: "Emirados Árabes Unidos",
      country_code: "AE",
      phone_code: "+971",
    },
    {
      id: 172,
      country_name: "Israel",
      country_code: "IL",
      phone_code: "+972",
    },
    {
      id: 58,
      country_name: "Bahrein",
      country_code: "BH",
      phone_code: "+973",
    },
    {
      id: 28,
      country_name: "Catar",
      country_code: "QA",
      phone_code: "+974",
    },
    {
      id: 45,
      country_name: "Butão",
      country_code: "BT",
      phone_code: "+975",
    },
    {
      id: 131,
      country_name: "Mongólia",
      country_code: "MN",
      phone_code: "+976",
    },
    {
      id: 215,
      country_name: "Nepal",
      country_code: "NP",
      phone_code: "+977",
    },
    {
      id: 168,
      country_name: "Irã",
      country_code: "IR",
      phone_code: "+98",
    },
    {
      id: 64,
      country_name: "Tadjiquistão",
      country_code: "TJ",
      phone_code: "+992",
    },
    {
      id: 115,
      country_name: "Turquemenistão",
      country_code: "TM",
      phone_code: "+993",
    },
    {
      id: 12,
      country_name: "Azerbaijão",
      country_code: "AZ",
      phone_code: "+994",
    },
    {
      id: 195,
      country_name: "Geórgia",
      country_code: "GE",
      phone_code: "+995",
    },
    {
      id: 159,
      country_name: "Quirguistão",
      country_code: "KG",
      phone_code: "+996",
    },
    {
      id: 96,
      country_name: "Uzbequistão",
      country_code: "UZ",
      phone_code: "+998",
    },
  ],
  es_ES: [
    {
      id: 2,
      country_name: "Canadá",
      country_code: "CA",
      phone_code: "+1",
    },
    {
      id: 239,
      country_name: "Islas Ultramarinas Menores de los Estados Unidos",
      country_code: "UM",
      phone_code: "+1",
    },
    {
      id: 5,
      country_name: "Estados Unidos",
      country_code: "US",
      phone_code: "+1",
    },
    {
      id: 47,
      country_name: "Bahamas",
      country_code: "BS",
      phone_code: "+1242",
    },
    {
      id: 9,
      country_name: "Barbados",
      country_code: "BB",
      phone_code: "+1246",
    },
    {
      id: 22,
      country_name: "Anguila",
      country_code: "AI",
      phone_code: "+1264",
    },
    {
      id: 23,
      country_name: "Antigua y Barbuda",
      country_code: "AG",
      phone_code: "+1268",
    },
    {
      id: 90,
      country_name: "Islas Vírgenes de los Estados Unidos",
      country_code: "VI",
      phone_code: "+1284",
    },
    {
      id: 91,
      country_name: "Islas Vírgenes Británicas",
      country_code: "VG",
      phone_code: "+1340",
    },
    {
      id: 152,
      country_name: "Ilhas Cayman",
      country_code: "KY",
      phone_code: "+1345",
    },
    {
      id: 55,
      country_name: "Islas Bermudas",
      country_code: "BM",
      phone_code: "+1441",
    },
    {
      id: 196,
      country_name: "Granada",
      country_code: "GD",
      phone_code: "+1473",
    },
    {
      id: 73,
      country_name: "Islas Turcas y Caicos",
      country_code: "TC",
      phone_code: "+1649",
    },
    {
      id: 126,
      country_name: "Montserrat",
      country_code: "MS",
      phone_code: "+1664",
    },
    {
      id: 129,
      country_name: "Ilhas Marianas",
      country_code: "MP",
      phone_code: "+1670",
    },
    {
      id: 184,
      country_name: "Guam",
      country_code: "GU",
      phone_code: "+1671",
    },
    {
      id: 17,
      country_name: "Samoa Americana",
      country_code: "AS",
      phone_code: "+1684",
    },
    {
      id: 82,
      country_name: "Sint Maarten (parte holandesa)",
      country_code: "SX",
      phone_code: "+1721",
    },
    {
      id: 148,
      country_name: "Santa Lúcia",
      country_code: "LC",
      phone_code: "+1758",
    },
    {
      id: 105,
      country_name: "Dominica",
      country_code: "DM",
      phone_code: "+1767",
    },
    {
      id: 95,
      country_name: "San Vicente y las Granadinas",
      country_code: "VC",
      phone_code: "+1784",
    },
    {
      id: 33,
      country_name: "Puerto Rico",
      country_code: "PR",
      phone_code: "+1787",
    },
    {
      id: 104,
      country_name: "República Dominicana",
      country_code: "DO",
      phone_code: "+1809",
    },
    {
      id: 111,
      country_name: "Trindade e Tobago",
      country_code: "TT",
      phone_code: "+1868",
    },
    {
      id: 155,
      country_name: "São Cristóvão e Nevis",
      country_code: "KN",
      phone_code: "+1869",
    },
    {
      id: 163,
      country_name: "Jamaica",
      country_code: "JM",
      phone_code: "+1876",
    },
    {
      id: 98,
      country_name: "Egipto",
      country_code: "EG",
      phone_code: "+20",
    },
    {
      id: 87,
      country_name: "Sudán del Sur",
      country_code: "SS",
      phone_code: "+211",
    },
    {
      id: 139,
      country_name: "Marrocos",
      country_code: "MA",
      phone_code: "+212",
    },
    {
      id: 101,
      country_name: "Argélia",
      country_code: "DZ",
      phone_code: "+213",
    },
    {
      id: 114,
      country_name: "Tunísia",
      country_code: "TN",
      phone_code: "+216",
    },
    {
      id: 140,
      country_name: "Líbia",
      country_code: "LY",
      phone_code: "+218",
    },
    {
      id: 190,
      country_name: "Gâmbia",
      country_code: "GM",
      phone_code: "+220",
    },
    {
      id: 35,
      country_name: "Senegal",
      country_code: "SN",
      phone_code: "+221",
    },
    {
      id: 127,
      country_name: "Mauritânia",
      country_code: "MR",
      phone_code: "+222",
    },
    {
      id: 133,
      country_name: "Mali",
      country_code: "ML",
      phone_code: "+223",
    },
    {
      id: 189,
      country_name: "Guiné",
      country_code: "GN",
      phone_code: "+224",
    },
    {
      id: 80,
      country_name: "Costa de Marfil",
      country_code: "CI",
      phone_code: "+225",
    },
    {
      id: 61,
      country_name: "Burkina Faso",
      country_code: "BF",
      phone_code: "+226",
    },
    {
      id: 116,
      country_name: "Níger",
      country_code: "NE",
      phone_code: "+227",
    },
    {
      id: 68,
      country_name: "Ir",
      country_code: "TG",
      phone_code: "+228",
    },
    {
      id: 56,
      country_name: "Benín",
      country_code: "BJ",
      phone_code: "+229",
    },
    {
      id: 124,
      country_name: "maurício",
      country_code: "MU",
      phone_code: "+230",
    },
    {
      id: 145,
      country_name: "Libéria",
      country_code: "LR",
      phone_code: "+231",
    },
    {
      id: 37,
      country_name: "Sierra Leona",
      country_code: "SL",
      phone_code: "+232",
    },
    {
      id: 193,
      country_name: "Gana",
      country_code: "GH",
      phone_code: "+233",
    },
    {
      id: 1,
      country_name: "Nigeria",
      country_code: "NG",
      phone_code: "+234",
    },
    {
      id: 71,
      country_name: "Chad",
      country_code: "TD",
      phone_code: "+235",
    },
    {
      id: 85,
      country_name: "República Centroafricana",
      country_code: "CF",
      phone_code: "+236",
    },
    {
      id: 75,
      country_name: "Camerún",
      country_code: "CM",
      phone_code: "+237",
    },
    {
      id: 69,
      country_name: "Capa",
      country_code: "CV",
      phone_code: "+238",
    },
    {
      id: 86,
      country_name: "Santo Tomé y Príncipe",
      country_code: "ST",
      phone_code: "+239",
    },
    {
      id: 187,
      country_name: "Guiné Equatorial",
      country_code: "GQ",
      phone_code: "+240",
    },
    {
      id: 199,
      country_name: "Gabão",
      country_code: "GA",
      phone_code: "+241",
    },
    {
      id: 83,
      country_name: "La republica del congo",
      country_code: "CG",
      phone_code: "+242",
    },
    {
      id: 3,
      country_name: "República Democrática del Congo",
      country_code: "CD",
      phone_code: "+243",
    },
    {
      id: 19,
      country_name: "Angola",
      country_code: "AO",
      phone_code: "+244",
    },
    {
      id: 183,
      country_name: "República da Guiné-Bissau",
      country_code: "GW",
      phone_code: "+245",
    },
    {
      id: 230,
      country_name: "Territorio Británico del Océano Índico",
      country_code: "IO",
      phone_code: "+246",
    },
    {
      id: 27,
      country_name: "Isla Ascencion",
      country_code: "AC",
      phone_code: "+247",
    },
    {
      id: 49,
      country_name: "Seychelles",
      country_code: "SC",
      phone_code: "+248",
    },
    {
      id: 46,
      country_name: "Sudán",
      country_code: "SD",
      phone_code: "+249",
    },
    {
      id: 60,
      country_name: "Ruanda",
      country_code: "RW",
      phone_code: "+250",
    },
    {
      id: 93,
      country_name: "Etiopía",
      country_code: "ET",
      phone_code: "+251",
    },
    {
      id: 34,
      country_name: "Somalia",
      country_code: "SO",
      phone_code: "+252",
    },
    {
      id: 108,
      country_name: "Djibuti",
      country_code: "DJ",
      phone_code: "+253",
    },
    {
      id: 160,
      country_name: "Quênia",
      country_code: "KE",
      phone_code: "+254",
    },
    {
      id: 107,
      country_name: "Tanzânia",
      country_code: "TZ",
      phone_code: "+255",
    },
    {
      id: 102,
      country_name: "Uganda",
      country_code: "UG",
      phone_code: "+256",
    },
    {
      id: 57,
      country_name: "Burundi",
      country_code: "BI",
      phone_code: "+257",
    },
    {
      id: 119,
      country_name: "Moçambique",
      country_code: "MZ",
      phone_code: "+258",
    },
    {
      id: 165,
      country_name: "Zâmbia",
      country_code: "ZM",
      phone_code: "+260",
    },
    {
      id: 135,
      country_name: "Madagáscar",
      country_code: "MG",
      phone_code: "+261",
    },
    {
      id: 16,
      country_name: "Reunión",
      country_code: "RE",
      phone_code: "+262",
    },
    {
      id: 231,
      country_name: "Territorios Australes Franceses",
      country_code: "TF",
      phone_code: "+262",
    },
    {
      id: 164,
      country_name: "Zimbábue",
      country_code: "ZW",
      phone_code: "+263",
    },
    {
      id: 118,
      country_name: "Namíbia",
      country_code: "NA",
      phone_code: "+264",
    },
    {
      id: 122,
      country_name: "Malauí",
      country_code: "MW",
      phone_code: "+265",
    },
    {
      id: 144,
      country_name: "Lesoto",
      country_code: "LS",
      phone_code: "+266",
    },
    {
      id: 42,
      country_name: "Botsuana",
      country_code: "BW",
      phone_code: "+267",
    },
    {
      id: 78,
      country_name: "Suazilandia",
      country_code: "SZ",
      phone_code: "+268",
    },
    {
      id: 156,
      country_name: "Comores",
      country_code: "KM",
      phone_code: "+269",
    },
    {
      id: 175,
      country_name: "Maiote",
      country_code: "YT",
      phone_code: "+269",
    },
    {
      id: 170,
      country_name: "África do Sul",
      country_code: "ZA",
      phone_code: "+27",
    },
    {
      id: 13,
      country_name: "Aruba",
      country_code: "AW",
      phone_code: "+297",
    },
    {
      id: 201,
      country_name: "Islas Faroe",
      country_code: "FO",
      phone_code: "+298",
    },
    {
      id: 191,
      country_name: "Groenlândia",
      country_code: "GL",
      phone_code: "+299",
    },
    {
      id: 186,
      country_name: "Grécia",
      country_code: "GR",
      phone_code: "+30",
    },
    {
      id: 217,
      country_name: "Países Bajos",
      country_code: "NL",
      phone_code: "+31",
    },
    {
      id: 6,
      country_name: "Bélgica",
      country_code: "BE",
      phone_code: "+32",
    },
    {
      id: 200,
      country_name: "França",
      country_code: "FR",
      phone_code: "+33",
    },
    {
      id: 94,
      country_name: "España",
      country_code: "ES",
      phone_code: "+34",
    },
    {
      id: 192,
      country_name: "Gibraltar",
      country_code: "GI",
      phone_code: "+350",
    },
    {
      id: 31,
      country_name: "Portugal",
      country_code: "PT",
      phone_code: "+351",
    },
    {
      id: 142,
      country_name: "Luxemburgo",
      country_code: "LU",
      phone_code: "+352",
    },
    {
      id: 173,
      country_name: "Irlanda",
      country_code: "IE",
      phone_code: "+353",
    },
    {
      id: 167,
      country_name: "Islândia",
      country_code: "IS",
      phone_code: "+354",
    },
    {
      id: 21,
      country_name: "Albania",
      country_code: "AL",
      phone_code: "+355",
    },
    {
      id: 125,
      country_name: "Malta",
      country_code: "MT",
      phone_code: "+356",
    },
    {
      id: 65,
      country_name: "Chipre",
      country_code: "CY",
      phone_code: "+357",
    },
    {
      id: 225,
      country_name: "Islas Åland",
      country_code: "AX",
      phone_code: "+358",
    },
    {
      id: 203,
      country_name: "Finlandia",
      country_code: "FI",
      phone_code: "+358",
    },
    {
      id: 59,
      country_name: "Bulgaria",
      country_code: "BG",
      phone_code: "+359",
    },
    {
      id: 176,
      country_name: "Hungria",
      country_code: "HU",
      phone_code: "+36",
    },
    {
      id: 143,
      country_name: "Lituânia",
      country_code: "LT",
      phone_code: "+370",
    },
    {
      id: 141,
      country_name: "Letônia",
      country_code: "LV",
      phone_code: "+371",
    },
    {
      id: 99,
      country_name: "Estonia",
      country_code: "EE",
      phone_code: "+372",
    },
    {
      id: 137,
      country_name: "Moldávia",
      country_code: "MD",
      phone_code: "+373",
    },
    {
      id: 20,
      country_name: "Armenia",
      country_code: "AM",
      phone_code: "+374",
    },
    {
      id: 40,
      country_name: "Bielorrusia",
      country_code: "BY",
      phone_code: "+375",
    },
    {
      id: 26,
      country_name: "Andorra",
      country_code: "AD",
      phone_code: "+376",
    },
    {
      id: 138,
      country_name: "Mônaco",
      country_code: "MC",
      phone_code: "+377",
    },
    {
      id: 36,
      country_name: "San Marino",
      country_code: "SM",
      phone_code: "+378",
    },
    {
      id: 220,
      country_name: "Vaticano",
      country_code: "VA",
      phone_code: "+379",
    },
    {
      id: 103,
      country_name: "Ucrânia",
      country_code: "UA",
      phone_code: "+380",
    },
    {
      id: 8,
      country_name: "Serbia",
      country_code: "RS",
      phone_code: "+381",
    },
    {
      id: 136,
      country_name: "Montenegro",
      country_code: "ME",
      phone_code: "+382",
    },
    {
      id: 179,
      country_name: "Croácia",
      country_code: "HR",
      phone_code: "+385",
    },
    {
      id: 41,
      country_name: "Eslovenia",
      country_code: "SI",
      phone_code: "+386",
    },
    {
      id: 10,
      country_name: "Bosnia y Herzegovina",
      country_code: "BA",
      phone_code: "+387",
    },
    {
      id: 134,
      country_name: "Macedônia",
      country_code: "MK",
      phone_code: "+389",
    },
    {
      id: 166,
      country_name: "Itália",
      country_code: "IT",
      phone_code: "+39",
    },
    {
      id: 11,
      country_name: "Rumania",
      country_code: "RO",
      phone_code: "+40",
    },
    {
      id: 81,
      country_name: "Suiza",
      country_code: "CH",
      phone_code: "+41",
    },
    {
      id: 63,
      country_name: "República Checa",
      country_code: "CZ",
      phone_code: "+420",
    },
    {
      id: 38,
      country_name: "Eslovaquia",
      country_code: "SK",
      phone_code: "+421",
    },
    {
      id: 147,
      country_name: "Liechtenstein",
      country_code: "LI",
      phone_code: "+423",
    },
    {
      id: 15,
      country_name: "Austria",
      country_code: "AT",
      phone_code: "+43",
    },
    {
      id: 198,
      country_name: "REINO UNIDO.",
      country_code: "GB",
      phone_code: "+44",
    },
    {
      id: 232,
      country_name: "Guernsey",
      country_code: "GG",
      phone_code: "+44",
    },
    {
      id: 234,
      country_name: "Isla de Man",
      country_code: "IM",
      phone_code: "+44",
    },
    {
      id: 233,
      country_name: "Jersey",
      country_code: "JE",
      phone_code: "+44",
    },
    {
      id: 106,
      country_name: "Dinamarca",
      country_code: "DK",
      phone_code: "+45",
    },
    {
      id: 44,
      country_name: "Suecia",
      country_code: "SE",
      phone_code: "+46",
    },
    {
      id: 226,
      country_name: "Isla Bouve",
      country_code: "BV",
      phone_code: "+47",
    },
    {
      id: 216,
      country_name: "Noruega",
      country_code: "NO",
      phone_code: "+47",
    },
    {
      id: 238,
      country_name: "Svalbard",
      country_code: "SJ",
      phone_code: "+47",
    },
    {
      id: 206,
      country_name: "Polonia",
      country_code: "PL",
      phone_code: "+48",
    },
    {
      id: 110,
      country_name: "Alemanha",
      country_code: "DE",
      phone_code: "+49",
    },
    {
      id: 237,
      country_name: "Isla Georgia del Sur",
      country_code: "GS",
      phone_code: "+500",
    },
    {
      id: 39,
      country_name: "Belice",
      country_code: "BZ",
      phone_code: "+501",
    },
    {
      id: 185,
      country_name: "Guatemala",
      country_code: "GT",
      phone_code: "+502",
    },
    {
      id: 84,
      country_name: "El Salvador",
      country_code: "SV",
      phone_code: "+503",
    },
    {
      id: 180,
      country_name: "Honduras",
      country_code: "HN",
      phone_code: "+504",
    },
    {
      id: 218,
      country_name: "Nicaragua",
      country_code: "NI",
      phone_code: "+505",
    },
    {
      id: 72,
      country_name: "Costa Rica",
      country_code: "CR",
      phone_code: "+506",
    },
    {
      id: 212,
      country_name: "Panamá",
      country_code: "PA",
      phone_code: "+507",
    },
    {
      id: 205,
      country_name: "San Pedro y Miquelón",
      country_code: "PM",
      phone_code: "+508",
    },
    {
      id: 178,
      country_name: "Haiti",
      country_code: "HT",
      phone_code: "+509",
    },
    {
      id: 211,
      country_name: "Perú",
      country_code: "PE",
      phone_code: "+51",
    },
    {
      id: 121,
      country_name: "México",
      country_code: "MX",
      phone_code: "+52",
    },
    {
      id: 70,
      country_name: "Cuba",
      country_code: "CU",
      phone_code: "+53",
    },
    {
      id: 18,
      country_name: "Argentina",
      country_code: "AR",
      phone_code: "+54",
    },
    {
      id: 48,
      country_name: "Brasil",
      country_code: "BR",
      phone_code: "+55",
    },
    {
      id: 76,
      country_name: "Chile",
      country_code: "CL",
      phone_code: "+56",
    },
    {
      id: 74,
      country_name: "Colombia",
      country_code: "CO",
      phone_code: "+57",
    },
    {
      id: 92,
      country_name: "Venezuela",
      country_code: "VE",
      phone_code: "+58",
    },
    {
      id: 188,
      country_name: "Guadalupe",
      country_code: "GP",
      phone_code: "+590",
    },
    {
      id: 53,
      country_name: "Bolivia",
      country_code: "BO",
      phone_code: "+591",
    },
    {
      id: 182,
      country_name: "Guiana",
      country_code: "GY",
      phone_code: "+592",
    },
    {
      id: 100,
      country_name: "Ecuador",
      country_code: "EC",
      phone_code: "+593",
    },
    {
      id: 194,
      country_name: "Guiana Francesa",
      country_code: "GF",
      phone_code: "+594",
    },
    {
      id: 29,
      country_name: "Paraguay",
      country_code: "PY",
      phone_code: "+595",
    },
    {
      id: 128,
      country_name: "Martinica",
      country_code: "MQ",
      phone_code: "+596",
    },
    {
      id: 88,
      country_name: "Surinam",
      country_code: "SR",
      phone_code: "+597",
    },
    {
      id: 97,
      country_name: "Uruguay",
      country_code: "UY",
      phone_code: "+598",
    },
    {
      id: 51,
      country_name: "Bonaire, San Eustaquio Y Saba",
      country_code: "BQ",
      phone_code: "+599",
    },
    {
      id: 67,
      country_name: "Curazao",
      country_code: "CW",
      phone_code: "+599",
    },
    {
      id: 120,
      country_name: "Malásia",
      country_code: "MY",
      phone_code: "+60",
    },
    {
      id: 14,
      country_name: "Australia",
      country_code: "AU",
      phone_code: "+61",
    },
    {
      id: 227,
      country_name: "Islas Cocos",
      country_code: "CC",
      phone_code: "+61",
    },
    {
      id: 228,
      country_name: "Isla de Navidad",
      country_code: "CX",
      phone_code: "+61",
    },
    {
      id: 174,
      country_name: "Indonésia",
      country_code: "ID",
      phone_code: "+62",
    },
    {
      id: 208,
      country_name: "Las Filipinas",
      country_code: "PH",
      phone_code: "+63",
    },
    {
      id: 214,
      country_name: "Nueva Zelanda",
      country_code: "NZ",
      phone_code: "+64",
    },
    {
      id: 236,
      country_name: "Islas Pitcairn",
      country_code: "PN",
      phone_code: "+64",
    },
    {
      id: 43,
      country_name: "Singapur",
      country_code: "SG",
      phone_code: "+65",
    },
    {
      id: 66,
      country_name: "Tailandia",
      country_code: "TH",
      phone_code: "+66",
    },
    {
      id: 62,
      country_name: "Timor Oriental",
      country_code: "TL",
      phone_code: "+670",
    },
    {
      id: 229,
      country_name: "Islas Heard y McDonald",
      country_code: "HM",
      phone_code: "+672",
    },
    {
      id: 235,
      country_name: "Norfolk' Isla",
      country_code: "NF",
      phone_code: "+672",
    },
    {
      id: 54,
      country_name: "Brunéi",
      country_code: "BN",
      phone_code: "+673",
    },
    {
      id: 223,
      country_name: "Nauru",
      country_code: "NR",
      phone_code: "+674",
    },
    {
      id: 209,
      country_name: "Papúa Nueva Guinea",
      country_code: "PG",
      phone_code: "+675",
    },
    {
      id: 113,
      country_name: "Tonga",
      country_code: "TO",
      phone_code: "+676",
    },
    {
      id: 50,
      country_name: "Islas Salomón",
      country_code: "SB",
      phone_code: "+677",
    },
    {
      id: 204,
      country_name: "Vanuatu",
      country_code: "VU",
      phone_code: "+678",
    },
    {
      id: 202,
      country_name: "Fiyi",
      country_code: "FJ",
      phone_code: "+679",
    },
    {
      id: 30,
      country_name: "Palaos",
      country_code: "PW",
      phone_code: "+680",
    },
    {
      id: 77,
      country_name: "Isla",
      country_code: "CK",
      phone_code: "+682",
    },
    {
      id: 197,
      country_name: "Samoa",
      country_code: "WS",
      phone_code: "+685",
    },
    {
      id: 157,
      country_name: "Kiribati",
      country_code: "KI",
      phone_code: "+686",
    },
    {
      id: 117,
      country_name: "Nova Caledônia",
      country_code: "NC",
      phone_code: "+687",
    },
    {
      id: 224,
      country_name: "Tuvalu",
      country_code: "TV",
      phone_code: "+688",
    },
    {
      id: 210,
      country_name: "Polinesia francés",
      country_code: "PF",
      phone_code: "+689",
    },
    {
      id: 222,
      country_name: "Micronesia",
      country_code: "FM",
      phone_code: "+691",
    },
    {
      id: 221,
      country_name: "Islas Marshall",
      country_code: "MH",
      phone_code: "+692",
    },
    {
      id: 151,
      country_name: "Cazaquistão",
      country_code: "KZ",
      phone_code: "+7",
    },
    {
      id: 4,
      country_name: "Rusia",
      country_code: "RU",
      phone_code: "+7",
    },
    {
      id: 161,
      country_name: "Japão",
      country_code: "JP",
      phone_code: "+81",
    },
    {
      id: 154,
      country_name: "Coreia do Sul",
      country_code: "KR",
      phone_code: "+82",
    },
    {
      id: 89,
      country_name: "Vietnam",
      country_code: "VN",
      phone_code: "+84",
    },
    {
      id: 181,
      country_name: "China Hong Kong",
      country_code: "HK",
      phone_code: "+852",
    },
    {
      id: 130,
      country_name: "Macau, China",
      country_code: "MO",
      phone_code: "+853",
    },
    {
      id: 158,
      country_name: "Camboja",
      country_code: "KH",
      phone_code: "+855",
    },
    {
      id: 150,
      country_name: "Laos",
      country_code: "LA",
      phone_code: "+856",
    },
    {
      id: 219,
      country_name: "China continental",
      country_code: "CN",
      phone_code: "+86",
    },
    {
      id: 7,
      country_name: "Bangladesh",
      country_code: "BD",
      phone_code: "+880",
    },
    {
      id: 109,
      country_name: "Taiwan, China",
      country_code: "TW",
      phone_code: "+886",
    },
    {
      id: 112,
      country_name: "Türkiye",
      country_code: "TR",
      phone_code: "+90",
    },
    {
      id: 171,
      country_name: "Índia",
      country_code: "IN",
      phone_code: "+91",
    },
    {
      id: 207,
      country_name: "Pakistán",
      country_code: "PK",
      phone_code: "+92",
    },
    {
      id: 24,
      country_name: "Afganistán",
      country_code: "AF",
      phone_code: "+93",
    },
    {
      id: 146,
      country_name: "Sri Lanka",
      country_code: "LK",
      phone_code: "+94",
    },
    {
      id: 132,
      country_name: "Mianmar",
      country_code: "MM",
      phone_code: "+95",
    },
    {
      id: 123,
      country_name: "Maldivas",
      country_code: "MV",
      phone_code: "+960",
    },
    {
      id: 149,
      country_name: "Líbano",
      country_code: "LB",
      phone_code: "+961",
    },
    {
      id: 162,
      country_name: "Jordânia",
      country_code: "JO",
      phone_code: "+962",
    },
    {
      id: 79,
      country_name: "Siria",
      country_code: "SY",
      phone_code: "+963",
    },
    {
      id: 169,
      country_name: "Iraque",
      country_code: "IQ",
      phone_code: "+964",
    },
    {
      id: 153,
      country_name: "Kuwait",
      country_code: "KW",
      phone_code: "+965",
    },
    {
      id: 52,
      country_name: "Arabia Saudita",
      country_code: "SA",
      phone_code: "+966",
    },
    {
      id: 177,
      country_name: "Iémen",
      country_code: "YE",
      phone_code: "+967",
    },
    {
      id: 213,
      country_name: "Omán",
      country_code: "OM",
      phone_code: "+968",
    },
    {
      id: 32,
      country_name: "Territorios palestinos",
      country_code: "PS",
      phone_code: "+970",
    },
    {
      id: 25,
      country_name: "Emiratos Árabes Unidos",
      country_code: "AE",
      phone_code: "+971",
    },
    {
      id: 172,
      country_name: "Israel",
      country_code: "IL",
      phone_code: "+972",
    },
    {
      id: 58,
      country_name: "Baréin",
      country_code: "BH",
      phone_code: "+973",
    },
    {
      id: 28,
      country_name: "Katar",
      country_code: "QA",
      phone_code: "+974",
    },
    {
      id: 45,
      country_name: "Bután",
      country_code: "BT",
      phone_code: "+975",
    },
    {
      id: 131,
      country_name: "Mongólia",
      country_code: "MN",
      phone_code: "+976",
    },
    {
      id: 215,
      country_name: "Nepal",
      country_code: "NP",
      phone_code: "+977",
    },
    {
      id: 168,
      country_name: "Irã",
      country_code: "IR",
      phone_code: "+98",
    },
    {
      id: 64,
      country_name: "Tayikistán",
      country_code: "TJ",
      phone_code: "+992",
    },
    {
      id: 115,
      country_name: "Turquemenistão",
      country_code: "TM",
      phone_code: "+993",
    },
    {
      id: 12,
      country_name: "Azerbaiyán",
      country_code: "AZ",
      phone_code: "+994",
    },
    {
      id: 195,
      country_name: "Geórgia",
      country_code: "GE",
      phone_code: "+995",
    },
    {
      id: 159,
      country_name: "Quirguistão",
      country_code: "KG",
      phone_code: "+996",
    },
    {
      id: 96,
      country_name: "Uzbekistán",
      country_code: "UZ",
      phone_code: "+998",
    },
  ],
  id_ID: [
    { id: 2, country_name: "Kanada", country_code: "CA", phone_code: "+1" },
    {
      id: 239,
      country_name: "Kepulauan Terluar Kecil AS",
      country_code: "UM",
      phone_code: "+1",
    },
    {
      id: 5,
      country_name: "Amerika Serikat",
      country_code: "US",
      phone_code: "+1",
    },
    { id: 47, country_name: "Bahama", country_code: "BS", phone_code: "+1242" },
    {
      id: 9,
      country_name: "Barbados",
      country_code: "BB",
      phone_code: "+1246",
    },
    {
      id: 22,
      country_name: "Anguilla",
      country_code: "AI",
      phone_code: "+1264",
    },
    {
      id: 23,
      country_name: "Antigua dan Barbuda",
      country_code: "AG",
      phone_code: "+1268",
    },
    {
      id: 90,
      country_name: "Kepulauan Virgin AS",
      country_code: "VI",
      phone_code: "+1284",
    },
    {
      id: 91,
      country_name: "Kepulauan Virgin Britania Raya",
      country_code: "VG",
      phone_code: "+1340",
    },
    {
      id: 152,
      country_name: "Kepulauan Cayman",
      country_code: "KY",
      phone_code: "+1345",
    },
    {
      id: 55,
      country_name: "Bermuda",
      country_code: "BM",
      phone_code: "+1441",
    },
    {
      id: 196,
      country_name: "Greneda",
      country_code: "GD",
      phone_code: "+1473",
    },
    {
      id: 73,
      country_name: "Kepulauan Turks dan Caicos",
      country_code: "TC",
      phone_code: "+1649",
    },
    {
      id: 126,
      country_name: "Montserrat",
      country_code: "MS",
      phone_code: "+1664",
    },
    {
      id: 129,
      country_name: "Kepulauan Mariana",
      country_code: "MP",
      phone_code: "+1670",
    },
    { id: 184, country_name: "Guam", country_code: "GU", phone_code: "+1671" },
    {
      id: 17,
      country_name: "Samoa Amerika",
      country_code: "AS",
      phone_code: "+1684",
    },
    {
      id: 82,
      country_name: "Sint Maarten (bagian Belanda)",
      country_code: "SX",
      phone_code: "+1721",
    },
    {
      id: 148,
      country_name: "St. Lucia",
      country_code: "LC",
      phone_code: "+1758",
    },
    {
      id: 105,
      country_name: "Dominika",
      country_code: "DM",
      phone_code: "+1767",
    },
    {
      id: 95,
      country_name: "Saint Vincent dan Grenadines",
      country_code: "VC",
      phone_code: "+1784",
    },
    {
      id: 33,
      country_name: "Puerto Riko",
      country_code: "PR",
      phone_code: "+1787",
    },
    {
      id: 104,
      country_name: "Republik Dominika",
      country_code: "DO",
      phone_code: "+1809",
    },
    {
      id: 111,
      country_name: "Trinidad dan Tobago",
      country_code: "TT",
      phone_code: "+1868",
    },
    {
      id: 155,
      country_name: "Saint Kitts dan Nevis",
      country_code: "KN",
      phone_code: "+1869",
    },
    {
      id: 163,
      country_name: "Jamaika",
      country_code: "JM",
      phone_code: "+1876",
    },
    { id: 98, country_name: "Mesir", country_code: "EG", phone_code: "+20" },
    {
      id: 87,
      country_name: "Sudan Selatan",
      country_code: "SS",
      phone_code: "+211",
    },
    { id: 139, country_name: "Maroko", country_code: "MA", phone_code: "+212" },
    {
      id: 101,
      country_name: "Aljazair",
      country_code: "DZ",
      phone_code: "+213",
    },
    {
      id: 114,
      country_name: "Tunisia",
      country_code: "TN",
      phone_code: "+216",
    },
    { id: 140, country_name: "Libya", country_code: "LY", phone_code: "+218" },
    { id: 190, country_name: "Gambia", country_code: "GM", phone_code: "+220" },
    { id: 35, country_name: "Senegal", country_code: "SN", phone_code: "+221" },
    {
      id: 127,
      country_name: "Mauritania",
      country_code: "MR",
      phone_code: "+222",
    },
    { id: 133, country_name: "Mali", country_code: "ML", phone_code: "+223" },
    { id: 189, country_name: "Guinea", country_code: "GN", phone_code: "+224" },
    {
      id: 80,
      country_name: "Pantai Gading",
      country_code: "CI",
      phone_code: "+225",
    },
    {
      id: 61,
      country_name: "Burkina Faso",
      country_code: "BF",
      phone_code: "+226",
    },
    {
      id: 116,
      country_name: "Nigeria",
      country_code: "NE",
      phone_code: "+227",
    },
    { id: 68, country_name: "Togo", country_code: "TG", phone_code: "+228" },
    { id: 56, country_name: "Benin", country_code: "BJ", phone_code: "+229" },
    {
      id: 124,
      country_name: "Mauritius",
      country_code: "MU",
      phone_code: "+230",
    },
    {
      id: 145,
      country_name: "Liberia",
      country_code: "LR",
      phone_code: "+231",
    },
    {
      id: 37,
      country_name: "Sierra Leone",
      country_code: "SL",
      phone_code: "+232",
    },
    { id: 193, country_name: "Ghana", country_code: "GH", phone_code: "+233" },
    { id: 1, country_name: "Nigeria", country_code: "NG", phone_code: "+234" },
    { id: 71, country_name: "Chad", country_code: "TD", phone_code: "+235" },
    {
      id: 85,
      country_name: "Republik Afrika Tengah",
      country_code: "CF",
      phone_code: "+236",
    },
    { id: 75, country_name: "Kamerun", country_code: "CM", phone_code: "+237" },
    { id: 69, country_name: "Tanjung", country_code: "CV", phone_code: "+238" },
    {
      id: 86,
      country_name: "Sao Tome dan Principe",
      country_code: "ST",
      phone_code: "+239",
    },
    {
      id: 187,
      country_name: "Guinea Khatulistiwa",
      country_code: "GQ",
      phone_code: "+240",
    },
    { id: 199, country_name: "Gabon", country_code: "GA", phone_code: "+241" },
    {
      id: 83,
      country_name: "Republik Kongo",
      country_code: "CG",
      phone_code: "+242",
    },
    {
      id: 3,
      country_name: "Republik Demokratik Kongo",
      country_code: "CD",
      phone_code: "+243",
    },
    { id: 19, country_name: "Angola", country_code: "AO", phone_code: "+244" },
    {
      id: 183,
      country_name: "Guinea-Bissau",
      country_code: "GW",
      phone_code: "+245",
    },
    {
      id: 230,
      country_name: "Wilayah Samudra Hindia Britania",
      country_code: "IO",
      phone_code: "+246",
    },
    {
      id: 27,
      country_name: "Pulau Ascension",
      country_code: "AC",
      phone_code: "+247",
    },
    {
      id: 49,
      country_name: "Seychelles",
      country_code: "SC",
      phone_code: "+248",
    },
    { id: 46, country_name: "Sudan", country_code: "SD", phone_code: "+249" },
    { id: 60, country_name: "Rwanda", country_code: "RW", phone_code: "+250" },
    { id: 93, country_name: "Etiopia", country_code: "ET", phone_code: "+251" },
    { id: 34, country_name: "Somalia", country_code: "SO", phone_code: "+252" },
    { id: 108, country_name: "Jibuti", country_code: "DJ", phone_code: "+253" },
    { id: 160, country_name: "Kenya", country_code: "KE", phone_code: "+254" },
    {
      id: 107,
      country_name: "Tanzania",
      country_code: "TZ",
      phone_code: "+255",
    },
    { id: 102, country_name: "Uganda", country_code: "UG", phone_code: "+256" },
    { id: 57, country_name: "Burundi", country_code: "BI", phone_code: "+257" },
    {
      id: 119,
      country_name: "Mozambik",
      country_code: "MZ",
      phone_code: "+258",
    },
    { id: 165, country_name: "Zambia", country_code: "ZM", phone_code: "+260" },
    {
      id: 135,
      country_name: "Madagaskar",
      country_code: "MG",
      phone_code: "+261",
    },
    { id: 16, country_name: "Reuni", country_code: "RE", phone_code: "+262" },
    {
      id: 231,
      country_name: "Wilayah Selatan Prancis",
      country_code: "TF",
      phone_code: "+262",
    },
    {
      id: 164,
      country_name: "Zimbabwe",
      country_code: "ZW",
      phone_code: "+263",
    },
    {
      id: 118,
      country_name: "Namibia",
      country_code: "NA",
      phone_code: "+264",
    },
    { id: 122, country_name: "Malawi", country_code: "MW", phone_code: "+265" },
    {
      id: 144,
      country_name: "Lesotho",
      country_code: "LS",
      phone_code: "+266",
    },
    {
      id: 42,
      country_name: "Botswana",
      country_code: "BW",
      phone_code: "+267",
    },
    {
      id: 78,
      country_name: "Swaziland",
      country_code: "SZ",
      phone_code: "+268",
    },
    { id: 156, country_name: "Komoro", country_code: "KM", phone_code: "+269" },
    {
      id: 175,
      country_name: "Mayotte",
      country_code: "YT",
      phone_code: "+269",
    },
    {
      id: 170,
      country_name: "Afrika Selatan",
      country_code: "ZA",
      phone_code: "+27",
    },
    { id: 13, country_name: "Aruba", country_code: "AW", phone_code: "+297" },
    {
      id: 201,
      country_name: "Kepulauan Faroe",
      country_code: "FO",
      phone_code: "+298",
    },
    {
      id: 191,
      country_name: "Tanah penggembalaan",
      country_code: "GL",
      phone_code: "+299",
    },
    { id: 186, country_name: "Yunani", country_code: "GR", phone_code: "+30" },
    { id: 217, country_name: "Belanda", country_code: "NL", phone_code: "+31" },
    { id: 6, country_name: "Belgia", country_code: "BE", phone_code: "+32" },
    {
      id: 200,
      country_name: "Perancis",
      country_code: "FR",
      phone_code: "+33",
    },
    { id: 94, country_name: "Spanyol", country_code: "ES", phone_code: "+34" },
    {
      id: 192,
      country_name: "Gibraltar",
      country_code: "GI",
      phone_code: "+350",
    },
    {
      id: 31,
      country_name: "Portugal",
      country_code: "PT",
      phone_code: "+351",
    },
    {
      id: 142,
      country_name: "Luksemburg",
      country_code: "LU",
      phone_code: "+352",
    },
    {
      id: 173,
      country_name: "Irlandia",
      country_code: "IE",
      phone_code: "+353",
    },
    {
      id: 167,
      country_name: "Islandia",
      country_code: "IS",
      phone_code: "+354",
    },
    { id: 21, country_name: "Albania", country_code: "AL", phone_code: "+355" },
    { id: 125, country_name: "Malta", country_code: "MT", phone_code: "+356" },
    { id: 65, country_name: "Siprus", country_code: "CY", phone_code: "+357" },
    {
      id: 225,
      country_name: "Kepulauan Åland",
      country_code: "AX",
      phone_code: "+358",
    },
    {
      id: 203,
      country_name: "Finlandia",
      country_code: "FI",
      phone_code: "+358",
    },
    {
      id: 59,
      country_name: "Bulgaria",
      country_code: "BG",
      phone_code: "+359",
    },
    {
      id: 176,
      country_name: "Hongaria",
      country_code: "HU",
      phone_code: "+36",
    },
    {
      id: 143,
      country_name: "Lithuania",
      country_code: "LT",
      phone_code: "+370",
    },
    { id: 141, country_name: "Latvia", country_code: "LV", phone_code: "+371" },
    { id: 99, country_name: "Estonia", country_code: "EE", phone_code: "+372" },
    {
      id: 137,
      country_name: "Moldova",
      country_code: "MD",
      phone_code: "+373",
    },
    { id: 20, country_name: "Armenia", country_code: "AM", phone_code: "+374" },
    {
      id: 40,
      country_name: "Belarusia",
      country_code: "BY",
      phone_code: "+375",
    },
    { id: 26, country_name: "Andorra", country_code: "AD", phone_code: "+376" },
    { id: 138, country_name: "Monako", country_code: "MC", phone_code: "+377" },
    {
      id: 36,
      country_name: "San Marino",
      country_code: "SM",
      phone_code: "+378",
    },
    {
      id: 220,
      country_name: "Kota Vatikan",
      country_code: "VA",
      phone_code: "+379",
    },
    {
      id: 103,
      country_name: "Ukraina",
      country_code: "UA",
      phone_code: "+380",
    },
    { id: 8, country_name: "Serbia", country_code: "RS", phone_code: "+381" },
    {
      id: 136,
      country_name: "Montenegro",
      country_code: "ME",
      phone_code: "+382",
    },
    {
      id: 179,
      country_name: "Kroasia",
      country_code: "HR",
      phone_code: "+385",
    },
    {
      id: 41,
      country_name: "Slovenia",
      country_code: "SI",
      phone_code: "+386",
    },
    {
      id: 10,
      country_name: "Bosnia dan Herzegovina",
      country_code: "BA",
      phone_code: "+387",
    },
    {
      id: 134,
      country_name: "Makedonia",
      country_code: "MK",
      phone_code: "+389",
    },
    { id: 166, country_name: "Italia", country_code: "IT", phone_code: "+39" },
    { id: 11, country_name: "Rumania", country_code: "RO", phone_code: "+40" },
    { id: 81, country_name: "Swiss", country_code: "CH", phone_code: "+41" },
    {
      id: 63,
      country_name: "Republik Ceko",
      country_code: "CZ",
      phone_code: "+420",
    },
    {
      id: 38,
      country_name: "Slowakia",
      country_code: "SK",
      phone_code: "+421",
    },
    {
      id: 147,
      country_name: "Liechtenstein",
      country_code: "LI",
      phone_code: "+423",
    },
    { id: 15, country_name: "Austria", country_code: "AT", phone_code: "+43" },
    { id: 198, country_name: "Inggris", country_code: "GB", phone_code: "+44" },
    {
      id: 232,
      country_name: "Guernsey",
      country_code: "GG",
      phone_code: "+44",
    },
    {
      id: 234,
      country_name: "Pulau Man",
      country_code: "IM",
      phone_code: "+44",
    },
    { id: 233, country_name: "Jersey", country_code: "JE", phone_code: "+44" },
    { id: 106, country_name: "Denmark", country_code: "DK", phone_code: "+45" },
    { id: 44, country_name: "Swedia", country_code: "SE", phone_code: "+46" },
    {
      id: 226,
      country_name: "Pulau Bouvet",
      country_code: "BV",
      phone_code: "+47",
    },
    {
      id: 216,
      country_name: "Norwegia",
      country_code: "NO",
      phone_code: "+47",
    },
    {
      id: 238,
      country_name: "Pulau Svalbard",
      country_code: "SJ",
      phone_code: "+47",
    },
    {
      id: 206,
      country_name: "Polandia",
      country_code: "PL",
      phone_code: "+48",
    },
    { id: 110, country_name: "Jerman", country_code: "DE", phone_code: "+49" },
    {
      id: 237,
      country_name: "Pulau Georgia Selatan",
      country_code: "GS",
      phone_code: "+500",
    },
    { id: 39, country_name: "Belize", country_code: "BZ", phone_code: "+501" },
    {
      id: 185,
      country_name: "Guatemala",
      country_code: "GT",
      phone_code: "+502",
    },
    {
      id: 84,
      country_name: "El Salvador",
      country_code: "SV",
      phone_code: "+503",
    },
    {
      id: 180,
      country_name: "Honduras",
      country_code: "HN",
      phone_code: "+504",
    },
    {
      id: 218,
      country_name: "Nikaragua",
      country_code: "NI",
      phone_code: "+505",
    },
    {
      id: 72,
      country_name: "Kosta Rika",
      country_code: "CR",
      phone_code: "+506",
    },
    { id: 212, country_name: "Panama", country_code: "PA", phone_code: "+507" },
    {
      id: 205,
      country_name: "Saint Pierre dan Miquelon",
      country_code: "PM",
      phone_code: "+508",
    },
    { id: 178, country_name: "Haiti", country_code: "HT", phone_code: "+509" },
    { id: 211, country_name: "Peru", country_code: "PE", phone_code: "+51" },
    { id: 121, country_name: "Meksiko", country_code: "MX", phone_code: "+52" },
    { id: 70, country_name: "Kuba", country_code: "CU", phone_code: "+53" },
    {
      id: 18,
      country_name: "Argentina",
      country_code: "AR",
      phone_code: "+54",
    },
    { id: 48, country_name: "Brazil", country_code: "BR", phone_code: "+55" },
    { id: 76, country_name: "Chili", country_code: "CL", phone_code: "+56" },
    { id: 74, country_name: "Kolumbia", country_code: "CO", phone_code: "+57" },
    {
      id: 92,
      country_name: "Venezuela",
      country_code: "VE",
      phone_code: "+58",
    },
    {
      id: 188,
      country_name: "Guadeloupe",
      country_code: "GP",
      phone_code: "+590",
    },
    { id: 53, country_name: "Bolivia", country_code: "BO", phone_code: "+591" },
    { id: 182, country_name: "Guyana", country_code: "GY", phone_code: "+592" },
    {
      id: 100,
      country_name: "Ekuador",
      country_code: "EC",
      phone_code: "+593",
    },
    {
      id: 194,
      country_name: "Guyana Prancis",
      country_code: "GF",
      phone_code: "+594",
    },
    {
      id: 29,
      country_name: "Paraguay",
      country_code: "PY",
      phone_code: "+595",
    },
    {
      id: 128,
      country_name: "Martinik",
      country_code: "MQ",
      phone_code: "+596",
    },
    {
      id: 88,
      country_name: "Suriname",
      country_code: "SR",
      phone_code: "+597",
    },
    { id: 97, country_name: "Uruguay", country_code: "UY", phone_code: "+598" },
    {
      id: 51,
      country_name: "Bonaire, St. Eustatius dan Saba",
      country_code: "BQ",
      phone_code: "+599",
    },
    { id: 67, country_name: "Curacao", country_code: "CW", phone_code: "+599" },
    {
      id: 120,
      country_name: "Malaysia",
      country_code: "MY",
      phone_code: "+60",
    },
    {
      id: 14,
      country_name: "Australia",
      country_code: "AU",
      phone_code: "+61",
    },
    {
      id: 227,
      country_name: "Kepulauan Cocos",
      country_code: "CC",
      phone_code: "+61",
    },
    {
      id: 228,
      country_name: "Pulau Natal",
      country_code: "CX",
      phone_code: "+61",
    },
    {
      id: 174,
      country_name: "Indonesia",
      country_code: "ID",
      phone_code: "+62",
    },
    {
      id: 208,
      country_name: "Filipina",
      country_code: "PH",
      phone_code: "+63",
    },
    {
      id: 214,
      country_name: "Selandia Baru",
      country_code: "NZ",
      phone_code: "+64",
    },
    {
      id: 236,
      country_name: "Kepulauan Pitcairn",
      country_code: "PN",
      phone_code: "+64",
    },
    {
      id: 43,
      country_name: "Singapura",
      country_code: "SG",
      phone_code: "+65",
    },
    { id: 66, country_name: "Thailand", country_code: "TH", phone_code: "+66" },
    {
      id: 62,
      country_name: "Timor Timur",
      country_code: "TL",
      phone_code: "+670",
    },
    {
      id: 229,
      country_name: "Pulau Heard dan Kepulauan McDonald",
      country_code: "HM",
      phone_code: "+672",
    },
    {
      id: 235,
      country_name: "Pulau Norfolk",
      country_code: "NF",
      phone_code: "+672",
    },
    { id: 54, country_name: "Brunei", country_code: "BN", phone_code: "+673" },
    { id: 223, country_name: "Nauru", country_code: "NR", phone_code: "+674" },
    {
      id: 209,
      country_name: "Papua Nugini",
      country_code: "PG",
      phone_code: "+675",
    },
    { id: 113, country_name: "Tonga", country_code: "TO", phone_code: "+676" },
    {
      id: 50,
      country_name: "Kepulauan Solomon",
      country_code: "SB",
      phone_code: "+677",
    },
    {
      id: 204,
      country_name: "Vanuatu",
      country_code: "VU",
      phone_code: "+678",
    },
    { id: 202, country_name: "Fiji", country_code: "FJ", phone_code: "+679" },
    { id: 30, country_name: "Palau", country_code: "PW", phone_code: "+680" },
    {
      id: 77,
      country_name: "Kepulauan Cook",
      country_code: "CK",
      phone_code: "+682",
    },
    { id: 197, country_name: "Samoa", country_code: "WS", phone_code: "+685" },
    {
      id: 157,
      country_name: "Kiribati",
      country_code: "KI",
      phone_code: "+686",
    },
    {
      id: 117,
      country_name: "Kaledonia Baru",
      country_code: "NC",
      phone_code: "+687",
    },
    { id: 224, country_name: "Tuvalu", country_code: "TV", phone_code: "+688" },
    {
      id: 210,
      country_name: "Polinesia Prancis",
      country_code: "PF",
      phone_code: "+689",
    },
    {
      id: 222,
      country_name: "Mikronesia",
      country_code: "FM",
      phone_code: "+691",
    },
    {
      id: 221,
      country_name: "Kepulauan Marshall",
      country_code: "MH",
      phone_code: "+692",
    },
    {
      id: 151,
      country_name: "Kazakstan",
      country_code: "KZ",
      phone_code: "+7",
    },
    { id: 4, country_name: "Rusia", country_code: "RU", phone_code: "+7" },
    { id: 161, country_name: "Jepang", country_code: "JP", phone_code: "+81" },
    {
      id: 154,
      country_name: "Korea Selatan",
      country_code: "KR",
      phone_code: "+82",
    },
    { id: 89, country_name: "Vietnam", country_code: "VN", phone_code: "+84" },
    {
      id: 181,
      country_name: "Hong Kong",
      country_code: "HK",
      phone_code: "+852",
    },
    {
      id: 130,
      country_name: "Makau, Tiongkok",
      country_code: "MO",
      phone_code: "+853",
    },
    {
      id: 158,
      country_name: "Kamboja",
      country_code: "KH",
      phone_code: "+855",
    },
    { id: 150, country_name: "Laos", country_code: "LA", phone_code: "+856" },
    {
      id: 219,
      country_name: "Daratan Cina",
      country_code: "CN",
      phone_code: "+86",
    },
    {
      id: 7,
      country_name: "Bangladesh",
      country_code: "BD",
      phone_code: "+880",
    },
    { id: 109, country_name: "Taiwan", country_code: "TW", phone_code: "+886" },
    { id: 112, country_name: "Turki", country_code: "TR", phone_code: "+90" },
    { id: 171, country_name: "India", country_code: "IN", phone_code: "+91" },
    {
      id: 207,
      country_name: "Pakistan",
      country_code: "PK",
      phone_code: "+92",
    },
    {
      id: 24,
      country_name: "Afganistan",
      country_code: "AF",
      phone_code: "+93",
    },
    {
      id: 146,
      country_name: "Sri Lanka",
      country_code: "LK",
      phone_code: "+94",
    },
    { id: 132, country_name: "Myanmar", country_code: "MM", phone_code: "+95" },
    {
      id: 123,
      country_name: "Maladewa",
      country_code: "MV",
      phone_code: "+960",
    },
    {
      id: 149,
      country_name: "Libanon",
      country_code: "LB",
      phone_code: "+961",
    },
    {
      id: 162,
      country_name: "Yordania",
      country_code: "JO",
      phone_code: "+962",
    },
    { id: 79, country_name: "Suriah", country_code: "SY", phone_code: "+963" },
    { id: 169, country_name: "Irak", country_code: "IQ", phone_code: "+964" },
    { id: 153, country_name: "Kuwait", country_code: "KW", phone_code: "+965" },
    {
      id: 52,
      country_name: "Arab Saudi",
      country_code: "SA",
      phone_code: "+966",
    },
    { id: 177, country_name: "Yaman", country_code: "YE", phone_code: "+967" },
    { id: 213, country_name: "Oman", country_code: "OM", phone_code: "+968" },
    {
      id: 32,
      country_name: "Wilayah Palestina",
      country_code: "PS",
      phone_code: "+970",
    },
    {
      id: 25,
      country_name: "Uni Emirat Arab",
      country_code: "AE",
      phone_code: "+971",
    },
    { id: 172, country_name: "Israel", country_code: "IL", phone_code: "+972" },
    { id: 58, country_name: "Bahrain", country_code: "BH", phone_code: "+973" },
    { id: 28, country_name: "Qatar", country_code: "QA", phone_code: "+974" },
    { id: 45, country_name: "Bhutan", country_code: "BT", phone_code: "+975" },
    {
      id: 131,
      country_name: "Mongolia",
      country_code: "MN",
      phone_code: "+976",
    },
    { id: 215, country_name: "Nepal", country_code: "NP", phone_code: "+977" },
    { id: 168, country_name: "Iran", country_code: "IR", phone_code: "+98" },
    {
      id: 64,
      country_name: "Tajikistan",
      country_code: "TJ",
      phone_code: "+992",
    },
    {
      id: 115,
      country_name: "Turkmenistan",
      country_code: "TM",
      phone_code: "+993",
    },
    {
      id: 12,
      country_name: "Azerbaijan",
      country_code: "AZ",
      phone_code: "+994",
    },
    {
      id: 195,
      country_name: "Georgia",
      country_code: "GE",
      phone_code: "+995",
    },
    {
      id: 159,
      country_name: "Kirgistan",
      country_code: "KG",
      phone_code: "+996",
    },
    {
      id: 96,
      country_name: "Uzbekistan",
      country_code: "UZ",
      phone_code: "+998",
    },
  ],
  de_DE: [
    { id: 2, country_name: "Kanada", country_code: "CA", phone_code: "+1" },
    {
      id: 239,
      country_name: "Kleinere abgelegene Inseln der USA",
      country_code: "UM",
      phone_code: "+1",
    },
    { id: 5, country_name: "USA", country_code: "US", phone_code: "+1" },
    {
      id: 47,
      country_name: "Bahamas",
      country_code: "BS",
      phone_code: "+1242",
    },
    {
      id: 9,
      country_name: "Barbados",
      country_code: "BB",
      phone_code: "+1246",
    },
    {
      id: 22,
      country_name: "Anguilla",
      country_code: "AI",
      phone_code: "+1264",
    },
    {
      id: 23,
      country_name: "Antigua und Barbuda",
      country_code: "AG",
      phone_code: "+1268",
    },
    {
      id: 90,
      country_name: "Amerikanische Jungferninseln",
      country_code: "VI",
      phone_code: "+1284",
    },
    {
      id: 91,
      country_name: "Britische Jungferninseln",
      country_code: "VG",
      phone_code: "+1340",
    },
    {
      id: 152,
      country_name: "Kaimaninseln",
      country_code: "KY",
      phone_code: "+1345",
    },
    {
      id: 55,
      country_name: "Bermuda",
      country_code: "BM",
      phone_code: "+1441",
    },
    {
      id: 196,
      country_name: "Greneda",
      country_code: "GD",
      phone_code: "+1473",
    },
    {
      id: 73,
      country_name: "Turks- und Caicosinseln",
      country_code: "TC",
      phone_code: "+1649",
    },
    {
      id: 126,
      country_name: "Montserrat",
      country_code: "MS",
      phone_code: "+1664",
    },
    {
      id: 129,
      country_name: "Marianen",
      country_code: "MP",
      phone_code: "+1670",
    },
    { id: 184, country_name: "Guam", country_code: "GU", phone_code: "+1671" },
    {
      id: 17,
      country_name: "Amerikanisch-Samoa",
      country_code: "AS",
      phone_code: "+1684",
    },
    {
      id: 82,
      country_name: "Sint Maarten (niederländischer Teil)",
      country_code: "SX",
      phone_code: "+1721",
    },
    {
      id: 148,
      country_name: "St. Lucia",
      country_code: "LC",
      phone_code: "+1758",
    },
    {
      id: 105,
      country_name: "Dominikanisch",
      country_code: "DM",
      phone_code: "+1767",
    },
    {
      id: 95,
      country_name: "St. Vincent und die Grenadinen",
      country_code: "VC",
      phone_code: "+1784",
    },
    {
      id: 33,
      country_name: "Puerto Rico",
      country_code: "PR",
      phone_code: "+1787",
    },
    {
      id: 104,
      country_name: "Dominikanische Republik",
      country_code: "DO",
      phone_code: "+1809",
    },
    {
      id: 111,
      country_name: "Trinidad und Tobago",
      country_code: "TT",
      phone_code: "+1868",
    },
    {
      id: 155,
      country_name: "St. Kitts und Nevis",
      country_code: "KN",
      phone_code: "+1869",
    },
    {
      id: 163,
      country_name: "Jamaika",
      country_code: "JM",
      phone_code: "+1876",
    },
    { id: 98, country_name: "Ägypten", country_code: "EG", phone_code: "+20" },
    {
      id: 87,
      country_name: "Südsudan",
      country_code: "SS",
      phone_code: "+211",
    },
    {
      id: 139,
      country_name: "Marokko",
      country_code: "MA",
      phone_code: "+212",
    },
    {
      id: 101,
      country_name: "Algerien",
      country_code: "DZ",
      phone_code: "+213",
    },
    {
      id: 114,
      country_name: "Tunesien",
      country_code: "TN",
      phone_code: "+216",
    },
    { id: 140, country_name: "Libyen", country_code: "LY", phone_code: "+218" },
    { id: 190, country_name: "Gambia", country_code: "GM", phone_code: "+220" },
    { id: 35, country_name: "Senegal", country_code: "SN", phone_code: "+221" },
    {
      id: 127,
      country_name: "Mauretanien",
      country_code: "MR",
      phone_code: "+222",
    },
    { id: 133, country_name: "Mali", country_code: "ML", phone_code: "+223" },
    { id: 189, country_name: "Guinea", country_code: "GN", phone_code: "+224" },
    {
      id: 80,
      country_name: "Elfenbeinküste",
      country_code: "CI",
      phone_code: "+225",
    },
    {
      id: 61,
      country_name: "Burkina Faso",
      country_code: "BF",
      phone_code: "+226",
    },
    { id: 116, country_name: "Niger", country_code: "NE", phone_code: "+227" },
    { id: 68, country_name: "Togo", country_code: "TG", phone_code: "+228" },
    { id: 56, country_name: "Benin", country_code: "BJ", phone_code: "+229" },
    {
      id: 124,
      country_name: "Mauritius",
      country_code: "MU",
      phone_code: "+230",
    },
    {
      id: 145,
      country_name: "Liberia",
      country_code: "LR",
      phone_code: "+231",
    },
    {
      id: 37,
      country_name: "Sierra Leone",
      country_code: "SL",
      phone_code: "+232",
    },
    { id: 193, country_name: "Ghana", country_code: "GH", phone_code: "+233" },
    { id: 1, country_name: "Nigeria", country_code: "NG", phone_code: "+234" },
    { id: 71, country_name: "Tschad", country_code: "TD", phone_code: "+235" },
    {
      id: 85,
      country_name: "Zentralafrikanische Republik",
      country_code: "CF",
      phone_code: "+236",
    },
    { id: 75, country_name: "Kamerun", country_code: "CM", phone_code: "+237" },
    { id: 69, country_name: "Kap", country_code: "CV", phone_code: "+238" },
    {
      id: 86,
      country_name: "São Tomé und Príncipe",
      country_code: "ST",
      phone_code: "+239",
    },
    {
      id: 187,
      country_name: "Äquatorialguinea",
      country_code: "GQ",
      phone_code: "+240",
    },
    { id: 199, country_name: "Gabun", country_code: "GA", phone_code: "+241" },
    {
      id: 83,
      country_name: "Republik Kongo",
      country_code: "CG",
      phone_code: "+242",
    },
    {
      id: 3,
      country_name: "Demokratische Republik Kongo",
      country_code: "CD",
      phone_code: "+243",
    },
    { id: 19, country_name: "Angola", country_code: "AO", phone_code: "+244" },
    {
      id: 183,
      country_name: "Guinea-Bissau",
      country_code: "GW",
      phone_code: "+245",
    },
    {
      id: 230,
      country_name: "Britisches Territorium im Indischen Ozean",
      country_code: "IO",
      phone_code: "+246",
    },
    {
      id: 27,
      country_name: "Ascension Island",
      country_code: "AC",
      phone_code: "+247",
    },
    {
      id: 49,
      country_name: "Seychellen",
      country_code: "SC",
      phone_code: "+248",
    },
    { id: 46, country_name: "Sudan", country_code: "SD", phone_code: "+249" },
    { id: 60, country_name: "Ruanda", country_code: "RW", phone_code: "+250" },
    {
      id: 93,
      country_name: "Äthiopien",
      country_code: "ET",
      phone_code: "+251",
    },
    { id: 34, country_name: "Somalia", country_code: "SO", phone_code: "+252" },
    {
      id: 108,
      country_name: "Dschibuti",
      country_code: "DJ",
      phone_code: "+253",
    },
    { id: 160, country_name: "Kenia", country_code: "KE", phone_code: "+254" },
    {
      id: 107,
      country_name: "Tansania",
      country_code: "TZ",
      phone_code: "+255",
    },
    { id: 102, country_name: "Uganda", country_code: "UG", phone_code: "+256" },
    { id: 57, country_name: "Burundi", country_code: "BI", phone_code: "+257" },
    {
      id: 119,
      country_name: "Mosambik",
      country_code: "MZ",
      phone_code: "+258",
    },
    { id: 165, country_name: "Sambia", country_code: "ZM", phone_code: "+260" },
    {
      id: 135,
      country_name: "Madagaskar",
      country_code: "MG",
      phone_code: "+261",
    },
    {
      id: 16,
      country_name: "Wiedervereinigung",
      country_code: "RE",
      phone_code: "+262",
    },
    {
      id: 231,
      country_name: "Französische Südgebiete",
      country_code: "TF",
      phone_code: "+262",
    },
    {
      id: 164,
      country_name: "Simbabwe",
      country_code: "ZW",
      phone_code: "+263",
    },
    {
      id: 118,
      country_name: "Namibia",
      country_code: "NA",
      phone_code: "+264",
    },
    { id: 122, country_name: "Malawi", country_code: "MW", phone_code: "+265" },
    {
      id: 144,
      country_name: "Lesotho",
      country_code: "LS",
      phone_code: "+266",
    },
    {
      id: 42,
      country_name: "Botswana",
      country_code: "BW",
      phone_code: "+267",
    },
    {
      id: 78,
      country_name: "Swasiland",
      country_code: "SZ",
      phone_code: "+268",
    },
    {
      id: 156,
      country_name: "Komoren",
      country_code: "KM",
      phone_code: "+269",
    },
    {
      id: 175,
      country_name: "Mayotte",
      country_code: "YT",
      phone_code: "+269",
    },
    {
      id: 170,
      country_name: "Südafrika",
      country_code: "ZA",
      phone_code: "+27",
    },
    { id: 13, country_name: "Aruba", country_code: "AW", phone_code: "+297" },
    {
      id: 201,
      country_name: "Färöer Inseln",
      country_code: "FO",
      phone_code: "+298",
    },
    {
      id: 191,
      country_name: "Grönland",
      country_code: "GL",
      phone_code: "+299",
    },
    {
      id: 186,
      country_name: "Griechenland",
      country_code: "GR",
      phone_code: "+30",
    },
    {
      id: 217,
      country_name: "Niederlande",
      country_code: "NL",
      phone_code: "+31",
    },
    { id: 6, country_name: "Belgien", country_code: "BE", phone_code: "+32" },
    {
      id: 200,
      country_name: "Frankreich",
      country_code: "FR",
      phone_code: "+33",
    },
    { id: 94, country_name: "Spanien", country_code: "ES", phone_code: "+34" },
    {
      id: 192,
      country_name: "Gibraltar",
      country_code: "GI",
      phone_code: "+350",
    },
    {
      id: 31,
      country_name: "Portugal",
      country_code: "PT",
      phone_code: "+351",
    },
    {
      id: 142,
      country_name: "Luxemburg",
      country_code: "LU",
      phone_code: "+352",
    },
    { id: 173, country_name: "Irland", country_code: "IE", phone_code: "+353" },
    { id: 167, country_name: "Island", country_code: "IS", phone_code: "+354" },
    {
      id: 21,
      country_name: "Albanien",
      country_code: "AL",
      phone_code: "+355",
    },
    { id: 125, country_name: "Malta", country_code: "MT", phone_code: "+356" },
    { id: 65, country_name: "Zypern", country_code: "CY", phone_code: "+357" },
    {
      id: 225,
      country_name: "Åland-Inseln",
      country_code: "AX",
      phone_code: "+358",
    },
    {
      id: 203,
      country_name: "Finnland",
      country_code: "FI",
      phone_code: "+358",
    },
    {
      id: 59,
      country_name: "Bulgarien",
      country_code: "BG",
      phone_code: "+359",
    },
    { id: 176, country_name: "Ungarn", country_code: "HU", phone_code: "+36" },
    {
      id: 143,
      country_name: "Litauen",
      country_code: "LT",
      phone_code: "+370",
    },
    {
      id: 141,
      country_name: "Lettland",
      country_code: "LV",
      phone_code: "+371",
    },
    { id: 99, country_name: "Estland", country_code: "EE", phone_code: "+372" },
    {
      id: 137,
      country_name: "Moldawien",
      country_code: "MD",
      phone_code: "+373",
    },
    {
      id: 20,
      country_name: "Armenien",
      country_code: "AM",
      phone_code: "+374",
    },
    {
      id: 40,
      country_name: "Weißrussland",
      country_code: "BY",
      phone_code: "+375",
    },
    { id: 26, country_name: "Andorra", country_code: "AD", phone_code: "+376" },
    { id: 138, country_name: "Monaco", country_code: "MC", phone_code: "+377" },
    {
      id: 36,
      country_name: "San Marino",
      country_code: "SM",
      phone_code: "+378",
    },
    {
      id: 220,
      country_name: "Vatikanstadt",
      country_code: "VA",
      phone_code: "+379",
    },
    {
      id: 103,
      country_name: "Ukraine",
      country_code: "UA",
      phone_code: "+380",
    },
    { id: 8, country_name: "Serbien", country_code: "RS", phone_code: "+381" },
    {
      id: 136,
      country_name: "Montenegro",
      country_code: "ME",
      phone_code: "+382",
    },
    {
      id: 179,
      country_name: "Kroatien",
      country_code: "HR",
      phone_code: "+385",
    },
    {
      id: 41,
      country_name: "Slowenien",
      country_code: "SI",
      phone_code: "+386",
    },
    {
      id: 10,
      country_name: "Bosnien und Herzegowina",
      country_code: "BA",
      phone_code: "+387",
    },
    {
      id: 134,
      country_name: "Mazedonien",
      country_code: "MK",
      phone_code: "+389",
    },
    { id: 166, country_name: "Italien", country_code: "IT", phone_code: "+39" },
    { id: 11, country_name: "Rumänien", country_code: "RO", phone_code: "+40" },
    { id: 81, country_name: "Schweiz", country_code: "CH", phone_code: "+41" },
    {
      id: 63,
      country_name: "Tschechische Republik",
      country_code: "CZ",
      phone_code: "+420",
    },
    {
      id: 38,
      country_name: "Slowakei",
      country_code: "SK",
      phone_code: "+421",
    },
    {
      id: 147,
      country_name: "Liechtenstein",
      country_code: "LI",
      phone_code: "+423",
    },
    {
      id: 15,
      country_name: "Österreich",
      country_code: "AT",
      phone_code: "+43",
    },
    {
      id: 198,
      country_name: "VEREINIGTES KÖNIGREICH.",
      country_code: "GB",
      phone_code: "+44",
    },
    {
      id: 232,
      country_name: "Guernsey",
      country_code: "GG",
      phone_code: "+44",
    },
    {
      id: 234,
      country_name: "Isle of Man",
      country_code: "IM",
      phone_code: "+44",
    },
    { id: 233, country_name: "Jersey", country_code: "JE", phone_code: "+44" },
    {
      id: 106,
      country_name: "Dänemark",
      country_code: "DK",
      phone_code: "+45",
    },
    { id: 44, country_name: "Schweden", country_code: "SE", phone_code: "+46" },
    {
      id: 226,
      country_name: "Bouvetinsel",
      country_code: "BV",
      phone_code: "+47",
    },
    {
      id: 216,
      country_name: "Norwegen",
      country_code: "NO",
      phone_code: "+47",
    },
    {
      id: 238,
      country_name: "Spitzbergen",
      country_code: "SJ",
      phone_code: "+47",
    },
    { id: 206, country_name: "Polen", country_code: "PL", phone_code: "+48" },
    {
      id: 110,
      country_name: "Deutschland",
      country_code: "DE",
      phone_code: "+49",
    },
    {
      id: 237,
      country_name: "Südgeorgien",
      country_code: "GS",
      phone_code: "+500",
    },
    { id: 39, country_name: "Belize", country_code: "BZ", phone_code: "+501" },
    {
      id: 185,
      country_name: "Guatemala",
      country_code: "GT",
      phone_code: "+502",
    },
    {
      id: 84,
      country_name: "El Salvador",
      country_code: "SV",
      phone_code: "+503",
    },
    {
      id: 180,
      country_name: "Honduras",
      country_code: "HN",
      phone_code: "+504",
    },
    {
      id: 218,
      country_name: "Nicaragua",
      country_code: "NI",
      phone_code: "+505",
    },
    {
      id: 72,
      country_name: "Costa Rica",
      country_code: "CR",
      phone_code: "+506",
    },
    { id: 212, country_name: "Panama", country_code: "PA", phone_code: "+507" },
    {
      id: 205,
      country_name: "Saint-Pierre und Miquelon",
      country_code: "PM",
      phone_code: "+508",
    },
    { id: 178, country_name: "Haiti", country_code: "HT", phone_code: "+509" },
    { id: 211, country_name: "Peru", country_code: "PE", phone_code: "+51" },
    { id: 121, country_name: "Mexiko", country_code: "MX", phone_code: "+52" },
    { id: 70, country_name: "Kuba", country_code: "CU", phone_code: "+53" },
    {
      id: 18,
      country_name: "Argentinien",
      country_code: "AR",
      phone_code: "+54",
    },
    {
      id: 48,
      country_name: "Brasilien",
      country_code: "BR",
      phone_code: "+55",
    },
    { id: 76, country_name: "Chile", country_code: "CL", phone_code: "+56" },
    {
      id: 74,
      country_name: "Kolumbien",
      country_code: "CO",
      phone_code: "+57",
    },
    {
      id: 92,
      country_name: "Venezuela",
      country_code: "VE",
      phone_code: "+58",
    },
    {
      id: 188,
      country_name: "Guadeloupe",
      country_code: "GP",
      phone_code: "+590",
    },
    {
      id: 53,
      country_name: "Bolivien",
      country_code: "BO",
      phone_code: "+591",
    },
    { id: 182, country_name: "Guyana", country_code: "GY", phone_code: "+592" },
    {
      id: 100,
      country_name: "Ecuador",
      country_code: "EC",
      phone_code: "+593",
    },
    {
      id: 194,
      country_name: "Französisch-Guayana",
      country_code: "GF",
      phone_code: "+594",
    },
    {
      id: 29,
      country_name: "Paraguay",
      country_code: "PY",
      phone_code: "+595",
    },
    {
      id: 128,
      country_name: "Martinique",
      country_code: "MQ",
      phone_code: "+596",
    },
    {
      id: 88,
      country_name: "Suriname",
      country_code: "SR",
      phone_code: "+597",
    },
    { id: 97, country_name: "Uruguay", country_code: "UY", phone_code: "+598" },
    {
      id: 51,
      country_name: "Bonaire, St. Eustatius und Saba",
      country_code: "BQ",
      phone_code: "+599",
    },
    { id: 67, country_name: "Curaçao", country_code: "CW", phone_code: "+599" },
    {
      id: 120,
      country_name: "Malaysia",
      country_code: "MY",
      phone_code: "+60",
    },
    {
      id: 14,
      country_name: "Australien",
      country_code: "AU",
      phone_code: "+61",
    },
    {
      id: 227,
      country_name: "Kokosinseln",
      country_code: "CC",
      phone_code: "+61",
    },
    {
      id: 228,
      country_name: "Weihnachtsinsel",
      country_code: "CX",
      phone_code: "+61",
    },
    {
      id: 174,
      country_name: "Indonesien",
      country_code: "ID",
      phone_code: "+62",
    },
    {
      id: 208,
      country_name: "Die Philippinen",
      country_code: "PH",
      phone_code: "+63",
    },
    {
      id: 214,
      country_name: "Neuseeland",
      country_code: "NZ",
      phone_code: "+64",
    },
    {
      id: 236,
      country_name: "Pitcairninseln",
      country_code: "PN",
      phone_code: "+64",
    },
    { id: 43, country_name: "Singapur", country_code: "SG", phone_code: "+65" },
    { id: 66, country_name: "Thailand", country_code: "TH", phone_code: "+66" },
    {
      id: 62,
      country_name: "Osttimor",
      country_code: "TL",
      phone_code: "+670",
    },
    {
      id: 229,
      country_name: "Heard Island und McDonald Islands",
      country_code: "HM",
      phone_code: "+672",
    },
    {
      id: 235,
      country_name: "Norfolkinsel",
      country_code: "NF",
      phone_code: "+672",
    },
    { id: 54, country_name: "Brunei", country_code: "BN", phone_code: "+673" },
    { id: 223, country_name: "Nauru", country_code: "NR", phone_code: "+674" },
    {
      id: 209,
      country_name: "Papua-Neuguinea",
      country_code: "PG",
      phone_code: "+675",
    },
    { id: 113, country_name: "Tonga", country_code: "TO", phone_code: "+676" },
    {
      id: 50,
      country_name: "Salomonen",
      country_code: "SB",
      phone_code: "+677",
    },
    {
      id: 204,
      country_name: "Vanuatu",
      country_code: "VU",
      phone_code: "+678",
    },
    {
      id: 202,
      country_name: "Fidschi",
      country_code: "FJ",
      phone_code: "+679",
    },
    { id: 30, country_name: "Palau", country_code: "PW", phone_code: "+680" },
    {
      id: 77,
      country_name: "Cookinseln",
      country_code: "CK",
      phone_code: "+682",
    },
    { id: 197, country_name: "Samoa", country_code: "WS", phone_code: "+685" },
    {
      id: 157,
      country_name: "Kiribati",
      country_code: "KI",
      phone_code: "+686",
    },
    {
      id: 117,
      country_name: "Neukaledonien",
      country_code: "NC",
      phone_code: "+687",
    },
    { id: 224, country_name: "Tuvalu", country_code: "TV", phone_code: "+688" },
    {
      id: 210,
      country_name: "Französisch-Polynesien",
      country_code: "PF",
      phone_code: "+689",
    },
    {
      id: 222,
      country_name: "Mikronesien",
      country_code: "FM",
      phone_code: "+691",
    },
    {
      id: 221,
      country_name: "Marshallinseln",
      country_code: "MH",
      phone_code: "+692",
    },
    {
      id: 151,
      country_name: "Kasachstan",
      country_code: "KZ",
      phone_code: "+7",
    },
    { id: 4, country_name: "Russland", country_code: "RU", phone_code: "+7" },
    { id: 161, country_name: "Japan", country_code: "JP", phone_code: "+81" },
    {
      id: 154,
      country_name: "Südkorea",
      country_code: "KR",
      phone_code: "+82",
    },
    { id: 89, country_name: "Vietnam", country_code: "VN", phone_code: "+84" },
    {
      id: 181,
      country_name: "Hongkong",
      country_code: "HK",
      phone_code: "+852",
    },
    {
      id: 130,
      country_name: "Macau, China",
      country_code: "MO",
      phone_code: "+853",
    },
    {
      id: 158,
      country_name: "Kambodscha",
      country_code: "KH",
      phone_code: "+855",
    },
    { id: 150, country_name: "Laos", country_code: "LA", phone_code: "+856" },
    {
      id: 219,
      country_name: "Chinesisches Festland",
      country_code: "CN",
      phone_code: "+86",
    },
    {
      id: 7,
      country_name: "Bangladesch",
      country_code: "BD",
      phone_code: "+880",
    },
    { id: 109, country_name: "Taiwan", country_code: "TW", phone_code: "+886" },
    { id: 112, country_name: "Türkei", country_code: "TR", phone_code: "+90" },
    { id: 171, country_name: "Indien", country_code: "IN", phone_code: "+91" },
    {
      id: 207,
      country_name: "Pakistan",
      country_code: "PK",
      phone_code: "+92",
    },
    {
      id: 24,
      country_name: "Afghanistan",
      country_code: "AF",
      phone_code: "+93",
    },
    {
      id: 146,
      country_name: "Sri Lanka",
      country_code: "LK",
      phone_code: "+94",
    },
    { id: 132, country_name: "Myanmar", country_code: "MM", phone_code: "+95" },
    {
      id: 123,
      country_name: "Malediven",
      country_code: "MV",
      phone_code: "+960",
    },
    {
      id: 149,
      country_name: "Libanon",
      country_code: "LB",
      phone_code: "+961",
    },
    {
      id: 162,
      country_name: "Jordanien",
      country_code: "JO",
      phone_code: "+962",
    },
    { id: 79, country_name: "Syrien", country_code: "SY", phone_code: "+963" },
    { id: 169, country_name: "Irak", country_code: "IQ", phone_code: "+964" },
    { id: 153, country_name: "Kuwait", country_code: "KW", phone_code: "+965" },
    {
      id: 52,
      country_name: "Saudi-Arabien",
      country_code: "SA",
      phone_code: "+966",
    },
    { id: 177, country_name: "Jemen", country_code: "YE", phone_code: "+967" },
    { id: 213, country_name: "Oman", country_code: "OM", phone_code: "+968" },
    {
      id: 32,
      country_name: "Palästinensisches Gebiet",
      country_code: "PS",
      phone_code: "+970",
    },
    {
      id: 25,
      country_name: "Vereinigte Arabische Emirate",
      country_code: "AE",
      phone_code: "+971",
    },
    { id: 172, country_name: "Israel", country_code: "IL", phone_code: "+972" },
    { id: 58, country_name: "Bahrain", country_code: "BH", phone_code: "+973" },
    { id: 28, country_name: "Katar", country_code: "QA", phone_code: "+974" },
    { id: 45, country_name: "Bhutan", country_code: "BT", phone_code: "+975" },
    {
      id: 131,
      country_name: "Mongolei",
      country_code: "MN",
      phone_code: "+976",
    },
    { id: 215, country_name: "Nepal", country_code: "NP", phone_code: "+977" },
    { id: 168, country_name: "Iran", country_code: "IR", phone_code: "+98" },
    {
      id: 64,
      country_name: "Tadschikistan",
      country_code: "TJ",
      phone_code: "+992",
    },
    {
      id: 115,
      country_name: "Turkmenistan",
      country_code: "TM",
      phone_code: "+993",
    },
    {
      id: 12,
      country_name: "Aserbaidschan",
      country_code: "AZ",
      phone_code: "+994",
    },
    {
      id: 195,
      country_name: "Georgia",
      country_code: "GE",
      phone_code: "+995",
    },
    {
      id: 159,
      country_name: "Kirgisistan",
      country_code: "KG",
      phone_code: "+996",
    },
    {
      id: 96,
      country_name: "Usbekistan",
      country_code: "UZ",
      phone_code: "+998",
    },
  ],
  it_IT: [
    { id: 2, country_name: "Canada", country_code: "CA", phone_code: "+1" },
    {
      id: 239,
      country_name: "Isole minori esterne degli Stati Uniti",
      country_code: "UM",
      phone_code: "+1",
    },
    { id: 5, country_name: "U.S.A.", country_code: "US", phone_code: "+1" },
    {
      id: 47,
      country_name: "Bahamas",
      country_code: "BS",
      phone_code: "+1242",
    },
    {
      id: 9,
      country_name: "Barbados",
      country_code: "BB",
      phone_code: "+1246",
    },
    {
      id: 22,
      country_name: "Anguilla",
      country_code: "AI",
      phone_code: "+1264",
    },
    {
      id: 23,
      country_name: "Antigua e Barbuda",
      country_code: "AG",
      phone_code: "+1268",
    },
    {
      id: 90,
      country_name: "Isole Vergini americane",
      country_code: "VI",
      phone_code: "+1284",
    },
    {
      id: 91,
      country_name: "Isole Vergini britanniche",
      country_code: "VG",
      phone_code: "+1340",
    },
    {
      id: 152,
      country_name: "Isole Cayman",
      country_code: "KY",
      phone_code: "+1345",
    },
    {
      id: 55,
      country_name: "Bermuda",
      country_code: "BM",
      phone_code: "+1441",
    },
    {
      id: 196,
      country_name: "Grenada",
      country_code: "GD",
      phone_code: "+1473",
    },
    {
      id: 73,
      country_name: "Isole Turks e Caicos",
      country_code: "TC",
      phone_code: "+1649",
    },
    {
      id: 126,
      country_name: "Montserrat",
      country_code: "MS",
      phone_code: "+1664",
    },
    {
      id: 129,
      country_name: "Isole Marianne",
      country_code: "MP",
      phone_code: "+1670",
    },
    { id: 184, country_name: "Guam", country_code: "GU", phone_code: "+1671" },
    {
      id: 17,
      country_name: "Samoa americane",
      country_code: "AS",
      phone_code: "+1684",
    },
    {
      id: 82,
      country_name: "Sint Maarten (parte olandese)",
      country_code: "SX",
      phone_code: "+1721",
    },
    {
      id: 148,
      country_name: "Santa Lucia",
      country_code: "LC",
      phone_code: "+1758",
    },
    {
      id: 105,
      country_name: "Dominicano",
      country_code: "DM",
      phone_code: "+1767",
    },
    {
      id: 95,
      country_name: "Saint Vincent e Grenadine",
      country_code: "VC",
      phone_code: "+1784",
    },
    {
      id: 33,
      country_name: "Porto Rico",
      country_code: "PR",
      phone_code: "+1787",
    },
    {
      id: 104,
      country_name: "Repubblica Dominicana",
      country_code: "DO",
      phone_code: "+1809",
    },
    {
      id: 111,
      country_name: "Trinidad e Tobago",
      country_code: "TT",
      phone_code: "+1868",
    },
    {
      id: 155,
      country_name: "Saint Kitts e Nevis",
      country_code: "KN",
      phone_code: "+1869",
    },
    {
      id: 163,
      country_name: "Giamaica",
      country_code: "JM",
      phone_code: "+1876",
    },
    { id: 98, country_name: "Egitto", country_code: "EG", phone_code: "+20" },
    {
      id: 87,
      country_name: "Sudan del Sud",
      country_code: "SS",
      phone_code: "+211",
    },
    {
      id: 139,
      country_name: "Marocco",
      country_code: "MA",
      phone_code: "+212",
    },
    {
      id: 101,
      country_name: "Algeria",
      country_code: "DZ",
      phone_code: "+213",
    },
    {
      id: 114,
      country_name: "Tunisia",
      country_code: "TN",
      phone_code: "+216",
    },
    { id: 140, country_name: "Libia", country_code: "LY", phone_code: "+218" },
    { id: 190, country_name: "Gambia", country_code: "GM", phone_code: "+220" },
    { id: 35, country_name: "Senegal", country_code: "SN", phone_code: "+221" },
    {
      id: 127,
      country_name: "Mauritania",
      country_code: "MR",
      phone_code: "+222",
    },
    { id: 133, country_name: "Mali", country_code: "ML", phone_code: "+223" },
    { id: 189, country_name: "Guinea", country_code: "GN", phone_code: "+224" },
    {
      id: 80,
      country_name: "Costa d'Avorio",
      country_code: "CI",
      phone_code: "+225",
    },
    {
      id: 61,
      country_name: "Burkina Faso",
      country_code: "BF",
      phone_code: "+226",
    },
    { id: 116, country_name: "Niger", country_code: "NE", phone_code: "+227" },
    { id: 68, country_name: "Togo", country_code: "TG", phone_code: "+228" },
    { id: 56, country_name: "Benin", country_code: "BJ", phone_code: "+229" },
    {
      id: 124,
      country_name: "Maurizio",
      country_code: "MU",
      phone_code: "+230",
    },
    {
      id: 145,
      country_name: "Liberia",
      country_code: "LR",
      phone_code: "+231",
    },
    {
      id: 37,
      country_name: "Sierra Leone",
      country_code: "SL",
      phone_code: "+232",
    },
    { id: 193, country_name: "Ghana", country_code: "GH", phone_code: "+233" },
    { id: 1, country_name: "Nigeria", country_code: "NG", phone_code: "+234" },
    { id: 71, country_name: "Chad", country_code: "TD", phone_code: "+235" },
    {
      id: 85,
      country_name: "Repubblica Centrafricana",
      country_code: "CF",
      phone_code: "+236",
    },
    { id: 75, country_name: "Camerun", country_code: "CM", phone_code: "+237" },
    { id: 69, country_name: "Capo", country_code: "CV", phone_code: "+238" },
    {
      id: 86,
      country_name: "Sao Tomé e Principe",
      country_code: "ST",
      phone_code: "+239",
    },
    {
      id: 187,
      country_name: "Guinea Equatoriale",
      country_code: "GQ",
      phone_code: "+240",
    },
    { id: 199, country_name: "Gabon", country_code: "GA", phone_code: "+241" },
    {
      id: 83,
      country_name: "Repubblica del Congo",
      country_code: "CG",
      phone_code: "+242",
    },
    {
      id: 3,
      country_name: "Repubblica Democratica del Congo",
      country_code: "CD",
      phone_code: "+243",
    },
    { id: 19, country_name: "Angola", country_code: "AO", phone_code: "+244" },
    {
      id: 183,
      country_name: "Guinea-Bissau",
      country_code: "GW",
      phone_code: "+245",
    },
    {
      id: 230,
      country_name: "Territorio britannico dell'Oceano Indiano",
      country_code: "IO",
      phone_code: "+246",
    },
    {
      id: 27,
      country_name: "Isola di Ascensione",
      country_code: "AC",
      phone_code: "+247",
    },
    {
      id: 49,
      country_name: "Seychelles",
      country_code: "SC",
      phone_code: "+248",
    },
    { id: 46, country_name: "Sudan", country_code: "SD", phone_code: "+249" },
    { id: 60, country_name: "Ruanda", country_code: "RW", phone_code: "+250" },
    { id: 93, country_name: "Etiopia", country_code: "ET", phone_code: "+251" },
    { id: 34, country_name: "Somalia", country_code: "SO", phone_code: "+252" },
    { id: 108, country_name: "Gibuti", country_code: "DJ", phone_code: "+253" },
    { id: 160, country_name: "Kenia", country_code: "KE", phone_code: "+254" },
    {
      id: 107,
      country_name: "Tanzania",
      country_code: "TZ",
      phone_code: "+255",
    },
    { id: 102, country_name: "Uganda", country_code: "UG", phone_code: "+256" },
    { id: 57, country_name: "Burundi", country_code: "BI", phone_code: "+257" },
    {
      id: 119,
      country_name: "Mozambico",
      country_code: "MZ",
      phone_code: "+258",
    },
    { id: 165, country_name: "Zambia", country_code: "ZM", phone_code: "+260" },
    {
      id: 135,
      country_name: "Madagascar",
      country_code: "MG",
      phone_code: "+261",
    },
    {
      id: 16,
      country_name: "Riunione",
      country_code: "RE",
      phone_code: "+262",
    },
    {
      id: 231,
      country_name: "Territori francesi australi",
      country_code: "TF",
      phone_code: "+262",
    },
    {
      id: 164,
      country_name: "Zimbabwe",
      country_code: "ZW",
      phone_code: "+263",
    },
    {
      id: 118,
      country_name: "Namibia",
      country_code: "NA",
      phone_code: "+264",
    },
    { id: 122, country_name: "Malawi", country_code: "MW", phone_code: "+265" },
    {
      id: 144,
      country_name: "Lesotho",
      country_code: "LS",
      phone_code: "+266",
    },
    {
      id: 42,
      country_name: "Il Botswana",
      country_code: "BW",
      phone_code: "+267",
    },
    {
      id: 78,
      country_name: "Swaziland",
      country_code: "SZ",
      phone_code: "+268",
    },
    { id: 156, country_name: "Comore", country_code: "KM", phone_code: "+269" },
    {
      id: 175,
      country_name: "Mayotte",
      country_code: "YT",
      phone_code: "+269",
    },
    {
      id: 170,
      country_name: "Sudafrica",
      country_code: "ZA",
      phone_code: "+27",
    },
    { id: 13, country_name: "Aruba", country_code: "AW", phone_code: "+297" },
    {
      id: 201,
      country_name: "Isole Faroe",
      country_code: "FO",
      phone_code: "+298",
    },
    {
      id: 191,
      country_name: "Groenlandia",
      country_code: "GL",
      phone_code: "+299",
    },
    { id: 186, country_name: "Grecia", country_code: "GR", phone_code: "+30" },
    {
      id: 217,
      country_name: "Paesi Bassi",
      country_code: "NL",
      phone_code: "+31",
    },
    { id: 6, country_name: "Belgio", country_code: "BE", phone_code: "+32" },
    { id: 200, country_name: "Francia", country_code: "FR", phone_code: "+33" },
    { id: 94, country_name: "Spagna", country_code: "ES", phone_code: "+34" },
    {
      id: 192,
      country_name: "Gibilterra",
      country_code: "GI",
      phone_code: "+350",
    },
    {
      id: 31,
      country_name: "Portogallo",
      country_code: "PT",
      phone_code: "+351",
    },
    {
      id: 142,
      country_name: "Lussemburgo",
      country_code: "LU",
      phone_code: "+352",
    },
    {
      id: 173,
      country_name: "Irlanda",
      country_code: "IE",
      phone_code: "+353",
    },
    {
      id: 167,
      country_name: "Islanda",
      country_code: "IS",
      phone_code: "+354",
    },
    { id: 21, country_name: "Albania", country_code: "AL", phone_code: "+355" },
    { id: 125, country_name: "Malta", country_code: "MT", phone_code: "+356" },
    { id: 65, country_name: "Cipro", country_code: "CY", phone_code: "+357" },
    {
      id: 225,
      country_name: "Isole Åland",
      country_code: "AX",
      phone_code: "+358",
    },
    {
      id: 203,
      country_name: "Finlandia",
      country_code: "FI",
      phone_code: "+358",
    },
    {
      id: 59,
      country_name: "Bulgaria",
      country_code: "BG",
      phone_code: "+359",
    },
    {
      id: 176,
      country_name: "Ungheria",
      country_code: "HU",
      phone_code: "+36",
    },
    {
      id: 143,
      country_name: "Lituania",
      country_code: "LT",
      phone_code: "+370",
    },
    {
      id: 141,
      country_name: "Lettonia",
      country_code: "LV",
      phone_code: "+371",
    },
    { id: 99, country_name: "Estonia", country_code: "EE", phone_code: "+372" },
    {
      id: 137,
      country_name: "Moldavia",
      country_code: "MD",
      phone_code: "+373",
    },
    { id: 20, country_name: "Armenia", country_code: "AM", phone_code: "+374" },
    {
      id: 40,
      country_name: "Bielorussia",
      country_code: "BY",
      phone_code: "+375",
    },
    { id: 26, country_name: "Andorra", country_code: "AD", phone_code: "+376" },
    { id: 138, country_name: "Monaco", country_code: "MC", phone_code: "+377" },
    {
      id: 36,
      country_name: "San Marino",
      country_code: "SM",
      phone_code: "+378",
    },
    {
      id: 220,
      country_name: "Città del Vaticano",
      country_code: "VA",
      phone_code: "+379",
    },
    {
      id: 103,
      country_name: "Ucraina",
      country_code: "UA",
      phone_code: "+380",
    },
    { id: 8, country_name: "Serbia", country_code: "RS", phone_code: "+381" },
    {
      id: 136,
      country_name: "Montenegro",
      country_code: "ME",
      phone_code: "+382",
    },
    {
      id: 179,
      country_name: "Croazia",
      country_code: "HR",
      phone_code: "+385",
    },
    {
      id: 41,
      country_name: "Slovenia",
      country_code: "SI",
      phone_code: "+386",
    },
    {
      id: 10,
      country_name: "Bosnia ed Erzegovina",
      country_code: "BA",
      phone_code: "+387",
    },
    {
      id: 134,
      country_name: "Macedonia",
      country_code: "MK",
      phone_code: "+389",
    },
    { id: 166, country_name: "Italia", country_code: "IT", phone_code: "+39" },
    { id: 11, country_name: "Romania", country_code: "RO", phone_code: "+40" },
    { id: 81, country_name: "Svizzera", country_code: "CH", phone_code: "+41" },
    {
      id: 63,
      country_name: "Repubblica Ceca",
      country_code: "CZ",
      phone_code: "+420",
    },
    {
      id: 38,
      country_name: "Slovacchia",
      country_code: "SK",
      phone_code: "+421",
    },
    {
      id: 147,
      country_name: "Liechtenstein",
      country_code: "LI",
      phone_code: "+423",
    },
    { id: 15, country_name: "Austria", country_code: "AT", phone_code: "+43" },
    {
      id: 198,
      country_name: "REGNO UNITO.",
      country_code: "GB",
      phone_code: "+44",
    },
    {
      id: 232,
      country_name: "Guernsey",
      country_code: "GG",
      phone_code: "+44",
    },
    {
      id: 234,
      country_name: "Isola di Man",
      country_code: "IM",
      phone_code: "+44",
    },
    { id: 233, country_name: "Maglia", country_code: "JE", phone_code: "+44" },
    {
      id: 106,
      country_name: "Danimarca",
      country_code: "DK",
      phone_code: "+45",
    },
    { id: 44, country_name: "Svezia", country_code: "SE", phone_code: "+46" },
    {
      id: 226,
      country_name: "Isola Bouvet",
      country_code: "BV",
      phone_code: "+47",
    },
    {
      id: 216,
      country_name: "Norvegia",
      country_code: "NO",
      phone_code: "+47",
    },
    {
      id: 238,
      country_name: "Isole Svalbard",
      country_code: "SJ",
      phone_code: "+47",
    },
    { id: 206, country_name: "Polonia", country_code: "PL", phone_code: "+48" },
    {
      id: 110,
      country_name: "Germania",
      country_code: "DE",
      phone_code: "+49",
    },
    {
      id: 237,
      country_name: "Isola della Georgia del Sud",
      country_code: "GS",
      phone_code: "+500",
    },
    { id: 39, country_name: "Belize", country_code: "BZ", phone_code: "+501" },
    {
      id: 185,
      country_name: "Guatemala",
      country_code: "GT",
      phone_code: "+502",
    },
    {
      id: 84,
      country_name: "El Salvador",
      country_code: "SV",
      phone_code: "+503",
    },
    {
      id: 180,
      country_name: "Honduras",
      country_code: "HN",
      phone_code: "+504",
    },
    {
      id: 218,
      country_name: "Nicaragua",
      country_code: "NI",
      phone_code: "+505",
    },
    {
      id: 72,
      country_name: "Costa Rica",
      country_code: "CR",
      phone_code: "+506",
    },
    { id: 212, country_name: "Panama", country_code: "PA", phone_code: "+507" },
    {
      id: 205,
      country_name: "Saint Pierre e Miquelon",
      country_code: "PM",
      phone_code: "+508",
    },
    { id: 178, country_name: "Haiti", country_code: "HT", phone_code: "+509" },
    { id: 211, country_name: "Perù", country_code: "PE", phone_code: "+51" },
    { id: 121, country_name: "Messico", country_code: "MX", phone_code: "+52" },
    { id: 70, country_name: "Cuba", country_code: "CU", phone_code: "+53" },
    {
      id: 18,
      country_name: "Argentina",
      country_code: "AR",
      phone_code: "+54",
    },
    { id: 48, country_name: "Brasile", country_code: "BR", phone_code: "+55" },
    { id: 76, country_name: "Chile", country_code: "CL", phone_code: "+56" },
    { id: 74, country_name: "Colombia", country_code: "CO", phone_code: "+57" },
    {
      id: 92,
      country_name: "Venezuela",
      country_code: "VE",
      phone_code: "+58",
    },
    {
      id: 188,
      country_name: "Guadalupa",
      country_code: "GP",
      phone_code: "+590",
    },
    { id: 53, country_name: "Bolivia", country_code: "BO", phone_code: "+591" },
    { id: 182, country_name: "Guyana", country_code: "GY", phone_code: "+592" },
    {
      id: 100,
      country_name: "Ecuador",
      country_code: "EC",
      phone_code: "+593",
    },
    {
      id: 194,
      country_name: "Guyana francese",
      country_code: "GF",
      phone_code: "+594",
    },
    {
      id: 29,
      country_name: "Il Paraguay",
      country_code: "PY",
      phone_code: "+595",
    },
    {
      id: 128,
      country_name: "Martinica",
      country_code: "MQ",
      phone_code: "+596",
    },
    {
      id: 88,
      country_name: "Suriname",
      country_code: "SR",
      phone_code: "+597",
    },
    { id: 97, country_name: "Uruguay", country_code: "UY", phone_code: "+598" },
    {
      id: 51,
      country_name: "Bonaire, Sant'Eustazio e Saba",
      country_code: "BQ",
      phone_code: "+599",
    },
    { id: 67, country_name: "Curaçao", country_code: "CW", phone_code: "+599" },
    {
      id: 120,
      country_name: "Malaysia",
      country_code: "MY",
      phone_code: "+60",
    },
    {
      id: 14,
      country_name: "Australia",
      country_code: "AU",
      phone_code: "+61",
    },
    {
      id: 227,
      country_name: "Isole Cocos",
      country_code: "CC",
      phone_code: "+61",
    },
    {
      id: 228,
      country_name: "Isola di Natale",
      country_code: "CX",
      phone_code: "+61",
    },
    {
      id: 174,
      country_name: "Indonesia",
      country_code: "ID",
      phone_code: "+62",
    },
    {
      id: 208,
      country_name: "Le Filippine",
      country_code: "PH",
      phone_code: "+63",
    },
    {
      id: 214,
      country_name: "Nuova Zelanda",
      country_code: "NZ",
      phone_code: "+64",
    },
    {
      id: 236,
      country_name: "Isole Pitcairn",
      country_code: "PN",
      phone_code: "+64",
    },
    {
      id: 43,
      country_name: "Singapore",
      country_code: "SG",
      phone_code: "+65",
    },
    {
      id: 66,
      country_name: "Thailandia",
      country_code: "TH",
      phone_code: "+66",
    },
    {
      id: 62,
      country_name: "Timor Est",
      country_code: "TL",
      phone_code: "+670",
    },
    {
      id: 229,
      country_name: "Isole Heard e McDonald",
      country_code: "HM",
      phone_code: "+672",
    },
    {
      id: 235,
      country_name: "Isola Norfolk",
      country_code: "NF",
      phone_code: "+672",
    },
    { id: 54, country_name: "Brunei", country_code: "BN", phone_code: "+673" },
    { id: 223, country_name: "Nauru", country_code: "NR", phone_code: "+674" },
    {
      id: 209,
      country_name: "Papua Nuova Guinea",
      country_code: "PG",
      phone_code: "+675",
    },
    { id: 113, country_name: "Tonga", country_code: "TO", phone_code: "+676" },
    {
      id: 50,
      country_name: "Isole Salomone",
      country_code: "SB",
      phone_code: "+677",
    },
    {
      id: 204,
      country_name: "Vanuatu",
      country_code: "VU",
      phone_code: "+678",
    },
    { id: 202, country_name: "Figi", country_code: "FJ", phone_code: "+679" },
    { id: 30, country_name: "Palau", country_code: "PW", phone_code: "+680" },
    {
      id: 77,
      country_name: "Isole Cook",
      country_code: "CK",
      phone_code: "+682",
    },
    { id: 197, country_name: "Samoa", country_code: "WS", phone_code: "+685" },
    {
      id: 157,
      country_name: "Kiribati",
      country_code: "KI",
      phone_code: "+686",
    },
    {
      id: 117,
      country_name: "Nuova Caledonia",
      country_code: "NC",
      phone_code: "+687",
    },
    { id: 224, country_name: "Tuvalu", country_code: "TV", phone_code: "+688" },
    {
      id: 210,
      country_name: "Polinesia francese",
      country_code: "PF",
      phone_code: "+689",
    },
    {
      id: 222,
      country_name: "Micronesia",
      country_code: "FM",
      phone_code: "+691",
    },
    {
      id: 221,
      country_name: "Isole Marshall",
      country_code: "MH",
      phone_code: "+692",
    },
    {
      id: 151,
      country_name: "Kazakistan",
      country_code: "KZ",
      phone_code: "+7",
    },
    { id: 4, country_name: "Russia", country_code: "RU", phone_code: "+7" },
    {
      id: 161,
      country_name: "Giappone",
      country_code: "JP",
      phone_code: "+81",
    },
    {
      id: 154,
      country_name: "Corea del Sud",
      country_code: "KR",
      phone_code: "+82",
    },
    { id: 89, country_name: "Vietnam", country_code: "VN", phone_code: "+84" },
    {
      id: 181,
      country_name: "Hong Kong",
      country_code: "HK",
      phone_code: "+852",
    },
    {
      id: 130,
      country_name: "Macao, Cina",
      country_code: "MO",
      phone_code: "+853",
    },
    {
      id: 158,
      country_name: "Cambogia",
      country_code: "KH",
      phone_code: "+855",
    },
    { id: 150, country_name: "Laos", country_code: "LA", phone_code: "+856" },
    {
      id: 219,
      country_name: "Cina continentale",
      country_code: "CN",
      phone_code: "+86",
    },
    {
      id: 7,
      country_name: "Bangladesh",
      country_code: "BD",
      phone_code: "+880",
    },
    { id: 109, country_name: "Taiwan", country_code: "TW", phone_code: "+886" },
    { id: 112, country_name: "Turchia", country_code: "TR", phone_code: "+90" },
    { id: 171, country_name: "India", country_code: "IN", phone_code: "+91" },
    {
      id: 207,
      country_name: "Pakistan",
      country_code: "PK",
      phone_code: "+92",
    },
    {
      id: 24,
      country_name: "Afghanistan",
      country_code: "AF",
      phone_code: "+93",
    },
    {
      id: 146,
      country_name: "Sri Lanka",
      country_code: "LK",
      phone_code: "+94",
    },
    {
      id: 132,
      country_name: "Birmania",
      country_code: "MM",
      phone_code: "+95",
    },
    {
      id: 123,
      country_name: "Maldive",
      country_code: "MV",
      phone_code: "+960",
    },
    { id: 149, country_name: "Libano", country_code: "LB", phone_code: "+961" },
    {
      id: 162,
      country_name: "Giordania",
      country_code: "JO",
      phone_code: "+962",
    },
    { id: 79, country_name: "Siria", country_code: "SY", phone_code: "+963" },
    { id: 169, country_name: "Iraq", country_code: "IQ", phone_code: "+964" },
    { id: 153, country_name: "Kuwait", country_code: "KW", phone_code: "+965" },
    {
      id: 52,
      country_name: "Arabia Saudita",
      country_code: "SA",
      phone_code: "+966",
    },
    { id: 177, country_name: "Yemen", country_code: "YE", phone_code: "+967" },
    { id: 213, country_name: "Oman", country_code: "OM", phone_code: "+968" },
    {
      id: 32,
      country_name: "Territorio palestinese",
      country_code: "PS",
      phone_code: "+970",
    },
    {
      id: 25,
      country_name: "Emirati Arabi Uniti",
      country_code: "AE",
      phone_code: "+971",
    },
    {
      id: 172,
      country_name: "Israele",
      country_code: "IL",
      phone_code: "+972",
    },
    { id: 58, country_name: "Bahrein", country_code: "BH", phone_code: "+973" },
    { id: 28, country_name: "Qatar", country_code: "QA", phone_code: "+974" },
    {
      id: 45,
      country_name: "Il Bhutan",
      country_code: "BT",
      phone_code: "+975",
    },
    {
      id: 131,
      country_name: "Mongolia",
      country_code: "MN",
      phone_code: "+976",
    },
    { id: 215, country_name: "Nepal", country_code: "NP", phone_code: "+977" },
    { id: 168, country_name: "L'Iran", country_code: "IR", phone_code: "+98" },
    {
      id: 64,
      country_name: "Tagikistan",
      country_code: "TJ",
      phone_code: "+992",
    },
    {
      id: 115,
      country_name: "Turkmenistan",
      country_code: "TM",
      phone_code: "+993",
    },
    {
      id: 12,
      country_name: "Azerbaigian",
      country_code: "AZ",
      phone_code: "+994",
    },
    {
      id: 195,
      country_name: "Georgia",
      country_code: "GE",
      phone_code: "+995",
    },
    {
      id: 159,
      country_name: "Kirghizistan",
      country_code: "KG",
      phone_code: "+996",
    },
    {
      id: 96,
      country_name: "Uzbekistan",
      country_code: "UZ",
      phone_code: "+998",
    },
  ],
  pl_PL: [
    { id: 2, country_name: "Kanada", country_code: "CA", phone_code: "+1" },
    {
      id: 239,
      country_name: "Dalekie Wyspy Mniejsze Stanów Zjednoczonych",
      country_code: "UM",
      phone_code: "+1",
    },
    { id: 5, country_name: "USA", country_code: "US", phone_code: "+1" },
    { id: 47, country_name: "Bahamy", country_code: "BS", phone_code: "+1242" },
    {
      id: 9,
      country_name: "Barbados",
      country_code: "BB",
      phone_code: "+1246",
    },
    {
      id: 22,
      country_name: "Anguilla",
      country_code: "AI",
      phone_code: "+1264",
    },
    {
      id: 23,
      country_name: "Antigua i Barbuda",
      country_code: "AG",
      phone_code: "+1268",
    },
    {
      id: 90,
      country_name: "Wyspy Dziewicze Stanów Zjednoczonych",
      country_code: "VI",
      phone_code: "+1284",
    },
    {
      id: 91,
      country_name: "Brytyjskie Wyspy Dziewicze",
      country_code: "VG",
      phone_code: "+1340",
    },
    {
      id: 152,
      country_name: "Wyspy Kajmany",
      country_code: "KY",
      phone_code: "+1345",
    },
    {
      id: 55,
      country_name: "Bermudy",
      country_code: "BM",
      phone_code: "+1441",
    },
    {
      id: 196,
      country_name: "Greneda",
      country_code: "GD",
      phone_code: "+1473",
    },
    {
      id: 73,
      country_name: "Wyspy Turks i Caicos",
      country_code: "TC",
      phone_code: "+1649",
    },
    {
      id: 126,
      country_name: "Montserrat",
      country_code: "MS",
      phone_code: "+1664",
    },
    {
      id: 129,
      country_name: "Wyspy Mariańskie",
      country_code: "MP",
      phone_code: "+1670",
    },
    { id: 184, country_name: "Guam", country_code: "GU", phone_code: "+1671" },
    {
      id: 17,
      country_name: "Samoa Amerykańskie",
      country_code: "AS",
      phone_code: "+1684",
    },
    {
      id: 82,
      country_name: "Sint Maarten (część holenderska)",
      country_code: "SX",
      phone_code: "+1721",
    },
    {
      id: 148,
      country_name: "Święta Łucja",
      country_code: "LC",
      phone_code: "+1758",
    },
    {
      id: 105,
      country_name: "dominikański",
      country_code: "DM",
      phone_code: "+1767",
    },
    {
      id: 95,
      country_name: "Saint Vincent i Grenadyny",
      country_code: "VC",
      phone_code: "+1784",
    },
    {
      id: 33,
      country_name: "Portoryko",
      country_code: "PR",
      phone_code: "+1787",
    },
    {
      id: 104,
      country_name: "Republika Dominikańska",
      country_code: "DO",
      phone_code: "+1809",
    },
    {
      id: 111,
      country_name: "Trynidad i Tobago",
      country_code: "TT",
      phone_code: "+1868",
    },
    {
      id: 155,
      country_name: "Saint Kitts i Nevis",
      country_code: "KN",
      phone_code: "+1869",
    },
    {
      id: 163,
      country_name: "Jamajka",
      country_code: "JM",
      phone_code: "+1876",
    },
    { id: 98, country_name: "Egipt", country_code: "EG", phone_code: "+20" },
    {
      id: 87,
      country_name: "Sudan Południowy",
      country_code: "SS",
      phone_code: "+211",
    },
    { id: 139, country_name: "Maroko", country_code: "MA", phone_code: "+212" },
    {
      id: 101,
      country_name: "Algieria",
      country_code: "DZ",
      phone_code: "+213",
    },
    {
      id: 114,
      country_name: "Tunezja",
      country_code: "TN",
      phone_code: "+216",
    },
    { id: 140, country_name: "Libia", country_code: "LY", phone_code: "+218" },
    { id: 190, country_name: "Gambia", country_code: "GM", phone_code: "+220" },
    { id: 35, country_name: "Senegal", country_code: "SN", phone_code: "+221" },
    {
      id: 127,
      country_name: "Mauretania",
      country_code: "MR",
      phone_code: "+222",
    },
    { id: 133, country_name: "Mali", country_code: "ML", phone_code: "+223" },
    { id: 189, country_name: "Gwinea", country_code: "GN", phone_code: "+224" },
    {
      id: 80,
      country_name: "Wybrzeże Kości Słoniowej",
      country_code: "CI",
      phone_code: "+225",
    },
    {
      id: 61,
      country_name: "Burkina Faso",
      country_code: "BF",
      phone_code: "+226",
    },
    { id: 116, country_name: "Niger", country_code: "NE", phone_code: "+227" },
    { id: 68, country_name: "Togo", country_code: "TG", phone_code: "+228" },
    { id: 56, country_name: "Benin", country_code: "BJ", phone_code: "+229" },
    {
      id: 124,
      country_name: "Mauritius",
      country_code: "MU",
      phone_code: "+230",
    },
    {
      id: 145,
      country_name: "Liberia",
      country_code: "LR",
      phone_code: "+231",
    },
    {
      id: 37,
      country_name: "Sierra Leone",
      country_code: "SL",
      phone_code: "+232",
    },
    { id: 193, country_name: "Ghana", country_code: "GH", phone_code: "+233" },
    { id: 1, country_name: "Nigeria", country_code: "NG", phone_code: "+234" },
    { id: 71, country_name: "Czad", country_code: "TD", phone_code: "+235" },
    {
      id: 85,
      country_name: "Republika Środkowoafrykańska",
      country_code: "CF",
      phone_code: "+236",
    },
    { id: 75, country_name: "Kamerun", country_code: "CM", phone_code: "+237" },
    {
      id: 69,
      country_name: "Peleryna",
      country_code: "CV",
      phone_code: "+238",
    },
    {
      id: 86,
      country_name: "Wyspy Świętego Tomasza i Książęca",
      country_code: "ST",
      phone_code: "+239",
    },
    {
      id: 187,
      country_name: "Gwinea Równikowa",
      country_code: "GQ",
      phone_code: "+240",
    },
    { id: 199, country_name: "Gabon", country_code: "GA", phone_code: "+241" },
    {
      id: 83,
      country_name: "Republika Konga",
      country_code: "CG",
      phone_code: "+242",
    },
    {
      id: 3,
      country_name: "Demokratyczna Republika Kongo",
      country_code: "CD",
      phone_code: "+243",
    },
    { id: 19, country_name: "Angola", country_code: "AO", phone_code: "+244" },
    {
      id: 183,
      country_name: "Gwinea Bissau",
      country_code: "GW",
      phone_code: "+245",
    },
    {
      id: 230,
      country_name: "Brytyjskie Terytorium Oceanu Indyjskiego",
      country_code: "IO",
      phone_code: "+246",
    },
    {
      id: 27,
      country_name: "Wyspa Wniebowstąpienia",
      country_code: "AC",
      phone_code: "+247",
    },
    { id: 49, country_name: "Seszele", country_code: "SC", phone_code: "+248" },
    { id: 46, country_name: "Sudan", country_code: "SD", phone_code: "+249" },
    { id: 60, country_name: "Rwanda", country_code: "RW", phone_code: "+250" },
    { id: 93, country_name: "Etiopia", country_code: "ET", phone_code: "+251" },
    { id: 34, country_name: "Somali", country_code: "SO", phone_code: "+252" },
    {
      id: 108,
      country_name: "Dżibuti",
      country_code: "DJ",
      phone_code: "+253",
    },
    { id: 160, country_name: "Kenia", country_code: "KE", phone_code: "+254" },
    {
      id: 107,
      country_name: "Tanzania",
      country_code: "TZ",
      phone_code: "+255",
    },
    { id: 102, country_name: "Uganda", country_code: "UG", phone_code: "+256" },
    { id: 57, country_name: "Burundi", country_code: "BI", phone_code: "+257" },
    {
      id: 119,
      country_name: "Mozambik",
      country_code: "MZ",
      phone_code: "+258",
    },
    { id: 165, country_name: "Zambia", country_code: "ZM", phone_code: "+260" },
    {
      id: 135,
      country_name: "Madagaskar",
      country_code: "MG",
      phone_code: "+261",
    },
    { id: 16, country_name: "Zjazd", country_code: "RE", phone_code: "+262" },
    {
      id: 231,
      country_name: "Francuskie Terytoria Południowe",
      country_code: "TF",
      phone_code: "+262",
    },
    {
      id: 164,
      country_name: "Zimbabwe",
      country_code: "ZW",
      phone_code: "+263",
    },
    {
      id: 118,
      country_name: "Namibia",
      country_code: "NA",
      phone_code: "+264",
    },
    { id: 122, country_name: "Malawi", country_code: "MW", phone_code: "+265" },
    {
      id: 144,
      country_name: "Lesotho",
      country_code: "LS",
      phone_code: "+266",
    },
    {
      id: 42,
      country_name: "Botswana",
      country_code: "BW",
      phone_code: "+267",
    },
    { id: 78, country_name: "Suazi", country_code: "SZ", phone_code: "+268" },
    { id: 156, country_name: "Komory", country_code: "KM", phone_code: "+269" },
    {
      id: 175,
      country_name: "Majotta",
      country_code: "YT",
      phone_code: "+269",
    },
    {
      id: 170,
      country_name: "Republika Południowej Afryki",
      country_code: "ZA",
      phone_code: "+27",
    },
    { id: 13, country_name: "Aruba", country_code: "AW", phone_code: "+297" },
    {
      id: 201,
      country_name: "Wyspy Owcze",
      country_code: "FO",
      phone_code: "+298",
    },
    {
      id: 191,
      country_name: "Grenlandia",
      country_code: "GL",
      phone_code: "+299",
    },
    { id: 186, country_name: "Grecja", country_code: "GR", phone_code: "+30" },
    {
      id: 217,
      country_name: "Niderlandy",
      country_code: "NL",
      phone_code: "+31",
    },
    { id: 6, country_name: "Belgia", country_code: "BE", phone_code: "+32" },
    { id: 200, country_name: "Francja", country_code: "FR", phone_code: "+33" },
    {
      id: 94,
      country_name: "Hiszpania",
      country_code: "ES",
      phone_code: "+34",
    },
    {
      id: 192,
      country_name: "Gibraltar",
      country_code: "GI",
      phone_code: "+350",
    },
    {
      id: 31,
      country_name: "Portugalia",
      country_code: "PT",
      phone_code: "+351",
    },
    {
      id: 142,
      country_name: "Luksemburg",
      country_code: "LU",
      phone_code: "+352",
    },
    {
      id: 173,
      country_name: "Irlandia",
      country_code: "IE",
      phone_code: "+353",
    },
    {
      id: 167,
      country_name: "Islandia",
      country_code: "IS",
      phone_code: "+354",
    },
    { id: 21, country_name: "Albania", country_code: "AL", phone_code: "+355" },
    { id: 125, country_name: "Malta", country_code: "MT", phone_code: "+356" },
    { id: 65, country_name: "Cypr", country_code: "CY", phone_code: "+357" },
    {
      id: 225,
      country_name: "Wyspy Alandzkie",
      country_code: "AX",
      phone_code: "+358",
    },
    {
      id: 203,
      country_name: "Finlandia",
      country_code: "FI",
      phone_code: "+358",
    },
    {
      id: 59,
      country_name: "Bułgaria",
      country_code: "BG",
      phone_code: "+359",
    },
    { id: 176, country_name: "Węgry", country_code: "HU", phone_code: "+36" },
    { id: 143, country_name: "Litwa", country_code: "LT", phone_code: "+370" },
    { id: 141, country_name: "Łotwa", country_code: "LV", phone_code: "+371" },
    { id: 99, country_name: "Estonia", country_code: "EE", phone_code: "+372" },
    {
      id: 137,
      country_name: "Moldova",
      country_code: "MD",
      phone_code: "+373",
    },
    { id: 20, country_name: "Armenia", country_code: "AM", phone_code: "+374" },
    {
      id: 40,
      country_name: "Białoruś",
      country_code: "BY",
      phone_code: "+375",
    },
    { id: 26, country_name: "Andora", country_code: "AD", phone_code: "+376" },
    { id: 138, country_name: "Monako", country_code: "MC", phone_code: "+377" },
    {
      id: 36,
      country_name: "San Marino",
      country_code: "SM",
      phone_code: "+378",
    },
    {
      id: 220,
      country_name: "Watykan",
      country_code: "VA",
      phone_code: "+379",
    },
    {
      id: 103,
      country_name: "Ukraina",
      country_code: "UA",
      phone_code: "+380",
    },
    { id: 8, country_name: "Serbia", country_code: "RS", phone_code: "+381" },
    {
      id: 136,
      country_name: "Czarnogóra",
      country_code: "ME",
      phone_code: "+382",
    },
    {
      id: 179,
      country_name: "Chorwacja",
      country_code: "HR",
      phone_code: "+385",
    },
    {
      id: 41,
      country_name: "Słowenia",
      country_code: "SI",
      phone_code: "+386",
    },
    {
      id: 10,
      country_name: "Bośnia i Hercegowina",
      country_code: "BA",
      phone_code: "+387",
    },
    {
      id: 134,
      country_name: "Macedonia",
      country_code: "MK",
      phone_code: "+389",
    },
    { id: 166, country_name: "Włochy", country_code: "IT", phone_code: "+39" },
    { id: 11, country_name: "Rumunia", country_code: "RO", phone_code: "+40" },
    {
      id: 81,
      country_name: "Szwajcaria",
      country_code: "CH",
      phone_code: "+41",
    },
    { id: 63, country_name: "Czechy", country_code: "CZ", phone_code: "+420" },
    {
      id: 38,
      country_name: "Słowacja",
      country_code: "SK",
      phone_code: "+421",
    },
    {
      id: 147,
      country_name: "Liechtenstein",
      country_code: "LI",
      phone_code: "+423",
    },
    { id: 15, country_name: "Austria", country_code: "AT", phone_code: "+43" },
    {
      id: 198,
      country_name: "Wielka Brytania",
      country_code: "GB",
      phone_code: "+44",
    },
    {
      id: 232,
      country_name: "Guernsey",
      country_code: "GG",
      phone_code: "+44",
    },
    {
      id: 234,
      country_name: "Wyspa Man",
      country_code: "IM",
      phone_code: "+44",
    },
    { id: 233, country_name: "Golf", country_code: "JE", phone_code: "+44" },
    { id: 106, country_name: "Dania", country_code: "DK", phone_code: "+45" },
    { id: 44, country_name: "Szwecja", country_code: "SE", phone_code: "+46" },
    {
      id: 226,
      country_name: "Wyspa Bouveta",
      country_code: "BV",
      phone_code: "+47",
    },
    {
      id: 216,
      country_name: "Norwegia",
      country_code: "NO",
      phone_code: "+47",
    },
    {
      id: 238,
      country_name: "Svalbard",
      country_code: "SJ",
      phone_code: "+47",
    },
    { id: 206, country_name: "Polska", country_code: "PL", phone_code: "+48" },
    { id: 110, country_name: "Niemcy", country_code: "DE", phone_code: "+49" },
    {
      id: 237,
      country_name: "Wyspa Georgia Południowa",
      country_code: "GS",
      phone_code: "+500",
    },
    { id: 39, country_name: "Belize", country_code: "BZ", phone_code: "+501" },
    {
      id: 185,
      country_name: "Gwatemala",
      country_code: "GT",
      phone_code: "+502",
    },
    {
      id: 84,
      country_name: "Salwador",
      country_code: "SV",
      phone_code: "+503",
    },
    {
      id: 180,
      country_name: "Honduras",
      country_code: "HN",
      phone_code: "+504",
    },
    {
      id: 218,
      country_name: "Nikaragua",
      country_code: "NI",
      phone_code: "+505",
    },
    {
      id: 72,
      country_name: "Kostaryka",
      country_code: "CR",
      phone_code: "+506",
    },
    { id: 212, country_name: "Panama", country_code: "PA", phone_code: "+507" },
    {
      id: 205,
      country_name: "Saint-Pierre i Miquelon",
      country_code: "PM",
      phone_code: "+508",
    },
    { id: 178, country_name: "Haiti", country_code: "HT", phone_code: "+509" },
    { id: 211, country_name: "Peru", country_code: "PE", phone_code: "+51" },
    { id: 121, country_name: "Meksyk", country_code: "MX", phone_code: "+52" },
    { id: 70, country_name: "Kuba", country_code: "CU", phone_code: "+53" },
    {
      id: 18,
      country_name: "Argentyna",
      country_code: "AR",
      phone_code: "+54",
    },
    { id: 48, country_name: "Brazylia", country_code: "BR", phone_code: "+55" },
    { id: 76, country_name: "Chile", country_code: "CL", phone_code: "+56" },
    { id: 74, country_name: "Kolumbia", country_code: "CO", phone_code: "+57" },
    {
      id: 92,
      country_name: "Wenezuela",
      country_code: "VE",
      phone_code: "+58",
    },
    {
      id: 188,
      country_name: "Gwadelupa",
      country_code: "GP",
      phone_code: "+590",
    },
    { id: 53, country_name: "Boliwia", country_code: "BO", phone_code: "+591" },
    { id: 182, country_name: "Gujana", country_code: "GY", phone_code: "+592" },
    {
      id: 100,
      country_name: "Ekwador",
      country_code: "EC",
      phone_code: "+593",
    },
    {
      id: 194,
      country_name: "Gujana Francuska",
      country_code: "GF",
      phone_code: "+594",
    },
    {
      id: 29,
      country_name: "Paragwaj",
      country_code: "PY",
      phone_code: "+595",
    },
    {
      id: 128,
      country_name: "Martynika",
      country_code: "MQ",
      phone_code: "+596",
    },
    { id: 88, country_name: "Surinam", country_code: "SR", phone_code: "+597" },
    { id: 97, country_name: "Urugwaj", country_code: "UY", phone_code: "+598" },
    {
      id: 51,
      country_name: "Bonaire, Saint Eustatius i Saba",
      country_code: "BQ",
      phone_code: "+599",
    },
    { id: 67, country_name: "Curacao", country_code: "CW", phone_code: "+599" },
    { id: 120, country_name: "Malezja", country_code: "MY", phone_code: "+60" },
    {
      id: 14,
      country_name: "Australia",
      country_code: "AU",
      phone_code: "+61",
    },
    {
      id: 227,
      country_name: "Wyspy Kokosowe",
      country_code: "CC",
      phone_code: "+61",
    },
    {
      id: 228,
      country_name: "Wyspa Bożego Narodzenia",
      country_code: "CX",
      phone_code: "+61",
    },
    {
      id: 174,
      country_name: "Indonezja",
      country_code: "ID",
      phone_code: "+62",
    },
    {
      id: 208,
      country_name: "Filipiny",
      country_code: "PH",
      phone_code: "+63",
    },
    {
      id: 214,
      country_name: "Nowa Zelandia",
      country_code: "NZ",
      phone_code: "+64",
    },
    {
      id: 236,
      country_name: "Wyspy Pitcairn",
      country_code: "PN",
      phone_code: "+64",
    },
    { id: 43, country_name: "Singapur", country_code: "SG", phone_code: "+65" },
    {
      id: 66,
      country_name: "Tajlandia",
      country_code: "TH",
      phone_code: "+66",
    },
    {
      id: 62,
      country_name: "Timor Wschodni",
      country_code: "TL",
      phone_code: "+670",
    },
    {
      id: 229,
      country_name: "Wyspy Heard i McDonalda",
      country_code: "HM",
      phone_code: "+672",
    },
    {
      id: 235,
      country_name: "Wyspa Norfolk",
      country_code: "NF",
      phone_code: "+672",
    },
    { id: 54, country_name: "Brunei", country_code: "BN", phone_code: "+673" },
    { id: 223, country_name: "Nauru", country_code: "NR", phone_code: "+674" },
    {
      id: 209,
      country_name: "Papua-Nowa Gwinea",
      country_code: "PG",
      phone_code: "+675",
    },
    { id: 113, country_name: "Tonga", country_code: "TO", phone_code: "+676" },
    {
      id: 50,
      country_name: "Wyspy Salomona",
      country_code: "SB",
      phone_code: "+677",
    },
    {
      id: 204,
      country_name: "Vanuatu",
      country_code: "VU",
      phone_code: "+678",
    },
    { id: 202, country_name: "Fidżi", country_code: "FJ", phone_code: "+679" },
    { id: 30, country_name: "Palau", country_code: "PW", phone_code: "+680" },
    {
      id: 77,
      country_name: "Wyspy Cooka",
      country_code: "CK",
      phone_code: "+682",
    },
    { id: 197, country_name: "Samoa", country_code: "WS", phone_code: "+685" },
    {
      id: 157,
      country_name: "Kiribati",
      country_code: "KI",
      phone_code: "+686",
    },
    {
      id: 117,
      country_name: "Nowa Kaledonia",
      country_code: "NC",
      phone_code: "+687",
    },
    { id: 224, country_name: "Tuvalu", country_code: "TV", phone_code: "+688" },
    {
      id: 210,
      country_name: "Polinezja Francuska",
      country_code: "PF",
      phone_code: "+689",
    },
    {
      id: 222,
      country_name: "Mikronezja",
      country_code: "FM",
      phone_code: "+691",
    },
    {
      id: 221,
      country_name: "Wyspy Marshalla",
      country_code: "MH",
      phone_code: "+692",
    },
    {
      id: 151,
      country_name: "Kazachstan",
      country_code: "KZ",
      phone_code: "+7",
    },
    { id: 4, country_name: "Rosja", country_code: "RU", phone_code: "+7" },
    { id: 161, country_name: "Japonia", country_code: "JP", phone_code: "+81" },
    {
      id: 154,
      country_name: "Korea Południowa",
      country_code: "KR",
      phone_code: "+82",
    },
    { id: 89, country_name: "Wietnam", country_code: "VN", phone_code: "+84" },
    {
      id: 181,
      country_name: "Hongkong",
      country_code: "HK",
      phone_code: "+852",
    },
    {
      id: 130,
      country_name: "Makau, Chiny",
      country_code: "MO",
      phone_code: "+853",
    },
    {
      id: 158,
      country_name: "Kambodża",
      country_code: "KH",
      phone_code: "+855",
    },
    { id: 150, country_name: "Laos", country_code: "LA", phone_code: "+856" },
    {
      id: 219,
      country_name: "Chiny kontynentalne",
      country_code: "CN",
      phone_code: "+86",
    },
    {
      id: 7,
      country_name: "Bangladesz",
      country_code: "BD",
      phone_code: "+880",
    },
    { id: 109, country_name: "Tajwan", country_code: "TW", phone_code: "+886" },
    { id: 112, country_name: "Turcja", country_code: "TR", phone_code: "+90" },
    { id: 171, country_name: "Indie", country_code: "IN", phone_code: "+91" },
    {
      id: 207,
      country_name: "Pakistan",
      country_code: "PK",
      phone_code: "+92",
    },
    {
      id: 24,
      country_name: "Afganistan",
      country_code: "AF",
      phone_code: "+93",
    },
    {
      id: 146,
      country_name: "Sri Lanka",
      country_code: "LK",
      phone_code: "+94",
    },
    { id: 132, country_name: "Myanmar", country_code: "MM", phone_code: "+95" },
    {
      id: 123,
      country_name: "Malediwy",
      country_code: "MV",
      phone_code: "+960",
    },
    { id: 149, country_name: "Liban", country_code: "LB", phone_code: "+961" },
    {
      id: 162,
      country_name: "Jordania",
      country_code: "JO",
      phone_code: "+962",
    },
    { id: 79, country_name: "Syria", country_code: "SY", phone_code: "+963" },
    { id: 169, country_name: "Irak", country_code: "IQ", phone_code: "+964" },
    { id: 153, country_name: "Kuwejt", country_code: "KW", phone_code: "+965" },
    {
      id: 52,
      country_name: "Arabia Saudyjska",
      country_code: "SA",
      phone_code: "+966",
    },
    { id: 177, country_name: "Jemen", country_code: "YE", phone_code: "+967" },
    { id: 213, country_name: "Oman", country_code: "OM", phone_code: "+968" },
    {
      id: 32,
      country_name: "Terytorium Palestyńskie",
      country_code: "PS",
      phone_code: "+970",
    },
    {
      id: 25,
      country_name: "Emiraty Arabskie",
      country_code: "AE",
      phone_code: "+971",
    },
    { id: 172, country_name: "Izrael", country_code: "IL", phone_code: "+972" },
    { id: 58, country_name: "Bahrajn", country_code: "BH", phone_code: "+973" },
    { id: 28, country_name: "Katar", country_code: "QA", phone_code: "+974" },
    { id: 45, country_name: "Bhutan", country_code: "BT", phone_code: "+975" },
    {
      id: 131,
      country_name: "Mongolia",
      country_code: "MN",
      phone_code: "+976",
    },
    { id: 215, country_name: "Nepal", country_code: "NP", phone_code: "+977" },
    { id: 168, country_name: "Iran", country_code: "IR", phone_code: "+98" },
    {
      id: 64,
      country_name: "Tadżykistan",
      country_code: "TJ",
      phone_code: "+992",
    },
    {
      id: 115,
      country_name: "Turkmenia",
      country_code: "TM",
      phone_code: "+993",
    },
    {
      id: 12,
      country_name: "Azerbejdżan",
      country_code: "AZ",
      phone_code: "+994",
    },
    { id: 195, country_name: "Gruzja", country_code: "GE", phone_code: "+995" },
    {
      id: 159,
      country_name: "Kirgistan",
      country_code: "KG",
      phone_code: "+996",
    },
    {
      id: 96,
      country_name: "Uzbekistan",
      country_code: "UZ",
      phone_code: "+998",
    },
  ],
  ru_RU: [
    { id: 2, country_name: "Канада", country_code: "CA", phone_code: "+1" },
    {
      id: 239,
      country_name: "Малые отдаленные острова США",
      country_code: "UM",
      phone_code: "+1",
    },
    { id: 5, country_name: "США", country_code: "US", phone_code: "+1" },
    {
      id: 47,
      country_name: "Багамские острова",
      country_code: "BS",
      phone_code: "+1242",
    },
    {
      id: 9,
      country_name: "Барбадос",
      country_code: "BB",
      phone_code: "+1246",
    },
    {
      id: 22,
      country_name: "Ангилья",
      country_code: "AI",
      phone_code: "+1264",
    },
    {
      id: 23,
      country_name: "Антигуа и Барбуда",
      country_code: "AG",
      phone_code: "+1268",
    },
    {
      id: 90,
      country_name: "Виргинские острова США",
      country_code: "VI",
      phone_code: "+1284",
    },
    {
      id: 91,
      country_name: "Британские Виргинские острова",
      country_code: "VG",
      phone_code: "+1340",
    },
    {
      id: 152,
      country_name: "Каймановы острова",
      country_code: "KY",
      phone_code: "+1345",
    },
    {
      id: 55,
      country_name: "Бермудские острова",
      country_code: "BM",
      phone_code: "+1441",
    },
    {
      id: 196,
      country_name: "Гренеда",
      country_code: "GD",
      phone_code: "+1473",
    },
    {
      id: 73,
      country_name: "Острова Теркс и Кайкос",
      country_code: "TC",
      phone_code: "+1649",
    },
    {
      id: 126,
      country_name: "Монтсеррат",
      country_code: "MS",
      phone_code: "+1664",
    },
    {
      id: 129,
      country_name: "Марианские острова",
      country_code: "MP",
      phone_code: "+1670",
    },
    { id: 184, country_name: "Гуам", country_code: "GU", phone_code: "+1671" },
    {
      id: 17,
      country_name: "Американское Самоа",
      country_code: "AS",
      phone_code: "+1684",
    },
    {
      id: 82,
      country_name: "Синт-Мартен (голландская часть)",
      country_code: "SX",
      phone_code: "+1721",
    },
    {
      id: 148,
      country_name: "Сент-Люсия",
      country_code: "LC",
      phone_code: "+1758",
    },
    {
      id: 105,
      country_name: "доминиканский",
      country_code: "DM",
      phone_code: "+1767",
    },
    {
      id: 95,
      country_name: "Сент-Винсент и Гренадины",
      country_code: "VC",
      phone_code: "+1784",
    },
    {
      id: 33,
      country_name: "Пуэрто-Рико",
      country_code: "PR",
      phone_code: "+1787",
    },
    {
      id: 104,
      country_name: "Доминиканская Республика",
      country_code: "DO",
      phone_code: "+1809",
    },
    {
      id: 111,
      country_name: "Тринидад и Тобаго",
      country_code: "TT",
      phone_code: "+1868",
    },
    {
      id: 155,
      country_name: "Сент-Китс и Невис",
      country_code: "KN",
      phone_code: "+1869",
    },
    {
      id: 163,
      country_name: "Ямайка",
      country_code: "JM",
      phone_code: "+1876",
    },
    { id: 98, country_name: "Египет", country_code: "EG", phone_code: "+20" },
    {
      id: 87,
      country_name: "Южный Судан",
      country_code: "SS",
      phone_code: "+211",
    },
    {
      id: 139,
      country_name: "Марокко",
      country_code: "MA",
      phone_code: "+212",
    },
    { id: 101, country_name: "Алжир", country_code: "DZ", phone_code: "+213" },
    { id: 114, country_name: "Тунис", country_code: "TN", phone_code: "+216" },
    { id: 140, country_name: "Ливия", country_code: "LY", phone_code: "+218" },
    { id: 190, country_name: "Гамбия", country_code: "GM", phone_code: "+220" },
    { id: 35, country_name: "Сенегал", country_code: "SN", phone_code: "+221" },
    {
      id: 127,
      country_name: "Мавритания",
      country_code: "MR",
      phone_code: "+222",
    },
    { id: 133, country_name: "Мали", country_code: "ML", phone_code: "+223" },
    { id: 189, country_name: "Гвинея", country_code: "GN", phone_code: "+224" },
    {
      id: 80,
      country_name: "Кот-д'Ивуар",
      country_code: "CI",
      phone_code: "+225",
    },
    {
      id: 61,
      country_name: "Буркина-Фасо",
      country_code: "BF",
      phone_code: "+226",
    },
    { id: 116, country_name: "Нигер", country_code: "NE", phone_code: "+227" },
    { id: 68, country_name: "Того", country_code: "TG", phone_code: "+228" },
    { id: 56, country_name: "Бенин", country_code: "BJ", phone_code: "+229" },
    {
      id: 124,
      country_name: "Маврикий",
      country_code: "MU",
      phone_code: "+230",
    },
    {
      id: 145,
      country_name: "Либерия",
      country_code: "LR",
      phone_code: "+231",
    },
    {
      id: 37,
      country_name: "Сьерра-Леоне",
      country_code: "SL",
      phone_code: "+232",
    },
    { id: 193, country_name: "Гана", country_code: "GH", phone_code: "+233" },
    { id: 1, country_name: "Нигерия", country_code: "NG", phone_code: "+234" },
    { id: 71, country_name: "Чад", country_code: "TD", phone_code: "+235" },
    {
      id: 85,
      country_name: "Центральноафриканская Республика",
      country_code: "CF",
      phone_code: "+236",
    },
    { id: 75, country_name: "Камерун", country_code: "CM", phone_code: "+237" },
    { id: 69, country_name: "Мыс", country_code: "CV", phone_code: "+238" },
    {
      id: 86,
      country_name: "Сан-Томе и Принсипи",
      country_code: "ST",
      phone_code: "+239",
    },
    {
      id: 187,
      country_name: "Экваториальная Гвинея",
      country_code: "GQ",
      phone_code: "+240",
    },
    { id: 199, country_name: "Габон", country_code: "GA", phone_code: "+241" },
    {
      id: 83,
      country_name: "Республика Конго",
      country_code: "CG",
      phone_code: "+242",
    },
    {
      id: 3,
      country_name: "Демократическая Республика Конго",
      country_code: "CD",
      phone_code: "+243",
    },
    { id: 19, country_name: "Ангола", country_code: "AO", phone_code: "+244" },
    {
      id: 183,
      country_name: "Гвинея-Бисау",
      country_code: "GW",
      phone_code: "+245",
    },
    {
      id: 230,
      country_name: "Британская территория в Индийском океане",
      country_code: "IO",
      phone_code: "+246",
    },
    {
      id: 27,
      country_name: "Остров Вознесения",
      country_code: "AC",
      phone_code: "+247",
    },
    {
      id: 49,
      country_name: "Сейшельские острова",
      country_code: "SC",
      phone_code: "+248",
    },
    { id: 46, country_name: "Судан", country_code: "SD", phone_code: "+249" },
    { id: 60, country_name: "Руанда", country_code: "RW", phone_code: "+250" },
    { id: 93, country_name: "Эфиопия", country_code: "ET", phone_code: "+251" },
    { id: 34, country_name: "Сомали", country_code: "SO", phone_code: "+252" },
    {
      id: 108,
      country_name: "Джибути",
      country_code: "DJ",
      phone_code: "+253",
    },
    { id: 160, country_name: "Кения", country_code: "KE", phone_code: "+254" },
    {
      id: 107,
      country_name: "Танзания",
      country_code: "TZ",
      phone_code: "+255",
    },
    { id: 102, country_name: "Уганда", country_code: "UG", phone_code: "+256" },
    { id: 57, country_name: "Бурунди", country_code: "BI", phone_code: "+257" },
    {
      id: 119,
      country_name: "Мозамбик",
      country_code: "MZ",
      phone_code: "+258",
    },
    { id: 165, country_name: "Замбия", country_code: "ZM", phone_code: "+260" },
    {
      id: 135,
      country_name: "Мадагаскар",
      country_code: "MG",
      phone_code: "+261",
    },
    {
      id: 16,
      country_name: "Воссоединение",
      country_code: "RE",
      phone_code: "+262",
    },
    {
      id: 231,
      country_name: "Французские Южные Территории",
      country_code: "TF",
      phone_code: "+262",
    },
    {
      id: 164,
      country_name: "Зимбабве",
      country_code: "ZW",
      phone_code: "+263",
    },
    {
      id: 118,
      country_name: "Намибия",
      country_code: "NA",
      phone_code: "+264",
    },
    { id: 122, country_name: "Малави", country_code: "MW", phone_code: "+265" },
    { id: 144, country_name: "Лесото", country_code: "LS", phone_code: "+266" },
    {
      id: 42,
      country_name: "Ботсвана",
      country_code: "BW",
      phone_code: "+267",
    },
    {
      id: 78,
      country_name: "Свазиленд",
      country_code: "SZ",
      phone_code: "+268",
    },
    {
      id: 156,
      country_name: "Коморские острова",
      country_code: "KM",
      phone_code: "+269",
    },
    {
      id: 175,
      country_name: "Майотта",
      country_code: "YT",
      phone_code: "+269",
    },
    { id: 170, country_name: "ЮАР", country_code: "ZA", phone_code: "+27" },
    { id: 13, country_name: "Аруба", country_code: "AW", phone_code: "+297" },
    {
      id: 201,
      country_name: "Фарерские острова",
      country_code: "FO",
      phone_code: "+298",
    },
    {
      id: 191,
      country_name: "Гренландия",
      country_code: "GL",
      phone_code: "+299",
    },
    { id: 186, country_name: "Греция", country_code: "GR", phone_code: "+30" },
    {
      id: 217,
      country_name: "Нидерланды",
      country_code: "NL",
      phone_code: "+31",
    },
    { id: 6, country_name: "Бельгия", country_code: "BE", phone_code: "+32" },
    { id: 200, country_name: "Франция", country_code: "FR", phone_code: "+33" },
    { id: 94, country_name: "Испания", country_code: "ES", phone_code: "+34" },
    {
      id: 192,
      country_name: "Гибралтар",
      country_code: "GI",
      phone_code: "+350",
    },
    {
      id: 31,
      country_name: "Португалия",
      country_code: "PT",
      phone_code: "+351",
    },
    {
      id: 142,
      country_name: "Люксембург",
      country_code: "LU",
      phone_code: "+352",
    },
    {
      id: 173,
      country_name: "Ирландия",
      country_code: "IE",
      phone_code: "+353",
    },
    {
      id: 167,
      country_name: "Исландия",
      country_code: "IS",
      phone_code: "+354",
    },
    { id: 21, country_name: "Албания", country_code: "AL", phone_code: "+355" },
    { id: 125, country_name: "Мальта", country_code: "MT", phone_code: "+356" },
    { id: 65, country_name: "Кипр", country_code: "CY", phone_code: "+357" },
    {
      id: 225,
      country_name: "Аландские острова",
      country_code: "AX",
      phone_code: "+358",
    },
    {
      id: 203,
      country_name: "Финляндия",
      country_code: "FI",
      phone_code: "+358",
    },
    {
      id: 59,
      country_name: "Болгария",
      country_code: "BG",
      phone_code: "+359",
    },
    { id: 176, country_name: "Венгрия", country_code: "HU", phone_code: "+36" },
    { id: 143, country_name: "Литва", country_code: "LT", phone_code: "+370" },
    { id: 141, country_name: "Латвия", country_code: "LV", phone_code: "+371" },
    { id: 99, country_name: "Эстония", country_code: "EE", phone_code: "+372" },
    {
      id: 137,
      country_name: "Молдова",
      country_code: "MD",
      phone_code: "+373",
    },
    { id: 20, country_name: "Армения", country_code: "AM", phone_code: "+374" },
    {
      id: 40,
      country_name: "Беларусь",
      country_code: "BY",
      phone_code: "+375",
    },
    { id: 26, country_name: "Андорра", country_code: "AD", phone_code: "+376" },
    { id: 138, country_name: "Монако", country_code: "MC", phone_code: "+377" },
    {
      id: 36,
      country_name: "Сан-Марино",
      country_code: "SM",
      phone_code: "+378",
    },
    {
      id: 220,
      country_name: "Ватикан",
      country_code: "VA",
      phone_code: "+379",
    },
    {
      id: 103,
      country_name: "Украина",
      country_code: "UA",
      phone_code: "+380",
    },
    { id: 8, country_name: "Сербия", country_code: "RS", phone_code: "+381" },
    {
      id: 136,
      country_name: "Черногория",
      country_code: "ME",
      phone_code: "+382",
    },
    {
      id: 179,
      country_name: "Хорватия",
      country_code: "HR",
      phone_code: "+385",
    },
    {
      id: 41,
      country_name: "Словения",
      country_code: "SI",
      phone_code: "+386",
    },
    {
      id: 10,
      country_name: "Босния и Герцеговина",
      country_code: "BA",
      phone_code: "+387",
    },
    {
      id: 134,
      country_name: "Македония",
      country_code: "MK",
      phone_code: "+389",
    },
    { id: 166, country_name: "Италия", country_code: "IT", phone_code: "+39" },
    { id: 11, country_name: "Румыния", country_code: "RO", phone_code: "+40" },
    {
      id: 81,
      country_name: "Швейцария",
      country_code: "CH",
      phone_code: "+41",
    },
    {
      id: 63,
      country_name: "Чешская Республика",
      country_code: "CZ",
      phone_code: "+420",
    },
    {
      id: 38,
      country_name: "Словакия",
      country_code: "SK",
      phone_code: "+421",
    },
    {
      id: 147,
      country_name: "Лихтенштейн",
      country_code: "LI",
      phone_code: "+423",
    },
    { id: 15, country_name: "Австрия", country_code: "AT", phone_code: "+43" },
    {
      id: 198,
      country_name: "Великобритания",
      country_code: "GB",
      phone_code: "+44",
    },
    { id: 232, country_name: "Гернси", country_code: "GG", phone_code: "+44" },
    {
      id: 234,
      country_name: "Остров Мэн",
      country_code: "IM",
      phone_code: "+44",
    },
    { id: 233, country_name: "Джерси", country_code: "JE", phone_code: "+44" },
    { id: 106, country_name: "Дания", country_code: "DK", phone_code: "+45" },
    { id: 44, country_name: "Швеция", country_code: "SE", phone_code: "+46" },
    {
      id: 226,
      country_name: "Остров Буве",
      country_code: "BV",
      phone_code: "+47",
    },
    {
      id: 216,
      country_name: "Норвегия",
      country_code: "NO",
      phone_code: "+47",
    },
    {
      id: 238,
      country_name: "Шпицберген",
      country_code: "SJ",
      phone_code: "+47",
    },
    { id: 206, country_name: "Польша", country_code: "PL", phone_code: "+48" },
    {
      id: 110,
      country_name: "Германия",
      country_code: "DE",
      phone_code: "+49",
    },
    {
      id: 237,
      country_name: "Остров Южная Георгия",
      country_code: "GS",
      phone_code: "+500",
    },
    { id: 39, country_name: "Белиз", country_code: "BZ", phone_code: "+501" },
    {
      id: 185,
      country_name: "Гватемала",
      country_code: "GT",
      phone_code: "+502",
    },
    {
      id: 84,
      country_name: "Сальвадор",
      country_code: "SV",
      phone_code: "+503",
    },
    {
      id: 180,
      country_name: "Гондурас",
      country_code: "HN",
      phone_code: "+504",
    },
    {
      id: 218,
      country_name: "Никарагуа",
      country_code: "NI",
      phone_code: "+505",
    },
    {
      id: 72,
      country_name: "Коста-Рика",
      country_code: "CR",
      phone_code: "+506",
    },
    { id: 212, country_name: "Панама", country_code: "PA", phone_code: "+507" },
    {
      id: 205,
      country_name: "Сен-Пьер и Микелон",
      country_code: "PM",
      phone_code: "+508",
    },
    { id: 178, country_name: "Гаити", country_code: "HT", phone_code: "+509" },
    { id: 211, country_name: "Перу", country_code: "PE", phone_code: "+51" },
    { id: 121, country_name: "Мексика", country_code: "MX", phone_code: "+52" },
    { id: 70, country_name: "Куба", country_code: "CU", phone_code: "+53" },
    {
      id: 18,
      country_name: "Аргентина",
      country_code: "AR",
      phone_code: "+54",
    },
    { id: 48, country_name: "Бразилия", country_code: "BR", phone_code: "+55" },
    { id: 76, country_name: "Чили", country_code: "CL", phone_code: "+56" },
    { id: 74, country_name: "Колумбия", country_code: "CO", phone_code: "+57" },
    {
      id: 92,
      country_name: "Венесуэла",
      country_code: "VE",
      phone_code: "+58",
    },
    {
      id: 188,
      country_name: "Гваделупа",
      country_code: "GP",
      phone_code: "+590",
    },
    { id: 53, country_name: "Боливия", country_code: "BO", phone_code: "+591" },
    { id: 182, country_name: "Гайана", country_code: "GY", phone_code: "+592" },
    {
      id: 100,
      country_name: "Эквадор",
      country_code: "EC",
      phone_code: "+593",
    },
    {
      id: 194,
      country_name: "Французская Гвиана",
      country_code: "GF",
      phone_code: "+594",
    },
    {
      id: 29,
      country_name: "Парагвай",
      country_code: "PY",
      phone_code: "+595",
    },
    {
      id: 128,
      country_name: "Мартиника",
      country_code: "MQ",
      phone_code: "+596",
    },
    { id: 88, country_name: "Суринам", country_code: "SR", phone_code: "+597" },
    { id: 97, country_name: "Уругвай", country_code: "UY", phone_code: "+598" },
    {
      id: 51,
      country_name: "Бонэйр, Синт-Эстатиус и Саба",
      country_code: "BQ",
      phone_code: "+599",
    },
    { id: 67, country_name: "Кюрасао", country_code: "CW", phone_code: "+599" },
    {
      id: 120,
      country_name: "Малайзия",
      country_code: "MY",
      phone_code: "+60",
    },
    {
      id: 14,
      country_name: "Австралия",
      country_code: "AU",
      phone_code: "+61",
    },
    {
      id: 227,
      country_name: "Кокосовые острова",
      country_code: "CC",
      phone_code: "+61",
    },
    {
      id: 228,
      country_name: "Остров Рождества",
      country_code: "CX",
      phone_code: "+61",
    },
    {
      id: 174,
      country_name: "Индонезия",
      country_code: "ID",
      phone_code: "+62",
    },
    {
      id: 208,
      country_name: "Филиппины",
      country_code: "PH",
      phone_code: "+63",
    },
    {
      id: 214,
      country_name: "Новая Зеландия",
      country_code: "NZ",
      phone_code: "+64",
    },
    {
      id: 236,
      country_name: "Острова Питкэрн",
      country_code: "PN",
      phone_code: "+64",
    },
    { id: 43, country_name: "Сингапур", country_code: "SG", phone_code: "+65" },
    { id: 66, country_name: "Таиланд", country_code: "TH", phone_code: "+66" },
    {
      id: 62,
      country_name: "Восточный Тимор",
      country_code: "TL",
      phone_code: "+670",
    },
    {
      id: 229,
      country_name: "Остров Херд и острова Макдональд",
      country_code: "HM",
      phone_code: "+672",
    },
    {
      id: 235,
      country_name: "остров Норфолк",
      country_code: "NF",
      phone_code: "+672",
    },
    { id: 54, country_name: "Бруней", country_code: "BN", phone_code: "+673" },
    { id: 223, country_name: "Науру", country_code: "NR", phone_code: "+674" },
    {
      id: 209,
      country_name: "Папуа-Новая Гвинея",
      country_code: "PG",
      phone_code: "+675",
    },
    { id: 113, country_name: "Тонга", country_code: "TO", phone_code: "+676" },
    {
      id: 50,
      country_name: "Соломоновы острова",
      country_code: "SB",
      phone_code: "+677",
    },
    {
      id: 204,
      country_name: "Вануату",
      country_code: "VU",
      phone_code: "+678",
    },
    { id: 202, country_name: "Фиджи", country_code: "FJ", phone_code: "+679" },
    { id: 30, country_name: "Палау", country_code: "PW", phone_code: "+680" },
    {
      id: 77,
      country_name: "Острова Кука",
      country_code: "CK",
      phone_code: "+682",
    },
    { id: 197, country_name: "Самоа", country_code: "WS", phone_code: "+685" },
    {
      id: 157,
      country_name: "Кирибати",
      country_code: "KI",
      phone_code: "+686",
    },
    {
      id: 117,
      country_name: "Новая Каледония",
      country_code: "NC",
      phone_code: "+687",
    },
    { id: 224, country_name: "Тувалу", country_code: "TV", phone_code: "+688" },
    {
      id: 210,
      country_name: "Французская Полинезия",
      country_code: "PF",
      phone_code: "+689",
    },
    {
      id: 222,
      country_name: "Микронезия",
      country_code: "FM",
      phone_code: "+691",
    },
    {
      id: 221,
      country_name: "Маршалловы Острова",
      country_code: "MH",
      phone_code: "+692",
    },
    {
      id: 151,
      country_name: "Казахстан",
      country_code: "KZ",
      phone_code: "+7",
    },
    { id: 4, country_name: "Россия", country_code: "RU", phone_code: "+7" },
    { id: 161, country_name: "Япония", country_code: "JP", phone_code: "+81" },
    {
      id: 154,
      country_name: "Южная Корея",
      country_code: "KR",
      phone_code: "+82",
    },
    { id: 89, country_name: "Вьетнам", country_code: "VN", phone_code: "+84" },
    {
      id: 181,
      country_name: "Гонконг",
      country_code: "HK",
      phone_code: "+852",
    },
    {
      id: 130,
      country_name: "Макао, Китай",
      country_code: "MO",
      phone_code: "+853",
    },
    {
      id: 158,
      country_name: "Камбоджа",
      country_code: "KH",
      phone_code: "+855",
    },
    { id: 150, country_name: "Лаос", country_code: "LA", phone_code: "+856" },
    {
      id: 219,
      country_name: "материковый Китай",
      country_code: "CN",
      phone_code: "+86",
    },
    {
      id: 7,
      country_name: "Бангладеш",
      country_code: "BD",
      phone_code: "+880",
    },
    {
      id: 109,
      country_name: "Тайвань",
      country_code: "TW",
      phone_code: "+886",
    },
    { id: 112, country_name: "Турция", country_code: "TR", phone_code: "+90" },
    { id: 171, country_name: "Индия", country_code: "IN", phone_code: "+91" },
    {
      id: 207,
      country_name: "Пакистан",
      country_code: "PK",
      phone_code: "+92",
    },
    {
      id: 24,
      country_name: "Афганистан",
      country_code: "AF",
      phone_code: "+93",
    },
    {
      id: 146,
      country_name: "Шри-Ланка",
      country_code: "LK",
      phone_code: "+94",
    },
    { id: 132, country_name: "Мьянма", country_code: "MM", phone_code: "+95" },
    {
      id: 123,
      country_name: "Мальдивы",
      country_code: "MV",
      phone_code: "+960",
    },
    { id: 149, country_name: "Ливан", country_code: "LB", phone_code: "+961" },
    {
      id: 162,
      country_name: "Иордания",
      country_code: "JO",
      phone_code: "+962",
    },
    { id: 79, country_name: "Сирия", country_code: "SY", phone_code: "+963" },
    { id: 169, country_name: "Ирак", country_code: "IQ", phone_code: "+964" },
    { id: 153, country_name: "Кувейт", country_code: "KW", phone_code: "+965" },
    {
      id: 52,
      country_name: "Саудовская Аравия",
      country_code: "SA",
      phone_code: "+966",
    },
    { id: 177, country_name: "Йемен", country_code: "YE", phone_code: "+967" },
    { id: 213, country_name: "Оман", country_code: "OM", phone_code: "+968" },
    {
      id: 32,
      country_name: "Палестинская территория",
      country_code: "PS",
      phone_code: "+970",
    },
    {
      id: 25,
      country_name: "Объединенные Арабские Эмираты",
      country_code: "AE",
      phone_code: "+971",
    },
    {
      id: 172,
      country_name: "Израиль",
      country_code: "IL",
      phone_code: "+972",
    },
    { id: 58, country_name: "Бахрейн", country_code: "BH", phone_code: "+973" },
    { id: 28, country_name: "Катар", country_code: "QA", phone_code: "+974" },
    { id: 45, country_name: "Бутан", country_code: "BT", phone_code: "+975" },
    {
      id: 131,
      country_name: "Монголия",
      country_code: "MN",
      phone_code: "+976",
    },
    { id: 215, country_name: "Непал", country_code: "NP", phone_code: "+977" },
    { id: 168, country_name: "Иран", country_code: "IR", phone_code: "+98" },
    {
      id: 64,
      country_name: "Таджикистан",
      country_code: "TJ",
      phone_code: "+992",
    },
    {
      id: 115,
      country_name: "Туркменистан",
      country_code: "TM",
      phone_code: "+993",
    },
    {
      id: 12,
      country_name: "Азербайджан",
      country_code: "AZ",
      phone_code: "+994",
    },
    {
      id: 195,
      country_name: "Джорджия",
      country_code: "GE",
      phone_code: "+995",
    },
    {
      id: 159,
      country_name: "Кыргызстан",
      country_code: "KG",
      phone_code: "+996",
    },
    {
      id: 96,
      country_name: "Узбекистан",
      country_code: "UZ",
      phone_code: "+998",
    },
  ],
  vi_VN: [
    { id: 2, country_name: "Canada", country_code: "CA", phone_code: "+1" },
    {
      id: 239,
      country_name: "Các đảo nhỏ xa xôi của Hoa Kỳ",
      country_code: "UM",
      phone_code: "+1",
    },
    { id: 5, country_name: "Hoa Kỳ", country_code: "US", phone_code: "+1" },
    {
      id: 47,
      country_name: "Bahamas",
      country_code: "BS",
      phone_code: "+1242",
    },
    {
      id: 9,
      country_name: "Barbados",
      country_code: "BB",
      phone_code: "+1246",
    },
    {
      id: 22,
      country_name: "Anguilla",
      country_code: "AI",
      phone_code: "+1264",
    },
    {
      id: 23,
      country_name: "Antigua và Barbuda",
      country_code: "AG",
      phone_code: "+1268",
    },
    {
      id: 90,
      country_name: "Quần đảo Virgin thuộc Hoa Kỳ",
      country_code: "VI",
      phone_code: "+1284",
    },
    {
      id: 91,
      country_name: "Quần đảo Virgin thuộc Anh",
      country_code: "VG",
      phone_code: "+1340",
    },
    {
      id: 152,
      country_name: "Quần đảo Cayman",
      country_code: "KY",
      phone_code: "+1345",
    },
    {
      id: 55,
      country_name: "Bermuda",
      country_code: "BM",
      phone_code: "+1441",
    },
    {
      id: 196,
      country_name: "Greneda",
      country_code: "GD",
      phone_code: "+1473",
    },
    {
      id: 73,
      country_name: "Quần đảo Turks và Caicos",
      country_code: "TC",
      phone_code: "+1649",
    },
    {
      id: 126,
      country_name: "Montserrat",
      country_code: "MS",
      phone_code: "+1664",
    },
    {
      id: 129,
      country_name: "Quần đảo Mariana",
      country_code: "MP",
      phone_code: "+1670",
    },
    { id: 184, country_name: "Guam", country_code: "GU", phone_code: "+1671" },
    {
      id: 17,
      country_name: "Samoa thuộc Mỹ",
      country_code: "AS",
      phone_code: "+1684",
    },
    {
      id: 82,
      country_name: "Sint Maarten (phần thuộc Hà Lan)",
      country_code: "SX",
      phone_code: "+1721",
    },
    {
      id: 148,
      country_name: "Thánh Lucia",
      country_code: "LC",
      phone_code: "+1758",
    },
    {
      id: 105,
      country_name: "người Dominica",
      country_code: "DM",
      phone_code: "+1767",
    },
    {
      id: 95,
      country_name: "Saint Vincent và Grenadines",
      country_code: "VC",
      phone_code: "+1784",
    },
    {
      id: 33,
      country_name: "Puerto Rico",
      country_code: "PR",
      phone_code: "+1787",
    },
    {
      id: 104,
      country_name: "Cộng hòa Dominica",
      country_code: "DO",
      phone_code: "+1809",
    },
    {
      id: 111,
      country_name: "Trinidad và Tobago",
      country_code: "TT",
      phone_code: "+1868",
    },
    {
      id: 155,
      country_name: "Saint Kitts và Nevis",
      country_code: "KN",
      phone_code: "+1869",
    },
    {
      id: 163,
      country_name: "Jamaica",
      country_code: "JM",
      phone_code: "+1876",
    },
    { id: 98, country_name: "Ai Cập", country_code: "EG", phone_code: "+20" },
    {
      id: 87,
      country_name: "Nam Sudan",
      country_code: "SS",
      phone_code: "+211",
    },
    { id: 139, country_name: "Ma-rốc", country_code: "MA", phone_code: "+212" },
    {
      id: 101,
      country_name: "Algeria",
      country_code: "DZ",
      phone_code: "+213",
    },
    {
      id: 114,
      country_name: "Tunisia",
      country_code: "TN",
      phone_code: "+216",
    },
    { id: 140, country_name: "Libya", country_code: "LY", phone_code: "+218" },
    { id: 190, country_name: "Gambia", country_code: "GM", phone_code: "+220" },
    { id: 35, country_name: "Senegal", country_code: "SN", phone_code: "+221" },
    {
      id: 127,
      country_name: "Mauritania",
      country_code: "MR",
      phone_code: "+222",
    },
    { id: 133, country_name: "Mali", country_code: "ML", phone_code: "+223" },
    { id: 189, country_name: "Guinea", country_code: "GN", phone_code: "+224" },
    {
      id: 80,
      country_name: "Bờ Biển Ngà",
      country_code: "CI",
      phone_code: "+225",
    },
    {
      id: 61,
      country_name: "Burkina Faso",
      country_code: "BF",
      phone_code: "+226",
    },
    { id: 116, country_name: "Niger", country_code: "NE", phone_code: "+227" },
    { id: 68, country_name: "Togo", country_code: "TG", phone_code: "+228" },
    { id: 56, country_name: "Bénin", country_code: "BJ", phone_code: "+229" },
    {
      id: 124,
      country_name: "Mauritius",
      country_code: "MU",
      phone_code: "+230",
    },
    {
      id: 145,
      country_name: "Liberia",
      country_code: "LR",
      phone_code: "+231",
    },
    {
      id: 37,
      country_name: "Sierra Leone",
      country_code: "SL",
      phone_code: "+232",
    },
    { id: 193, country_name: "Ghana", country_code: "GH", phone_code: "+233" },
    { id: 1, country_name: "Nigeria", country_code: "NG", phone_code: "+234" },
    { id: 71, country_name: "Chad", country_code: "TD", phone_code: "+235" },
    {
      id: 85,
      country_name: "Cộng hòa Trung Phi",
      country_code: "CF",
      phone_code: "+236",
    },
    {
      id: 75,
      country_name: "Cameroon",
      country_code: "CM",
      phone_code: "+237",
    },
    { id: 69, country_name: "Mũi đất", country_code: "CV", phone_code: "+238" },
    {
      id: 86,
      country_name: "Sao Tome và Principe",
      country_code: "ST",
      phone_code: "+239",
    },
    {
      id: 187,
      country_name: "Guinea Xích Đạo",
      country_code: "GQ",
      phone_code: "+240",
    },
    { id: 199, country_name: "Gabon", country_code: "GA", phone_code: "+241" },
    {
      id: 83,
      country_name: "Cộng hòa Congo",
      country_code: "CG",
      phone_code: "+242",
    },
    {
      id: 3,
      country_name: "Cộng hòa Dân chủ Congo",
      country_code: "CD",
      phone_code: "+243",
    },
    { id: 19, country_name: "Angola", country_code: "AO", phone_code: "+244" },
    {
      id: 183,
      country_name: "Guinea-Bissau",
      country_code: "GW",
      phone_code: "+245",
    },
    {
      id: 230,
      country_name: "Lãnh thổ Ấn Độ Dương thuộc Anh",
      country_code: "IO",
      phone_code: "+246",
    },
    {
      id: 27,
      country_name: "Đảo Ascension",
      country_code: "AC",
      phone_code: "+247",
    },
    {
      id: 49,
      country_name: "Seychelles",
      country_code: "SC",
      phone_code: "+248",
    },
    { id: 46, country_name: "Sudan", country_code: "SD", phone_code: "+249" },
    { id: 60, country_name: "Rwanda", country_code: "RW", phone_code: "+250" },
    {
      id: 93,
      country_name: "Ethiopia",
      country_code: "ET",
      phone_code: "+251",
    },
    { id: 34, country_name: "Somalia", country_code: "SO", phone_code: "+252" },
    {
      id: 108,
      country_name: "Djibouti",
      country_code: "DJ",
      phone_code: "+253",
    },
    { id: 160, country_name: "Kenya", country_code: "KE", phone_code: "+254" },
    {
      id: 107,
      country_name: "Tanzania",
      country_code: "TZ",
      phone_code: "+255",
    },
    { id: 102, country_name: "Uganda", country_code: "UG", phone_code: "+256" },
    { id: 57, country_name: "Burundi", country_code: "BI", phone_code: "+257" },
    {
      id: 119,
      country_name: "Mozambique",
      country_code: "MZ",
      phone_code: "+258",
    },
    { id: 165, country_name: "Zambia", country_code: "ZM", phone_code: "+260" },
    {
      id: 135,
      country_name: "Madagascar",
      country_code: "MG",
      phone_code: "+261",
    },
    { id: 16, country_name: "Đoàn tụ", country_code: "RE", phone_code: "+262" },
    {
      id: 231,
      country_name: "Lãnh thổ phía Nam của Pháp",
      country_code: "TF",
      phone_code: "+262",
    },
    {
      id: 164,
      country_name: "Zimbabwe",
      country_code: "ZW",
      phone_code: "+263",
    },
    {
      id: 118,
      country_name: "Namibia",
      country_code: "NA",
      phone_code: "+264",
    },
    { id: 122, country_name: "Malawi", country_code: "MW", phone_code: "+265" },
    {
      id: 144,
      country_name: "Lesotho",
      country_code: "LS",
      phone_code: "+266",
    },
    {
      id: 42,
      country_name: "Botswana",
      country_code: "BW",
      phone_code: "+267",
    },
    {
      id: 78,
      country_name: "Swaziland",
      country_code: "SZ",
      phone_code: "+268",
    },
    {
      id: 156,
      country_name: "Comoros",
      country_code: "KM",
      phone_code: "+269",
    },
    {
      id: 175,
      country_name: "Mayotte",
      country_code: "YT",
      phone_code: "+269",
    },
    { id: 170, country_name: "Nam Phi", country_code: "ZA", phone_code: "+27" },
    { id: 13, country_name: "Aruba", country_code: "AW", phone_code: "+297" },
    {
      id: 201,
      country_name: "Quần đảo Faroe",
      country_code: "FO",
      phone_code: "+298",
    },
    {
      id: 191,
      country_name: "Greenland",
      country_code: "GL",
      phone_code: "+299",
    },
    { id: 186, country_name: "Hy Lạp", country_code: "GR", phone_code: "+30" },
    { id: 217, country_name: "Hà Lan", country_code: "NL", phone_code: "+31" },
    { id: 6, country_name: "Bỉ", country_code: "BE", phone_code: "+32" },
    { id: 200, country_name: "Pháp", country_code: "FR", phone_code: "+33" },
    {
      id: 94,
      country_name: "Tây ban nha",
      country_code: "ES",
      phone_code: "+34",
    },
    {
      id: 192,
      country_name: "Gibraltar",
      country_code: "GI",
      phone_code: "+350",
    },
    {
      id: 31,
      country_name: "Bồ Đào Nha",
      country_code: "PT",
      phone_code: "+351",
    },
    {
      id: 142,
      country_name: "Luxembourg",
      country_code: "LU",
      phone_code: "+352",
    },
    { id: 173, country_name: "Ai-len", country_code: "IE", phone_code: "+353" },
    {
      id: 167,
      country_name: "Iceland",
      country_code: "IS",
      phone_code: "+354",
    },
    { id: 21, country_name: "Albania", country_code: "AL", phone_code: "+355" },
    { id: 125, country_name: "Malta", country_code: "MT", phone_code: "+356" },
    { id: 65, country_name: "Síp", country_code: "CY", phone_code: "+357" },
    {
      id: 225,
      country_name: "Quần đảo Åland",
      country_code: "AX",
      phone_code: "+358",
    },
    {
      id: 203,
      country_name: "Phần Lan",
      country_code: "FI",
      phone_code: "+358",
    },
    {
      id: 59,
      country_name: "Bulgaria",
      country_code: "BG",
      phone_code: "+359",
    },
    { id: 176, country_name: "Hungary", country_code: "HU", phone_code: "+36" },
    { id: 143, country_name: "Litva", country_code: "LT", phone_code: "+370" },
    { id: 141, country_name: "Latvia", country_code: "LV", phone_code: "+371" },
    { id: 99, country_name: "Estonia", country_code: "EE", phone_code: "+372" },
    {
      id: 137,
      country_name: "Moldova",
      country_code: "MD",
      phone_code: "+373",
    },
    { id: 20, country_name: "Armenia", country_code: "AM", phone_code: "+374" },
    { id: 40, country_name: "Belarus", country_code: "BY", phone_code: "+375" },
    { id: 26, country_name: "Andorra", country_code: "AD", phone_code: "+376" },
    { id: 138, country_name: "Monaco", country_code: "MC", phone_code: "+377" },
    {
      id: 36,
      country_name: "San Marino",
      country_code: "SM",
      phone_code: "+378",
    },
    {
      id: 220,
      country_name: "Thành phố Vatican",
      country_code: "VA",
      phone_code: "+379",
    },
    {
      id: 103,
      country_name: "Ukraina",
      country_code: "UA",
      phone_code: "+380",
    },
    { id: 8, country_name: "Serbia", country_code: "RS", phone_code: "+381" },
    {
      id: 136,
      country_name: "Montenegro",
      country_code: "ME",
      phone_code: "+382",
    },
    {
      id: 179,
      country_name: "Croatia",
      country_code: "HR",
      phone_code: "+385",
    },
    {
      id: 41,
      country_name: "Slovenia",
      country_code: "SI",
      phone_code: "+386",
    },
    {
      id: 10,
      country_name: "Bosnia và Herzegovina",
      country_code: "BA",
      phone_code: "+387",
    },
    {
      id: 134,
      country_name: "Macedonia",
      country_code: "MK",
      phone_code: "+389",
    },
    { id: 166, country_name: "Ý", country_code: "IT", phone_code: "+39" },
    { id: 11, country_name: "Rumani", country_code: "RO", phone_code: "+40" },
    { id: 81, country_name: "Thụy Sĩ", country_code: "CH", phone_code: "+41" },
    {
      id: 63,
      country_name: "Cộng hòa Séc",
      country_code: "CZ",
      phone_code: "+420",
    },
    {
      id: 38,
      country_name: "Slovakia",
      country_code: "SK",
      phone_code: "+421",
    },
    {
      id: 147,
      country_name: "Liechtenstein",
      country_code: "LI",
      phone_code: "+423",
    },
    { id: 15, country_name: "Áo", country_code: "AT", phone_code: "+43" },
    { id: 198, country_name: "Anh", country_code: "GB", phone_code: "+44" },
    {
      id: 232,
      country_name: "Guernsey",
      country_code: "GG",
      phone_code: "+44",
    },
    { id: 234, country_name: "Đảo Man", country_code: "IM", phone_code: "+44" },
    { id: 233, country_name: "Jersey", country_code: "JE", phone_code: "+44" },
    {
      id: 106,
      country_name: "Đan Mạch",
      country_code: "DK",
      phone_code: "+45",
    },
    {
      id: 44,
      country_name: "Thụy Điển",
      country_code: "SE",
      phone_code: "+46",
    },
    {
      id: 226,
      country_name: "Đảo Bouvet",
      country_code: "BV",
      phone_code: "+47",
    },
    { id: 216, country_name: "Na Uy", country_code: "NO", phone_code: "+47" },
    {
      id: 238,
      country_name: "Svalbard",
      country_code: "SJ",
      phone_code: "+47",
    },
    { id: 206, country_name: "Ba Lan", country_code: "PL", phone_code: "+48" },
    { id: 110, country_name: "Đức", country_code: "DE", phone_code: "+49" },
    {
      id: 237,
      country_name: "Đảo Nam Georgia",
      country_code: "GS",
      phone_code: "+500",
    },
    { id: 39, country_name: "Belize", country_code: "BZ", phone_code: "+501" },
    {
      id: 185,
      country_name: "Guatemala",
      country_code: "GT",
      phone_code: "+502",
    },
    {
      id: 84,
      country_name: "El Salvador",
      country_code: "SV",
      phone_code: "+503",
    },
    {
      id: 180,
      country_name: "Honduras",
      country_code: "HN",
      phone_code: "+504",
    },
    {
      id: 218,
      country_name: "Nicaragua",
      country_code: "NI",
      phone_code: "+505",
    },
    {
      id: 72,
      country_name: "Costa Rica",
      country_code: "CR",
      phone_code: "+506",
    },
    { id: 212, country_name: "Panama", country_code: "PA", phone_code: "+507" },
    {
      id: 205,
      country_name: "Saint Pierre và Miquelon",
      country_code: "PM",
      phone_code: "+508",
    },
    { id: 178, country_name: "Haiti", country_code: "HT", phone_code: "+509" },
    { id: 211, country_name: "Peru", country_code: "PE", phone_code: "+51" },
    { id: 121, country_name: "Mexico", country_code: "MX", phone_code: "+52" },
    { id: 70, country_name: "Cuba", country_code: "CU", phone_code: "+53" },
    {
      id: 18,
      country_name: "Argentina",
      country_code: "AR",
      phone_code: "+54",
    },
    { id: 48, country_name: "Brazil", country_code: "BR", phone_code: "+55" },
    { id: 76, country_name: "Chile", country_code: "CL", phone_code: "+56" },
    { id: 74, country_name: "Colombia", country_code: "CO", phone_code: "+57" },
    {
      id: 92,
      country_name: "Venezuela",
      country_code: "VE",
      phone_code: "+58",
    },
    {
      id: 188,
      country_name: "Guadeloupe",
      country_code: "GP",
      phone_code: "+590",
    },
    { id: 53, country_name: "Bolivia", country_code: "BO", phone_code: "+591" },
    { id: 182, country_name: "Guyana", country_code: "GY", phone_code: "+592" },
    {
      id: 100,
      country_name: "Ecuador",
      country_code: "EC",
      phone_code: "+593",
    },
    {
      id: 194,
      country_name: "Guiana thuộc Pháp",
      country_code: "GF",
      phone_code: "+594",
    },
    {
      id: 29,
      country_name: "Paraguay",
      country_code: "PY",
      phone_code: "+595",
    },
    {
      id: 128,
      country_name: "Martinique",
      country_code: "MQ",
      phone_code: "+596",
    },
    { id: 88, country_name: "Surinam", country_code: "SR", phone_code: "+597" },
    { id: 97, country_name: "Uruguay", country_code: "UY", phone_code: "+598" },
    {
      id: 51,
      country_name: "Bonaire, Thánh Eustatius và Saba",
      country_code: "BQ",
      phone_code: "+599",
    },
    { id: 67, country_name: "Curacao", country_code: "CW", phone_code: "+599" },
    {
      id: 120,
      country_name: "Malaysia",
      country_code: "MY",
      phone_code: "+60",
    },
    { id: 14, country_name: "Úc", country_code: "AU", phone_code: "+61" },
    {
      id: 227,
      country_name: "Quần đảo Cocos",
      country_code: "CC",
      phone_code: "+61",
    },
    {
      id: 228,
      country_name: "Đảo Giáng Sinh",
      country_code: "CX",
      phone_code: "+61",
    },
    {
      id: 174,
      country_name: "Indonesia",
      country_code: "ID",
      phone_code: "+62",
    },
    {
      id: 208,
      country_name: "Philippines",
      country_code: "PH",
      phone_code: "+63",
    },
    {
      id: 214,
      country_name: "New Zealand",
      country_code: "NZ",
      phone_code: "+64",
    },
    {
      id: 236,
      country_name: "Quần đảo Pitcairn",
      country_code: "PN",
      phone_code: "+64",
    },
    {
      id: 43,
      country_name: "Singapore",
      country_code: "SG",
      phone_code: "+65",
    },
    { id: 66, country_name: "Thái Lan", country_code: "TH", phone_code: "+66" },
    {
      id: 62,
      country_name: "Đông Timor",
      country_code: "TL",
      phone_code: "+670",
    },
    {
      id: 229,
      country_name: "Đảo Heard và Quần đảo McDonald",
      country_code: "HM",
      phone_code: "+672",
    },
    {
      id: 235,
      country_name: "Đảo Norfolk",
      country_code: "NF",
      phone_code: "+672",
    },
    { id: 54, country_name: "Brunei", country_code: "BN", phone_code: "+673" },
    { id: 223, country_name: "Nauru", country_code: "NR", phone_code: "+674" },
    {
      id: 209,
      country_name: "Papua New Guinea",
      country_code: "PG",
      phone_code: "+675",
    },
    { id: 113, country_name: "Tonga", country_code: "TO", phone_code: "+676" },
    {
      id: 50,
      country_name: "quần đảo Solomon",
      country_code: "SB",
      phone_code: "+677",
    },
    {
      id: 204,
      country_name: "Vanuatu",
      country_code: "VU",
      phone_code: "+678",
    },
    { id: 202, country_name: "Fiji", country_code: "FJ", phone_code: "+679" },
    { id: 30, country_name: "Palau", country_code: "PW", phone_code: "+680" },
    {
      id: 77,
      country_name: "Quần đảo Cook",
      country_code: "CK",
      phone_code: "+682",
    },
    { id: 197, country_name: "Samoa", country_code: "WS", phone_code: "+685" },
    {
      id: 157,
      country_name: "Kiribati",
      country_code: "KI",
      phone_code: "+686",
    },
    {
      id: 117,
      country_name: "New Caledonia",
      country_code: "NC",
      phone_code: "+687",
    },
    { id: 224, country_name: "Tuvalu", country_code: "TV", phone_code: "+688" },
    {
      id: 210,
      country_name: "Polynésie thuộc Pháp",
      country_code: "PF",
      phone_code: "+689",
    },
    {
      id: 222,
      country_name: "Micronesia",
      country_code: "FM",
      phone_code: "+691",
    },
    {
      id: 221,
      country_name: "Quần đảo Marshall",
      country_code: "MH",
      phone_code: "+692",
    },
    {
      id: 151,
      country_name: "Kazakhstan",
      country_code: "KZ",
      phone_code: "+7",
    },
    { id: 4, country_name: "Nga", country_code: "RU", phone_code: "+7" },
    {
      id: 161,
      country_name: "Nhật Bản",
      country_code: "JP",
      phone_code: "+81",
    },
    {
      id: 154,
      country_name: "Hàn Quốc",
      country_code: "KR",
      phone_code: "+82",
    },
    { id: 89, country_name: "Việt Nam", country_code: "VN", phone_code: "+84" },
    {
      id: 181,
      country_name: "Hồng Kông",
      country_code: "HK",
      phone_code: "+852",
    },
    {
      id: 130,
      country_name: "Ma Cao, Trung Quốc",
      country_code: "MO",
      phone_code: "+853",
    },
    {
      id: 158,
      country_name: "Campuchia",
      country_code: "KH",
      phone_code: "+855",
    },
    { id: 150, country_name: "Lào", country_code: "LA", phone_code: "+856" },
    {
      id: 219,
      country_name: "Trung Quốc đại lục",
      country_code: "CN",
      phone_code: "+86",
    },
    {
      id: 7,
      country_name: "Bangladesh",
      country_code: "BD",
      phone_code: "+880",
    },
    {
      id: 109,
      country_name: "Đài Loan",
      country_code: "TW",
      phone_code: "+886",
    },
    {
      id: 112,
      country_name: "Thổ Nhĩ Kỳ",
      country_code: "TR",
      phone_code: "+90",
    },
    { id: 171, country_name: "Ấn Độ", country_code: "IN", phone_code: "+91" },
    {
      id: 207,
      country_name: "Pakistan",
      country_code: "PK",
      phone_code: "+92",
    },
    {
      id: 24,
      country_name: "Afghanistan",
      country_code: "AF",
      phone_code: "+93",
    },
    {
      id: 146,
      country_name: "Sri Lanka",
      country_code: "LK",
      phone_code: "+94",
    },
    { id: 132, country_name: "Myanmar", country_code: "MM", phone_code: "+95" },
    {
      id: 123,
      country_name: "Maldives",
      country_code: "MV",
      phone_code: "+960",
    },
    {
      id: 149,
      country_name: "Li-băng",
      country_code: "LB",
      phone_code: "+961",
    },
    { id: 162, country_name: "Jordan", country_code: "JO", phone_code: "+962" },
    { id: 79, country_name: "Syria", country_code: "SY", phone_code: "+963" },
    { id: 169, country_name: "Iraq", country_code: "IQ", phone_code: "+964" },
    { id: 153, country_name: "Cô-oét", country_code: "KW", phone_code: "+965" },
    {
      id: 52,
      country_name: "Ả Rập Xê Út",
      country_code: "SA",
      phone_code: "+966",
    },
    { id: 177, country_name: "Yemen", country_code: "YE", phone_code: "+967" },
    { id: 213, country_name: "Ô-man", country_code: "OM", phone_code: "+968" },
    {
      id: 32,
      country_name: "Lãnh thổ Palestine",
      country_code: "PS",
      phone_code: "+970",
    },
    {
      id: 25,
      country_name: "Các Tiểu vương quốc Ả Rập Thống nhất",
      country_code: "AE",
      phone_code: "+971",
    },
    { id: 172, country_name: "Israel", country_code: "IL", phone_code: "+972" },
    { id: 58, country_name: "Bahrain", country_code: "BH", phone_code: "+973" },
    { id: 28, country_name: "Qatar", country_code: "QA", phone_code: "+974" },
    { id: 45, country_name: "Bhutan", country_code: "BT", phone_code: "+975" },
    {
      id: 131,
      country_name: "Mông Cổ",
      country_code: "MN",
      phone_code: "+976",
    },
    { id: 215, country_name: "Nepal", country_code: "NP", phone_code: "+977" },
    { id: 168, country_name: "Iran", country_code: "IR", phone_code: "+98" },
    {
      id: 64,
      country_name: "Tajikistan",
      country_code: "TJ",
      phone_code: "+992",
    },
    {
      id: 115,
      country_name: "Turkmenistan",
      country_code: "TM",
      phone_code: "+993",
    },
    {
      id: 12,
      country_name: "Azerbaijan",
      country_code: "AZ",
      phone_code: "+994",
    },
    {
      id: 195,
      country_name: "Georgia",
      country_code: "GE",
      phone_code: "+995",
    },
    {
      id: 159,
      country_name: "Kyrgyzstan",
      country_code: "KG",
      phone_code: "+996",
    },
    {
      id: 96,
      country_name: "Uzbekistan",
      country_code: "UZ",
      phone_code: "+998",
    },
  ],
  th_TH: [
    { id: 2, country_name: "แคนาดา", country_code: "CA", phone_code: "+1" },
    {
      id: 239,
      country_name: "หมู่เกาะรอบนอกเล็กของสหรัฐอเมริกา",
      country_code: "UM",
      phone_code: "+1",
    },
    {
      id: 5,
      country_name: "สหรัฐอเมริกา",
      country_code: "US",
      phone_code: "+1",
    },
    {
      id: 47,
      country_name: "บาฮามาส",
      country_code: "BS",
      phone_code: "+1242",
    },
    {
      id: 9,
      country_name: "บาร์เบโดส",
      country_code: "BB",
      phone_code: "+1246",
    },
    {
      id: 22,
      country_name: "แองกวิลลา",
      country_code: "AI",
      phone_code: "+1264",
    },
    {
      id: 23,
      country_name: "แอนติกาและบาร์บูดา",
      country_code: "AG",
      phone_code: "+1268",
    },
    {
      id: 90,
      country_name: "หมู่เกาะเวอร์จินของสหรัฐอเมริกา",
      country_code: "VI",
      phone_code: "+1284",
    },
    {
      id: 91,
      country_name: "หมู่เกาะบริติชเวอร์จิน",
      country_code: "VG",
      phone_code: "+1340",
    },
    {
      id: 152,
      country_name: "หมู่เกาะเคย์แมน",
      country_code: "KY",
      phone_code: "+1345",
    },
    {
      id: 55,
      country_name: "เบอร์มิวดา",
      country_code: "BM",
      phone_code: "+1441",
    },
    {
      id: 196,
      country_name: "เกรเนดา",
      country_code: "GD",
      phone_code: "+1473",
    },
    {
      id: 73,
      country_name: "หมู่เกาะเติกส์และเคคอส",
      country_code: "TC",
      phone_code: "+1649",
    },
    {
      id: 126,
      country_name: "มอนต์เซอร์รัต",
      country_code: "MS",
      phone_code: "+1664",
    },
    {
      id: 129,
      country_name: "หมู่เกาะมาเรียนา",
      country_code: "MP",
      phone_code: "+1670",
    },
    { id: 184, country_name: "กวม", country_code: "GU", phone_code: "+1671" },
    {
      id: 17,
      country_name: "อเมริกันซามัว",
      country_code: "AS",
      phone_code: "+1684",
    },
    {
      id: 82,
      country_name: "ซินต์มาร์เทน (ส่วนภาษาดัตช์)",
      country_code: "SX",
      phone_code: "+1721",
    },
    {
      id: 148,
      country_name: "เซนต์ลูเซีย",
      country_code: "LC",
      phone_code: "+1758",
    },
    {
      id: 105,
      country_name: "โดมินิกัน",
      country_code: "DM",
      phone_code: "+1767",
    },
    {
      id: 95,
      country_name: "เซนต์วินเซนต์และเกรนาดีนส์",
      country_code: "VC",
      phone_code: "+1784",
    },
    {
      id: 33,
      country_name: "เปอร์โตริโก",
      country_code: "PR",
      phone_code: "+1787",
    },
    {
      id: 104,
      country_name: "สาธารณรัฐโดมินิกัน",
      country_code: "DO",
      phone_code: "+1809",
    },
    {
      id: 111,
      country_name: "ตรินิแดดและโตเบโก",
      country_code: "TT",
      phone_code: "+1868",
    },
    {
      id: 155,
      country_name: "เซนต์คิตส์และเนวิส",
      country_code: "KN",
      phone_code: "+1869",
    },
    {
      id: 163,
      country_name: "จาเมกา",
      country_code: "JM",
      phone_code: "+1876",
    },
    { id: 98, country_name: "อียิปต์", country_code: "EG", phone_code: "+20" },
    {
      id: 87,
      country_name: "ซูดานใต้",
      country_code: "SS",
      phone_code: "+211",
    },
    {
      id: 139,
      country_name: "โมร็อกโก",
      country_code: "MA",
      phone_code: "+212",
    },
    {
      id: 101,
      country_name: "แอลจีเรีย",
      country_code: "DZ",
      phone_code: "+213",
    },
    {
      id: 114,
      country_name: "ตูนิเซีย",
      country_code: "TN",
      phone_code: "+216",
    },
    { id: 140, country_name: "ลิเบีย", country_code: "LY", phone_code: "+218" },
    {
      id: 190,
      country_name: "แกมเบีย",
      country_code: "GM",
      phone_code: "+220",
    },
    { id: 35, country_name: "เซเนกัล", country_code: "SN", phone_code: "+221" },
    {
      id: 127,
      country_name: "มอริเตเนีย",
      country_code: "MR",
      phone_code: "+222",
    },
    { id: 133, country_name: "มาลี", country_code: "ML", phone_code: "+223" },
    { id: 189, country_name: "กินี", country_code: "GN", phone_code: "+224" },
    {
      id: 80,
      country_name: "ไอวอรีโคสต์",
      country_code: "CI",
      phone_code: "+225",
    },
    {
      id: 61,
      country_name: "บูร์กินาฟาโซ",
      country_code: "BF",
      phone_code: "+226",
    },
    {
      id: 116,
      country_name: "ไนเจอร์",
      country_code: "NE",
      phone_code: "+227",
    },
    { id: 68, country_name: "โตโก", country_code: "TG", phone_code: "+228" },
    { id: 56, country_name: "เบนิน", country_code: "BJ", phone_code: "+229" },
    {
      id: 124,
      country_name: "มอริเชียส",
      country_code: "MU",
      phone_code: "+230",
    },
    {
      id: 145,
      country_name: "ไลบีเรีย",
      country_code: "LR",
      phone_code: "+231",
    },
    {
      id: 37,
      country_name: "เซียร์ราลีโอน",
      country_code: "SL",
      phone_code: "+232",
    },
    { id: 193, country_name: "กานา", country_code: "GH", phone_code: "+233" },
    { id: 1, country_name: "ไนจีเรีย", country_code: "NG", phone_code: "+234" },
    { id: 71, country_name: "แชด", country_code: "TD", phone_code: "+235" },
    {
      id: 85,
      country_name: "สาธารณรัฐแอฟริกากลาง",
      country_code: "CF",
      phone_code: "+236",
    },
    {
      id: 75,
      country_name: "แคเมอรูน",
      country_code: "CM",
      phone_code: "+237",
    },
    { id: 69, country_name: "แหลม", country_code: "CV", phone_code: "+238" },
    {
      id: 86,
      country_name: "เซาตูเมและปรินซิปี",
      country_code: "ST",
      phone_code: "+239",
    },
    {
      id: 187,
      country_name: "อิเควทอเรียลกินี",
      country_code: "GQ",
      phone_code: "+240",
    },
    { id: 199, country_name: "กาบอง", country_code: "GA", phone_code: "+241" },
    {
      id: 83,
      country_name: "สาธารณรัฐคองโก",
      country_code: "CG",
      phone_code: "+242",
    },
    {
      id: 3,
      country_name: "สาธารณรัฐประชาธิปไตยคองโก",
      country_code: "CD",
      phone_code: "+243",
    },
    { id: 19, country_name: "แองโกลา", country_code: "AO", phone_code: "+244" },
    {
      id: 183,
      country_name: "กินี-บิสเซา",
      country_code: "GW",
      phone_code: "+245",
    },
    {
      id: 230,
      country_name: "ดินแดนมหาสมุทรอินเดียของอังกฤษ",
      country_code: "IO",
      phone_code: "+246",
    },
    {
      id: 27,
      country_name: "เกาะแอสเซนชัน",
      country_code: "AC",
      phone_code: "+247",
    },
    { id: 49, country_name: "เซเชลส์", country_code: "SC", phone_code: "+248" },
    { id: 46, country_name: "ซูดาน", country_code: "SD", phone_code: "+249" },
    { id: 60, country_name: "รวันดา", country_code: "RW", phone_code: "+250" },
    {
      id: 93,
      country_name: "เอธิโอเปีย",
      country_code: "ET",
      phone_code: "+251",
    },
    {
      id: 34,
      country_name: "โซมาเลีย",
      country_code: "SO",
      phone_code: "+252",
    },
    { id: 108, country_name: "จิบูตี", country_code: "DJ", phone_code: "+253" },
    { id: 160, country_name: "เคนยา", country_code: "KE", phone_code: "+254" },
    {
      id: 107,
      country_name: "แทนซาเนีย",
      country_code: "TZ",
      phone_code: "+255",
    },
    {
      id: 102,
      country_name: "ยูกันดา",
      country_code: "UG",
      phone_code: "+256",
    },
    { id: 57, country_name: "บุรุนดี", country_code: "BI", phone_code: "+257" },
    {
      id: 119,
      country_name: "โมซัมบิก",
      country_code: "MZ",
      phone_code: "+258",
    },
    {
      id: 165,
      country_name: "แซมเบีย",
      country_code: "ZM",
      phone_code: "+260",
    },
    {
      id: 135,
      country_name: "มาดากัสการ์",
      country_code: "MG",
      phone_code: "+261",
    },
    {
      id: 16,
      country_name: "การกลับมาพบกันอีกครั้ง",
      country_code: "RE",
      phone_code: "+262",
    },
    {
      id: 231,
      country_name: "ดินแดนทางใต้ของเฟรนช์",
      country_code: "TF",
      phone_code: "+262",
    },
    {
      id: 164,
      country_name: "ซิมบับเว",
      country_code: "ZW",
      phone_code: "+263",
    },
    {
      id: 118,
      country_name: "นามิเบีย",
      country_code: "NA",
      phone_code: "+264",
    },
    { id: 122, country_name: "มาลาวี", country_code: "MW", phone_code: "+265" },
    { id: 144, country_name: "เลโซโท", country_code: "LS", phone_code: "+266" },
    {
      id: 42,
      country_name: "บอตสวานา",
      country_code: "BW",
      phone_code: "+267",
    },
    {
      id: 78,
      country_name: "สวาซิแลนด์",
      country_code: "SZ",
      phone_code: "+268",
    },
    {
      id: 156,
      country_name: "คอโมโรส",
      country_code: "KM",
      phone_code: "+269",
    },
    { id: 175, country_name: "มายอต", country_code: "YT", phone_code: "+269" },
    {
      id: 170,
      country_name: "แอฟริกาใต้",
      country_code: "ZA",
      phone_code: "+27",
    },
    { id: 13, country_name: "อารูบา", country_code: "AW", phone_code: "+297" },
    {
      id: 201,
      country_name: "หมู่เกาะแฟโร",
      country_code: "FO",
      phone_code: "+298",
    },
    {
      id: 191,
      country_name: "กรีนแลนด์",
      country_code: "GL",
      phone_code: "+299",
    },
    { id: 186, country_name: "กรีซ", country_code: "GR", phone_code: "+30" },
    {
      id: 217,
      country_name: "เนเธอร์แลนด์",
      country_code: "NL",
      phone_code: "+31",
    },
    { id: 6, country_name: "เบลเยียม", country_code: "BE", phone_code: "+32" },
    {
      id: 200,
      country_name: "ฝรั่งเศส",
      country_code: "FR",
      phone_code: "+33",
    },
    { id: 94, country_name: "สเปน", country_code: "ES", phone_code: "+34" },
    {
      id: 192,
      country_name: "ยิบรอลตาร์",
      country_code: "GI",
      phone_code: "+350",
    },
    {
      id: 31,
      country_name: "โปรตุเกส",
      country_code: "PT",
      phone_code: "+351",
    },
    {
      id: 142,
      country_name: "ลักเซมเบิร์ก",
      country_code: "LU",
      phone_code: "+352",
    },
    {
      id: 173,
      country_name: "ไอร์แลนด์",
      country_code: "IE",
      phone_code: "+353",
    },
    {
      id: 167,
      country_name: "ไอซ์แลนด์",
      country_code: "IS",
      phone_code: "+354",
    },
    {
      id: 21,
      country_name: "แอลเบเนีย",
      country_code: "AL",
      phone_code: "+355",
    },
    { id: 125, country_name: "มอลตา", country_code: "MT", phone_code: "+356" },
    { id: 65, country_name: "ไซปรัส", country_code: "CY", phone_code: "+357" },
    {
      id: 225,
      country_name: "หมู่เกาะโอลันด์",
      country_code: "AX",
      phone_code: "+358",
    },
    {
      id: 203,
      country_name: "ฟินแลนด์",
      country_code: "FI",
      phone_code: "+358",
    },
    {
      id: 59,
      country_name: "บัลแกเรีย",
      country_code: "BG",
      phone_code: "+359",
    },
    { id: 176, country_name: "ฮังการี", country_code: "HU", phone_code: "+36" },
    {
      id: 143,
      country_name: "ลิทัวเนีย",
      country_code: "LT",
      phone_code: "+370",
    },
    {
      id: 141,
      country_name: "ลัตเวีย",
      country_code: "LV",
      phone_code: "+371",
    },
    {
      id: 99,
      country_name: "เอสโตเนีย",
      country_code: "EE",
      phone_code: "+372",
    },
    {
      id: 137,
      country_name: "มอลโดวา",
      country_code: "MD",
      phone_code: "+373",
    },
    {
      id: 20,
      country_name: "อาร์เมเนีย",
      country_code: "AM",
      phone_code: "+374",
    },
    { id: 40, country_name: "เบลารุส", country_code: "BY", phone_code: "+375" },
    {
      id: 26,
      country_name: "อันดอร์รา",
      country_code: "AD",
      phone_code: "+376",
    },
    { id: 138, country_name: "โมนาโก", country_code: "MC", phone_code: "+377" },
    {
      id: 36,
      country_name: "ซานมารีโน",
      country_code: "SM",
      phone_code: "+378",
    },
    {
      id: 220,
      country_name: "นครรัฐวาติกัน",
      country_code: "VA",
      phone_code: "+379",
    },
    { id: 103, country_name: "ยูเครน", country_code: "UA", phone_code: "+380" },
    {
      id: 8,
      country_name: "เซอร์เบีย",
      country_code: "RS",
      phone_code: "+381",
    },
    {
      id: 136,
      country_name: "มอนเตเนโกร",
      country_code: "ME",
      phone_code: "+382",
    },
    {
      id: 179,
      country_name: "โครเอเชีย",
      country_code: "HR",
      phone_code: "+385",
    },
    {
      id: 41,
      country_name: "สโลวีเนีย",
      country_code: "SI",
      phone_code: "+386",
    },
    {
      id: 10,
      country_name: "บอสเนียและเฮอร์เซโกวีนา",
      country_code: "BA",
      phone_code: "+387",
    },
    {
      id: 134,
      country_name: "มาซิโดเนีย",
      country_code: "MK",
      phone_code: "+389",
    },
    { id: 166, country_name: "อิตาลี", country_code: "IT", phone_code: "+39" },
    { id: 11, country_name: "โรมาเนีย", country_code: "RO", phone_code: "+40" },
    {
      id: 81,
      country_name: "สวิตเซอร์แลนด์",
      country_code: "CH",
      phone_code: "+41",
    },
    {
      id: 63,
      country_name: "สาธารณรัฐเช็ก",
      country_code: "CZ",
      phone_code: "+420",
    },
    {
      id: 38,
      country_name: "สโลวาเกีย",
      country_code: "SK",
      phone_code: "+421",
    },
    {
      id: 147,
      country_name: "ลิกเตนสไตน์",
      country_code: "LI",
      phone_code: "+423",
    },
    { id: 15, country_name: "ออสเตรีย", country_code: "AT", phone_code: "+43" },
    {
      id: 198,
      country_name: "สหราชอาณาจักร",
      country_code: "GB",
      phone_code: "+44",
    },
    {
      id: 232,
      country_name: "เกิร์นซีย์",
      country_code: "GG",
      phone_code: "+44",
    },
    { id: 234, country_name: "เกาะแมน", country_code: "IM", phone_code: "+44" },
    {
      id: 233,
      country_name: "เสื้อเจอร์ซีย์",
      country_code: "JE",
      phone_code: "+44",
    },
    {
      id: 106,
      country_name: "เดนมาร์ก",
      country_code: "DK",
      phone_code: "+45",
    },
    { id: 44, country_name: "สวีเดน", country_code: "SE", phone_code: "+46" },
    {
      id: 226,
      country_name: "เกาะบูเวต์",
      country_code: "BV",
      phone_code: "+47",
    },
    {
      id: 216,
      country_name: "นอร์เวย์",
      country_code: "NO",
      phone_code: "+47",
    },
    {
      id: 238,
      country_name: "สฟาลบาร์ด",
      country_code: "SJ",
      phone_code: "+47",
    },
    { id: 206, country_name: "โปแลนด์", country_code: "PL", phone_code: "+48" },
    { id: 110, country_name: "เยอรมนี", country_code: "DE", phone_code: "+49" },
    {
      id: 237,
      country_name: "เกาะเซาท์จอร์เจีย",
      country_code: "GS",
      phone_code: "+500",
    },
    { id: 39, country_name: "เบลีซ", country_code: "BZ", phone_code: "+501" },
    {
      id: 185,
      country_name: "กัวเตมาลา",
      country_code: "GT",
      phone_code: "+502",
    },
    {
      id: 84,
      country_name: "เอลซัลวาดอร์",
      country_code: "SV",
      phone_code: "+503",
    },
    {
      id: 180,
      country_name: "ฮอนดูรัส",
      country_code: "HN",
      phone_code: "+504",
    },
    {
      id: 218,
      country_name: "นิการากัว",
      country_code: "NI",
      phone_code: "+505",
    },
    {
      id: 72,
      country_name: "คอสตาริกา",
      country_code: "CR",
      phone_code: "+506",
    },
    { id: 212, country_name: "ปานามา", country_code: "PA", phone_code: "+507" },
    {
      id: 205,
      country_name: "แซงต์ปีแยร์และมีเกอลง",
      country_code: "PM",
      phone_code: "+508",
    },
    { id: 178, country_name: "เฮติ", country_code: "HT", phone_code: "+509" },
    { id: 211, country_name: "เปรู", country_code: "PE", phone_code: "+51" },
    {
      id: 121,
      country_name: "เม็กซิโก",
      country_code: "MX",
      phone_code: "+52",
    },
    { id: 70, country_name: "คิวบา", country_code: "CU", phone_code: "+53" },
    {
      id: 18,
      country_name: "อาร์เจนตินา",
      country_code: "AR",
      phone_code: "+54",
    },
    { id: 48, country_name: "บราซิล", country_code: "BR", phone_code: "+55" },
    { id: 76, country_name: "ชิลี", country_code: "CL", phone_code: "+56" },
    {
      id: 74,
      country_name: "โคลอมเบีย",
      country_code: "CO",
      phone_code: "+57",
    },
    {
      id: 92,
      country_name: "เวเนซุเอลา",
      country_code: "VE",
      phone_code: "+58",
    },
    {
      id: 188,
      country_name: "กัวเดอลูป",
      country_code: "GP",
      phone_code: "+590",
    },
    {
      id: 53,
      country_name: "โบลิเวีย",
      country_code: "BO",
      phone_code: "+591",
    },
    {
      id: 182,
      country_name: "กายอานา",
      country_code: "GY",
      phone_code: "+592",
    },
    {
      id: 100,
      country_name: "เอกวาดอร์",
      country_code: "EC",
      phone_code: "+593",
    },
    {
      id: 194,
      country_name: "เฟรนช์เกียนา",
      country_code: "GF",
      phone_code: "+594",
    },
    {
      id: 29,
      country_name: "ปารากวัย",
      country_code: "PY",
      phone_code: "+595",
    },
    {
      id: 128,
      country_name: "มาร์ตินีก",
      country_code: "MQ",
      phone_code: "+596",
    },
    { id: 88, country_name: "ซูรินาม", country_code: "SR", phone_code: "+597" },
    {
      id: 97,
      country_name: "อุรุกวัย",
      country_code: "UY",
      phone_code: "+598",
    },
    {
      id: 51,
      country_name: "โบแนร์ เซนต์เอิสทาทิอุส และซาบา",
      country_code: "BQ",
      phone_code: "+599",
    },
    { id: 67, country_name: "คูราเซา", country_code: "CW", phone_code: "+599" },
    {
      id: 120,
      country_name: "มาเลเซีย",
      country_code: "MY",
      phone_code: "+60",
    },
    {
      id: 14,
      country_name: "ออสเตรเลีย",
      country_code: "AU",
      phone_code: "+61",
    },
    {
      id: 227,
      country_name: "หมู่เกาะโคโคส",
      country_code: "CC",
      phone_code: "+61",
    },
    {
      id: 228,
      country_name: "เกาะคริสต์มาส",
      country_code: "CX",
      phone_code: "+61",
    },
    {
      id: 174,
      country_name: "อินโดนีเซีย",
      country_code: "ID",
      phone_code: "+62",
    },
    {
      id: 208,
      country_name: "ฟิลิปปินส์",
      country_code: "PH",
      phone_code: "+63",
    },
    {
      id: 214,
      country_name: "นิวซีแลนด์",
      country_code: "NZ",
      phone_code: "+64",
    },
    {
      id: 236,
      country_name: "หมู่เกาะพิตแคร์น",
      country_code: "PN",
      phone_code: "+64",
    },
    { id: 43, country_name: "สิงคโปร์", country_code: "SG", phone_code: "+65" },
    {
      id: 66,
      country_name: "ประเทศไทย",
      country_code: "TH",
      phone_code: "+66",
    },
    {
      id: 62,
      country_name: "ติมอร์ตะวันออก",
      country_code: "TL",
      phone_code: "+670",
    },
    {
      id: 229,
      country_name: "เกาะเฮิร์ดและหมู่เกาะแมคโดนัลด์",
      country_code: "HM",
      phone_code: "+672",
    },
    {
      id: 235,
      country_name: "เกาะนอร์ฟอล์ก",
      country_code: "NF",
      phone_code: "+672",
    },
    { id: 54, country_name: "บรูไน", country_code: "BN", phone_code: "+673" },
    { id: 223, country_name: "นาอูรู", country_code: "NR", phone_code: "+674" },
    {
      id: 209,
      country_name: "ปาปัวนิวกินี",
      country_code: "PG",
      phone_code: "+675",
    },
    { id: 113, country_name: "ตองกา", country_code: "TO", phone_code: "+676" },
    {
      id: 50,
      country_name: "หมู่เกาะโซโลมอน",
      country_code: "SB",
      phone_code: "+677",
    },
    {
      id: 204,
      country_name: "วานูอาตู",
      country_code: "VU",
      phone_code: "+678",
    },
    { id: 202, country_name: "ฟิจิ", country_code: "FJ", phone_code: "+679" },
    { id: 30, country_name: "ปาเลา", country_code: "PW", phone_code: "+680" },
    {
      id: 77,
      country_name: "หมู่เกาะคุก",
      country_code: "CK",
      phone_code: "+682",
    },
    { id: 197, country_name: "ซามัว", country_code: "WS", phone_code: "+685" },
    {
      id: 157,
      country_name: "คิริบาติ",
      country_code: "KI",
      phone_code: "+686",
    },
    {
      id: 117,
      country_name: "นิวแคลิโดเนีย",
      country_code: "NC",
      phone_code: "+687",
    },
    { id: 224, country_name: "ตูวาลู", country_code: "TV", phone_code: "+688" },
    {
      id: 210,
      country_name: "เฟรนช์โปลินีเซีย",
      country_code: "PF",
      phone_code: "+689",
    },
    {
      id: 222,
      country_name: "ไมโครนีเซีย",
      country_code: "FM",
      phone_code: "+691",
    },
    {
      id: 221,
      country_name: "หมู่เกาะมาร์แชลล์",
      country_code: "MH",
      phone_code: "+692",
    },
    {
      id: 151,
      country_name: "คาซัคสถาน",
      country_code: "KZ",
      phone_code: "+7",
    },
    { id: 4, country_name: "รัสเซีย", country_code: "RU", phone_code: "+7" },
    {
      id: 161,
      country_name: "ประเทศญี่ปุ่น",
      country_code: "JP",
      phone_code: "+81",
    },
    {
      id: 154,
      country_name: "เกาหลีใต้",
      country_code: "KR",
      phone_code: "+82",
    },
    { id: 89, country_name: "เวียดนาม", country_code: "VN", phone_code: "+84" },
    { id: 181, country_name: "ฮ่องกง", country_code: "HK", phone_code: "+852" },
    {
      id: 130,
      country_name: "มาเก๊า ประเทศจีน",
      country_code: "MO",
      phone_code: "+853",
    },
    {
      id: 158,
      country_name: "กัมพูชา",
      country_code: "KH",
      phone_code: "+855",
    },
    { id: 150, country_name: "ลาว", country_code: "LA", phone_code: "+856" },
    {
      id: 219,
      country_name: "จีนแผ่นดินใหญ่",
      country_code: "CN",
      phone_code: "+86",
    },
    {
      id: 7,
      country_name: "บังคลาเทศ",
      country_code: "BD",
      phone_code: "+880",
    },
    {
      id: 109,
      country_name: "ไต้หวัน",
      country_code: "TW",
      phone_code: "+886",
    },
    { id: 112, country_name: "ตุรกี", country_code: "TR", phone_code: "+90" },
    { id: 171, country_name: "อินเดีย", country_code: "IN", phone_code: "+91" },
    {
      id: 207,
      country_name: "ปากีสถาน",
      country_code: "PK",
      phone_code: "+92",
    },
    {
      id: 24,
      country_name: "อัฟกานิสถาน",
      country_code: "AF",
      phone_code: "+93",
    },
    {
      id: 146,
      country_name: "ศรีลังกา",
      country_code: "LK",
      phone_code: "+94",
    },
    { id: 132, country_name: "พม่า", country_code: "MM", phone_code: "+95" },
    {
      id: 123,
      country_name: "มัลดีฟส์",
      country_code: "MV",
      phone_code: "+960",
    },
    {
      id: 149,
      country_name: "เลบานอน",
      country_code: "LB",
      phone_code: "+961",
    },
    {
      id: 162,
      country_name: "จอร์แดน",
      country_code: "JO",
      phone_code: "+962",
    },
    { id: 79, country_name: "ซีเรีย", country_code: "SY", phone_code: "+963" },
    { id: 169, country_name: "อิรัก", country_code: "IQ", phone_code: "+964" },
    { id: 153, country_name: "คูเวต", country_code: "KW", phone_code: "+965" },
    {
      id: 52,
      country_name: "ซาอุดีอาระเบีย",
      country_code: "SA",
      phone_code: "+966",
    },
    { id: 177, country_name: "เยเมน", country_code: "YE", phone_code: "+967" },
    { id: 213, country_name: "โอมาน", country_code: "OM", phone_code: "+968" },
    {
      id: 32,
      country_name: "ดินแดนปาเลสไตน์",
      country_code: "PS",
      phone_code: "+970",
    },
    {
      id: 25,
      country_name: "สหรัฐอาหรับเอมิเรตส์",
      country_code: "AE",
      phone_code: "+971",
    },
    {
      id: 172,
      country_name: "อิสราเอล",
      country_code: "IL",
      phone_code: "+972",
    },
    { id: 58, country_name: "บาห์เรน", country_code: "BH", phone_code: "+973" },
    { id: 28, country_name: "กาตาร์", country_code: "QA", phone_code: "+974" },
    { id: 45, country_name: "ภูฏาน", country_code: "BT", phone_code: "+975" },
    {
      id: 131,
      country_name: "มองโกเลีย",
      country_code: "MN",
      phone_code: "+976",
    },
    { id: 215, country_name: "เนปาล", country_code: "NP", phone_code: "+977" },
    { id: 168, country_name: "อิหร่าน", country_code: "IR", phone_code: "+98" },
    {
      id: 64,
      country_name: "ทาจิกิสถาน",
      country_code: "TJ",
      phone_code: "+992",
    },
    {
      id: 115,
      country_name: "เติร์กเมนิสถาน",
      country_code: "TM",
      phone_code: "+993",
    },
    {
      id: 12,
      country_name: "อาเซอร์ไบจาน",
      country_code: "AZ",
      phone_code: "+994",
    },
    {
      id: 195,
      country_name: "จอร์เจีย",
      country_code: "GE",
      phone_code: "+995",
    },
    {
      id: 159,
      country_name: "คีร์กีซสถาน",
      country_code: "KG",
      phone_code: "+996",
    },
    {
      id: 96,
      country_name: "อุซเบกิสถาน",
      country_code: "UZ",
      phone_code: "+998",
    },
  ],
  ar_SA: [
    { id: 2, country_name: "كندا", country_code: "CA", phone_code: "+1" },
    {
      id: 239,
      country_name: "الجزر الصغيرة النائية التابعة للولايات المتحدة",
      country_code: "UM",
      phone_code: "+1",
    },
    {
      id: 5,
      country_name: "الولايات المتحدة الأمريكية",
      country_code: "US",
      phone_code: "+1",
    },
    {
      id: 47,
      country_name: "جزر البهاما",
      country_code: "BS",
      phone_code: "+1242",
    },
    { id: 9, country_name: "بربادوس", country_code: "BB", phone_code: "+1246" },
    { id: 22, country_name: "أنغيلا", country_code: "AI", phone_code: "+1264" },
    {
      id: 23,
      country_name: "أنتيغوا وباربودا",
      country_code: "AG",
      phone_code: "+1268",
    },
    {
      id: 90,
      country_name: "جزر فيرجن الأمريكية",
      country_code: "VI",
      phone_code: "+1284",
    },
    {
      id: 91,
      country_name: "جزر فيرجن البريطانية",
      country_code: "VG",
      phone_code: "+1340",
    },
    {
      id: 152,
      country_name: "جزر كايمان",
      country_code: "KY",
      phone_code: "+1345",
    },
    { id: 55, country_name: "برمودا", country_code: "BM", phone_code: "+1441" },
    {
      id: 196,
      country_name: "غرينيدا",
      country_code: "GD",
      phone_code: "+1473",
    },
    {
      id: 73,
      country_name: "جزر توركس وكايكوس",
      country_code: "TC",
      phone_code: "+1649",
    },
    {
      id: 126,
      country_name: "مونتسيرات",
      country_code: "MS",
      phone_code: "+1664",
    },
    {
      id: 129,
      country_name: "جزر ماريانا",
      country_code: "MP",
      phone_code: "+1670",
    },
    { id: 184, country_name: "غوام", country_code: "GU", phone_code: "+1671" },
    {
      id: 17,
      country_name: "ساموا الأمريكية",
      country_code: "AS",
      phone_code: "+1684",
    },
    {
      id: 82,
      country_name: "سانت مارتن (الجزء الهولندي)",
      country_code: "SX",
      phone_code: "+1721",
    },
    {
      id: 148,
      country_name: "سانت لوسيا",
      country_code: "LC",
      phone_code: "+1758",
    },
    {
      id: 105,
      country_name: "الدومينيكان",
      country_code: "DM",
      phone_code: "+1767",
    },
    {
      id: 95,
      country_name: "سانت فنسنت وجزر غرينادين",
      country_code: "VC",
      phone_code: "+1784",
    },
    {
      id: 33,
      country_name: "بورتوريكو",
      country_code: "PR",
      phone_code: "+1787",
    },
    {
      id: 104,
      country_name: "جمهورية الدومينيكان",
      country_code: "DO",
      phone_code: "+1809",
    },
    {
      id: 111,
      country_name: "ترينيداد وتوباغو",
      country_code: "TT",
      phone_code: "+1868",
    },
    {
      id: 155,
      country_name: "سانت كيتس ونيفيس",
      country_code: "KN",
      phone_code: "+1869",
    },
    {
      id: 163,
      country_name: "جامايكا",
      country_code: "JM",
      phone_code: "+1876",
    },
    { id: 98, country_name: "مصر", country_code: "EG", phone_code: "+20" },
    {
      id: 87,
      country_name: "جنوب السودان",
      country_code: "SS",
      phone_code: "+211",
    },
    { id: 139, country_name: "المغرب", country_code: "MA", phone_code: "+212" },
    {
      id: 101,
      country_name: "الجزائر",
      country_code: "DZ",
      phone_code: "+213",
    },
    { id: 114, country_name: "تونس", country_code: "TN", phone_code: "+216" },
    { id: 140, country_name: "ليبيا", country_code: "LY", phone_code: "+218" },
    { id: 190, country_name: "غامبيا", country_code: "GM", phone_code: "+220" },
    { id: 35, country_name: "السنغال", country_code: "SN", phone_code: "+221" },
    {
      id: 127,
      country_name: "موريتانيا",
      country_code: "MR",
      phone_code: "+222",
    },
    { id: 133, country_name: "مالي", country_code: "ML", phone_code: "+223" },
    { id: 189, country_name: "غينيا", country_code: "GN", phone_code: "+224" },
    {
      id: 80,
      country_name: "ساحل العاج",
      country_code: "CI",
      phone_code: "+225",
    },
    {
      id: 61,
      country_name: "بوركينا فاسو",
      country_code: "BF",
      phone_code: "+226",
    },
    { id: 116, country_name: "النيجر", country_code: "NE", phone_code: "+227" },
    { id: 68, country_name: "توغو", country_code: "TG", phone_code: "+228" },
    { id: 56, country_name: "بنين", country_code: "BJ", phone_code: "+229" },
    {
      id: 124,
      country_name: "موريشيوس",
      country_code: "MU",
      phone_code: "+230",
    },
    {
      id: 145,
      country_name: "ليبيريا",
      country_code: "LR",
      phone_code: "+231",
    },
    {
      id: 37,
      country_name: "سيراليون",
      country_code: "SL",
      phone_code: "+232",
    },
    { id: 193, country_name: "غانا", country_code: "GH", phone_code: "+233" },
    { id: 1, country_name: "نيجيريا", country_code: "NG", phone_code: "+234" },
    { id: 71, country_name: "تشاد", country_code: "TD", phone_code: "+235" },
    {
      id: 85,
      country_name: "جمهورية أفريقيا الوسطى",
      country_code: "CF",
      phone_code: "+236",
    },
    {
      id: 75,
      country_name: "الكاميرون",
      country_code: "CM",
      phone_code: "+237",
    },
    { id: 69, country_name: "كيب", country_code: "CV", phone_code: "+238" },
    {
      id: 86,
      country_name: "ساو تومي وبرينسيبي",
      country_code: "ST",
      phone_code: "+239",
    },
    {
      id: 187,
      country_name: "غينيا الاستوائية",
      country_code: "GQ",
      phone_code: "+240",
    },
    {
      id: 199,
      country_name: "الجابون",
      country_code: "GA",
      phone_code: "+241",
    },
    {
      id: 83,
      country_name: "جمهورية الكونغو",
      country_code: "CG",
      phone_code: "+242",
    },
    {
      id: 3,
      country_name: "جمهورية الكونغو الديمقراطية",
      country_code: "CD",
      phone_code: "+243",
    },
    { id: 19, country_name: "أنغولا", country_code: "AO", phone_code: "+244" },
    {
      id: 183,
      country_name: "غينيا بيساو",
      country_code: "GW",
      phone_code: "+245",
    },
    {
      id: 230,
      country_name: "إقليم المحيط الهندي البريطاني",
      country_code: "IO",
      phone_code: "+246",
    },
    {
      id: 27,
      country_name: "جزيرة أسينشن",
      country_code: "AC",
      phone_code: "+247",
    },
    { id: 49, country_name: "سيشل", country_code: "SC", phone_code: "+248" },
    { id: 46, country_name: "السودان", country_code: "SD", phone_code: "+249" },
    { id: 60, country_name: "رواندا", country_code: "RW", phone_code: "+250" },
    { id: 93, country_name: "أثيوبيا", country_code: "ET", phone_code: "+251" },
    { id: 34, country_name: "الصومال", country_code: "SO", phone_code: "+252" },
    { id: 108, country_name: "جيبوتي", country_code: "DJ", phone_code: "+253" },
    { id: 160, country_name: "كينيا", country_code: "KE", phone_code: "+254" },
    {
      id: 107,
      country_name: "تنزانيا",
      country_code: "TZ",
      phone_code: "+255",
    },
    { id: 102, country_name: "أوغندا", country_code: "UG", phone_code: "+256" },
    { id: 57, country_name: "بوروندي", country_code: "BI", phone_code: "+257" },
    {
      id: 119,
      country_name: "موزمبيق",
      country_code: "MZ",
      phone_code: "+258",
    },
    { id: 165, country_name: "زامبيا", country_code: "ZM", phone_code: "+260" },
    { id: 135, country_name: "مدغشقر", country_code: "MG", phone_code: "+261" },
    { id: 16, country_name: "جمع شمل", country_code: "RE", phone_code: "+262" },
    {
      id: 231,
      country_name: "الأقاليم الجنوبية الفرنسية",
      country_code: "TF",
      phone_code: "+262",
    },
    {
      id: 164,
      country_name: "زيمبابوي",
      country_code: "ZW",
      phone_code: "+263",
    },
    {
      id: 118,
      country_name: "ناميبيا",
      country_code: "NA",
      phone_code: "+264",
    },
    { id: 122, country_name: "ملاوي", country_code: "MW", phone_code: "+265" },
    { id: 144, country_name: "ليسوتو", country_code: "LS", phone_code: "+266" },
    {
      id: 42,
      country_name: "بوتسوانا",
      country_code: "BW",
      phone_code: "+267",
    },
    {
      id: 78,
      country_name: "سوازيلاند",
      country_code: "SZ",
      phone_code: "+268",
    },
    {
      id: 156,
      country_name: "جزر القمر",
      country_code: "KM",
      phone_code: "+269",
    },
    { id: 175, country_name: "مايوت", country_code: "YT", phone_code: "+269" },
    {
      id: 170,
      country_name: "جنوب أفريقيا",
      country_code: "ZA",
      phone_code: "+27",
    },
    { id: 13, country_name: "أروبا", country_code: "AW", phone_code: "+297" },
    {
      id: 201,
      country_name: "جزر فارو",
      country_code: "FO",
      phone_code: "+298",
    },
    {
      id: 191,
      country_name: "جرينلاند",
      country_code: "GL",
      phone_code: "+299",
    },
    { id: 186, country_name: "اليونان", country_code: "GR", phone_code: "+30" },
    { id: 217, country_name: "هولندا", country_code: "NL", phone_code: "+31" },
    { id: 6, country_name: "بلجيكا", country_code: "BE", phone_code: "+32" },
    { id: 200, country_name: "فرنسا", country_code: "FR", phone_code: "+33" },
    { id: 94, country_name: "إسبانيا", country_code: "ES", phone_code: "+34" },
    {
      id: 192,
      country_name: "جبل طارق",
      country_code: "GI",
      phone_code: "+350",
    },
    {
      id: 31,
      country_name: "البرتغال",
      country_code: "PT",
      phone_code: "+351",
    },
    {
      id: 142,
      country_name: "لوكسمبورغ",
      country_code: "LU",
      phone_code: "+352",
    },
    {
      id: 173,
      country_name: "أيرلندا",
      country_code: "IE",
      phone_code: "+353",
    },
    {
      id: 167,
      country_name: "أيسلندا",
      country_code: "IS",
      phone_code: "+354",
    },
    { id: 21, country_name: "ألبانيا", country_code: "AL", phone_code: "+355" },
    { id: 125, country_name: "مالطا", country_code: "MT", phone_code: "+356" },
    { id: 65, country_name: "قبرص", country_code: "CY", phone_code: "+357" },
    {
      id: 225,
      country_name: "جزر آلاند",
      country_code: "AX",
      phone_code: "+358",
    },
    { id: 203, country_name: "فنلندا", country_code: "FI", phone_code: "+358" },
    { id: 59, country_name: "بلغاريا", country_code: "BG", phone_code: "+359" },
    { id: 176, country_name: "هنغاريا", country_code: "HU", phone_code: "+36" },
    {
      id: 143,
      country_name: "ليتوانيا",
      country_code: "LT",
      phone_code: "+370",
    },
    { id: 141, country_name: "لاتفيا", country_code: "LV", phone_code: "+371" },
    { id: 99, country_name: "إستونيا", country_code: "EE", phone_code: "+372" },
    {
      id: 137,
      country_name: "مولدوفا",
      country_code: "MD",
      phone_code: "+373",
    },
    { id: 20, country_name: "أرمينيا", country_code: "AM", phone_code: "+374" },
    {
      id: 40,
      country_name: "بيلاروسيا",
      country_code: "BY",
      phone_code: "+375",
    },
    { id: 26, country_name: "أندورا", country_code: "AD", phone_code: "+376" },
    { id: 138, country_name: "موناكو", country_code: "MC", phone_code: "+377" },
    {
      id: 36,
      country_name: "سان مارينو",
      country_code: "SM",
      phone_code: "+378",
    },
    {
      id: 220,
      country_name: "مدينة الفاتيكان",
      country_code: "VA",
      phone_code: "+379",
    },
    {
      id: 103,
      country_name: "أوكرانيا",
      country_code: "UA",
      phone_code: "+380",
    },
    { id: 8, country_name: "صربيا", country_code: "RS", phone_code: "+381" },
    {
      id: 136,
      country_name: "الجبل الأسود",
      country_code: "ME",
      phone_code: "+382",
    },
    {
      id: 179,
      country_name: "كرواتيا",
      country_code: "HR",
      phone_code: "+385",
    },
    {
      id: 41,
      country_name: "سلوفينيا",
      country_code: "SI",
      phone_code: "+386",
    },
    {
      id: 10,
      country_name: "البوسنة والهرسك",
      country_code: "BA",
      phone_code: "+387",
    },
    {
      id: 134,
      country_name: "مقدونيا",
      country_code: "MK",
      phone_code: "+389",
    },
    { id: 166, country_name: "إيطاليا", country_code: "IT", phone_code: "+39" },
    { id: 11, country_name: "رومانيا", country_code: "RO", phone_code: "+40" },
    { id: 81, country_name: "سويسرا", country_code: "CH", phone_code: "+41" },
    {
      id: 63,
      country_name: "الجمهورية التشيكية",
      country_code: "CZ",
      phone_code: "+420",
    },
    {
      id: 38,
      country_name: "سلوفاكيا",
      country_code: "SK",
      phone_code: "+421",
    },
    {
      id: 147,
      country_name: "ليختنشتاين",
      country_code: "LI",
      phone_code: "+423",
    },
    { id: 15, country_name: "النمسا", country_code: "AT", phone_code: "+43" },
    {
      id: 198,
      country_name: "المملكة المتحدة.",
      country_code: "GB",
      phone_code: "+44",
    },
    { id: 232, country_name: "غيرنسي", country_code: "GG", phone_code: "+44" },
    {
      id: 234,
      country_name: "جزيرة مان",
      country_code: "IM",
      phone_code: "+44",
    },
    { id: 233, country_name: "جيرسي", country_code: "JE", phone_code: "+44" },
    {
      id: 106,
      country_name: "الدنمارك",
      country_code: "DK",
      phone_code: "+45",
    },
    { id: 44, country_name: "السويد", country_code: "SE", phone_code: "+46" },
    {
      id: 226,
      country_name: "جزيرة بوفيه",
      country_code: "BV",
      phone_code: "+47",
    },
    { id: 216, country_name: "النرويج", country_code: "NO", phone_code: "+47" },
    {
      id: 238,
      country_name: "سفالبارد",
      country_code: "SJ",
      phone_code: "+47",
    },
    { id: 206, country_name: "بولندا", country_code: "PL", phone_code: "+48" },
    { id: 110, country_name: "ألمانيا", country_code: "DE", phone_code: "+49" },
    {
      id: 237,
      country_name: "جزيرة جورجيا الجنوبية",
      country_code: "GS",
      phone_code: "+500",
    },
    { id: 39, country_name: "بليز", country_code: "BZ", phone_code: "+501" },
    {
      id: 185,
      country_name: "غواتيمالا",
      country_code: "GT",
      phone_code: "+502",
    },
    {
      id: 84,
      country_name: "السلفادور",
      country_code: "SV",
      phone_code: "+503",
    },
    {
      id: 180,
      country_name: "هندوراس",
      country_code: "HN",
      phone_code: "+504",
    },
    {
      id: 218,
      country_name: "نيكاراغوا",
      country_code: "NI",
      phone_code: "+505",
    },
    {
      id: 72,
      country_name: "كوستاريكا",
      country_code: "CR",
      phone_code: "+506",
    },
    { id: 212, country_name: "بنما", country_code: "PA", phone_code: "+507" },
    {
      id: 205,
      country_name: "سان بيير وميكلون",
      country_code: "PM",
      phone_code: "+508",
    },
    { id: 178, country_name: "هايتي", country_code: "HT", phone_code: "+509" },
    { id: 211, country_name: "بيرو", country_code: "PE", phone_code: "+51" },
    { id: 121, country_name: "المكسيك", country_code: "MX", phone_code: "+52" },
    { id: 70, country_name: "كوبا", country_code: "CU", phone_code: "+53" },
    {
      id: 18,
      country_name: "الأرجنتين",
      country_code: "AR",
      phone_code: "+54",
    },
    { id: 48, country_name: "البرازيل", country_code: "BR", phone_code: "+55" },
    { id: 76, country_name: "تشيلي", country_code: "CL", phone_code: "+56" },
    { id: 74, country_name: "كولومبيا", country_code: "CO", phone_code: "+57" },
    { id: 92, country_name: "فنزويلا", country_code: "VE", phone_code: "+58" },
    {
      id: 188,
      country_name: "غوادلوب",
      country_code: "GP",
      phone_code: "+590",
    },
    { id: 53, country_name: "بوليفيا", country_code: "BO", phone_code: "+591" },
    { id: 182, country_name: "غيانا", country_code: "GY", phone_code: "+592" },
    {
      id: 100,
      country_name: "الإكوادور",
      country_code: "EC",
      phone_code: "+593",
    },
    {
      id: 194,
      country_name: "غيانا الفرنسية",
      country_code: "GF",
      phone_code: "+594",
    },
    {
      id: 29,
      country_name: "باراغواي",
      country_code: "PY",
      phone_code: "+595",
    },
    {
      id: 128,
      country_name: "مارتينيك",
      country_code: "MQ",
      phone_code: "+596",
    },
    { id: 88, country_name: "سورينام", country_code: "SR", phone_code: "+597" },
    {
      id: 97,
      country_name: "أوروغواي",
      country_code: "UY",
      phone_code: "+598",
    },
    {
      id: 51,
      country_name: "بونير وسانت أوستاتيوس وسابا",
      country_code: "BQ",
      phone_code: "+599",
    },
    { id: 67, country_name: "كوراساو", country_code: "CW", phone_code: "+599" },
    { id: 120, country_name: "ماليزيا", country_code: "MY", phone_code: "+60" },
    { id: 14, country_name: "أستراليا", country_code: "AU", phone_code: "+61" },
    {
      id: 227,
      country_name: "جزر كوكوس",
      country_code: "CC",
      phone_code: "+61",
    },
    {
      id: 228,
      country_name: "جزيرة الكريسماس",
      country_code: "CX",
      phone_code: "+61",
    },
    {
      id: 174,
      country_name: "أندونيسيا",
      country_code: "ID",
      phone_code: "+62",
    },
    { id: 208, country_name: "الفلبين", country_code: "PH", phone_code: "+63" },
    {
      id: 214,
      country_name: "نيوزيلندا",
      country_code: "NZ",
      phone_code: "+64",
    },
    {
      id: 236,
      country_name: "جزر بيتكيرن",
      country_code: "PN",
      phone_code: "+64",
    },
    { id: 43, country_name: "سنغافورة", country_code: "SG", phone_code: "+65" },
    { id: 66, country_name: "تايلاند", country_code: "TH", phone_code: "+66" },
    {
      id: 62,
      country_name: "تيمور الشرقية",
      country_code: "TL",
      phone_code: "+670",
    },
    {
      id: 229,
      country_name: "جزيرة هيرد وجزر ماكدونالد",
      country_code: "HM",
      phone_code: "+672",
    },
    {
      id: 235,
      country_name: "جزيرة نورفولك",
      country_code: "NF",
      phone_code: "+672",
    },
    { id: 54, country_name: "بروناي", country_code: "BN", phone_code: "+673" },
    { id: 223, country_name: "ناورو", country_code: "NR", phone_code: "+674" },
    {
      id: 209,
      country_name: "بابوا غينيا الجديدة",
      country_code: "PG",
      phone_code: "+675",
    },
    { id: 113, country_name: "تونغا", country_code: "TO", phone_code: "+676" },
    {
      id: 50,
      country_name: "جزر سليمان",
      country_code: "SB",
      phone_code: "+677",
    },
    {
      id: 204,
      country_name: "فانواتو",
      country_code: "VU",
      phone_code: "+678",
    },
    { id: 202, country_name: "فيجي", country_code: "FJ", phone_code: "+679" },
    { id: 30, country_name: "بالاو", country_code: "PW", phone_code: "+680" },
    { id: 77, country_name: "جزر كوك", country_code: "CK", phone_code: "+682" },
    { id: 197, country_name: "ساموا", country_code: "WS", phone_code: "+685" },
    {
      id: 157,
      country_name: "كيريباتي",
      country_code: "KI",
      phone_code: "+686",
    },
    {
      id: 117,
      country_name: "كاليدونيا الجديدة",
      country_code: "NC",
      phone_code: "+687",
    },
    { id: 224, country_name: "توفالو", country_code: "TV", phone_code: "+688" },
    {
      id: 210,
      country_name: "بولينيزيا الفرنسية",
      country_code: "PF",
      phone_code: "+689",
    },
    {
      id: 222,
      country_name: "ميكرونيزيا",
      country_code: "FM",
      phone_code: "+691",
    },
    {
      id: 221,
      country_name: "جزر مارشال",
      country_code: "MH",
      phone_code: "+692",
    },
    {
      id: 151,
      country_name: "كازاخستان",
      country_code: "KZ",
      phone_code: "+7",
    },
    { id: 4, country_name: "روسيا", country_code: "RU", phone_code: "+7" },
    { id: 161, country_name: "اليابان", country_code: "JP", phone_code: "+81" },
    {
      id: 154,
      country_name: "كوريا الجنوبية",
      country_code: "KR",
      phone_code: "+82",
    },
    { id: 89, country_name: "فيتنام", country_code: "VN", phone_code: "+84" },
    {
      id: 181,
      country_name: "هونغ كونغ",
      country_code: "HK",
      phone_code: "+852",
    },
    {
      id: 130,
      country_name: "ماكاو، الصين",
      country_code: "MO",
      phone_code: "+853",
    },
    {
      id: 158,
      country_name: "كمبوديا",
      country_code: "KH",
      phone_code: "+855",
    },
    { id: 150, country_name: "لاوس", country_code: "LA", phone_code: "+856" },
    {
      id: 219,
      country_name: "البر الرئيسي الصيني",
      country_code: "CN",
      phone_code: "+86",
    },
    { id: 7, country_name: "بنغلاديش", country_code: "BD", phone_code: "+880" },
    { id: 109, country_name: "تايوان", country_code: "TW", phone_code: "+886" },
    { id: 112, country_name: "تركيا", country_code: "TR", phone_code: "+90" },
    { id: 171, country_name: "الهند", country_code: "IN", phone_code: "+91" },
    { id: 207, country_name: "باكستان", country_code: "PK", phone_code: "+92" },
    {
      id: 24,
      country_name: "أفغانستان",
      country_code: "AF",
      phone_code: "+93",
    },
    {
      id: 146,
      country_name: "سريلانكا",
      country_code: "LK",
      phone_code: "+94",
    },
    { id: 132, country_name: "ميانمار", country_code: "MM", phone_code: "+95" },
    {
      id: 123,
      country_name: "جزر المالديف",
      country_code: "MV",
      phone_code: "+960",
    },
    { id: 149, country_name: "لبنان", country_code: "LB", phone_code: "+961" },
    { id: 162, country_name: "الأردن", country_code: "JO", phone_code: "+962" },
    { id: 79, country_name: "سوريا", country_code: "SY", phone_code: "+963" },
    { id: 169, country_name: "العراق", country_code: "IQ", phone_code: "+964" },
    { id: 153, country_name: "الكويت", country_code: "KW", phone_code: "+965" },
    {
      id: 52,
      country_name: "المملكة العربية السعودية",
      country_code: "SA",
      phone_code: "+966",
    },
    { id: 177, country_name: "اليمن", country_code: "YE", phone_code: "+967" },
    { id: 213, country_name: "عُمان", country_code: "OM", phone_code: "+968" },
    {
      id: 32,
      country_name: "الأراضي الفلسطينية",
      country_code: "PS",
      phone_code: "+970",
    },
    {
      id: 25,
      country_name: "الإمارات العربية المتحدة",
      country_code: "AE",
      phone_code: "+971",
    },
    {
      id: 172,
      country_name: "إسرائيل",
      country_code: "IL",
      phone_code: "+972",
    },
    { id: 58, country_name: "البحرين", country_code: "BH", phone_code: "+973" },
    { id: 28, country_name: "قطر", country_code: "QA", phone_code: "+974" },
    { id: 45, country_name: "بوتان", country_code: "BT", phone_code: "+975" },
    {
      id: 131,
      country_name: "منغوليا",
      country_code: "MN",
      phone_code: "+976",
    },
    { id: 215, country_name: "نيبال", country_code: "NP", phone_code: "+977" },
    { id: 168, country_name: "إيران", country_code: "IR", phone_code: "+98" },
    {
      id: 64,
      country_name: "طاجيكستان",
      country_code: "TJ",
      phone_code: "+992",
    },
    {
      id: 115,
      country_name: "تركمانستان",
      country_code: "TM",
      phone_code: "+993",
    },
    {
      id: 12,
      country_name: "أذربيجان",
      country_code: "AZ",
      phone_code: "+994",
    },
    { id: 195, country_name: "جورجيا", country_code: "GE", phone_code: "+995" },
    {
      id: 159,
      country_name: "قيرغيزستان",
      country_code: "KG",
      phone_code: "+996",
    },
    {
      id: 96,
      country_name: "أوزبكستان",
      country_code: "UZ",
      phone_code: "+998",
    },
  ],
  ja_JP: [
    { id: 2, country_name: "カナダ", country_code: "CA", phone_code: "+1" },
    {
      id: 239,
      country_name: "米国の未編入小島嶼",
      country_code: "UM",
      phone_code: "+1",
    },
    {
      id: 5,
      country_name: "アメリカ合衆国",
      country_code: "US",
      phone_code: "+1",
    },
    { id: 47, country_name: "バハマ", country_code: "BS", phone_code: "+1242" },
    {
      id: 9,
      country_name: "バルバドス",
      country_code: "BB",
      phone_code: "+1246",
    },
    {
      id: 22,
      country_name: "アンギラ",
      country_code: "AI",
      phone_code: "+1264",
    },
    {
      id: 23,
      country_name: "アンティグア・バーブーダ",
      country_code: "AG",
      phone_code: "+1268",
    },
    {
      id: 90,
      country_name: "アメリカ領ヴァージン諸島",
      country_code: "VI",
      phone_code: "+1284",
    },
    {
      id: 91,
      country_name: "イギリス領ヴァージン諸島",
      country_code: "VG",
      phone_code: "+1340",
    },
    {
      id: 152,
      country_name: "ケイマン諸島",
      country_code: "KY",
      phone_code: "+1345",
    },
    {
      id: 55,
      country_name: "バミューダ",
      country_code: "BM",
      phone_code: "+1441",
    },
    {
      id: 196,
      country_name: "グレネダ",
      country_code: "GD",
      phone_code: "+1473",
    },
    {
      id: 73,
      country_name: "タークス・カイコス諸島",
      country_code: "TC",
      phone_code: "+1649",
    },
    {
      id: 126,
      country_name: "モントセラト",
      country_code: "MS",
      phone_code: "+1664",
    },
    {
      id: 129,
      country_name: "マリアナ諸島",
      country_code: "MP",
      phone_code: "+1670",
    },
    {
      id: 184,
      country_name: "グアム",
      country_code: "GU",
      phone_code: "+1671",
    },
    {
      id: 17,
      country_name: "アメリカ領サモア",
      country_code: "AS",
      phone_code: "+1684",
    },
    {
      id: 82,
      country_name: "シント・マールテン（オランダ領）",
      country_code: "SX",
      phone_code: "+1721",
    },
    {
      id: 148,
      country_name: "セントルシア",
      country_code: "LC",
      phone_code: "+1758",
    },
    {
      id: 105,
      country_name: "ドミニカ",
      country_code: "DM",
      phone_code: "+1767",
    },
    {
      id: 95,
      country_name: "セントビンセントおよびグレナディーン諸島",
      country_code: "VC",
      phone_code: "+1784",
    },
    {
      id: 33,
      country_name: "プエルトリコ",
      country_code: "PR",
      phone_code: "+1787",
    },
    {
      id: 104,
      country_name: "ドミニカ共和国",
      country_code: "DO",
      phone_code: "+1809",
    },
    {
      id: 111,
      country_name: "トリニダード・トバゴ",
      country_code: "TT",
      phone_code: "+1868",
    },
    {
      id: 155,
      country_name: "セントクリストファー・ネイビス",
      country_code: "KN",
      phone_code: "+1869",
    },
    {
      id: 163,
      country_name: "ジャマイカ",
      country_code: "JM",
      phone_code: "+1876",
    },
    { id: 98, country_name: "エジプト", country_code: "EG", phone_code: "+20" },
    {
      id: 87,
      country_name: "南スーダン",
      country_code: "SS",
      phone_code: "+211",
    },
    {
      id: 139,
      country_name: "モロッコ",
      country_code: "MA",
      phone_code: "+212",
    },
    {
      id: 101,
      country_name: "アルジェリア",
      country_code: "DZ",
      phone_code: "+213",
    },
    {
      id: 114,
      country_name: "チュニジア",
      country_code: "TN",
      phone_code: "+216",
    },
    { id: 140, country_name: "リビア", country_code: "LY", phone_code: "+218" },
    {
      id: 190,
      country_name: "ガンビア",
      country_code: "GM",
      phone_code: "+220",
    },
    {
      id: 35,
      country_name: "セネガル",
      country_code: "SN",
      phone_code: "+221",
    },
    {
      id: 127,
      country_name: "モーリタニア",
      country_code: "MR",
      phone_code: "+222",
    },
    { id: 133, country_name: "マリ", country_code: "ML", phone_code: "+223" },
    { id: 189, country_name: "ギニア", country_code: "GN", phone_code: "+224" },
    {
      id: 80,
      country_name: "コートジボワール",
      country_code: "CI",
      phone_code: "+225",
    },
    {
      id: 61,
      country_name: "ブルキナファソ",
      country_code: "BF",
      phone_code: "+226",
    },
    {
      id: 116,
      country_name: "ニジェール",
      country_code: "NE",
      phone_code: "+227",
    },
    {
      id: 68,
      country_name: "持ち帰り",
      country_code: "TG",
      phone_code: "+228",
    },
    { id: 56, country_name: "ベナン", country_code: "BJ", phone_code: "+229" },
    {
      id: 124,
      country_name: "モーリシャス",
      country_code: "MU",
      phone_code: "+230",
    },
    {
      id: 145,
      country_name: "リベリア",
      country_code: "LR",
      phone_code: "+231",
    },
    {
      id: 37,
      country_name: "シエラレオネ",
      country_code: "SL",
      phone_code: "+232",
    },
    { id: 193, country_name: "ガーナ", country_code: "GH", phone_code: "+233" },
    {
      id: 1,
      country_name: "ナイジェリア",
      country_code: "NG",
      phone_code: "+234",
    },
    { id: 71, country_name: "チャド", country_code: "TD", phone_code: "+235" },
    {
      id: 85,
      country_name: "中央アフリカ共和国",
      country_code: "CF",
      phone_code: "+236",
    },
    {
      id: 75,
      country_name: "カメルーン",
      country_code: "CM",
      phone_code: "+237",
    },
    { id: 69, country_name: "ケープ", country_code: "CV", phone_code: "+238" },
    {
      id: 86,
      country_name: "サントメ・プリンシペ",
      country_code: "ST",
      phone_code: "+239",
    },
    {
      id: 187,
      country_name: "赤道ギニア",
      country_code: "GQ",
      phone_code: "+240",
    },
    { id: 199, country_name: "ガボン", country_code: "GA", phone_code: "+241" },
    {
      id: 83,
      country_name: "コンゴ共和国",
      country_code: "CG",
      phone_code: "+242",
    },
    {
      id: 3,
      country_name: "コンゴ民主共和国",
      country_code: "CD",
      phone_code: "+243",
    },
    {
      id: 19,
      country_name: "アンゴラ",
      country_code: "AO",
      phone_code: "+244",
    },
    {
      id: 183,
      country_name: "ギニアビサウ",
      country_code: "GW",
      phone_code: "+245",
    },
    {
      id: 230,
      country_name: "イギリス領インド洋地域",
      country_code: "IO",
      phone_code: "+246",
    },
    {
      id: 27,
      country_name: "アセンション島",
      country_code: "AC",
      phone_code: "+247",
    },
    {
      id: 49,
      country_name: "セイシェル",
      country_code: "SC",
      phone_code: "+248",
    },
    {
      id: 46,
      country_name: "スーダン",
      country_code: "SD",
      phone_code: "+249",
    },
    {
      id: 60,
      country_name: "ルワンダ",
      country_code: "RW",
      phone_code: "+250",
    },
    {
      id: 93,
      country_name: "エチオピア",
      country_code: "ET",
      phone_code: "+251",
    },
    {
      id: 34,
      country_name: "ソマリア",
      country_code: "SO",
      phone_code: "+252",
    },
    { id: 108, country_name: "ジブチ", country_code: "DJ", phone_code: "+253" },
    { id: 160, country_name: "ケニア", country_code: "KE", phone_code: "+254" },
    {
      id: 107,
      country_name: "タンザニア",
      country_code: "TZ",
      phone_code: "+255",
    },
    {
      id: 102,
      country_name: "ウガンダ",
      country_code: "UG",
      phone_code: "+256",
    },
    {
      id: 57,
      country_name: "ブルンジ",
      country_code: "BI",
      phone_code: "+257",
    },
    {
      id: 119,
      country_name: "モザンビーク",
      country_code: "MZ",
      phone_code: "+258",
    },
    {
      id: 165,
      country_name: "ザンビア",
      country_code: "ZM",
      phone_code: "+260",
    },
    {
      id: 135,
      country_name: "マダガスカル",
      country_code: "MG",
      phone_code: "+261",
    },
    { id: 16, country_name: "再会", country_code: "RE", phone_code: "+262" },
    {
      id: 231,
      country_name: "フランス領南方領土",
      country_code: "TF",
      phone_code: "+262",
    },
    {
      id: 164,
      country_name: "ジンバブエ",
      country_code: "ZW",
      phone_code: "+263",
    },
    {
      id: 118,
      country_name: "ナミビア",
      country_code: "NA",
      phone_code: "+264",
    },
    {
      id: 122,
      country_name: "マラウイ",
      country_code: "MW",
      phone_code: "+265",
    },
    { id: 144, country_name: "レソト", country_code: "LS", phone_code: "+266" },
    {
      id: 42,
      country_name: "ボツワナ",
      country_code: "BW",
      phone_code: "+267",
    },
    {
      id: 78,
      country_name: "スワジランド",
      country_code: "SZ",
      phone_code: "+268",
    },
    { id: 156, country_name: "コモロ", country_code: "KM", phone_code: "+269" },
    {
      id: 175,
      country_name: "マヨット",
      country_code: "YT",
      phone_code: "+269",
    },
    {
      id: 170,
      country_name: "南アフリカ",
      country_code: "ZA",
      phone_code: "+27",
    },
    { id: 13, country_name: "アルバ", country_code: "AW", phone_code: "+297" },
    {
      id: 201,
      country_name: "フェロー諸島",
      country_code: "FO",
      phone_code: "+298",
    },
    {
      id: 191,
      country_name: "グリーンランド",
      country_code: "GL",
      phone_code: "+299",
    },
    {
      id: 186,
      country_name: "ギリシャ",
      country_code: "GR",
      phone_code: "+30",
    },
    {
      id: 217,
      country_name: "オランダ",
      country_code: "NL",
      phone_code: "+31",
    },
    { id: 6, country_name: "ベルギー", country_code: "BE", phone_code: "+32" },
    {
      id: 200,
      country_name: "フランス",
      country_code: "FR",
      phone_code: "+33",
    },
    { id: 94, country_name: "スペイン", country_code: "ES", phone_code: "+34" },
    {
      id: 192,
      country_name: "ジブラルタル",
      country_code: "GI",
      phone_code: "+350",
    },
    {
      id: 31,
      country_name: "ポルトガル",
      country_code: "PT",
      phone_code: "+351",
    },
    {
      id: 142,
      country_name: "ルクセンブルク",
      country_code: "LU",
      phone_code: "+352",
    },
    {
      id: 173,
      country_name: "アイルランド",
      country_code: "IE",
      phone_code: "+353",
    },
    {
      id: 167,
      country_name: "アイスランド",
      country_code: "IS",
      phone_code: "+354",
    },
    {
      id: 21,
      country_name: "アルバニア",
      country_code: "AL",
      phone_code: "+355",
    },
    { id: 125, country_name: "マルタ", country_code: "MT", phone_code: "+356" },
    {
      id: 65,
      country_name: "キプロス",
      country_code: "CY",
      phone_code: "+357",
    },
    {
      id: 225,
      country_name: "オーランド諸島",
      country_code: "AX",
      phone_code: "+358",
    },
    {
      id: 203,
      country_name: "フィンランド",
      country_code: "FI",
      phone_code: "+358",
    },
    {
      id: 59,
      country_name: "ブルガリア",
      country_code: "BG",
      phone_code: "+359",
    },
    {
      id: 176,
      country_name: "ハンガリー",
      country_code: "HU",
      phone_code: "+36",
    },
    {
      id: 143,
      country_name: "リトアニア",
      country_code: "LT",
      phone_code: "+370",
    },
    {
      id: 141,
      country_name: "ラトビア",
      country_code: "LV",
      phone_code: "+371",
    },
    {
      id: 99,
      country_name: "エストニア",
      country_code: "EE",
      phone_code: "+372",
    },
    {
      id: 137,
      country_name: "モルドバ",
      country_code: "MD",
      phone_code: "+373",
    },
    {
      id: 20,
      country_name: "アルメニア",
      country_code: "AM",
      phone_code: "+374",
    },
    {
      id: 40,
      country_name: "ベラルーシ",
      country_code: "BY",
      phone_code: "+375",
    },
    {
      id: 26,
      country_name: "アンドラ",
      country_code: "AD",
      phone_code: "+376",
    },
    { id: 138, country_name: "モナコ", country_code: "MC", phone_code: "+377" },
    {
      id: 36,
      country_name: "サンマリノ",
      country_code: "SM",
      phone_code: "+378",
    },
    {
      id: 220,
      country_name: "バチカン市国",
      country_code: "VA",
      phone_code: "+379",
    },
    {
      id: 103,
      country_name: "ウクライナ",
      country_code: "UA",
      phone_code: "+380",
    },
    { id: 8, country_name: "セルビア", country_code: "RS", phone_code: "+381" },
    {
      id: 136,
      country_name: "モンテネグロ",
      country_code: "ME",
      phone_code: "+382",
    },
    {
      id: 179,
      country_name: "クロアチア",
      country_code: "HR",
      phone_code: "+385",
    },
    {
      id: 41,
      country_name: "スロベニア",
      country_code: "SI",
      phone_code: "+386",
    },
    {
      id: 10,
      country_name: "ボスニア・ヘルツェゴビナ",
      country_code: "BA",
      phone_code: "+387",
    },
    {
      id: 134,
      country_name: "マケドニア",
      country_code: "MK",
      phone_code: "+389",
    },
    {
      id: 166,
      country_name: "イタリア",
      country_code: "IT",
      phone_code: "+39",
    },
    {
      id: 11,
      country_name: "ルーマニア",
      country_code: "RO",
      phone_code: "+40",
    },
    { id: 81, country_name: "スイス", country_code: "CH", phone_code: "+41" },
    {
      id: 63,
      country_name: "チェコ共和国",
      country_code: "CZ",
      phone_code: "+420",
    },
    {
      id: 38,
      country_name: "スロバキア",
      country_code: "SK",
      phone_code: "+421",
    },
    {
      id: 147,
      country_name: "リヒテンシュタイン",
      country_code: "LI",
      phone_code: "+423",
    },
    {
      id: 15,
      country_name: "オーストリア",
      country_code: "AT",
      phone_code: "+43",
    },
    { id: 198, country_name: "英国", country_code: "GB", phone_code: "+44" },
    {
      id: 232,
      country_name: "ガーンジー島",
      country_code: "GG",
      phone_code: "+44",
    },
    { id: 234, country_name: "マン島", country_code: "IM", phone_code: "+44" },
    {
      id: 233,
      country_name: "ジャージー",
      country_code: "JE",
      phone_code: "+44",
    },
    {
      id: 106,
      country_name: "デンマーク",
      country_code: "DK",
      phone_code: "+45",
    },
    {
      id: 44,
      country_name: "スウェーデン",
      country_code: "SE",
      phone_code: "+46",
    },
    {
      id: 226,
      country_name: "ブーベ島",
      country_code: "BV",
      phone_code: "+47",
    },
    {
      id: 216,
      country_name: "ノルウェー",
      country_code: "NO",
      phone_code: "+47",
    },
    {
      id: 238,
      country_name: "スヴァールバル諸島",
      country_code: "SJ",
      phone_code: "+47",
    },
    {
      id: 206,
      country_name: "ポーランド",
      country_code: "PL",
      phone_code: "+48",
    },
    { id: 110, country_name: "ドイツ", country_code: "DE", phone_code: "+49" },
    {
      id: 237,
      country_name: "サウスジョージア島",
      country_code: "GS",
      phone_code: "+500",
    },
    {
      id: 39,
      country_name: "ベリーズ",
      country_code: "BZ",
      phone_code: "+501",
    },
    {
      id: 185,
      country_name: "グアテマラ",
      country_code: "GT",
      phone_code: "+502",
    },
    {
      id: 84,
      country_name: "エルサルバドル",
      country_code: "SV",
      phone_code: "+503",
    },
    {
      id: 180,
      country_name: "ホンジュラス",
      country_code: "HN",
      phone_code: "+504",
    },
    {
      id: 218,
      country_name: "ニカラグア",
      country_code: "NI",
      phone_code: "+505",
    },
    {
      id: 72,
      country_name: "コスタリカ",
      country_code: "CR",
      phone_code: "+506",
    },
    { id: 212, country_name: "パナマ", country_code: "PA", phone_code: "+507" },
    {
      id: 205,
      country_name: "サンピエール島とミクロン島",
      country_code: "PM",
      phone_code: "+508",
    },
    { id: 178, country_name: "ハイチ", country_code: "HT", phone_code: "+509" },
    { id: 211, country_name: "ペルー", country_code: "PE", phone_code: "+51" },
    {
      id: 121,
      country_name: "メキシコ",
      country_code: "MX",
      phone_code: "+52",
    },
    { id: 70, country_name: "キューバ", country_code: "CU", phone_code: "+53" },
    {
      id: 18,
      country_name: "アルゼンチン",
      country_code: "AR",
      phone_code: "+54",
    },
    { id: 48, country_name: "ブラジル", country_code: "BR", phone_code: "+55" },
    { id: 76, country_name: "チリ", country_code: "CL", phone_code: "+56" },
    {
      id: 74,
      country_name: "コロンビア",
      country_code: "CO",
      phone_code: "+57",
    },
    {
      id: 92,
      country_name: "ベネズエラ",
      country_code: "VE",
      phone_code: "+58",
    },
    {
      id: 188,
      country_name: "グアドループ",
      country_code: "GP",
      phone_code: "+590",
    },
    {
      id: 53,
      country_name: "ボリビア",
      country_code: "BO",
      phone_code: "+591",
    },
    {
      id: 182,
      country_name: "ガイアナ",
      country_code: "GY",
      phone_code: "+592",
    },
    {
      id: 100,
      country_name: "エクアドル",
      country_code: "EC",
      phone_code: "+593",
    },
    {
      id: 194,
      country_name: "フランス領ギアナ",
      country_code: "GF",
      phone_code: "+594",
    },
    {
      id: 29,
      country_name: "パラグアイ",
      country_code: "PY",
      phone_code: "+595",
    },
    {
      id: 128,
      country_name: "マルティニーク",
      country_code: "MQ",
      phone_code: "+596",
    },
    {
      id: 88,
      country_name: "スリナム",
      country_code: "SR",
      phone_code: "+597",
    },
    {
      id: 97,
      country_name: "ウルグアイ",
      country_code: "UY",
      phone_code: "+598",
    },
    {
      id: 51,
      country_name: "ボネール島、シント・ユースタティウス島、サバ島",
      country_code: "BQ",
      phone_code: "+599",
    },
    {
      id: 67,
      country_name: "キュラソー",
      country_code: "CW",
      phone_code: "+599",
    },
    {
      id: 120,
      country_name: "マレーシア",
      country_code: "MY",
      phone_code: "+60",
    },
    {
      id: 14,
      country_name: "オーストラリア",
      country_code: "AU",
      phone_code: "+61",
    },
    {
      id: 227,
      country_name: "ココス諸島",
      country_code: "CC",
      phone_code: "+61",
    },
    {
      id: 228,
      country_name: "クリスマス島",
      country_code: "CX",
      phone_code: "+61",
    },
    {
      id: 174,
      country_name: "インドネシア",
      country_code: "ID",
      phone_code: "+62",
    },
    {
      id: 208,
      country_name: "フィリピン",
      country_code: "PH",
      phone_code: "+63",
    },
    {
      id: 214,
      country_name: "ニュージーランド",
      country_code: "NZ",
      phone_code: "+64",
    },
    {
      id: 236,
      country_name: "ピトケアン諸島",
      country_code: "PN",
      phone_code: "+64",
    },
    {
      id: 43,
      country_name: "シンガポール",
      country_code: "SG",
      phone_code: "+65",
    },
    { id: 66, country_name: "タイ", country_code: "TH", phone_code: "+66" },
    {
      id: 62,
      country_name: "東ティモール",
      country_code: "TL",
      phone_code: "+670",
    },
    {
      id: 229,
      country_name: "ハード島とマクドナルド諸島",
      country_code: "HM",
      phone_code: "+672",
    },
    {
      id: 235,
      country_name: "ノーフォーク島",
      country_code: "NF",
      phone_code: "+672",
    },
    {
      id: 54,
      country_name: "ブルネイ",
      country_code: "BN",
      phone_code: "+673",
    },
    { id: 223, country_name: "ナウル", country_code: "NR", phone_code: "+674" },
    {
      id: 209,
      country_name: "パプアニューギニア",
      country_code: "PG",
      phone_code: "+675",
    },
    { id: 113, country_name: "トンガ", country_code: "TO", phone_code: "+676" },
    {
      id: 50,
      country_name: "ソロモン諸島",
      country_code: "SB",
      phone_code: "+677",
    },
    {
      id: 204,
      country_name: "バヌアツ",
      country_code: "VU",
      phone_code: "+678",
    },
    {
      id: 202,
      country_name: "フィジー",
      country_code: "FJ",
      phone_code: "+679",
    },
    { id: 30, country_name: "パラオ", country_code: "PW", phone_code: "+680" },
    {
      id: 77,
      country_name: "クック諸島",
      country_code: "CK",
      phone_code: "+682",
    },
    { id: 197, country_name: "サモア", country_code: "WS", phone_code: "+685" },
    {
      id: 157,
      country_name: "キリバス",
      country_code: "KI",
      phone_code: "+686",
    },
    {
      id: 117,
      country_name: "ニューカレドニア",
      country_code: "NC",
      phone_code: "+687",
    },
    { id: 224, country_name: "ツバル", country_code: "TV", phone_code: "+688" },
    {
      id: 210,
      country_name: "フランス領ポリネシア",
      country_code: "PF",
      phone_code: "+689",
    },
    {
      id: 222,
      country_name: "ミクロネシア",
      country_code: "FM",
      phone_code: "+691",
    },
    {
      id: 221,
      country_name: "マーシャル諸島",
      country_code: "MH",
      phone_code: "+692",
    },
    {
      id: 151,
      country_name: "カザフスタン",
      country_code: "KZ",
      phone_code: "+7",
    },
    { id: 4, country_name: "ロシア", country_code: "RU", phone_code: "+7" },
    { id: 161, country_name: "日本", country_code: "JP", phone_code: "+81" },
    { id: 154, country_name: "韓国", country_code: "KR", phone_code: "+82" },
    { id: 89, country_name: "ベトナム", country_code: "VN", phone_code: "+84" },
    { id: 181, country_name: "香港", country_code: "HK", phone_code: "+852" },
    {
      id: 130,
      country_name: "マカオ、中国",
      country_code: "MO",
      phone_code: "+853",
    },
    {
      id: 158,
      country_name: "カンボジア",
      country_code: "KH",
      phone_code: "+855",
    },
    { id: 150, country_name: "ラオス", country_code: "LA", phone_code: "+856" },
    {
      id: 219,
      country_name: "中国本土",
      country_code: "CN",
      phone_code: "+86",
    },
    {
      id: 7,
      country_name: "バングラデシュ",
      country_code: "BD",
      phone_code: "+880",
    },
    { id: 109, country_name: "台湾", country_code: "TW", phone_code: "+886" },
    { id: 112, country_name: "トルコ", country_code: "TR", phone_code: "+90" },
    { id: 171, country_name: "インド", country_code: "IN", phone_code: "+91" },
    {
      id: 207,
      country_name: "パキスタン",
      country_code: "PK",
      phone_code: "+92",
    },
    {
      id: 24,
      country_name: "アフガニスタン",
      country_code: "AF",
      phone_code: "+93",
    },
    {
      id: 146,
      country_name: "スリランカ",
      country_code: "LK",
      phone_code: "+94",
    },
    {
      id: 132,
      country_name: "ミャンマー",
      country_code: "MM",
      phone_code: "+95",
    },
    {
      id: 123,
      country_name: "モルディブ",
      country_code: "MV",
      phone_code: "+960",
    },
    {
      id: 149,
      country_name: "レバノン",
      country_code: "LB",
      phone_code: "+961",
    },
    {
      id: 162,
      country_name: "ヨルダン",
      country_code: "JO",
      phone_code: "+962",
    },
    { id: 79, country_name: "シリア", country_code: "SY", phone_code: "+963" },
    { id: 169, country_name: "イラク", country_code: "IQ", phone_code: "+964" },
    {
      id: 153,
      country_name: "クウェート",
      country_code: "KW",
      phone_code: "+965",
    },
    {
      id: 52,
      country_name: "サウジアラビア",
      country_code: "SA",
      phone_code: "+966",
    },
    {
      id: 177,
      country_name: "イエメン",
      country_code: "YE",
      phone_code: "+967",
    },
    {
      id: 213,
      country_name: "オマーン",
      country_code: "OM",
      phone_code: "+968",
    },
    {
      id: 32,
      country_name: "パレスチナ自治区",
      country_code: "PS",
      phone_code: "+970",
    },
    {
      id: 25,
      country_name: "アラブ首長国連邦",
      country_code: "AE",
      phone_code: "+971",
    },
    {
      id: 172,
      country_name: "イスラエル",
      country_code: "IL",
      phone_code: "+972",
    },
    {
      id: 58,
      country_name: "バーレーン",
      country_code: "BH",
      phone_code: "+973",
    },
    {
      id: 28,
      country_name: "カタール",
      country_code: "QA",
      phone_code: "+974",
    },
    {
      id: 45,
      country_name: "ブータン",
      country_code: "BT",
      phone_code: "+975",
    },
    {
      id: 131,
      country_name: "モンゴル",
      country_code: "MN",
      phone_code: "+976",
    },
    {
      id: 215,
      country_name: "ネパール",
      country_code: "NP",
      phone_code: "+977",
    },
    { id: 168, country_name: "イラン", country_code: "IR", phone_code: "+98" },
    {
      id: 64,
      country_name: "タジキスタン",
      country_code: "TJ",
      phone_code: "+992",
    },
    {
      id: 115,
      country_name: "トルクメニスタン",
      country_code: "TM",
      phone_code: "+993",
    },
    {
      id: 12,
      country_name: "アゼルバイジャン",
      country_code: "AZ",
      phone_code: "+994",
    },
    {
      id: 195,
      country_name: "ジョージア",
      country_code: "GE",
      phone_code: "+995",
    },
    {
      id: 159,
      country_name: "キルギスタン",
      country_code: "KG",
      phone_code: "+996",
    },
    {
      id: 96,
      country_name: "ウズベキスタン",
      country_code: "UZ",
      phone_code: "+998",
    },
  ],
  ko_KR: [
    { id: 2, country_name: "캐나다", country_code: "CA", phone_code: "+1" },
    {
      id: 239,
      country_name: "미국령 군소 도서",
      country_code: "UM",
      phone_code: "+1",
    },
    { id: 5, country_name: "미국", country_code: "US", phone_code: "+1" },
    { id: 47, country_name: "바하마", country_code: "BS", phone_code: "+1242" },
    {
      id: 9,
      country_name: "바베이도스",
      country_code: "BB",
      phone_code: "+1246",
    },
    { id: 22, country_name: "앵귈라", country_code: "AI", phone_code: "+1264" },
    {
      id: 23,
      country_name: "앤티가 바부다",
      country_code: "AG",
      phone_code: "+1268",
    },
    {
      id: 90,
      country_name: "미국령 버진아일랜드",
      country_code: "VI",
      phone_code: "+1284",
    },
    {
      id: 91,
      country_name: "영국령 버진아일랜드",
      country_code: "VG",
      phone_code: "+1340",
    },
    {
      id: 152,
      country_name: "케이맨 제도",
      country_code: "KY",
      phone_code: "+1345",
    },
    { id: 55, country_name: "버뮤다", country_code: "BM", phone_code: "+1441" },
    {
      id: 196,
      country_name: "그레나다",
      country_code: "GD",
      phone_code: "+1473",
    },
    {
      id: 73,
      country_name: "터크스 케이커스 제도",
      country_code: "TC",
      phone_code: "+1649",
    },
    {
      id: 126,
      country_name: "몬세라트",
      country_code: "MS",
      phone_code: "+1664",
    },
    {
      id: 129,
      country_name: "마리아나 제도",
      country_code: "MP",
      phone_code: "+1670",
    },
    { id: 184, country_name: "괌", country_code: "GU", phone_code: "+1671" },
    {
      id: 17,
      country_name: "아메리칸 사모아",
      country_code: "AS",
      phone_code: "+1684",
    },
    {
      id: 82,
      country_name: "신트마르틴(네덜란드 지역)",
      country_code: "SX",
      phone_code: "+1721",
    },
    {
      id: 148,
      country_name: "세인트 루시아",
      country_code: "LC",
      phone_code: "+1758",
    },
    {
      id: 105,
      country_name: "도미니카 공화국",
      country_code: "DM",
      phone_code: "+1767",
    },
    {
      id: 95,
      country_name: "세인트빈센트 그레나딘",
      country_code: "VC",
      phone_code: "+1784",
    },
    {
      id: 33,
      country_name: "푸에르토리코",
      country_code: "PR",
      phone_code: "+1787",
    },
    {
      id: 104,
      country_name: "도미니카 공화국",
      country_code: "DO",
      phone_code: "+1809",
    },
    {
      id: 111,
      country_name: "트리니다드 토바고",
      country_code: "TT",
      phone_code: "+1868",
    },
    {
      id: 155,
      country_name: "세인트키츠 네비스",
      country_code: "KN",
      phone_code: "+1869",
    },
    {
      id: 163,
      country_name: "자메이카",
      country_code: "JM",
      phone_code: "+1876",
    },
    { id: 98, country_name: "이집트", country_code: "EG", phone_code: "+20" },
    { id: 87, country_name: "남수단", country_code: "SS", phone_code: "+211" },
    {
      id: 139,
      country_name: "모로코 가죽",
      country_code: "MA",
      phone_code: "+212",
    },
    { id: 101, country_name: "알제리", country_code: "DZ", phone_code: "+213" },
    { id: 114, country_name: "튀니지", country_code: "TN", phone_code: "+216" },
    { id: 140, country_name: "리비아", country_code: "LY", phone_code: "+218" },
    { id: 190, country_name: "감비아", country_code: "GM", phone_code: "+220" },
    { id: 35, country_name: "세네갈", country_code: "SN", phone_code: "+221" },
    {
      id: 127,
      country_name: "모리타니",
      country_code: "MR",
      phone_code: "+222",
    },
    { id: 133, country_name: "말리", country_code: "ML", phone_code: "+223" },
    { id: 189, country_name: "기니", country_code: "GN", phone_code: "+224" },
    {
      id: 80,
      country_name: "상아 해안",
      country_code: "CI",
      phone_code: "+225",
    },
    {
      id: 61,
      country_name: "부르키나파소",
      country_code: "BF",
      phone_code: "+226",
    },
    { id: 116, country_name: "니제르", country_code: "NE", phone_code: "+227" },
    { id: 68, country_name: "토고", country_code: "TG", phone_code: "+228" },
    { id: 56, country_name: "베냉", country_code: "BJ", phone_code: "+229" },
    {
      id: 124,
      country_name: "모리셔스",
      country_code: "MU",
      phone_code: "+230",
    },
    {
      id: 145,
      country_name: "라이베리아",
      country_code: "LR",
      phone_code: "+231",
    },
    {
      id: 37,
      country_name: "시에라리온",
      country_code: "SL",
      phone_code: "+232",
    },
    { id: 193, country_name: "가나", country_code: "GH", phone_code: "+233" },
    {
      id: 1,
      country_name: "나이지리아",
      country_code: "NG",
      phone_code: "+234",
    },
    { id: 71, country_name: "차드", country_code: "TD", phone_code: "+235" },
    {
      id: 85,
      country_name: "중앙아프리카 공화국",
      country_code: "CF",
      phone_code: "+236",
    },
    { id: 75, country_name: "카메룬", country_code: "CM", phone_code: "+237" },
    { id: 69, country_name: "곶", country_code: "CV", phone_code: "+238" },
    {
      id: 86,
      country_name: "상투메 프린시페",
      country_code: "ST",
      phone_code: "+239",
    },
    {
      id: 187,
      country_name: "적도 기니",
      country_code: "GQ",
      phone_code: "+240",
    },
    { id: 199, country_name: "가봉", country_code: "GA", phone_code: "+241" },
    {
      id: 83,
      country_name: "콩고 공화국",
      country_code: "CG",
      phone_code: "+242",
    },
    {
      id: 3,
      country_name: "콩고 민주 공화국",
      country_code: "CD",
      phone_code: "+243",
    },
    { id: 19, country_name: "앙골라", country_code: "AO", phone_code: "+244" },
    {
      id: 183,
      country_name: "기니비사우",
      country_code: "GW",
      phone_code: "+245",
    },
    {
      id: 230,
      country_name: "영국령 인도양 지역",
      country_code: "IO",
      phone_code: "+246",
    },
    {
      id: 27,
      country_name: "어센션 섬",
      country_code: "AC",
      phone_code: "+247",
    },
    { id: 49, country_name: "세이셸", country_code: "SC", phone_code: "+248" },
    { id: 46, country_name: "수단", country_code: "SD", phone_code: "+249" },
    { id: 60, country_name: "르완다", country_code: "RW", phone_code: "+250" },
    {
      id: 93,
      country_name: "에티오피아",
      country_code: "ET",
      phone_code: "+251",
    },
    {
      id: 34,
      country_name: "소말리아",
      country_code: "SO",
      phone_code: "+252",
    },
    { id: 108, country_name: "지부티", country_code: "DJ", phone_code: "+253" },
    { id: 160, country_name: "케냐", country_code: "KE", phone_code: "+254" },
    {
      id: 107,
      country_name: "탄자니아",
      country_code: "TZ",
      phone_code: "+255",
    },
    { id: 102, country_name: "우간다", country_code: "UG", phone_code: "+256" },
    { id: 57, country_name: "부룬디", country_code: "BI", phone_code: "+257" },
    {
      id: 119,
      country_name: "모잠비크",
      country_code: "MZ",
      phone_code: "+258",
    },
    { id: 165, country_name: "잠비아", country_code: "ZM", phone_code: "+260" },
    {
      id: 135,
      country_name: "마다가스카르",
      country_code: "MG",
      phone_code: "+261",
    },
    { id: 16, country_name: "재결합", country_code: "RE", phone_code: "+262" },
    {
      id: 231,
      country_name: "프랑스령 남부 지역",
      country_code: "TF",
      phone_code: "+262",
    },
    {
      id: 164,
      country_name: "짐바브웨",
      country_code: "ZW",
      phone_code: "+263",
    },
    {
      id: 118,
      country_name: "나미비아",
      country_code: "NA",
      phone_code: "+264",
    },
    { id: 122, country_name: "말라위", country_code: "MW", phone_code: "+265" },
    { id: 144, country_name: "레소토", country_code: "LS", phone_code: "+266" },
    {
      id: 42,
      country_name: "보츠와나",
      country_code: "BW",
      phone_code: "+267",
    },
    {
      id: 78,
      country_name: "스와질랜드",
      country_code: "SZ",
      phone_code: "+268",
    },
    { id: 156, country_name: "코모로", country_code: "KM", phone_code: "+269" },
    { id: 175, country_name: "마요트", country_code: "YT", phone_code: "+269" },
    {
      id: 170,
      country_name: "남아프리카 공화국",
      country_code: "ZA",
      phone_code: "+27",
    },
    { id: 13, country_name: "아루바", country_code: "AW", phone_code: "+297" },
    {
      id: 201,
      country_name: "페로 제도",
      country_code: "FO",
      phone_code: "+298",
    },
    {
      id: 191,
      country_name: "그린란드",
      country_code: "GL",
      phone_code: "+299",
    },
    { id: 186, country_name: "그리스", country_code: "GR", phone_code: "+30" },
    {
      id: 217,
      country_name: "네덜란드",
      country_code: "NL",
      phone_code: "+31",
    },
    { id: 6, country_name: "벨기에", country_code: "BE", phone_code: "+32" },
    { id: 200, country_name: "프랑스", country_code: "FR", phone_code: "+33" },
    { id: 94, country_name: "스페인", country_code: "ES", phone_code: "+34" },
    {
      id: 192,
      country_name: "지브롤터",
      country_code: "GI",
      phone_code: "+350",
    },
    {
      id: 31,
      country_name: "포르투갈",
      country_code: "PT",
      phone_code: "+351",
    },
    {
      id: 142,
      country_name: "룩셈부르크",
      country_code: "LU",
      phone_code: "+352",
    },
    {
      id: 173,
      country_name: "아일랜드",
      country_code: "IE",
      phone_code: "+353",
    },
    {
      id: 167,
      country_name: "아이슬란드",
      country_code: "IS",
      phone_code: "+354",
    },
    {
      id: 21,
      country_name: "알바니아",
      country_code: "AL",
      phone_code: "+355",
    },
    { id: 125, country_name: "몰타", country_code: "MT", phone_code: "+356" },
    {
      id: 65,
      country_name: "키프로스",
      country_code: "CY",
      phone_code: "+357",
    },
    {
      id: 225,
      country_name: "올란드 제도",
      country_code: "AX",
      phone_code: "+358",
    },
    { id: 203, country_name: "핀란드", country_code: "FI", phone_code: "+358" },
    {
      id: 59,
      country_name: "불가리아",
      country_code: "BG",
      phone_code: "+359",
    },
    { id: 176, country_name: "헝가리", country_code: "HU", phone_code: "+36" },
    {
      id: 143,
      country_name: "리투아니아",
      country_code: "LT",
      phone_code: "+370",
    },
    {
      id: 141,
      country_name: "라트비아",
      country_code: "LV",
      phone_code: "+371",
    },
    {
      id: 99,
      country_name: "에스토니아",
      country_code: "EE",
      phone_code: "+372",
    },
    { id: 137, country_name: "몰도바", country_code: "MD", phone_code: "+373" },
    {
      id: 20,
      country_name: "아르메니아",
      country_code: "AM",
      phone_code: "+374",
    },
    {
      id: 40,
      country_name: "벨라루스",
      country_code: "BY",
      phone_code: "+375",
    },
    { id: 26, country_name: "안도라", country_code: "AD", phone_code: "+376" },
    { id: 138, country_name: "모나코", country_code: "MC", phone_code: "+377" },
    {
      id: 36,
      country_name: "산마리노",
      country_code: "SM",
      phone_code: "+378",
    },
    {
      id: 220,
      country_name: "바티칸 시국",
      country_code: "VA",
      phone_code: "+379",
    },
    {
      id: 103,
      country_name: "우크라이나",
      country_code: "UA",
      phone_code: "+380",
    },
    { id: 8, country_name: "세르비아", country_code: "RS", phone_code: "+381" },
    {
      id: 136,
      country_name: "몬테네그로",
      country_code: "ME",
      phone_code: "+382",
    },
    {
      id: 179,
      country_name: "크로아티아",
      country_code: "HR",
      phone_code: "+385",
    },
    {
      id: 41,
      country_name: "슬로베니아",
      country_code: "SI",
      phone_code: "+386",
    },
    {
      id: 10,
      country_name: "보스니아 헤르체고비나",
      country_code: "BA",
      phone_code: "+387",
    },
    {
      id: 134,
      country_name: "마케도니아",
      country_code: "MK",
      phone_code: "+389",
    },
    {
      id: 166,
      country_name: "이탈리아",
      country_code: "IT",
      phone_code: "+39",
    },
    { id: 11, country_name: "루마니아", country_code: "RO", phone_code: "+40" },
    { id: 81, country_name: "스위스", country_code: "CH", phone_code: "+41" },
    {
      id: 63,
      country_name: "체코 공화국",
      country_code: "CZ",
      phone_code: "+420",
    },
    {
      id: 38,
      country_name: "슬로바키아",
      country_code: "SK",
      phone_code: "+421",
    },
    {
      id: 147,
      country_name: "리히텐슈타인",
      country_code: "LI",
      phone_code: "+423",
    },
    {
      id: 15,
      country_name: "오스트리아",
      country_code: "AT",
      phone_code: "+43",
    },
    { id: 198, country_name: "영국", country_code: "GB", phone_code: "+44" },
    { id: 232, country_name: "건지섬", country_code: "GG", phone_code: "+44" },
    { id: 234, country_name: "맨 섬", country_code: "IM", phone_code: "+44" },
    { id: 233, country_name: "저지", country_code: "JE", phone_code: "+44" },
    { id: 106, country_name: "덴마크", country_code: "DK", phone_code: "+45" },
    { id: 44, country_name: "스웨덴", country_code: "SE", phone_code: "+46" },
    { id: 226, country_name: "부베 섬", country_code: "BV", phone_code: "+47" },
    {
      id: 216,
      country_name: "노르웨이",
      country_code: "NO",
      phone_code: "+47",
    },
    {
      id: 238,
      country_name: "스발바르",
      country_code: "SJ",
      phone_code: "+47",
    },
    { id: 206, country_name: "폴란드", country_code: "PL", phone_code: "+48" },
    { id: 110, country_name: "독일", country_code: "DE", phone_code: "+49" },
    {
      id: 237,
      country_name: "사우스조지아 섬",
      country_code: "GS",
      phone_code: "+500",
    },
    { id: 39, country_name: "벨리즈", country_code: "BZ", phone_code: "+501" },
    {
      id: 185,
      country_name: "과테말라",
      country_code: "GT",
      phone_code: "+502",
    },
    {
      id: 84,
      country_name: "엘살바도르",
      country_code: "SV",
      phone_code: "+503",
    },
    {
      id: 180,
      country_name: "온두라스",
      country_code: "HN",
      phone_code: "+504",
    },
    {
      id: 218,
      country_name: "니카라과",
      country_code: "NI",
      phone_code: "+505",
    },
    {
      id: 72,
      country_name: "코스타리카",
      country_code: "CR",
      phone_code: "+506",
    },
    { id: 212, country_name: "파나마", country_code: "PA", phone_code: "+507" },
    {
      id: 205,
      country_name: "생피에르 미클롱",
      country_code: "PM",
      phone_code: "+508",
    },
    { id: 178, country_name: "아이티", country_code: "HT", phone_code: "+509" },
    { id: 211, country_name: "페루", country_code: "PE", phone_code: "+51" },
    { id: 121, country_name: "멕시코", country_code: "MX", phone_code: "+52" },
    { id: 70, country_name: "쿠바", country_code: "CU", phone_code: "+53" },
    {
      id: 18,
      country_name: "아르헨티나",
      country_code: "AR",
      phone_code: "+54",
    },
    { id: 48, country_name: "브라질", country_code: "BR", phone_code: "+55" },
    { id: 76, country_name: "칠레", country_code: "CL", phone_code: "+56" },
    { id: 74, country_name: "콜롬비아", country_code: "CO", phone_code: "+57" },
    {
      id: 92,
      country_name: "베네수엘라",
      country_code: "VE",
      phone_code: "+58",
    },
    {
      id: 188,
      country_name: "과들루프",
      country_code: "GP",
      phone_code: "+590",
    },
    {
      id: 53,
      country_name: "볼리비아",
      country_code: "BO",
      phone_code: "+591",
    },
    {
      id: 182,
      country_name: "가이아나",
      country_code: "GY",
      phone_code: "+592",
    },
    {
      id: 100,
      country_name: "에콰도르",
      country_code: "EC",
      phone_code: "+593",
    },
    {
      id: 194,
      country_name: "프랑스령 기아나",
      country_code: "GF",
      phone_code: "+594",
    },
    {
      id: 29,
      country_name: "파라과이",
      country_code: "PY",
      phone_code: "+595",
    },
    {
      id: 128,
      country_name: "마르티니크",
      country_code: "MQ",
      phone_code: "+596",
    },
    { id: 88, country_name: "수리남", country_code: "SR", phone_code: "+597" },
    {
      id: 97,
      country_name: "우루과이",
      country_code: "UY",
      phone_code: "+598",
    },
    {
      id: 51,
      country_name: "보네르, 세인트 유스타티우스 및 사바",
      country_code: "BQ",
      phone_code: "+599",
    },
    { id: 67, country_name: "퀴라소", country_code: "CW", phone_code: "+599" },
    {
      id: 120,
      country_name: "말레이시아",
      country_code: "MY",
      phone_code: "+60",
    },
    { id: 14, country_name: "호주", country_code: "AU", phone_code: "+61" },
    {
      id: 227,
      country_name: "코코스 제도",
      country_code: "CC",
      phone_code: "+61",
    },
    {
      id: 228,
      country_name: "크리스마스 섬",
      country_code: "CX",
      phone_code: "+61",
    },
    {
      id: 174,
      country_name: "인도네시아 공화국",
      country_code: "ID",
      phone_code: "+62",
    },
    { id: 208, country_name: "필리핀", country_code: "PH", phone_code: "+63" },
    {
      id: 214,
      country_name: "뉴질랜드",
      country_code: "NZ",
      phone_code: "+64",
    },
    {
      id: 236,
      country_name: "피트케언 제도",
      country_code: "PN",
      phone_code: "+64",
    },
    { id: 43, country_name: "싱가포르", country_code: "SG", phone_code: "+65" },
    { id: 66, country_name: "태국", country_code: "TH", phone_code: "+66" },
    {
      id: 62,
      country_name: "동티모르",
      country_code: "TL",
      phone_code: "+670",
    },
    {
      id: 229,
      country_name: "허드 섬과 맥도날드 섬",
      country_code: "HM",
      phone_code: "+672",
    },
    {
      id: 235,
      country_name: "노퍽 섬",
      country_code: "NF",
      phone_code: "+672",
    },
    {
      id: 54,
      country_name: "브루나이",
      country_code: "BN",
      phone_code: "+673",
    },
    { id: 223, country_name: "나우루", country_code: "NR", phone_code: "+674" },
    {
      id: 209,
      country_name: "파푸아뉴기니",
      country_code: "PG",
      phone_code: "+675",
    },
    { id: 113, country_name: "통가", country_code: "TO", phone_code: "+676" },
    {
      id: 50,
      country_name: "솔로몬 제도",
      country_code: "SB",
      phone_code: "+677",
    },
    {
      id: 204,
      country_name: "바누아투",
      country_code: "VU",
      phone_code: "+678",
    },
    { id: 202, country_name: "피지", country_code: "FJ", phone_code: "+679" },
    { id: 30, country_name: "팔라우", country_code: "PW", phone_code: "+680" },
    { id: 77, country_name: "쿡 제도", country_code: "CK", phone_code: "+682" },
    { id: 197, country_name: "사모아", country_code: "WS", phone_code: "+685" },
    {
      id: 157,
      country_name: "키리바시",
      country_code: "KI",
      phone_code: "+686",
    },
    {
      id: 117,
      country_name: "뉴칼레도니아",
      country_code: "NC",
      phone_code: "+687",
    },
    { id: 224, country_name: "투발루", country_code: "TV", phone_code: "+688" },
    {
      id: 210,
      country_name: "프랑스령 폴리네시아",
      country_code: "PF",
      phone_code: "+689",
    },
    {
      id: 222,
      country_name: "미크로네시아",
      country_code: "FM",
      phone_code: "+691",
    },
    {
      id: 221,
      country_name: "마셜 제도",
      country_code: "MH",
      phone_code: "+692",
    },
    {
      id: 151,
      country_name: "카자흐스탄",
      country_code: "KZ",
      phone_code: "+7",
    },
    {
      id: 4,
      country_name: "러시아 제국",
      country_code: "RU",
      phone_code: "+7",
    },
    { id: 161, country_name: "일본", country_code: "JP", phone_code: "+81" },
    {
      id: 154,
      country_name: "대한민국",
      country_code: "KR",
      phone_code: "+82",
    },
    { id: 89, country_name: "베트남", country_code: "VN", phone_code: "+84" },
    { id: 181, country_name: "홍콩", country_code: "HK", phone_code: "+852" },
    {
      id: 130,
      country_name: "마카오, 중국",
      country_code: "MO",
      phone_code: "+853",
    },
    {
      id: 158,
      country_name: "캄보디아",
      country_code: "KH",
      phone_code: "+855",
    },
    { id: 150, country_name: "라오스", country_code: "LA", phone_code: "+856" },
    {
      id: 219,
      country_name: "중국 본토",
      country_code: "CN",
      phone_code: "+86",
    },
    {
      id: 7,
      country_name: "방글라데시",
      country_code: "BD",
      phone_code: "+880",
    },
    { id: 109, country_name: "대만", country_code: "TW", phone_code: "+886" },
    { id: 112, country_name: "터키어", country_code: "TR", phone_code: "+90" },
    { id: 171, country_name: "인도", country_code: "IN", phone_code: "+91" },
    {
      id: 207,
      country_name: "파키스탄",
      country_code: "PK",
      phone_code: "+92",
    },
    {
      id: 24,
      country_name: "아프가니스탄",
      country_code: "AF",
      phone_code: "+93",
    },
    {
      id: 146,
      country_name: "스리랑카",
      country_code: "LK",
      phone_code: "+94",
    },
    { id: 132, country_name: "미얀마", country_code: "MM", phone_code: "+95" },
    { id: 123, country_name: "몰디브", country_code: "MV", phone_code: "+960" },
    { id: 149, country_name: "레바논", country_code: "LB", phone_code: "+961" },
    { id: 162, country_name: "요르단", country_code: "JO", phone_code: "+962" },
    { id: 79, country_name: "시리아", country_code: "SY", phone_code: "+963" },
    { id: 169, country_name: "이라크", country_code: "IQ", phone_code: "+964" },
    {
      id: 153,
      country_name: "쿠웨이트",
      country_code: "KW",
      phone_code: "+965",
    },
    {
      id: 52,
      country_name: "사우디 아라비아",
      country_code: "SA",
      phone_code: "+966",
    },
    {
      id: 177,
      country_name: "예멘 아랍 공화국",
      country_code: "YE",
      phone_code: "+967",
    },
    { id: 213, country_name: "오만", country_code: "OM", phone_code: "+968" },
    {
      id: 32,
      country_name: "팔레스타인 자치구",
      country_code: "PS",
      phone_code: "+970",
    },
    {
      id: 25,
      country_name: "아랍에미리트",
      country_code: "AE",
      phone_code: "+971",
    },
    {
      id: 172,
      country_name: "이스라엘",
      country_code: "IL",
      phone_code: "+972",
    },
    { id: 58, country_name: "바레인", country_code: "BH", phone_code: "+973" },
    { id: 28, country_name: "카타르", country_code: "QA", phone_code: "+974" },
    { id: 45, country_name: "부탄", country_code: "BT", phone_code: "+975" },
    {
      id: 131,
      country_name: "몽골리아",
      country_code: "MN",
      phone_code: "+976",
    },
    { id: 215, country_name: "네팔", country_code: "NP", phone_code: "+977" },
    { id: 168, country_name: "이란", country_code: "IR", phone_code: "+98" },
    {
      id: 64,
      country_name: "타지키스탄",
      country_code: "TJ",
      phone_code: "+992",
    },
    {
      id: 115,
      country_name: "투르크메니스탄",
      country_code: "TM",
      phone_code: "+993",
    },
    {
      id: 12,
      country_name: "아제르바이잔",
      country_code: "AZ",
      phone_code: "+994",
    },
    {
      id: 195,
      country_name: "그루지야",
      country_code: "GE",
      phone_code: "+995",
    },
    {
      id: 159,
      country_name: "키르기스스탄",
      country_code: "KG",
      phone_code: "+996",
    },
    {
      id: 96,
      country_name: "우즈베키스탄",
      country_code: "UZ",
      phone_code: "+998",
    },
  ],
  my_MM: [
    { id: 2, country_name: "ကနေဒါ", country_code: "CA", phone_code: "+1" },
    {
      id: 239,
      country_name: "U.S. Minor Outlying ကျွန်းများ",
      country_code: "UM",
      phone_code: "+1",
    },
    { id: 5, country_name: "ယူအက်စ်အေ", country_code: "US", phone_code: "+1" },
    {
      id: 47,
      country_name: "ဘဟားမား",
      country_code: "BS",
      phone_code: "+1242",
    },
    {
      id: 9,
      country_name: "ဘာဘေးဒိုးစ်",
      country_code: "BB",
      phone_code: "+1246",
    },
    {
      id: 22,
      country_name: "အင်ဂီလာ",
      country_code: "AI",
      phone_code: "+1264",
    },
    {
      id: 23,
      country_name: "အန်တီဂွါနဲ့ ဘာဘူဒါ",
      country_code: "AG",
      phone_code: "+1268",
    },
    {
      id: 90,
      country_name: "အမေရိကန် ဗာဂျင်ကျွန်းစုများ",
      country_code: "VI",
      phone_code: "+1284",
    },
    {
      id: 91,
      country_name: "ဗြိတိသျှ ဗာဂျင်ကျွန်းစုများ",
      country_code: "VG",
      phone_code: "+1340",
    },
    {
      id: 152,
      country_name: "ကေမန်ကျွန်းများ",
      country_code: "KY",
      phone_code: "+1345",
    },
    {
      id: 55,
      country_name: "ဘာမြူဒါ",
      country_code: "BM",
      phone_code: "+1441",
    },
    {
      id: 196,
      country_name: "ဂရီနီဒါ",
      country_code: "GD",
      phone_code: "+1473",
    },
    {
      id: 73,
      country_name: "Turks နှင့် Caicos ကျွန်းစုများ",
      country_code: "TC",
      phone_code: "+1649",
    },
    {
      id: 126,
      country_name: "Montserrat",
      country_code: "MS",
      phone_code: "+1664",
    },
    {
      id: 129,
      country_name: "မာရီယာနာကျွန်းစုများ",
      country_code: "MP",
      phone_code: "+1670",
    },
    { id: 184, country_name: "ဂူအမ်", country_code: "GU", phone_code: "+1671" },
    {
      id: 17,
      country_name: "အမေရိကန် ဆာမိုအာ",
      country_code: "AS",
      phone_code: "+1684",
    },
    {
      id: 82,
      country_name: "Sint Maarten (ဒတ်ခ်ျအပိုင်း)",
      country_code: "SX",
      phone_code: "+1721",
    },
    {
      id: 148,
      country_name: "စိန့်လူစီယာ",
      country_code: "LC",
      phone_code: "+1758",
    },
    {
      id: 105,
      country_name: "ဒိုမီနီကန်",
      country_code: "DM",
      phone_code: "+1767",
    },
    {
      id: 95,
      country_name: "Saint Vincent နှင့် Grenadines",
      country_code: "VC",
      phone_code: "+1784",
    },
    {
      id: 33,
      country_name: "ပွာတိုရီကို",
      country_code: "PR",
      phone_code: "+1787",
    },
    {
      id: 104,
      country_name: "ဒိုမီနီကန်သမ္မတနိုင်ငံ၊",
      country_code: "DO",
      phone_code: "+1809",
    },
    {
      id: 111,
      country_name: "ထရီနီဒက်နှင့်တိုဘာဂို",
      country_code: "TT",
      phone_code: "+1868",
    },
    {
      id: 155,
      country_name: "Saint Kitts နှင့် Nevis",
      country_code: "KN",
      phone_code: "+1869",
    },
    { id: 163, country_name: "ဂျ", country_code: "JM", phone_code: "+1876" },
    { id: 98, country_name: "အီဂျစ်", country_code: "EG", phone_code: "+20" },
    {
      id: 87,
      country_name: "တောင်ဆူဒန်",
      country_code: "SS",
      phone_code: "+211",
    },
    { id: 139, country_name: "မော်", country_code: "MA", phone_code: "+212" },
    {
      id: 101,
      country_name: "အယ်လ်ဂျီးရီးယား",
      country_code: "DZ",
      phone_code: "+213",
    },
    {
      id: 114,
      country_name: "တူနီးရှား",
      country_code: "TN",
      phone_code: "+216",
    },
    {
      id: 140,
      country_name: "လစ်ဗျား",
      country_code: "LY",
      phone_code: "+218",
    },
    {
      id: 190,
      country_name: "ဂမ်ဘီယာ",
      country_code: "GM",
      phone_code: "+220",
    },
    { id: 35, country_name: "ဆီနီဂေါ", country_code: "SN", phone_code: "+221" },
    {
      id: 127,
      country_name: "မော်ရီတေးနီးယား",
      country_code: "MR",
      phone_code: "+222",
    },
    { id: 133, country_name: "မာလီ", country_code: "ML", phone_code: "+223" },
    { id: 189, country_name: "ဂီနီ", country_code: "GN", phone_code: "+224" },
    {
      id: 80,
      country_name: "အိုင်ဗရီကို့စ်",
      country_code: "CI",
      phone_code: "+225",
    },
    {
      id: 61,
      country_name: "ဘာကီနာဖာဆို",
      country_code: "BF",
      phone_code: "+226",
    },
    {
      id: 116,
      country_name: "နိုင်ဂျာ",
      country_code: "NE",
      phone_code: "+227",
    },
    { id: 68, country_name: "ဂို", country_code: "TG", phone_code: "+228" },
    { id: 56, country_name: "နင်", country_code: "BJ", phone_code: "+229" },
    {
      id: 124,
      country_name: "မောရစ်သျှ",
      country_code: "MU",
      phone_code: "+230",
    },
    {
      id: 145,
      country_name: "လိုက်ဘေးရီးယား",
      country_code: "LR",
      phone_code: "+231",
    },
    {
      id: 37,
      country_name: "ဆီယာရာလီယွန်",
      country_code: "SL",
      phone_code: "+232",
    },
    { id: 193, country_name: "ဂါနာ", country_code: "GH", phone_code: "+233" },
    {
      id: 1,
      country_name: "နိုင်ဂျီးရီးယား",
      country_code: "NG",
      phone_code: "+234",
    },
    { id: 71, country_name: "ချဒ်", country_code: "TD", phone_code: "+235" },
    {
      id: 85,
      country_name: "ဗဟိုအာဖရိကသမ္မတနိုင်ငံ၊",
      country_code: "CF",
      phone_code: "+236",
    },
    {
      id: 75,
      country_name: "ကင်မရွန်း",
      country_code: "CM",
      phone_code: "+237",
    },
    { id: 69, country_name: "အငူ", country_code: "CV", phone_code: "+238" },
    {
      id: 86,
      country_name: "Sao Tome နှင့် Principe",
      country_code: "ST",
      phone_code: "+239",
    },
    {
      id: 187,
      country_name: "အီကွေတိုရီရယ်ဂီနီ",
      country_code: "GQ",
      phone_code: "+240",
    },
    { id: 199, country_name: "ဂါဘွန်", country_code: "GA", phone_code: "+241" },
    {
      id: 83,
      country_name: "ကွန်ဂိုသမ္မတနိုင်ငံ၊",
      country_code: "CG",
      phone_code: "+242",
    },
    {
      id: 3,
      country_name: "ကွန်ဂိုဒီမိုကရက်တစ်သမ္မတနိုင်ငံ",
      country_code: "CD",
      phone_code: "+243",
    },
    {
      id: 19,
      country_name: "အင်ဂိုလာ",
      country_code: "AO",
      phone_code: "+244",
    },
    {
      id: 183,
      country_name: "ဂီနီဘစ်ဆော",
      country_code: "GW",
      phone_code: "+245",
    },
    {
      id: 230,
      country_name: "ဗြိတိသျှအိန္ဒိယသမုဒ္ဒရာနယ်မြေ",
      country_code: "IO",
      phone_code: "+246",
    },
    {
      id: 27,
      country_name: "Ascension ကျွန်း",
      country_code: "AC",
      phone_code: "+247",
    },
    {
      id: 49,
      country_name: "ဆေးရှဲလ်",
      country_code: "SC",
      phone_code: "+248",
    },
    { id: 46, country_name: "ဆူဒန်", country_code: "SD", phone_code: "+249" },
    { id: 60, country_name: "ရဝမ်ဒါ", country_code: "RW", phone_code: "+250" },
    {
      id: 93,
      country_name: "အီသီယိုးပီးယား",
      country_code: "ET",
      phone_code: "+251",
    },
    {
      id: 34,
      country_name: "ဆိုမာလီယာ",
      country_code: "SO",
      phone_code: "+252",
    },
    {
      id: 108,
      country_name: "ဂျီဘူတီ",
      country_code: "DJ",
      phone_code: "+253",
    },
    { id: 160, country_name: "ကင်ညာ", country_code: "KE", phone_code: "+254" },
    {
      id: 107,
      country_name: "တန်ဇန်းနီးယား",
      country_code: "TZ",
      phone_code: "+255",
    },
    {
      id: 102,
      country_name: "ယူဂန်ဒါ",
      country_code: "UG",
      phone_code: "+256",
    },
    {
      id: 57,
      country_name: "ဘူရွန်ဒီ",
      country_code: "BI",
      phone_code: "+257",
    },
    {
      id: 119,
      country_name: "မိုဇမ်ဘစ်",
      country_code: "MZ",
      phone_code: "+258",
    },
    {
      id: 165,
      country_name: "ဇမ်ဘီယာ",
      country_code: "ZM",
      phone_code: "+260",
    },
    {
      id: 135,
      country_name: "မဒါဂတ်စကာ",
      country_code: "MG",
      phone_code: "+261",
    },
    {
      id: 16,
      country_name: "ပြန်လည်ဆုံဆည်းခြင်း။",
      country_code: "RE",
      phone_code: "+262",
    },
    {
      id: 231,
      country_name: "ပြင်သစ်တောင်ပိုင်းနယ်မြေများ",
      country_code: "TF",
      phone_code: "+262",
    },
    {
      id: 164,
      country_name: "ဇင်ဘာဘွေ",
      country_code: "ZW",
      phone_code: "+263",
    },
    {
      id: 118,
      country_name: "နမီးဘီးယား",
      country_code: "NA",
      phone_code: "+264",
    },
    {
      id: 122,
      country_name: "မော်လဝီ",
      country_code: "MW",
      phone_code: "+265",
    },
    {
      id: 144,
      country_name: "လီဆိုသို",
      country_code: "LS",
      phone_code: "+266",
    },
    {
      id: 42,
      country_name: "ဘော့ဆွာနာ",
      country_code: "BW",
      phone_code: "+267",
    },
    {
      id: 78,
      country_name: "ဆွာဇီလန်",
      country_code: "SZ",
      phone_code: "+268",
    },
    {
      id: 156,
      country_name: "ကွန်မိုရို",
      country_code: "KM",
      phone_code: "+269",
    },
    { id: 175, country_name: "မာယော့", country_code: "YT", phone_code: "+269" },
    {
      id: 170,
      country_name: "တောင်အာဖရိက",
      country_code: "ZA",
      phone_code: "+27",
    },
    { id: 13, country_name: "Aruba", country_code: "AW", phone_code: "+297" },
    {
      id: 201,
      country_name: "ဖာရိုးကျွန်းစုများ",
      country_code: "FO",
      phone_code: "+298",
    },
    {
      id: 191,
      country_name: "ဂရင်းလန်း",
      country_code: "GL",
      phone_code: "+299",
    },
    { id: 186, country_name: "ဟေ", country_code: "GR", phone_code: "+30" },
    {
      id: 217,
      country_name: "နယ်သာလန်",
      country_code: "NL",
      phone_code: "+31",
    },
    {
      id: 6,
      country_name: "ဘယ်လ်ဂျီယံ",
      country_code: "BE",
      phone_code: "+32",
    },
    { id: 200, country_name: "ပြင်သစ်", country_code: "FR", phone_code: "+33" },
    { id: 94, country_name: "စပိန်", country_code: "ES", phone_code: "+34" },
    {
      id: 192,
      country_name: "Gibraltar",
      country_code: "GI",
      phone_code: "+350",
    },
    {
      id: 31,
      country_name: "ပေါ်တူဂီ",
      country_code: "PT",
      phone_code: "+351",
    },
    {
      id: 142,
      country_name: "လူဇင်ဘတ်",
      country_code: "LU",
      phone_code: "+352",
    },
    {
      id: 173,
      country_name: "အိုင်ယာလန်",
      country_code: "IE",
      phone_code: "+353",
    },
    { id: 167, country_name: "လန်", country_code: "IS", phone_code: "+354" },
    {
      id: 21,
      country_name: "အယ်လ်ဘေးနီးယား",
      country_code: "AL",
      phone_code: "+355",
    },
    {
      id: 125,
      country_name: "မော်လတာ",
      country_code: "MT",
      phone_code: "+356",
    },
    {
      id: 65,
      country_name: "ဆိုက်ပရပ်စ်",
      country_code: "CY",
      phone_code: "+357",
    },
    {
      id: 225,
      country_name: "Åland ကျွန်းစုများ",
      country_code: "AX",
      phone_code: "+358",
    },
    { id: 203, country_name: "ဖင်လန်", country_code: "FI", phone_code: "+358" },
    {
      id: 59,
      country_name: "ဘူလ်ဂေးရီးယား",
      country_code: "BG",
      phone_code: "+359",
    },
    { id: 176, country_name: "ဟန်ဂေရီ", country_code: "HU", phone_code: "+36" },
    {
      id: 143,
      country_name: "လစ်သူယေးနီးယား",
      country_code: "LT",
      phone_code: "+370",
    },
    { id: 141, country_name: "လတ်", country_code: "LV", phone_code: "+371" },
    {
      id: 99,
      country_name: "အက်စ်တိုးနီးယား",
      country_code: "EE",
      phone_code: "+372",
    },
    {
      id: 137,
      country_name: "မော်လ်ဒိုဗာ",
      country_code: "MD",
      phone_code: "+373",
    },
    {
      id: 20,
      country_name: "အာမေးနီးယား",
      country_code: "AM",
      phone_code: "+374",
    },
    {
      id: 40,
      country_name: "ဘီလာရုစ်",
      country_code: "BY",
      phone_code: "+375",
    },
    {
      id: 26,
      country_name: "အန်ဒိုရာ",
      country_code: "AD",
      phone_code: "+376",
    },
    {
      id: 138,
      country_name: "မိုနာကို",
      country_code: "MC",
      phone_code: "+377",
    },
    {
      id: 36,
      country_name: "ဆန်မာရီနို",
      country_code: "SM",
      phone_code: "+378",
    },
    {
      id: 220,
      country_name: "ဗာတီကန်မြို့",
      country_code: "VA",
      phone_code: "+379",
    },
    {
      id: 103,
      country_name: "ယူကရိန်း",
      country_code: "UA",
      phone_code: "+380",
    },
    {
      id: 8,
      country_name: "ဆားဗီးယား",
      country_code: "RS",
      phone_code: "+381",
    },
    {
      id: 136,
      country_name: "မွန်တီနီဂရိုး",
      country_code: "ME",
      phone_code: "+382",
    },
    {
      id: 179,
      country_name: "ခရိုအေးရှား",
      country_code: "HR",
      phone_code: "+385",
    },
    {
      id: 41,
      country_name: "စလိုဗေးနီးယား",
      country_code: "SI",
      phone_code: "+386",
    },
    {
      id: 10,
      country_name: "ဘော့စနီးယားနှင့် ဟာဇီဂိုဗီးနား",
      country_code: "BA",
      phone_code: "+387",
    },
    {
      id: 134,
      country_name: "မက်ဆီဒိုးနီးယား",
      country_code: "MK",
      phone_code: "+389",
    },
    { id: 166, country_name: "အီတလီ", country_code: "IT", phone_code: "+39" },
    {
      id: 11,
      country_name: "ရိုမေးနီးယား",
      country_code: "RO",
      phone_code: "+40",
    },
    {
      id: 81,
      country_name: "ဆွစ်ဇာလန်",
      country_code: "CH",
      phone_code: "+41",
    },
    {
      id: 63,
      country_name: "ချက်သမ္မတနိုင်ငံ",
      country_code: "CZ",
      phone_code: "+420",
    },
    {
      id: 38,
      country_name: "ဆလိုဗက်ကီးယား",
      country_code: "SK",
      phone_code: "+421",
    },
    {
      id: 147,
      country_name: "လစ်ချ်တင်စတိန်း",
      country_code: "LI",
      phone_code: "+423",
    },
    {
      id: 15,
      country_name: "သြစတြီးယား",
      country_code: "AT",
      phone_code: "+43",
    },
    { id: 198, country_name: "U.K.", country_code: "GB", phone_code: "+44" },
    { id: 232, country_name: "ဂွာစီ", country_code: "GG", phone_code: "+44" },
    {
      id: 234,
      country_name: "Isle of Man",
      country_code: "IM",
      phone_code: "+44",
    },
    { id: 233, country_name: "ဂျာစီ", country_code: "JE", phone_code: "+44" },
    {
      id: 106,
      country_name: "ဒိန်းမတ်",
      country_code: "DK",
      phone_code: "+45",
    },
    { id: 44, country_name: "ဆွီဒင်", country_code: "SE", phone_code: "+46" },
    {
      id: 226,
      country_name: "Bouvet ကျွန်း",
      country_code: "BV",
      phone_code: "+47",
    },
    { id: 216, country_name: "နော်ဝေး", country_code: "NO", phone_code: "+47" },
    { id: 238, country_name: "ဗဲ", country_code: "SJ", phone_code: "+47" },
    { id: 206, country_name: "ပိုလန်", country_code: "PL", phone_code: "+48" },
    { id: 110, country_name: "ဂျာမနီ", country_code: "DE", phone_code: "+49" },
    {
      id: 237,
      country_name: "တောင်ဂျော်ဂျီယာကျွန်း",
      country_code: "GS",
      phone_code: "+500",
    },
    { id: 39, country_name: "ဘေလီဇ်", country_code: "BZ", phone_code: "+501" },
    {
      id: 185,
      country_name: "ဂွါတီမာလာ",
      country_code: "GT",
      phone_code: "+502",
    },
    {
      id: 84,
      country_name: "အယ်လ်ဆာဗေဒို",
      country_code: "SV",
      phone_code: "+503",
    },
    {
      id: 180,
      country_name: "ဟွန်ဒူးရပ်စ်",
      country_code: "HN",
      phone_code: "+504",
    },
    {
      id: 218,
      country_name: "နီကာရာဂွာ",
      country_code: "NI",
      phone_code: "+505",
    },
    {
      id: 72,
      country_name: "ကော်စတာရီကာ",
      country_code: "CR",
      phone_code: "+506",
    },
    {
      id: 212,
      country_name: "ပနားမား",
      country_code: "PA",
      phone_code: "+507",
    },
    {
      id: 205,
      country_name: "Saint Pierre နှင့် Miquelon",
      country_code: "PM",
      phone_code: "+508",
    },
    { id: 178, country_name: "ဟေတီ", country_code: "HT", phone_code: "+509" },
    { id: 211, country_name: "ပီရူး", country_code: "PE", phone_code: "+51" },
    {
      id: 121,
      country_name: "မက္ကဆီကို",
      country_code: "MX",
      phone_code: "+52",
    },
    { id: 70, country_name: "ကျူး", country_code: "CU", phone_code: "+53" },
    {
      id: 18,
      country_name: "အာဂျင်တီးနား",
      country_code: "AR",
      phone_code: "+54",
    },
    { id: 48, country_name: "ဘရာဇီး", country_code: "BR", phone_code: "+55" },
    { id: 76, country_name: "ချီလီ", country_code: "CL", phone_code: "+56" },
    {
      id: 74,
      country_name: "ကိုလံဘီယာ",
      country_code: "CO",
      phone_code: "+57",
    },
    {
      id: 92,
      country_name: "ဗင်နီဇွဲလား",
      country_code: "VE",
      phone_code: "+58",
    },
    { id: 188, country_name: "ဂွတ်", country_code: "GP", phone_code: "+590" },
    {
      id: 53,
      country_name: "ဘိုလီးဗီးယား",
      country_code: "BO",
      phone_code: "+591",
    },
    {
      id: 182,
      country_name: "ဂိုင်ယာနာ",
      country_code: "GY",
      phone_code: "+592",
    },
    {
      id: 100,
      country_name: "အီကွေဒေါ",
      country_code: "EC",
      phone_code: "+593",
    },
    {
      id: 194,
      country_name: "ပြင်သစ်ဂီယာနာ",
      country_code: "GF",
      phone_code: "+594",
    },
    {
      id: 29,
      country_name: "ပါရာဂွေး",
      country_code: "PY",
      phone_code: "+595",
    },
    {
      id: 128,
      country_name: "မာတီနစ်",
      country_code: "MQ",
      phone_code: "+596",
    },
    { id: 88, country_name: "ဆူရီနမ်", country_code: "SR", phone_code: "+597" },
    { id: 97, country_name: "ဥရုဂွေး", country_code: "UY", phone_code: "+598" },
    {
      id: 51,
      country_name: "Bonaire၊ St. Eustatius နှင့် Saba",
      country_code: "BQ",
      phone_code: "+599",
    },
    { id: 67, country_name: "Curacao", country_code: "CW", phone_code: "+599" },
    {
      id: 120,
      country_name: "မလေးရှား",
      country_code: "MY",
      phone_code: "+60",
    },
    {
      id: 14,
      country_name: "သြစတြေးလျ",
      country_code: "AU",
      phone_code: "+61",
    },
    {
      id: 227,
      country_name: "ကိုကိုးကျွန်းများ",
      country_code: "CC",
      phone_code: "+61",
    },
    {
      id: 228,
      country_name: "ခရစ္စမတ်ကျွန်း",
      country_code: "CX",
      phone_code: "+61",
    },
    {
      id: 174,
      country_name: "အင်ဒိုနီးရှား",
      country_code: "ID",
      phone_code: "+62",
    },
    {
      id: 208,
      country_name: "ဖိလစ်ပိုင်",
      country_code: "PH",
      phone_code: "+63",
    },
    {
      id: 214,
      country_name: "နယူးဇီလန်",
      country_code: "NZ",
      phone_code: "+64",
    },
    {
      id: 236,
      country_name: "ကိန်ကျွန်းများ",
      country_code: "PN",
      phone_code: "+64",
    },
    { id: 43, country_name: "စင်္ကာပူ", country_code: "SG", phone_code: "+65" },
    { id: 66, country_name: "ထိုင်း", country_code: "TH", phone_code: "+66" },
    {
      id: 62,
      country_name: "အရှေ့တီမော",
      country_code: "TL",
      phone_code: "+670",
    },
    {
      id: 229,
      country_name: "Heard Island နှင့် McDonald ကျွန်းများ",
      country_code: "HM",
      phone_code: "+672",
    },
    {
      id: 235,
      country_name: "Norfolk ကျွန်း",
      country_code: "NF",
      phone_code: "+672",
    },
    {
      id: 54,
      country_name: "ဘရူနိုင်း",
      country_code: "BN",
      phone_code: "+673",
    },
    { id: 223, country_name: "Nauru", country_code: "NR", phone_code: "+674" },
    {
      id: 209,
      country_name: "ပါပူဝါ နယူးဂီနီ",
      country_code: "PG",
      phone_code: "+675",
    },
    { id: 113, country_name: "တွန်ဂါ", country_code: "TO", phone_code: "+676" },
    {
      id: 50,
      country_name: "ဆော်လမွန်ကျွန်းများ",
      country_code: "SB",
      phone_code: "+677",
    },
    {
      id: 204,
      country_name: "ဗာနူအာတူ",
      country_code: "VU",
      phone_code: "+678",
    },
    { id: 202, country_name: "ဖီဂျီ", country_code: "FJ", phone_code: "+679" },
    { id: 30, country_name: "ပလောင်", country_code: "PW", phone_code: "+680" },
    {
      id: 77,
      country_name: "Cook ကျွန်းများ",
      country_code: "CK",
      phone_code: "+682",
    },
    {
      id: 197,
      country_name: "ဆာမိုအာ",
      country_code: "WS",
      phone_code: "+685",
    },
    {
      id: 157,
      country_name: "ကီရီဘာတီ",
      country_code: "KI",
      phone_code: "+686",
    },
    {
      id: 117,
      country_name: "နယူးကယ်လီဒိုးနီးယား",
      country_code: "NC",
      phone_code: "+687",
    },
    { id: 224, country_name: "တူဗာလူ", country_code: "TV", phone_code: "+688" },
    {
      id: 210,
      country_name: "ပြင်သစ်ပိုလီနီးရှား",
      country_code: "PF",
      phone_code: "+689",
    },
    {
      id: 222,
      country_name: "မိုက်ခရိုနီးရှား",
      country_code: "FM",
      phone_code: "+691",
    },
    {
      id: 221,
      country_name: "မာရှယ်ကျွန်းများ",
      country_code: "MH",
      phone_code: "+692",
    },
    { id: 151, country_name: "ဇတ်", country_code: "KZ", phone_code: "+7" },
    { id: 4, country_name: "ရုရှား", country_code: "RU", phone_code: "+7" },
    { id: 161, country_name: "ဂျပန်", country_code: "JP", phone_code: "+81" },
    {
      id: 154,
      country_name: "တောင်ကိုရီးယား",
      country_code: "KR",
      phone_code: "+82",
    },
    { id: 89, country_name: "ဗီယက်နမ်", country_code: "VN", phone_code: "+84" },
    {
      id: 181,
      country_name: "ဟောင်ကောင်",
      country_code: "HK",
      phone_code: "+852",
    },
    {
      id: 130,
      country_name: "မကာအို၊ တရုတ်",
      country_code: "MO",
      phone_code: "+853",
    },
    {
      id: 158,
      country_name: "ကမ္ဘောဒီးယား",
      country_code: "KH",
      phone_code: "+855",
    },
    { id: 150, country_name: "လာအို", country_code: "LA", phone_code: "+856" },
    {
      id: 219,
      country_name: "တရုတ် ပြည်မကြီး",
      country_code: "CN",
      phone_code: "+86",
    },
    {
      id: 7,
      country_name: "ဘင်္ဂလားဒေ့ရှ်",
      country_code: "BD",
      phone_code: "+880",
    },
    {
      id: 109,
      country_name: "ထိုင်ဝမ်",
      country_code: "TW",
      phone_code: "+886",
    },
    { id: 112, country_name: "Türkiye", country_code: "TR", phone_code: "+90" },
    { id: 171, country_name: "အိန္ဒိယ", country_code: "IN", phone_code: "+91" },
    {
      id: 207,
      country_name: "ပါကစ္စတန်",
      country_code: "PK",
      phone_code: "+92",
    },
    {
      id: 24,
      country_name: "အာဖဂန်နစ္စတန်",
      country_code: "AF",
      phone_code: "+93",
    },
    {
      id: 146,
      country_name: "သီရိလင်္ကာ",
      country_code: "LK",
      phone_code: "+94",
    },
    { id: 132, country_name: "မြန်မာ", country_code: "MM", phone_code: "+95" },
    {
      id: 123,
      country_name: "မော်လဒိုက်",
      country_code: "MV",
      phone_code: "+960",
    },
    {
      id: 149,
      country_name: "လက်ဘနွန်",
      country_code: "LB",
      phone_code: "+961",
    },
    {
      id: 162,
      country_name: "ဂျော်ဒန်",
      country_code: "JO",
      phone_code: "+962",
    },
    {
      id: 79,
      country_name: "ဆီးရီးယား",
      country_code: "SY",
      phone_code: "+963",
    },
    { id: 169, country_name: "အီရတ်", country_code: "IQ", phone_code: "+964" },
    { id: 153, country_name: "ကူဝိတ်", country_code: "KW", phone_code: "+965" },
    {
      id: 52,
      country_name: "ဆော်ဒီအာရေဗျ",
      country_code: "SA",
      phone_code: "+966",
    },
    { id: 177, country_name: "ယီမင်", country_code: "YE", phone_code: "+967" },
    { id: 213, country_name: "အိုမန်", country_code: "OM", phone_code: "+968" },
    {
      id: 32,
      country_name: "ပါလက်စတိုင်းနယ်မြေ",
      country_code: "PS",
      phone_code: "+970",
    },
    {
      id: 25,
      country_name: "အာရပ်စော်ဘွားများ ပြည်ထောင်စု",
      country_code: "AE",
      phone_code: "+971",
    },
    {
      id: 172,
      country_name: "အစ္စရေး",
      country_code: "IL",
      phone_code: "+972",
    },
    { id: 58, country_name: "ဘာရိန်း", country_code: "BH", phone_code: "+973" },
    { id: 28, country_name: "ကာတာ", country_code: "QA", phone_code: "+974" },
    { id: 45, country_name: "ဘူတန်", country_code: "BT", phone_code: "+975" },
    {
      id: 131,
      country_name: "မွန်ဂိုလီးယား",
      country_code: "MN",
      phone_code: "+976",
    },
    { id: 215, country_name: "နီပေါ", country_code: "NP", phone_code: "+977" },
    { id: 168, country_name: "အီရန်", country_code: "IR", phone_code: "+98" },
    {
      id: 64,
      country_name: "တာဂျစ်ကစ္စတန်",
      country_code: "TJ",
      phone_code: "+992",
    },
    {
      id: 115,
      country_name: "တာ့ခ်မင်နစ္စတန်",
      country_code: "TM",
      phone_code: "+993",
    },
    {
      id: 12,
      country_name: "အဇာဘိုင်ဂျန်",
      country_code: "AZ",
      phone_code: "+994",
    },
    {
      id: 195,
      country_name: "ဂျော်ဂျီယာ",
      country_code: "GE",
      phone_code: "+995",
    },
    {
      id: 159,
      country_name: "ကာဂျစ္စတန်",
      country_code: "KG",
      phone_code: "+996",
    },
    {
      id: 96,
      country_name: "ဧကစ္စတန်",
      country_code: "UZ",
      phone_code: "+998",
    },
  ],
  km_KH: [
    {
      id: 2,
      country_name: "ប្រទេសកាណាដា",
      country_code: "CA",
      phone_code: "+1",
    },
    {
      id: 239,
      country_name: "កោះ Minor Outlying របស់សហរដ្ឋអាមេរិក",
      country_code: "UM",
      phone_code: "+1",
    },
    {
      id: 5,
      country_name: "សហរដ្ឋអាមេរិក",
      country_code: "US",
      phone_code: "+1",
    },
    {
      id: 47,
      country_name: "បាហាម៉ាស",
      country_code: "BS",
      phone_code: "+1242",
    },
    { id: 9, country_name: "បាបាដូស", country_code: "BB", phone_code: "+1246" },
    {
      id: 22,
      country_name: "អង់ហ្គីឡា",
      country_code: "AI",
      phone_code: "+1264",
    },
    {
      id: 23,
      country_name: "Antigua និង Barbuda",
      country_code: "AG",
      phone_code: "+1268",
    },
    {
      id: 90,
      country_name: "កោះវឺជីនរបស់សហរដ្ឋអាមេរិក",
      country_code: "VI",
      phone_code: "+1284",
    },
    {
      id: 91,
      country_name: "កោះ British Virgin",
      country_code: "VG",
      phone_code: "+1340",
    },
    {
      id: 152,
      country_name: "កោះកៃម៉ាន",
      country_code: "KY",
      phone_code: "+1345",
    },
    {
      id: 55,
      country_name: "ប៊ឺមូដា",
      country_code: "BM",
      phone_code: "+1441",
    },
    {
      id: 196,
      country_name: "ហ្គ្រេនដា",
      country_code: "GD",
      phone_code: "+1473",
    },
    {
      id: 73,
      country_name: "កោះ Turks និង Caicos",
      country_code: "TC",
      phone_code: "+1649",
    },
    {
      id: 126,
      country_name: "ម៉ុងសឺរ៉ាត់",
      country_code: "MS",
      phone_code: "+1664",
    },
    {
      id: 129,
      country_name: "កោះម៉ារីណា",
      country_code: "MP",
      phone_code: "+1670",
    },
    {
      id: 184,
      country_name: "កោះហ្គាំ",
      country_code: "GU",
      phone_code: "+1671",
    },
    {
      id: 17,
      country_name: "សាម័រអាមេរិក",
      country_code: "AS",
      phone_code: "+1684",
    },
    {
      id: 82,
      country_name: "Sint Maarten (ផ្នែកហូឡង់)",
      country_code: "SX",
      phone_code: "+1721",
    },
    {
      id: 148,
      country_name: "ផ្លូវ Lucia",
      country_code: "LC",
      phone_code: "+1758",
    },
    {
      id: 105,
      country_name: "ដូមីនីកែន",
      country_code: "DM",
      phone_code: "+1767",
    },
    {
      id: 95,
      country_name: "Saint Vincent និង Grenadines",
      country_code: "VC",
      phone_code: "+1784",
    },
    {
      id: 33,
      country_name: "ព័រតូរីកូ",
      country_code: "PR",
      phone_code: "+1787",
    },
    {
      id: 104,
      country_name: "សាធារណរដ្ឋដូមីនិក",
      country_code: "DO",
      phone_code: "+1809",
    },
    {
      id: 111,
      country_name: "ទ្រីនីដាដ និងតូបាហ្គោ",
      country_code: "TT",
      phone_code: "+1868",
    },
    {
      id: 155,
      country_name: "Saint Kitts និង Nevis",
      country_code: "KN",
      phone_code: "+1869",
    },
    {
      id: 163,
      country_name: "ហ្សាម៉ាអ៊ីក",
      country_code: "JM",
      phone_code: "+1876",
    },
    { id: 98, country_name: "អេហ្ស៊ីប", country_code: "EG", phone_code: "+20" },
    {
      id: 87,
      country_name: "ស៊ូដង់ខាងត្បូង",
      country_code: "SS",
      phone_code: "+211",
    },
    {
      id: 139,
      country_name: "ម៉ារ៉ុក",
      country_code: "MA",
      phone_code: "+212",
    },
    {
      id: 101,
      country_name: "អាល់ហ្សេរី",
      country_code: "DZ",
      phone_code: "+213",
    },
    {
      id: 114,
      country_name: "ទុយនីស៊ី",
      country_code: "TN",
      phone_code: "+216",
    },
    { id: 140, country_name: "លីប៊ី", country_code: "LY", phone_code: "+218" },
    {
      id: 190,
      country_name: "ហ្គាំប៊ី",
      country_code: "GM",
      phone_code: "+220",
    },
    {
      id: 35,
      country_name: "សេណេហ្គាល់",
      country_code: "SN",
      phone_code: "+221",
    },
    {
      id: 127,
      country_name: "ម៉ូរីតានី",
      country_code: "MR",
      phone_code: "+222",
    },
    { id: 133, country_name: "ម៉ាលី", country_code: "ML", phone_code: "+223" },
    { id: 189, country_name: "ហ្គីណេ", country_code: "GN", phone_code: "+224" },
    {
      id: 80,
      country_name: "កូតឌីវ័រ",
      country_code: "CI",
      phone_code: "+225",
    },
    {
      id: 61,
      country_name: "ប៊ូគីណាហ្វាសូ",
      country_code: "BF",
      phone_code: "+226",
    },
    {
      id: 116,
      country_name: "នីហ្សេរីយ៉ា",
      country_code: "NE",
      phone_code: "+227",
    },
    { id: 68, country_name: "តូហ្គោ", country_code: "TG", phone_code: "+228" },
    { id: 56, country_name: "បេនីន", country_code: "BJ", phone_code: "+229" },
    { id: 124, country_name: "ម៉ូរីស", country_code: "MU", phone_code: "+230" },
    {
      id: 145,
      country_name: "លីបេរីយ៉ា",
      country_code: "LR",
      phone_code: "+231",
    },
    {
      id: 37,
      country_name: "សៀរ៉ាឡេអូន",
      country_code: "SL",
      phone_code: "+232",
    },
    { id: 193, country_name: "ហ្គាណា", country_code: "GH", phone_code: "+233" },
    {
      id: 1,
      country_name: "នីហ្សេរីយ៉ា",
      country_code: "NG",
      phone_code: "+234",
    },
    { id: 71, country_name: "ឆាដ", country_code: "TD", phone_code: "+235" },
    {
      id: 85,
      country_name: "សាធារណរដ្ឋអាហ្វ្រិកកណ្តាល",
      country_code: "CF",
      phone_code: "+236",
    },
    { id: 75, country_name: "កាមេរូន", country_code: "CM", phone_code: "+237" },
    { id: 69, country_name: "Cape", country_code: "CV", phone_code: "+238" },
    {
      id: 86,
      country_name: "Sao Tome និង Principe",
      country_code: "ST",
      phone_code: "+239",
    },
    {
      id: 187,
      country_name: "អេក្វាទ័រហ្គីណេ",
      country_code: "GQ",
      phone_code: "+240",
    },
    {
      id: 199,
      country_name: "ហ្គាបុង",
      country_code: "GA",
      phone_code: "+241",
    },
    {
      id: 83,
      country_name: "សាធារណរដ្ឋកុងហ្គោ",
      country_code: "CG",
      phone_code: "+242",
    },
    {
      id: 3,
      country_name: "សាធារណរដ្ឋប្រជាធិបតេយ្យកុងហ្គោ",
      country_code: "CD",
      phone_code: "+243",
    },
    {
      id: 19,
      country_name: "អង់ហ្គោឡា",
      country_code: "AO",
      phone_code: "+244",
    },
    {
      id: 183,
      country_name: "ហ្គីណេ-ប៊ីសា",
      country_code: "GW",
      phone_code: "+245",
    },
    {
      id: 230,
      country_name: "ដែនដីមហាសមុទ្រឥណ្ឌាអង់គ្លេស",
      country_code: "IO",
      phone_code: "+246",
    },
    {
      id: 27,
      country_name: "កោះ Ascension",
      country_code: "AC",
      phone_code: "+247",
    },
    { id: 49, country_name: "សីស្ហែល", country_code: "SC", phone_code: "+248" },
    { id: 46, country_name: "ស៊ូដង់", country_code: "SD", phone_code: "+249" },
    {
      id: 60,
      country_name: "រវ៉ាន់ដា",
      country_code: "RW",
      phone_code: "+250",
    },
    {
      id: 93,
      country_name: "អេត្យូពី",
      country_code: "ET",
      phone_code: "+251",
    },
    { id: 34, country_name: "សូម៉ាលី", country_code: "SO", phone_code: "+252" },
    {
      id: 108,
      country_name: "ជីប៊ូទី",
      country_code: "DJ",
      phone_code: "+253",
    },
    { id: 160, country_name: "កេនយ៉ា", country_code: "KE", phone_code: "+254" },
    {
      id: 107,
      country_name: "តង់ហ្សានី",
      country_code: "TZ",
      phone_code: "+255",
    },
    {
      id: 102,
      country_name: "អ៊ូហ្គង់ដា",
      country_code: "UG",
      phone_code: "+256",
    },
    {
      id: 57,
      country_name: "ប៊ូរុនឌី",
      country_code: "BI",
      phone_code: "+257",
    },
    {
      id: 119,
      country_name: "ម៉ូសំប៊ិក",
      country_code: "MZ",
      phone_code: "+258",
    },
    { id: 165, country_name: "សំប៊ី", country_code: "ZM", phone_code: "+260" },
    {
      id: 135,
      country_name: "ម៉ាដាហ្គាស្ការ",
      country_code: "MG",
      phone_code: "+261",
    },
    {
      id: 16,
      country_name: "ការជួបជុំគ្នា។",
      country_code: "RE",
      phone_code: "+262",
    },
    {
      id: 231,
      country_name: "ដែនដីភាគខាងត្បូងបារាំង",
      country_code: "TF",
      phone_code: "+262",
    },
    {
      id: 164,
      country_name: "ហ្ស៊ីមបាវ៉េ",
      country_code: "ZW",
      phone_code: "+263",
    },
    {
      id: 118,
      country_name: "ណាមីប៊ី",
      country_code: "NA",
      phone_code: "+264",
    },
    {
      id: 122,
      country_name: "ម៉ាឡាវី",
      country_code: "MW",
      phone_code: "+265",
    },
    { id: 144, country_name: "ឡេសូតូ", country_code: "LS", phone_code: "+266" },
    {
      id: 42,
      country_name: "បូតស្វាណា",
      country_code: "BW",
      phone_code: "+267",
    },
    {
      id: 78,
      country_name: "ស្វាស៊ីឡង់",
      country_code: "SZ",
      phone_code: "+268",
    },
    {
      id: 156,
      country_name: "កូម៉ូរ៉ូ",
      country_code: "KM",
      phone_code: "+269",
    },
    {
      id: 175,
      country_name: "ម៉ាយ៉ាត",
      country_code: "YT",
      phone_code: "+269",
    },
    {
      id: 170,
      country_name: "អាហ្វ្រិកខាងត្បូង",
      country_code: "ZA",
      phone_code: "+27",
    },
    { id: 13, country_name: "អារូបា", country_code: "AW", phone_code: "+297" },
    {
      id: 201,
      country_name: "កោះហ្វារ៉ូ",
      country_code: "FO",
      phone_code: "+298",
    },
    {
      id: 191,
      country_name: "ហ្គ្រីនឡែន",
      country_code: "GL",
      phone_code: "+299",
    },
    {
      id: 186,
      country_name: "ប្រទេសក្រិក",
      country_code: "GR",
      phone_code: "+30",
    },
    { id: 217, country_name: "ហូឡង់", country_code: "NL", phone_code: "+31" },
    { id: 6, country_name: "បែលហ្សិក", country_code: "BE", phone_code: "+32" },
    {
      id: 200,
      country_name: "ប្រទេសបារាំង",
      country_code: "FR",
      phone_code: "+33",
    },
    { id: 94, country_name: "អេស្ប៉ាញ", country_code: "ES", phone_code: "+34" },
    {
      id: 192,
      country_name: "Gibraltar",
      country_code: "GI",
      phone_code: "+350",
    },
    {
      id: 31,
      country_name: "ព័រទុយហ្គាល់",
      country_code: "PT",
      phone_code: "+351",
    },
    {
      id: 142,
      country_name: "លុចសំបួរ",
      country_code: "LU",
      phone_code: "+352",
    },
    { id: 173, country_name: "អៀរឡង់", country_code: "IE", phone_code: "+353" },
    {
      id: 167,
      country_name: "អ៊ីស្លង់",
      country_code: "IS",
      phone_code: "+354",
    },
    {
      id: 21,
      country_name: "អាល់បានី",
      country_code: "AL",
      phone_code: "+355",
    },
    {
      id: 125,
      country_name: "ម៉ាល់តា",
      country_code: "MT",
      phone_code: "+356",
    },
    { id: 65, country_name: "ស៊ីប", country_code: "CY", phone_code: "+357" },
    {
      id: 225,
      country_name: "កោះ Åland",
      country_code: "AX",
      phone_code: "+358",
    },
    {
      id: 203,
      country_name: "ហ្វាំងឡង់",
      country_code: "FI",
      phone_code: "+358",
    },
    {
      id: 59,
      country_name: "ប៊ុលហ្គារី",
      country_code: "BG",
      phone_code: "+359",
    },
    { id: 176, country_name: "ហុងគ្រី", country_code: "HU", phone_code: "+36" },
    {
      id: 143,
      country_name: "លីទុយអានី",
      country_code: "LT",
      phone_code: "+370",
    },
    { id: 141, country_name: "ឡាតវី", country_code: "LV", phone_code: "+371" },
    {
      id: 99,
      country_name: "អេស្តូនី",
      country_code: "EE",
      phone_code: "+372",
    },
    {
      id: 137,
      country_name: "ម៉ុលដាវី",
      country_code: "MD",
      phone_code: "+373",
    },
    { id: 20, country_name: "អាមេនី", country_code: "AM", phone_code: "+374" },
    {
      id: 40,
      country_name: "បេឡារុស្ស",
      country_code: "BY",
      phone_code: "+375",
    },
    {
      id: 26,
      country_name: "អង់ដូរ៉ា",
      country_code: "AD",
      phone_code: "+376",
    },
    {
      id: 138,
      country_name: "ម៉ូណាកូ",
      country_code: "MC",
      phone_code: "+377",
    },
    {
      id: 36,
      country_name: "សាន់ម៉ារីណូ",
      country_code: "SM",
      phone_code: "+378",
    },
    {
      id: 220,
      country_name: "ទីក្រុងវ៉ាទីកង់",
      country_code: "VA",
      phone_code: "+379",
    },
    {
      id: 103,
      country_name: "អ៊ុយក្រែន",
      country_code: "UA",
      phone_code: "+380",
    },
    { id: 8, country_name: "ស៊ែប៊ី", country_code: "RS", phone_code: "+381" },
    {
      id: 136,
      country_name: "ម៉ុងតេណេហ្គ្រោ",
      country_code: "ME",
      phone_code: "+382",
    },
    {
      id: 179,
      country_name: "ក្រូអាត",
      country_code: "HR",
      phone_code: "+385",
    },
    {
      id: 41,
      country_name: "ស្លូវេនី",
      country_code: "SI",
      phone_code: "+386",
    },
    {
      id: 10,
      country_name: "បូស្នៀ និងហឺហ្សេហ្គោវីណា",
      country_code: "BA",
      phone_code: "+387",
    },
    {
      id: 134,
      country_name: "ម៉ាសេដូនៀ",
      country_code: "MK",
      phone_code: "+389",
    },
    {
      id: 166,
      country_name: "ប្រទេសអ៊ីតាលី",
      country_code: "IT",
      phone_code: "+39",
    },
    { id: 11, country_name: "រូម៉ានី", country_code: "RO", phone_code: "+40" },
    { id: 81, country_name: "ស្វីស", country_code: "CH", phone_code: "+41" },
    {
      id: 63,
      country_name: "សាធារណរដ្ឋឆេក",
      country_code: "CZ",
      phone_code: "+420",
    },
    {
      id: 38,
      country_name: "ស្លូវ៉ាគី",
      country_code: "SK",
      phone_code: "+421",
    },
    {
      id: 147,
      country_name: "លីចតេនស្ទីន",
      country_code: "LI",
      phone_code: "+423",
    },
    { id: 15, country_name: "អូទ្រីស", country_code: "AT", phone_code: "+43" },
    { id: 198, country_name: "U.K.", country_code: "GB", phone_code: "+44" },
    {
      id: 232,
      country_name: "ហ្គេនស៊ី",
      country_code: "GG",
      phone_code: "+44",
    },
    {
      id: 234,
      country_name: "កោះម៉ាន់",
      country_code: "IM",
      phone_code: "+44",
    },
    { id: 233, country_name: "អាវ", country_code: "JE", phone_code: "+44" },
    {
      id: 106,
      country_name: "ដាណឺម៉ាក",
      country_code: "DK",
      phone_code: "+45",
    },
    { id: 44, country_name: "ស៊ុយអែត", country_code: "SE", phone_code: "+46" },
    {
      id: 226,
      country_name: "កោះប៊ូវេ",
      country_code: "BV",
      phone_code: "+47",
    },
    {
      id: 216,
      country_name: "ប្រទេសន័រវេស",
      country_code: "NO",
      phone_code: "+47",
    },
    {
      id: 238,
      country_name: "Svalbard",
      country_code: "SJ",
      phone_code: "+47",
    },
    { id: 206, country_name: "ប៉ូឡូញ", country_code: "PL", phone_code: "+48" },
    {
      id: 110,
      country_name: "អាល្លឺម៉ង់",
      country_code: "DE",
      phone_code: "+49",
    },
    {
      id: 237,
      country_name: "កោះហ្សកហ្ស៊ីខាងត្បូង",
      country_code: "GS",
      phone_code: "+500",
    },
    { id: 39, country_name: "បេលីស", country_code: "BZ", phone_code: "+501" },
    {
      id: 185,
      country_name: "ហ្គាតេម៉ាឡា",
      country_code: "GT",
      phone_code: "+502",
    },
    {
      id: 84,
      country_name: "អែលសាល់វ៉ាឌ័រ",
      country_code: "SV",
      phone_code: "+503",
    },
    {
      id: 180,
      country_name: "ហុងឌូរ៉ាស",
      country_code: "HN",
      phone_code: "+504",
    },
    {
      id: 218,
      country_name: "នីការ៉ាហ្គា",
      country_code: "NI",
      phone_code: "+505",
    },
    {
      id: 72,
      country_name: "កូស្តារីកា",
      country_code: "CR",
      phone_code: "+506",
    },
    {
      id: 212,
      country_name: "ប៉ាណាម៉ា",
      country_code: "PA",
      phone_code: "+507",
    },
    {
      id: 205,
      country_name: "Saint Pierre និង Miquelon",
      country_code: "PM",
      phone_code: "+508",
    },
    { id: 178, country_name: "ហៃទី", country_code: "HT", phone_code: "+509" },
    {
      id: 211,
      country_name: "ប្រទេសប៉េរូ",
      country_code: "PE",
      phone_code: "+51",
    },
    {
      id: 121,
      country_name: "ម៉ិកស៊ិក",
      country_code: "MX",
      phone_code: "+52",
    },
    { id: 70, country_name: "គុយបា", country_code: "CU", phone_code: "+53" },
    {
      id: 18,
      country_name: "អាហ្សង់ទីន",
      country_code: "AR",
      phone_code: "+54",
    },
    { id: 48, country_name: "ប្រេស៊ីល", country_code: "BR", phone_code: "+55" },
    { id: 76, country_name: "ឈីលី", country_code: "CL", phone_code: "+56" },
    { id: 74, country_name: "កូឡុំប៊ី", country_code: "CO", phone_code: "+57" },
    {
      id: 92,
      country_name: "វ៉េណេស៊ុយអេឡា",
      country_code: "VE",
      phone_code: "+58",
    },
    {
      id: 188,
      country_name: "ហ្គូដលូប",
      country_code: "GP",
      phone_code: "+590",
    },
    { id: 53, country_name: "បូលីវី", country_code: "BO", phone_code: "+591" },
    {
      id: 182,
      country_name: "ហ្គីយ៉ាណា",
      country_code: "GY",
      phone_code: "+592",
    },
    {
      id: 100,
      country_name: "អេក្វាឌ័រ",
      country_code: "EC",
      phone_code: "+593",
    },
    {
      id: 194,
      country_name: "ហ្គីយ៉ាណាបារាំង",
      country_code: "GF",
      phone_code: "+594",
    },
    {
      id: 29,
      country_name: "ប៉ារ៉ាហ្គាយ",
      country_code: "PY",
      phone_code: "+595",
    },
    {
      id: 128,
      country_name: "ម៉ាទីនីក",
      country_code: "MQ",
      phone_code: "+596",
    },
    {
      id: 88,
      country_name: "ស៊ូរីណាម",
      country_code: "SR",
      phone_code: "+597",
    },
    {
      id: 97,
      country_name: "អ៊ុយរូហ្គាយ",
      country_code: "UY",
      phone_code: "+598",
    },
    {
      id: 51,
      country_name: "Bonaire, St. Eustatius និង Saba",
      country_code: "BQ",
      phone_code: "+599",
    },
    {
      id: 67,
      country_name: "គូរ៉ាកាវ",
      country_code: "CW",
      phone_code: "+599",
    },
    {
      id: 120,
      country_name: "ម៉ាឡេស៊ី",
      country_code: "MY",
      phone_code: "+60",
    },
    {
      id: 14,
      country_name: "អូស្ត្រាលី",
      country_code: "AU",
      phone_code: "+61",
    },
    {
      id: 227,
      country_name: "កោះកូកូស",
      country_code: "CC",
      phone_code: "+61",
    },
    {
      id: 228,
      country_name: "កោះណូអែល",
      country_code: "CX",
      phone_code: "+61",
    },
    {
      id: 174,
      country_name: "ប្រទេសឥណ្ឌូនេស៊ី",
      country_code: "ID",
      phone_code: "+62",
    },
    {
      id: 208,
      country_name: "ហ្វីលីពីន",
      country_code: "PH",
      phone_code: "+63",
    },
    {
      id: 214,
      country_name: "នូវែលសេឡង់",
      country_code: "NZ",
      phone_code: "+64",
    },
    {
      id: 236,
      country_name: "កោះ Pitcairn",
      country_code: "PN",
      phone_code: "+64",
    },
    {
      id: 43,
      country_name: "សិង្ហបុរី",
      country_code: "SG",
      phone_code: "+65",
    },
    { id: 66, country_name: "ប្រទេសថៃ", country_code: "TH", phone_code: "+66" },
    {
      id: 62,
      country_name: "ទីម័រខាងកើត",
      country_code: "TL",
      phone_code: "+670",
    },
    {
      id: 229,
      country_name: "កោះ Heard និងកោះ McDonald",
      country_code: "HM",
      phone_code: "+672",
    },
    {
      id: 235,
      country_name: "កោះ Norfolk",
      country_code: "NF",
      phone_code: "+672",
    },
    {
      id: 54,
      country_name: "ប្រ៊ុយណេ",
      country_code: "BN",
      phone_code: "+673",
    },
    { id: 223, country_name: "ណៅរូ", country_code: "NR", phone_code: "+674" },
    {
      id: 209,
      country_name: "ប៉ាពួញូហ្គីណេ",
      country_code: "PG",
      phone_code: "+675",
    },
    {
      id: 113,
      country_name: "តុងហ្គា",
      country_code: "TO",
      phone_code: "+676",
    },
    {
      id: 50,
      country_name: "កោះសាឡូម៉ូន",
      country_code: "SB",
      phone_code: "+677",
    },
    {
      id: 204,
      country_name: "វ៉ានូអាទូ",
      country_code: "VU",
      phone_code: "+678",
    },
    { id: 202, country_name: "ហ្វីជី", country_code: "FJ", phone_code: "+679" },
    { id: 30, country_name: "ប៉ាឡូ", country_code: "PW", phone_code: "+680" },
    { id: 77, country_name: "កោះឃុក", country_code: "CK", phone_code: "+682" },
    { id: 197, country_name: "សាម័រ", country_code: "WS", phone_code: "+685" },
    {
      id: 157,
      country_name: "គីរីបាទី",
      country_code: "KI",
      phone_code: "+686",
    },
    {
      id: 117,
      country_name: "កាឡេដូនៀថ្មី។",
      country_code: "NC",
      phone_code: "+687",
    },
    {
      id: 224,
      country_name: "ទូវ៉ាលូ",
      country_code: "TV",
      phone_code: "+688",
    },
    {
      id: 210,
      country_name: "ប៉ូលីនេស៊ីបារាំង",
      country_code: "PF",
      phone_code: "+689",
    },
    {
      id: 222,
      country_name: "មីក្រូនេស៊ី",
      country_code: "FM",
      phone_code: "+691",
    },
    {
      id: 221,
      country_name: "កោះ Marshall",
      country_code: "MH",
      phone_code: "+692",
    },
    {
      id: 151,
      country_name: "កាហ្សាក់ស្ថាន",
      country_code: "KZ",
      phone_code: "+7",
    },
    { id: 4, country_name: "រុស្សី", country_code: "RU", phone_code: "+7" },
    { id: 161, country_name: "ជប៉ុន", country_code: "JP", phone_code: "+81" },
    {
      id: 154,
      country_name: "កូរ៉េខាងត្បូង",
      country_code: "KR",
      phone_code: "+82",
    },
    {
      id: 89,
      country_name: "ប្រទេសវៀតណាម",
      country_code: "VN",
      phone_code: "+84",
    },
    { id: 181, country_name: "ហុងកុង", country_code: "HK", phone_code: "+852" },
    {
      id: 130,
      country_name: "ម៉ាកាវ ប្រទេសចិន",
      country_code: "MO",
      phone_code: "+853",
    },
    {
      id: 158,
      country_name: "កម្ពុជា។",
      country_code: "KH",
      phone_code: "+855",
    },
    { id: 150, country_name: "ឡាវ", country_code: "LA", phone_code: "+856" },
    {
      id: 219,
      country_name: "ចិនដីគោក",
      country_code: "CN",
      phone_code: "+86",
    },
    {
      id: 7,
      country_name: "បង់ក្លាដែស",
      country_code: "BD",
      phone_code: "+880",
    },
    {
      id: 109,
      country_name: "តៃវ៉ាន់",
      country_code: "TW",
      phone_code: "+886",
    },
    { id: 112, country_name: "ទួរគី", country_code: "TR", phone_code: "+90" },
    {
      id: 171,
      country_name: "ប្រទេសឥណ្ឌា",
      country_code: "IN",
      phone_code: "+91",
    },
    {
      id: 207,
      country_name: "ប៉ាគីស្ថាន",
      country_code: "PK",
      phone_code: "+92",
    },
    {
      id: 24,
      country_name: "អាហ្វហ្គានីស្ថាន",
      country_code: "AF",
      phone_code: "+93",
    },
    {
      id: 146,
      country_name: "ស្រីលង្កា",
      country_code: "LK",
      phone_code: "+94",
    },
    {
      id: 132,
      country_name: "មីយ៉ាន់ម៉ា",
      country_code: "MM",
      phone_code: "+95",
    },
    {
      id: 123,
      country_name: "ម៉ាល់ឌីវ",
      country_code: "MV",
      phone_code: "+960",
    },
    { id: 149, country_name: "លីបង់", country_code: "LB", phone_code: "+961" },
    {
      id: 162,
      country_name: "ហ្ស៊កដានី",
      country_code: "JO",
      phone_code: "+962",
    },
    { id: 79, country_name: "ស៊ីរី", country_code: "SY", phone_code: "+963" },
    {
      id: 169,
      country_name: "អ៊ីរ៉ាក់",
      country_code: "IQ",
      phone_code: "+964",
    },
    {
      id: 153,
      country_name: "គុយវ៉ែត",
      country_code: "KW",
      phone_code: "+965",
    },
    {
      id: 52,
      country_name: "អារ៉ាប៊ីសាអូឌីត",
      country_code: "SA",
      phone_code: "+966",
    },
    { id: 177, country_name: "យេម៉ែន", country_code: "YE", phone_code: "+967" },
    { id: 213, country_name: "អូម៉ង់", country_code: "OM", phone_code: "+968" },
    {
      id: 32,
      country_name: "ទឹកដីប៉ាឡេស្ទីន",
      country_code: "PS",
      phone_code: "+970",
    },
    {
      id: 25,
      country_name: "អេមីរ៉ាតអារ៉ាប់រួម",
      country_code: "AE",
      phone_code: "+971",
    },
    {
      id: 172,
      country_name: "អ៊ីស្រាអែល",
      country_code: "IL",
      phone_code: "+972",
    },
    { id: 58, country_name: "បារ៉ែន", country_code: "BH", phone_code: "+973" },
    { id: 28, country_name: "កាតា", country_code: "QA", phone_code: "+974" },
    { id: 45, country_name: "ប៊ូតាន", country_code: "BT", phone_code: "+975" },
    {
      id: 131,
      country_name: "ម៉ុងហ្គោលី",
      country_code: "MN",
      phone_code: "+976",
    },
    {
      id: 215,
      country_name: "នេប៉ាល់",
      country_code: "NP",
      phone_code: "+977",
    },
    { id: 168, country_name: "អ៊ីរ៉ង់", country_code: "IR", phone_code: "+98" },
    {
      id: 64,
      country_name: "តាជីគីស្ថាន",
      country_code: "TJ",
      phone_code: "+992",
    },
    {
      id: 115,
      country_name: "តូមិននីស្ថាន",
      country_code: "TM",
      phone_code: "+993",
    },
    {
      id: 12,
      country_name: "អាស៊ែបៃហ្សង់",
      country_code: "AZ",
      phone_code: "+994",
    },
    {
      id: 195,
      country_name: "ហ្សកហ្ស៊ី",
      country_code: "GE",
      phone_code: "+995",
    },
    {
      id: 159,
      country_name: "កៀហ្ស៊ីស៊ីស្ថាន",
      country_code: "KG",
      phone_code: "+996",
    },
    {
      id: 96,
      country_name: "អ៊ូសបេគីស្ថាន",
      country_code: "UZ",
      phone_code: "+998",
    },
  ],
};
  
export default country;
  